import * as Types from './operations';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export const MonitoringSessionPartsFragmentDoc = gql`
    fragment MonitoringSessionParts on CbtMonitoringSession {
  id
  room_id
  status
  is_flagged
  flag_reason
  flagged_at
  started_at
  ended_at
  last_heartbeat_at
  student {
    id
    first_name
    surname
    other_name
    matric_no
    photo
  }
  testSession {
    id
    cbtTest {
      id
      title
    }
  }
}
    `;
export const MonitoringEventPartsFragmentDoc = gql`
    fragment MonitoringEventParts on CbtMonitoringEvent {
  id
  event_type
  severity
  occurred_at
  payload
}
    `;
export const MonitoringRecordingPartsFragmentDoc = gql`
    fragment MonitoringRecordingParts on CbtRecording {
  id
  kind
  storage_path
  mime_type
  size_bytes
  duration_ms
  started_at
  ended_at
  finalized_at
  status
}
    `;
export const AdmissionLetterDesignFieldsFragmentDoc = gql`
    fragment AdmissionLetterDesignFields on AdmissionLetterDesign {
  accent_color
  font_preset
  margin_mm
  vertical_margin_mm
  header_padding_mm
  watermark_type
  watermark_text
  watermark_opacity
  watermark_font_size
  watermark_rotation
  show_affiliate
  affiliation_text
  reporting_instructions
  secondary_color
  page_decoration
  letterhead_align
  title_style
  title_second_line
  heading_style
  bullet_style
  meta_style
  footer_pinned
  conditions_heading
  letterhead_motto
  letterhead_contact
  letterhead_rule
  letterhead_image_mode
}
    `;
export const AdmissionLetterTemplateFieldsFragmentDoc = gql`
    fragment AdmissionLetterTemplateFields on AdmissionLetterTemplate {
  id
  name
  layout
  show_logo
  show_qr_code
  header_text
  letter_title
  body
  conditions
  signatures {
    name
    title
    detail
    image_id
  }
  details {
    label
    value
    full_width
  }
  sections {
    type
    heading
    text
    height_mm
  }
  footer_text
  resumption_date
  is_default
  has_custom_watermark
  has_letterhead_image
  created_at
  updated_at
  design {
    ...AdmissionLetterDesignFields
  }
}
    ${AdmissionLetterDesignFieldsFragmentDoc}`;
export const AdmissionLetterStatusFieldsFragmentDoc = gql`
    fragment AdmissionLetterStatusFields on FormSubmission {
  id
  admission_letter_url
  admission_letter_generated_at
  admission_letter_sent_at
  admission_letter_warnings
  admission_letter_programme_check {
    letter_programme
    regenerated_programme
    applied_programme
    placed_programme
    placed_elsewhere
    placed_on_purpose
    letter_outdated
  }
}
    `;
export const FormFragmentDoc = gql`
    fragment FormFragment on CustomForm {
  id
  title
  description
  slug
  public_url
  embed_code
  is_active
  is_public
  form_type
  restrict_to_students
  target_classroom_section_id
  target_programme_id
  admission_field_mapping
  application_deadline
  payment_gates_review
  declaration_text
  sections {
    id
    title
    description
    order
  }
  stages {
    id
    title
    description
    order
    field_names
    fee_bill_item_template_id
    gate
  }
  branding {
    cover_image_url
    logo_url
    logo_position
    primary_color
    accent_color
    background_color
    background_image_url
    font_family
    layout_preset
    theme_preset
  }
  billItem {
    id
    name
    default_amount
  }
  targetClassroomSection {
    id
    classroom {
      id
      name
    }
  }
  targetProgramme {
    id
    program_name
  }
  reference_requirements {
    key
    label
    description
    count
    reference_form_id
    stage_id
  }
  reference_settings {
    applicants_can_view_responses
    expires_days
  }
  created_at
  updated_at
}
    `;
export const FormFieldFragmentDoc = gql`
    fragment FormFieldFragment on FormField {
  name
  label
  type
  required
  placeholder
  options
  min
  max
  max_size
  allowed_extensions
  order
  section_id
  show_if {
    field
    operator
    value
  }
  age_eligibility {
    min_age
    max_age
    reference_date
    message
  }
  maps_to
  data_source
  show_in_table
}
    `;
export const WaiverCodeRowFragmentDoc = gql`
    fragment WaiverCodeRow on FormWaiverCode {
  id
  status
  batch_label
  used_by_email
  used_at
  revoked_at
  created_at
  bill_amount_paid
  campus {
    id
    name
  }
  form {
    id
    title
  }
  generatedBy {
    id
    name
  }
  academicCalendar {
    id
    session {
      name
    }
    termStructure {
      name
    }
  }
  usedBySubmission {
    id
    tracking_code
    applicant_name
  }
  revokedBy {
    id
    name
  }
}
    `;
export const PaginatorPartsFragmentDoc = gql`
    fragment PaginatorParts on PaginatorInfo {
  currentPage
  total
  perPage
  count
  lastPage
}
    `;
export const FacultyDetailsFragmentDoc = gql`
    fragment FacultyDetails on FacultyType {
  id
  faculty_name
  school_id
  type
  is_active
  createdAt
  updatedAt
}
    `;
export const AcademicCalendarDetailsFragmentDoc = gql`
    fragment AcademicCalendarDetails on AcademicCalendar {
  id
  is_active
  session {
    id
    name
  }
  termStructure {
    id
    name
  }
  total_school_days
  started_at
  ended_at
}
    `;
export const StudentDetailsFragmentDoc = gql`
    fragment StudentDetails on Student {
  id
  first_name
  surname
  other_name
  matric_no
  gender
  email
  dob
  phone
  home_address
  nationality
  city
  state
  photo
  is_active
  currentClassroomSection {
    id
    name
    classroom {
      id
      name
    }
  }
  academicCalendars {
    started_at
    id
    termStructure {
      id
      name
    }
    session {
      id
      name
      sessionStructure {
        id
        name
      }
    }
  }
}
    `;
export const BillDetailsFragmentDoc = gql`
    fragment BillDetails on Bill {
  id
  amount
  due_date
  status
  billable_type
  billable_id
  created_at
  billable {
    __typename
    ... on Student {
      ...StudentDetails
    }
    ... on Classroom {
      id
      name
    }
    ... on ClassroomSection {
      id
      name
      classroom {
        id
        name
      }
    }
    ... on FormSubmission {
      id
      tracking_code
      applicant_name
    }
    ... on TranscriptRequest {
      id
      request_applicant_name: applicant_name
      request_tracking_code: tracking_code
    }
  }
  billDetails {
    id
    amount
    billItemTemplate {
      id
      name
      default_amount
      description
    }
  }
  session {
    id
    name
  }
  academicCalendar {
    id
    termStructure {
      id
      name
    }
  }
}
    ${StudentDetailsFragmentDoc}`;
export const StudentBillsDetailsFragmentDoc = gql`
    fragment StudentBillsDetails on Student {
  studentBills {
    id
    amount
    due_date
    status
    paymentStatusDetails {
      balance
    }
    derivedAdjustments {
      bill_detail_id
      source
      label
      amount
    }
    billDetails {
      id
      amount
      billItemTemplate {
        name
      }
    }
  }
}
    `;
export const TicketFragmentDoc = gql`
    fragment TicketFragment on Ticket {
  id
  subject
  status
  priority
  created_at
  category {
    name
  }
  sender {
    ... on User {
      id
      name
    }
    ... on Student {
      id
      surname
      first_name
    }
  }
}
    `;
export const GuardianStudentLinkFieldsFragmentDoc = gql`
    fragment GuardianStudentLinkFields on GuardianStudent {
  id
  relationshipType
  isPrimaryContact
  canAuthorizePickup
  receivesFeeNotifications
  receivesAttendanceNotifications
  receivesResultNotifications
  student {
    id
    first_name
    surname
    other_name
    matric_no
    gender
    photo
  }
  createdAt
  updatedAt
}
    `;
export const GuardianFieldsFragmentDoc = gql`
    fragment GuardianFields on Guardian {
  id
  firstName
  lastName
  fullName
  phoneNumber
  altPhoneNumber
  email
  whatsappOptIn
  verifiedAt
  preferredLanguage
  notes
  user {
    id
    name
  }
  students {
    id
    first_name
    surname
    matric_no
    photo
  }
  studentLinks {
    ...GuardianStudentLinkFields
  }
  createdAt
  updatedAt
}
    ${GuardianStudentLinkFieldsFragmentDoc}`;
export const AiPreviewRowFieldsFragmentDoc = gql`
    fragment AiPreviewRowFields on AiPreviewRow {
  id
  label
  detail
  eligible
  reason
}
    `;
export const AiActionRunFieldsFragmentDoc = gql`
    fragment AiActionRunFields on AiActionRun {
  id
  status
  total
  succeeded
  failed
  skipped
  startedAt
  finishedAt
}
    `;
export const AiPendingActionFieldsFragmentDoc = gql`
    fragment AiPendingActionFields on AiPendingAction {
  id
  actionKey
  label
  tier
  status
  expiresAt
  createdAt
  confirmedAt
  resultMessage
  preview {
    title
    summary
    fields {
      label
      value
    }
    warnings
    subjectCount
    eligibleCount
    skippedCount
    sample {
      ...AiPreviewRowFields
    }
    confirmLabel
    destructive
    changes {
      kind
      subject
      label
      detail
    }
  }
  resultLink {
    routeName
    params
    label
  }
  run {
    ...AiActionRunFields
  }
}
    ${AiPreviewRowFieldsFragmentDoc}
${AiActionRunFieldsFragmentDoc}`;
export const AttendanceEventFieldsFragmentDoc = gql`
    fragment AttendanceEventFields on AttendanceEvent {
  id
  name
  slug
  category
  lifecycle
  academic_calendar_id
  eventable_type
  eventable_id
  course {
    id
    course_code
    course_title
  }
  scope_type
  scope_id
  recurrence_days
  scheduled_date
  start_time
  end_time
  is_active
  created_at
}
    `;
export const SettlementAccountFieldsFragmentDoc = gql`
    fragment SettlementAccountFields on SettlementAccount {
  id
  school_id
  provider_name
  sub_account_id
  account_name
  account_number
  bank_code
  bank_name
  is_active
  created_at
}
    `;
export const FeeSplitRuleFieldsFragmentDoc = gql`
    fragment FeeSplitRuleFields on FeeSplitRule {
  id
  fee_split_profile_id
  bill_item_template_id
  bill_item_category_id
  billable_type
  billable_id
  hq_amount
  campus_amount
  hq_percentage
  campus_percentage
  base_amount
  campus_price
  priority
  billItemTemplate {
    id
    name
  }
  billItemCategory {
    id
    name
  }
}
    `;
export const FeeSplitProfileFieldsFragmentDoc = gql`
    fragment FeeSplitProfileFields on FeeSplitProfile {
  id
  name
  description
  split_mode
  is_default
  is_active
  created_at
  rules {
    ...FeeSplitRuleFields
  }
  assignments {
    id
    fee_split_profile_id
    child_school_id
    is_active
    childSchool {
      id
      name
    }
    overrides {
      id
      fee_split_assignment_id
      fee_split_rule_id
      hq_amount
      campus_amount
      hq_percentage
      campus_percentage
      base_amount
      campus_price
    }
  }
}
    ${FeeSplitRuleFieldsFragmentDoc}`;
export const BillItemTemplateFieldsFragmentDoc = gql`
    fragment BillItemTemplateFields on BillItemTemplate {
  id
  school_id
  name
  description
  bill_item_category_id
  billItemCategory {
    id
    name
  }
  default_amount
  is_active
  gateway_settlement_account_id
  gatewaySettlementAccount {
    id
    label
  }
  created_at
  updated_at
}
    `;
export const BillDetailFieldsFragmentDoc = gql`
    fragment BillDetailFields on BillDetail {
  id
  bill_id
  bill_item_template_id
  item_name
  item_description
  bill_item_category_id
  billItemCategory {
    id
    name
  }
  amount
  discount_amount
  net_amount
  amount_paid
  sort_order
  balance
  gateway_settlement_account_id
  gatewaySettlementAccount {
    id
    label
    gateway_identifier
  }
  derivedAdjustments {
    bill_detail_id
    source
    label
    amount
  }
}
    `;
export const BillDiscountFieldsFragmentDoc = gql`
    fragment BillDiscountFields on BillDiscount {
  id
  bill_id
  bill_detail_id
  source
  description
  reason
  discount_type
  discount_value
  calculated_amount
  voided_at
  created_at
  appliedBy {
    id
    name
  }
}
    `;
export const BillFieldsFragmentDoc = gql`
    fragment BillFields on Bill {
  id
  invoice_number
  school_id
  session_id
  academic_calendar_id
  billable_type
  billable_id
  due_date
  status
  amount
  discount_amount
  net_amount
  amount_paid
  notes
  created_by
  created_at
  updated_at
  balance
  gateway_settlement_account_id
  gatewaySettlementAccount {
    id
    label
  }
  billable {
    ... on Student {
      id
      first_name
      surname
      other_name
      matric_no
    }
    ... on Classroom {
      id
      name
      abbreviation
    }
    ... on ClassroomSection {
      id
      classroom {
        id
        name
        abbreviation
      }
      section {
        id
        name
      }
    }
    ... on ProgrammeType {
      id
      prog_code
      program_name
      degree
    }
    ... on FormSubmission {
      id
      tracking_code
      applicant_email
      applicant_name
      form {
        id
        title
      }
    }
    ... on TranscriptRequest {
      id
      request_applicant_name: applicant_name
      request_tracking_code: tracking_code
    }
  }
  session {
    id
    name
  }
  academicCalendar {
    id
    termStructure {
      id
      name
    }
  }
  paymentStatusDetails {
    payment_status
    total_amount
    amount_paid
    balance
  }
  derivedAdjustments {
    bill_detail_id
    source
    label
    amount
  }
  aggregates {
    student_count
    total_billed
    total_paid
    total_outstanding
    total_discounted
    total_exempted
  }
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  school_id
  order_id
  student_id
  amount
  payment_method
  payment_channel
  transaction_reference
  payment_date
  status
  currency_code
  notes
  void_reason
  voided_at
  created_at
  student {
    id
    first_name
    surname
  }
  form_context {
    form_title
    form_slug
    tracking_code
    applicant_name
    applicant_email
    submission_id
  }
  paymentAllocations {
    id
    amount
    billDetail {
      id
      item_name
      billItemCategory {
        id
        name
      }
      bill {
        id
      }
    }
  }
}
    `;
export const GatewaySettlementAccountFieldsFragmentDoc = gql`
    fragment GatewaySettlementAccountFields on GatewaySettlementAccount {
  id
  school_id
  payment_provider_id
  label
  gateway_identifier
  config
  bank_name
  account_number
  account_name
  is_default
  is_active
  metadata
  created_at
  updated_at
  paymentProvider {
    id
    name
  }
}
    `;
export const CertificateTemplateFieldsFragmentDoc = gql`
    fragment CertificateTemplateFields on CertificateTemplate {
  id
  name
  slug
  description
  paper_size
  orientation
  custom_width_mm
  custom_height_mm
  background_image_path
  design
  color_scheme
  fields
  signatures
  metadata
  is_active
  programmes {
    id
    program_name
    prog_code
    degree
  }
  created_at
  updated_at
}
    `;
export const GraduationRecordFieldsFragmentDoc = gql`
    fragment GraduationRecordFields on GraduationRecord {
  id
  calculation_method
  final_result
  degree_classification
  total_units_registered
  total_units_passed
  has_outstanding_courses
  outstanding_courses
  graduation_status
  approved_at
  graduated_at
  metadata
  student {
    id
    first_name
    surname
    other_name
    matric_no
    email
  }
  programme {
    id
    program_name
    prog_code
    degree
  }
  academicCalendar {
    id
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
  }
  approver {
    id
    name
  }
  created_at
  updated_at
}
    `;
export const GeneratedCertificateFieldsFragmentDoc = gql`
    fragment GeneratedCertificateFields on GeneratedCertificate {
  id
  certificate_number
  verification_code
  verification_hash
  data
  status
  delivery_method
  file_path
  version
  generated_at
  reviewed_at
  approved_at
  released_at
  rejection_reason
  revoked_at
  revocation_reason
  reissue_reason
  metadata
  template {
    id
    name
  }
  student {
    id
    first_name
    surname
    other_name
    matric_no
    email
  }
  graduationRecord {
    id
    degree_classification
    final_result
    graduation_status
  }
  generator {
    id
    name
  }
  reviewer {
    id
    name
  }
  approver {
    id
    name
  }
  revoker {
    id
    name
  }
  reissuedFrom {
    id
    certificate_number
    version
  }
  created_at
  updated_at
}
    `;
export const CertificateBatchJobFieldsFragmentDoc = gql`
    fragment CertificateBatchJobFields on CertificateBatchJob {
  id
  status
  total_students
  processed_count
  successful_count
  failed_count
  error_log
  retry_count
  max_retries
  started_at
  completed_at
  metadata
  template {
    id
    name
  }
  programme {
    id
    program_name
    prog_code
  }
  academicCalendar {
    id
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
  }
  initiator {
    id
    name
  }
  created_at
  updated_at
}
    `;
export const CertificateAuditLogFieldsFragmentDoc = gql`
    fragment CertificateAuditLogFields on CertificateAuditLog {
  id
  action
  details
  ip_address
  user {
    id
    name
  }
  created_at
}
    `;
export const CustomFieldFieldsFragmentDoc = gql`
    fragment CustomFieldFields on CustomField {
  id
  key
  label
  type
  entity
  is_required
  is_active
  student_access
  sequence
  description
  values_count
  options {
    value
    label
  }
  options_source
  depends_on
}
    `;
export const CustomFieldValueFieldsFragmentDoc = gql`
    fragment CustomFieldValueFields on CustomFieldValue {
  value
  filled_by
  filled_at
  field {
    id
    key
    label
    type
    is_required
    description
    options {
      value
      label
    }
    options_source
    depends_on
  }
}
    `;
export const GuardianStudentLinkResultFragmentDoc = gql`
    fragment GuardianStudentLinkResult on GuardianStudent {
  id
  relationshipType
  isPrimaryContact
  canAuthorizePickup
  receivesFeeNotifications
  receivesAttendanceNotifications
  receivesResultNotifications
  student {
    id
    first_name
    surname
    matric_no
    photo
  }
  guardian {
    id
    fullName
  }
  createdAt
  updatedAt
}
    `;
export const GuardianResultFragmentDoc = gql`
    fragment GuardianResult on Guardian {
  id
  firstName
  lastName
  fullName
  phoneNumber
  altPhoneNumber
  email
  whatsappOptIn
  verifiedAt
  preferredLanguage
  notes
  students {
    id
    first_name
    surname
    matric_no
    photo
  }
  studentLinks {
    id
    relationshipType
    isPrimaryContact
    canAuthorizePickup
    receivesFeeNotifications
    receivesAttendanceNotifications
    receivesResultNotifications
    student {
      id
      first_name
      surname
      matric_no
      photo
    }
  }
  createdAt
  updatedAt
}
    `;
export const StudentAllocationResultFieldsFragmentDoc = gql`
    fragment StudentAllocationResultFields on StudentAllocationResult {
  success
  message
  total_allocated
  unallocated_count
  allocations {
    course_lecturer_id
    lecturer_name
    school_staff_id
    allocated_count
    students {
      id
      course_id
      studentCourseRegistration {
        id
        student_id
        registration_level
        programme {
          id
          program_name
          prog_code
        }
        student {
          id
          first_name
          surname
          matric_no
        }
      }
    }
  }
}
    `;
export const SchoolNoticeFieldsFragmentDoc = gql`
    fragment SchoolNoticeFields on SchoolAnnouncement {
  id
  title
  body
  severity
  requires_acknowledgement
  pinned
  audience_label
  published_at
  expires_at
  read_at
  acknowledged_at
  createdBy {
    id
    name
  }
}
    `;
export const StudentDataRequestFieldsFragmentDoc = gql`
    fragment StudentDataRequestFields on StudentDataRequest {
  id
  title
  message
  due_on
  status
  is_overdue
  blocks_portal
  lock_on_close
  include_late_joiners
  created_by_name
  created_at
  closed_at
  recipients_count
  completed_count
  viewer_can_manage
  fields {
    key
    label
    required
  }
  audience {
    all_students
    classroom_ids
    section_ids
    programme_ids
    student_ids
    label
  }
}
    `;
export const StudentProfileFormFieldsFragmentDoc = gql`
    fragment StudentProfileFormFields on StudentProfileForm {
  missing_required
  fields {
    key
    field_id
    label
    type
    is_required
    max_length
    editable
    requested
    locked
    value
    filled_by
    filled_at
    description
    options {
      value
      label
    }
    options_source
    depends_on
  }
}
    `;
export const TranscriptTypeFieldsFragmentDoc = gql`
    fragment TranscriptTypeFields on TranscriptType {
  id
  name
  slug
  description
  category
  is_active
  metadata
  created_at
  updated_at
  billItemTemplate {
    id
    name
    default_amount
    billItemCategory {
      id
      name
    }
  }
}
    `;
export const TranscriptActivityFieldsFragmentDoc = gql`
    fragment TranscriptActivityFields on TranscriptRequestActivity {
  id
  transcript_request_id
  type
  content
  old_status
  new_status
  is_visible_to_applicant
  metadata
  created_at
  user {
    id
    name
  }
}
    `;
export const GeneratedTranscriptFieldsFragmentDoc = gql`
    fragment GeneratedTranscriptFields on GeneratedTranscript {
  id
  transcript_request_id
  student_id
  data
  summary
  version
  generated_at
  file_path
  cover_letter
  metadata
  transcript_template_id
  transcriptTemplate {
    id
    name
    style_code
  }
  created_at
  generatedBy {
    id
    name
  }
}
    `;
export const TranscriptTemplateFieldsFragmentDoc = gql`
    fragment TranscriptTemplateFields on TranscriptTemplate {
  id
  name
  style_code
  properties
  programmes {
    id
    program_name
    degree
  }
  created_at
  updated_at
}
    `;
export const TranscriptRequestFieldsFragmentDoc = gql`
    fragment TranscriptRequestFields on TranscriptRequest {
  id
  transcript_type_id
  student_id
  programme_id
  tracking_code
  applicant_category
  applicant_name
  applicant_email
  applicant_phone
  matric_no
  student_status
  supporting_document_path
  supporting_document_name
  supporting_document_url
  programme_name
  year_of_admission
  year_of_graduation
  destination_address
  destination_institution
  recipient_email
  courier_name
  courier_address
  courier_phone
  platform_name
  platform_code
  number_of_copies
  status
  rejection_reason
  complaint_note
  submitted_at
  processed_at
  approved_at
  collected_at
  admin_notes
  created_at
  updated_at
  transcriptType {
    id
    name
    category
  }
  student {
    id
    first_name
    surname
    other_name
    matric_no
    email
  }
  approvedBy {
    id
    name
  }
}
    `;
export const StartCbtMonitoringSessionDocument = gql`
    mutation StartCbtMonitoringSession($cbt_test_session_id: ID!) {
  startCbtMonitoringSession(cbt_test_session_id: $cbt_test_session_id) {
    ...MonitoringSessionParts
  }
}
    ${MonitoringSessionPartsFragmentDoc}`;

/**
 * __useStartCbtMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useStartCbtMonitoringSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartCbtMonitoringSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartCbtMonitoringSessionMutation({
 *   variables: {
 *     cbt_test_session_id: // value for 'cbt_test_session_id'
 *   },
 * });
 */
export function useStartCbtMonitoringSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.StartCbtMonitoringSessionMutation, Types.StartCbtMonitoringSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StartCbtMonitoringSessionMutation, Types.StartCbtMonitoringSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StartCbtMonitoringSessionMutation, Types.StartCbtMonitoringSessionMutationVariables>(StartCbtMonitoringSessionDocument, options);
}
export type StartCbtMonitoringSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StartCbtMonitoringSessionMutation, Types.StartCbtMonitoringSessionMutationVariables>;
export const EndCbtMonitoringSessionDocument = gql`
    mutation EndCbtMonitoringSession($id: ID!) {
  endCbtMonitoringSession(id: $id) {
    ...MonitoringSessionParts
  }
}
    ${MonitoringSessionPartsFragmentDoc}`;

/**
 * __useEndCbtMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useEndCbtMonitoringSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndCbtMonitoringSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndCbtMonitoringSessionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useEndCbtMonitoringSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.EndCbtMonitoringSessionMutation, Types.EndCbtMonitoringSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EndCbtMonitoringSessionMutation, Types.EndCbtMonitoringSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EndCbtMonitoringSessionMutation, Types.EndCbtMonitoringSessionMutationVariables>(EndCbtMonitoringSessionDocument, options);
}
export type EndCbtMonitoringSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EndCbtMonitoringSessionMutation, Types.EndCbtMonitoringSessionMutationVariables>;
export const RecordCbtMonitoringEventDocument = gql`
    mutation RecordCbtMonitoringEvent($input: RecordCbtMonitoringEventInput!) {
  recordCbtMonitoringEvent(input: $input) {
    ...MonitoringEventParts
  }
}
    ${MonitoringEventPartsFragmentDoc}`;

/**
 * __useRecordCbtMonitoringEventMutation__
 *
 * To run a mutation, you first call `useRecordCbtMonitoringEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordCbtMonitoringEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordCbtMonitoringEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRecordCbtMonitoringEventMutation(options: VueApolloComposable.UseMutationOptions<Types.RecordCbtMonitoringEventMutation, Types.RecordCbtMonitoringEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RecordCbtMonitoringEventMutation, Types.RecordCbtMonitoringEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RecordCbtMonitoringEventMutation, Types.RecordCbtMonitoringEventMutationVariables>(RecordCbtMonitoringEventDocument, options);
}
export type RecordCbtMonitoringEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RecordCbtMonitoringEventMutation, Types.RecordCbtMonitoringEventMutationVariables>;
export const FlagCbtMonitoringSessionDocument = gql`
    mutation FlagCbtMonitoringSession($id: ID!, $reason: String!) {
  flagCbtMonitoringSession(id: $id, reason: $reason) {
    ...MonitoringSessionParts
  }
}
    ${MonitoringSessionPartsFragmentDoc}`;

/**
 * __useFlagCbtMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useFlagCbtMonitoringSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useFlagCbtMonitoringSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useFlagCbtMonitoringSessionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useFlagCbtMonitoringSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.FlagCbtMonitoringSessionMutation, Types.FlagCbtMonitoringSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.FlagCbtMonitoringSessionMutation, Types.FlagCbtMonitoringSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.FlagCbtMonitoringSessionMutation, Types.FlagCbtMonitoringSessionMutationVariables>(FlagCbtMonitoringSessionDocument, options);
}
export type FlagCbtMonitoringSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.FlagCbtMonitoringSessionMutation, Types.FlagCbtMonitoringSessionMutationVariables>;
export const RecordCbtMonitoringConsentDocument = gql`
    mutation RecordCbtMonitoringConsent($cbt_test_session_id: ID!) {
  recordCbtMonitoringConsent(cbt_test_session_id: $cbt_test_session_id) {
    id
    accepted_at
  }
}
    `;

/**
 * __useRecordCbtMonitoringConsentMutation__
 *
 * To run a mutation, you first call `useRecordCbtMonitoringConsentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordCbtMonitoringConsentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordCbtMonitoringConsentMutation({
 *   variables: {
 *     cbt_test_session_id: // value for 'cbt_test_session_id'
 *   },
 * });
 */
export function useRecordCbtMonitoringConsentMutation(options: VueApolloComposable.UseMutationOptions<Types.RecordCbtMonitoringConsentMutation, Types.RecordCbtMonitoringConsentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RecordCbtMonitoringConsentMutation, Types.RecordCbtMonitoringConsentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RecordCbtMonitoringConsentMutation, Types.RecordCbtMonitoringConsentMutationVariables>(RecordCbtMonitoringConsentDocument, options);
}
export type RecordCbtMonitoringConsentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RecordCbtMonitoringConsentMutation, Types.RecordCbtMonitoringConsentMutationVariables>;
export const GetCbtMonitoringSignalingTokenDocument = gql`
    mutation GetCbtMonitoringSignalingToken($monitoring_session_id: ID!, $role: CbtMonitoringSignalingRoleEnum!) {
  getCbtMonitoringSignalingToken(
    monitoring_session_id: $monitoring_session_id
    role: $role
  ) {
    token
    ws_url
    room_id
    role
    expires_at
  }
}
    `;

/**
 * __useGetCbtMonitoringSignalingTokenMutation__
 *
 * To run a mutation, you first call `useGetCbtMonitoringSignalingTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGetCbtMonitoringSignalingTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGetCbtMonitoringSignalingTokenMutation({
 *   variables: {
 *     monitoring_session_id: // value for 'monitoring_session_id'
 *     role: // value for 'role'
 *   },
 * });
 */
export function useGetCbtMonitoringSignalingTokenMutation(options: VueApolloComposable.UseMutationOptions<Types.GetCbtMonitoringSignalingTokenMutation, Types.GetCbtMonitoringSignalingTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GetCbtMonitoringSignalingTokenMutation, Types.GetCbtMonitoringSignalingTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GetCbtMonitoringSignalingTokenMutation, Types.GetCbtMonitoringSignalingTokenMutationVariables>(GetCbtMonitoringSignalingTokenDocument, options);
}
export type GetCbtMonitoringSignalingTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GetCbtMonitoringSignalingTokenMutation, Types.GetCbtMonitoringSignalingTokenMutationVariables>;
export const ActiveCbtMonitoringSessionsDocument = gql`
    query ActiveCbtMonitoringSessions($testId: ID, $first: Int = 50, $page: Int) {
  activeCbtMonitoringSessions(testId: $testId, first: $first, page: $page) {
    data {
      ...MonitoringSessionParts
    }
    paginatorInfo {
      ...PaginatorParts
    }
  }
}
    ${MonitoringSessionPartsFragmentDoc}
${PaginatorPartsFragmentDoc}`;

/**
 * __useActiveCbtMonitoringSessionsQuery__
 *
 * To run a query within a Vue component, call `useActiveCbtMonitoringSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCbtMonitoringSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActiveCbtMonitoringSessionsQuery({
 *   testId: // value for 'testId'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useActiveCbtMonitoringSessionsQuery(variables: Types.ActiveCbtMonitoringSessionsQueryVariables | VueCompositionApi.Ref<Types.ActiveCbtMonitoringSessionsQueryVariables> | ReactiveFunction<Types.ActiveCbtMonitoringSessionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>(ActiveCbtMonitoringSessionsDocument, variables, options);
}
export function useActiveCbtMonitoringSessionsLazyQuery(variables: Types.ActiveCbtMonitoringSessionsQueryVariables | VueCompositionApi.Ref<Types.ActiveCbtMonitoringSessionsQueryVariables> | ReactiveFunction<Types.ActiveCbtMonitoringSessionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>(ActiveCbtMonitoringSessionsDocument, variables, options);
}
export type ActiveCbtMonitoringSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ActiveCbtMonitoringSessionsQuery, Types.ActiveCbtMonitoringSessionsQueryVariables>;
export const ListCbtMonitoringSessionsDocument = gql`
    query ListCbtMonitoringSessions($testId: ID, $status: CbtMonitoringSessionStatusEnum, $first: Int = 25, $page: Int) {
  listCbtMonitoringSessions(
    testId: $testId
    status: $status
    first: $first
    page: $page
  ) {
    data {
      ...MonitoringSessionParts
      recordings {
        ...MonitoringRecordingParts
      }
    }
    paginatorInfo {
      ...PaginatorParts
    }
  }
}
    ${MonitoringSessionPartsFragmentDoc}
${MonitoringRecordingPartsFragmentDoc}
${PaginatorPartsFragmentDoc}`;

/**
 * __useListCbtMonitoringSessionsQuery__
 *
 * To run a query within a Vue component, call `useListCbtMonitoringSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCbtMonitoringSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCbtMonitoringSessionsQuery({
 *   testId: // value for 'testId'
 *   status: // value for 'status'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useListCbtMonitoringSessionsQuery(variables: Types.ListCbtMonitoringSessionsQueryVariables | VueCompositionApi.Ref<Types.ListCbtMonitoringSessionsQueryVariables> | ReactiveFunction<Types.ListCbtMonitoringSessionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>(ListCbtMonitoringSessionsDocument, variables, options);
}
export function useListCbtMonitoringSessionsLazyQuery(variables: Types.ListCbtMonitoringSessionsQueryVariables | VueCompositionApi.Ref<Types.ListCbtMonitoringSessionsQueryVariables> | ReactiveFunction<Types.ListCbtMonitoringSessionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>(ListCbtMonitoringSessionsDocument, variables, options);
}
export type ListCbtMonitoringSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListCbtMonitoringSessionsQuery, Types.ListCbtMonitoringSessionsQueryVariables>;
export const CbtMonitoringSessionDetailDocument = gql`
    query CbtMonitoringSessionDetail($id: ID!) {
  cbtMonitoringSession(id: $id) {
    ...MonitoringSessionParts
    events {
      ...MonitoringEventParts
    }
    recordings {
      ...MonitoringRecordingParts
    }
  }
}
    ${MonitoringSessionPartsFragmentDoc}
${MonitoringEventPartsFragmentDoc}
${MonitoringRecordingPartsFragmentDoc}`;

/**
 * __useCbtMonitoringSessionDetailQuery__
 *
 * To run a query within a Vue component, call `useCbtMonitoringSessionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbtMonitoringSessionDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCbtMonitoringSessionDetailQuery({
 *   id: // value for 'id'
 * });
 */
export function useCbtMonitoringSessionDetailQuery(variables: Types.CbtMonitoringSessionDetailQueryVariables | VueCompositionApi.Ref<Types.CbtMonitoringSessionDetailQueryVariables> | ReactiveFunction<Types.CbtMonitoringSessionDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>(CbtMonitoringSessionDetailDocument, variables, options);
}
export function useCbtMonitoringSessionDetailLazyQuery(variables?: Types.CbtMonitoringSessionDetailQueryVariables | VueCompositionApi.Ref<Types.CbtMonitoringSessionDetailQueryVariables> | ReactiveFunction<Types.CbtMonitoringSessionDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>(CbtMonitoringSessionDetailDocument, variables, options);
}
export type CbtMonitoringSessionDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CbtMonitoringSessionDetailQuery, Types.CbtMonitoringSessionDetailQueryVariables>;
export const CbtRecordingDownloadUrlDocument = gql`
    query CbtRecordingDownloadUrl($id: ID!) {
  cbtRecordingDownloadUrl(id: $id) {
    url
    expires_at
  }
}
    `;

/**
 * __useCbtRecordingDownloadUrlQuery__
 *
 * To run a query within a Vue component, call `useCbtRecordingDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCbtRecordingDownloadUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCbtRecordingDownloadUrlQuery({
 *   id: // value for 'id'
 * });
 */
export function useCbtRecordingDownloadUrlQuery(variables: Types.CbtRecordingDownloadUrlQueryVariables | VueCompositionApi.Ref<Types.CbtRecordingDownloadUrlQueryVariables> | ReactiveFunction<Types.CbtRecordingDownloadUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>(CbtRecordingDownloadUrlDocument, variables, options);
}
export function useCbtRecordingDownloadUrlLazyQuery(variables?: Types.CbtRecordingDownloadUrlQueryVariables | VueCompositionApi.Ref<Types.CbtRecordingDownloadUrlQueryVariables> | ReactiveFunction<Types.CbtRecordingDownloadUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>(CbtRecordingDownloadUrlDocument, variables, options);
}
export type CbtRecordingDownloadUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CbtRecordingDownloadUrlQuery, Types.CbtRecordingDownloadUrlQueryVariables>;
export const SchoolFeaturesForMonitoringDocument = gql`
    query SchoolFeaturesForMonitoring {
  schoolFeatures {
    code
    name
    enabled
    source
  }
}
    `;

/**
 * __useSchoolFeaturesForMonitoringQuery__
 *
 * To run a query within a Vue component, call `useSchoolFeaturesForMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolFeaturesForMonitoringQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolFeaturesForMonitoringQuery();
 */
export function useSchoolFeaturesForMonitoringQuery(options: VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>(SchoolFeaturesForMonitoringDocument, {}, options);
}
export function useSchoolFeaturesForMonitoringLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>(SchoolFeaturesForMonitoringDocument, {}, options);
}
export type SchoolFeaturesForMonitoringQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchoolFeaturesForMonitoringQuery, Types.SchoolFeaturesForMonitoringQueryVariables>;
export const AdmissionLetterTemplatesDocument = gql`
    query AdmissionLetterTemplates {
  admissionLetterTemplates {
    ...AdmissionLetterTemplateFields
  }
}
    ${AdmissionLetterTemplateFieldsFragmentDoc}`;

/**
 * __useAdmissionLetterTemplatesQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterTemplatesQuery();
 */
export function useAdmissionLetterTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>(AdmissionLetterTemplatesDocument, {}, options);
}
export function useAdmissionLetterTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>(AdmissionLetterTemplatesDocument, {}, options);
}
export type AdmissionLetterTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterTemplatesQuery, Types.AdmissionLetterTemplatesQueryVariables>;
export const AdmissionLetterPresetsDocument = gql`
    query AdmissionLetterPresets {
  admissionLetterPresets {
    id
    name
    layout
    show_logo
    show_qr_code
    letter_title
    header_text
    body
    footer_text
    conditions
    signatures {
      name
      title
      detail
    }
    details {
      label
      value
      full_width
    }
    sections {
      type
      heading
      text
      height_mm
    }
    design {
      ...AdmissionLetterDesignFields
    }
  }
}
    ${AdmissionLetterDesignFieldsFragmentDoc}`;

/**
 * __useAdmissionLetterPresetsQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterPresetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterPresetsQuery();
 */
export function useAdmissionLetterPresetsQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>(AdmissionLetterPresetsDocument, {}, options);
}
export function useAdmissionLetterPresetsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>(AdmissionLetterPresetsDocument, {}, options);
}
export type AdmissionLetterPresetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterPresetsQuery, Types.AdmissionLetterPresetsQueryVariables>;
export const AdmissionLetterSettingsDocument = gql`
    query AdmissionLetterSettings {
  admissionLetterSettings {
    auto_send
    auto_revoke
    ai_match_available
  }
}
    `;

/**
 * __useAdmissionLetterSettingsQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterSettingsQuery();
 */
export function useAdmissionLetterSettingsQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>(AdmissionLetterSettingsDocument, {}, options);
}
export function useAdmissionLetterSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>(AdmissionLetterSettingsDocument, {}, options);
}
export type AdmissionLetterSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterSettingsQuery, Types.AdmissionLetterSettingsQueryVariables>;
export const AdmissionLetterAssignmentsDocument = gql`
    query AdmissionLetterAssignments {
  admissionLetterAssignments {
    forms {
      id
      name
      template_id
    }
    programmes {
      id
      name
      template_id
    }
  }
}
    `;

/**
 * __useAdmissionLetterAssignmentsQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterAssignmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterAssignmentsQuery();
 */
export function useAdmissionLetterAssignmentsQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>(AdmissionLetterAssignmentsDocument, {}, options);
}
export function useAdmissionLetterAssignmentsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>(AdmissionLetterAssignmentsDocument, {}, options);
}
export type AdmissionLetterAssignmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterAssignmentsQuery, Types.AdmissionLetterAssignmentsQueryVariables>;
export const AdmissionLetterHistoryDocument = gql`
    query AdmissionLetterHistory($submission_id: ID!) {
  admissionLetterHistory(submission_id: $submission_id) {
    id
    revision
    status
    created_at
    revoked_at
    revocation_reason
  }
}
    `;

/**
 * __useAdmissionLetterHistoryQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterHistoryQuery({
 *   submission_id: // value for 'submission_id'
 * });
 */
export function useAdmissionLetterHistoryQuery(variables: Types.AdmissionLetterHistoryQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterHistoryQueryVariables> | ReactiveFunction<Types.AdmissionLetterHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>(AdmissionLetterHistoryDocument, variables, options);
}
export function useAdmissionLetterHistoryLazyQuery(variables?: Types.AdmissionLetterHistoryQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterHistoryQueryVariables> | ReactiveFunction<Types.AdmissionLetterHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>(AdmissionLetterHistoryDocument, variables, options);
}
export type AdmissionLetterHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterHistoryQuery, Types.AdmissionLetterHistoryQueryVariables>;
export const AdmissionLetterExportPreviewDocument = gql`
    query AdmissionLetterExportPreview($submission_ids: [ID!]!) {
  admissionLetterExportPreview(submission_ids: $submission_ids) {
    id
    name
    reference
    state
    reason
  }
}
    `;

/**
 * __useAdmissionLetterExportPreviewQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterExportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterExportPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterExportPreviewQuery({
 *   submission_ids: // value for 'submission_ids'
 * });
 */
export function useAdmissionLetterExportPreviewQuery(variables: Types.AdmissionLetterExportPreviewQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterExportPreviewQueryVariables> | ReactiveFunction<Types.AdmissionLetterExportPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>(AdmissionLetterExportPreviewDocument, variables, options);
}
export function useAdmissionLetterExportPreviewLazyQuery(variables?: Types.AdmissionLetterExportPreviewQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterExportPreviewQueryVariables> | ReactiveFunction<Types.AdmissionLetterExportPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>(AdmissionLetterExportPreviewDocument, variables, options);
}
export type AdmissionLetterExportPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterExportPreviewQuery, Types.AdmissionLetterExportPreviewQueryVariables>;
export const ApprovalLetterPreviewDocument = gql`
    query ApprovalLetterPreview($id: ID!) {
  formSubmission(id: $id) {
    id
    approval_letter_preview {
      final_approval
      issues_letter
      emails_letter
      waits_for_matric_no
      email
      programme
      programme_source
    }
  }
}
    `;

/**
 * __useApprovalLetterPreviewQuery__
 *
 * To run a query within a Vue component, call `useApprovalLetterPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalLetterPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useApprovalLetterPreviewQuery({
 *   id: // value for 'id'
 * });
 */
export function useApprovalLetterPreviewQuery(variables: Types.ApprovalLetterPreviewQueryVariables | VueCompositionApi.Ref<Types.ApprovalLetterPreviewQueryVariables> | ReactiveFunction<Types.ApprovalLetterPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>(ApprovalLetterPreviewDocument, variables, options);
}
export function useApprovalLetterPreviewLazyQuery(variables?: Types.ApprovalLetterPreviewQueryVariables | VueCompositionApi.Ref<Types.ApprovalLetterPreviewQueryVariables> | ReactiveFunction<Types.ApprovalLetterPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>(ApprovalLetterPreviewDocument, variables, options);
}
export type ApprovalLetterPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ApprovalLetterPreviewQuery, Types.ApprovalLetterPreviewQueryVariables>;
export const AdmissionLetterStatusDocument = gql`
    query AdmissionLetterStatus($id: ID!) {
  formSubmission(id: $id) {
    ...AdmissionLetterStatusFields
  }
}
    ${AdmissionLetterStatusFieldsFragmentDoc}`;

/**
 * __useAdmissionLetterStatusQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterStatusQuery({
 *   id: // value for 'id'
 * });
 */
export function useAdmissionLetterStatusQuery(variables: Types.AdmissionLetterStatusQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterStatusQueryVariables> | ReactiveFunction<Types.AdmissionLetterStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>(AdmissionLetterStatusDocument, variables, options);
}
export function useAdmissionLetterStatusLazyQuery(variables?: Types.AdmissionLetterStatusQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterStatusQueryVariables> | ReactiveFunction<Types.AdmissionLetterStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>(AdmissionLetterStatusDocument, variables, options);
}
export type AdmissionLetterStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterStatusQuery, Types.AdmissionLetterStatusQueryVariables>;
export const SaveAdmissionLetterTemplateDocument = gql`
    mutation SaveAdmissionLetterTemplate($id: ID, $name: String!, $layout: AdmissionLetterLayout, $show_logo: Boolean, $show_qr_code: Boolean, $header_text: String, $letter_title: String, $body: String!, $conditions: [String!], $signatures: [AdmissionLetterSignatureInput!], $details: [AdmissionLetterDetailInput!], $sections: [AdmissionLetterSectionInput!], $footer_text: String, $resumption_date: Date, $is_default: Boolean, $design: AdmissionLetterDesignInput) {
  saveAdmissionLetterTemplate(
    id: $id
    name: $name
    layout: $layout
    show_logo: $show_logo
    show_qr_code: $show_qr_code
    header_text: $header_text
    letter_title: $letter_title
    body: $body
    conditions: $conditions
    signatures: $signatures
    details: $details
    sections: $sections
    footer_text: $footer_text
    resumption_date: $resumption_date
    is_default: $is_default
    design: $design
  ) {
    ...AdmissionLetterTemplateFields
  }
}
    ${AdmissionLetterTemplateFieldsFragmentDoc}`;

/**
 * __useSaveAdmissionLetterTemplateMutation__
 *
 * To run a mutation, you first call `useSaveAdmissionLetterTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdmissionLetterTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveAdmissionLetterTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     layout: // value for 'layout'
 *     show_logo: // value for 'show_logo'
 *     show_qr_code: // value for 'show_qr_code'
 *     header_text: // value for 'header_text'
 *     letter_title: // value for 'letter_title'
 *     body: // value for 'body'
 *     conditions: // value for 'conditions'
 *     signatures: // value for 'signatures'
 *     details: // value for 'details'
 *     sections: // value for 'sections'
 *     footer_text: // value for 'footer_text'
 *     resumption_date: // value for 'resumption_date'
 *     is_default: // value for 'is_default'
 *     design: // value for 'design'
 *   },
 * });
 */
export function useSaveAdmissionLetterTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.SaveAdmissionLetterTemplateMutation, Types.SaveAdmissionLetterTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SaveAdmissionLetterTemplateMutation, Types.SaveAdmissionLetterTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SaveAdmissionLetterTemplateMutation, Types.SaveAdmissionLetterTemplateMutationVariables>(SaveAdmissionLetterTemplateDocument, options);
}
export type SaveAdmissionLetterTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SaveAdmissionLetterTemplateMutation, Types.SaveAdmissionLetterTemplateMutationVariables>;
export const DeleteAdmissionLetterTemplateDocument = gql`
    mutation DeleteAdmissionLetterTemplate($id: ID!) {
  deleteAdmissionLetterTemplate(id: $id)
}
    `;

/**
 * __useDeleteAdmissionLetterTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteAdmissionLetterTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdmissionLetterTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAdmissionLetterTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdmissionLetterTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteAdmissionLetterTemplateMutation, Types.DeleteAdmissionLetterTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteAdmissionLetterTemplateMutation, Types.DeleteAdmissionLetterTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteAdmissionLetterTemplateMutation, Types.DeleteAdmissionLetterTemplateMutationVariables>(DeleteAdmissionLetterTemplateDocument, options);
}
export type DeleteAdmissionLetterTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteAdmissionLetterTemplateMutation, Types.DeleteAdmissionLetterTemplateMutationVariables>;
export const PreviewAdmissionLetterTemplateDocument = gql`
    mutation PreviewAdmissionLetterTemplate($input: AdmissionLetterPreviewInput!, $letterhead: Upload) {
  previewAdmissionLetterTemplate(input: $input, letterhead: $letterhead)
}
    `;

/**
 * __usePreviewAdmissionLetterTemplateMutation__
 *
 * To run a mutation, you first call `usePreviewAdmissionLetterTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewAdmissionLetterTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewAdmissionLetterTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *     letterhead: // value for 'letterhead'
 *   },
 * });
 */
export function usePreviewAdmissionLetterTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.PreviewAdmissionLetterTemplateMutation, Types.PreviewAdmissionLetterTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PreviewAdmissionLetterTemplateMutation, Types.PreviewAdmissionLetterTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PreviewAdmissionLetterTemplateMutation, Types.PreviewAdmissionLetterTemplateMutationVariables>(PreviewAdmissionLetterTemplateDocument, options);
}
export type PreviewAdmissionLetterTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PreviewAdmissionLetterTemplateMutation, Types.PreviewAdmissionLetterTemplateMutationVariables>;
export const UpdateAdmissionLetterSettingsDocument = gql`
    mutation UpdateAdmissionLetterSettings($auto_send: Boolean!, $auto_revoke: Boolean!) {
  updateAdmissionLetterSettings(auto_send: $auto_send, auto_revoke: $auto_revoke) {
    auto_send
    auto_revoke
  }
}
    `;

/**
 * __useUpdateAdmissionLetterSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateAdmissionLetterSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdmissionLetterSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAdmissionLetterSettingsMutation({
 *   variables: {
 *     auto_send: // value for 'auto_send'
 *     auto_revoke: // value for 'auto_revoke'
 *   },
 * });
 */
export function useUpdateAdmissionLetterSettingsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateAdmissionLetterSettingsMutation, Types.UpdateAdmissionLetterSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateAdmissionLetterSettingsMutation, Types.UpdateAdmissionLetterSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateAdmissionLetterSettingsMutation, Types.UpdateAdmissionLetterSettingsMutationVariables>(UpdateAdmissionLetterSettingsDocument, options);
}
export type UpdateAdmissionLetterSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateAdmissionLetterSettingsMutation, Types.UpdateAdmissionLetterSettingsMutationVariables>;
export const AssignAdmissionLetterTemplateDocument = gql`
    mutation AssignAdmissionLetterTemplate($template_id: ID, $form_id: ID, $programme_id: ID) {
  assignAdmissionLetterTemplate(
    template_id: $template_id
    form_id: $form_id
    programme_id: $programme_id
  )
}
    `;

/**
 * __useAssignAdmissionLetterTemplateMutation__
 *
 * To run a mutation, you first call `useAssignAdmissionLetterTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignAdmissionLetterTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignAdmissionLetterTemplateMutation({
 *   variables: {
 *     template_id: // value for 'template_id'
 *     form_id: // value for 'form_id'
 *     programme_id: // value for 'programme_id'
 *   },
 * });
 */
export function useAssignAdmissionLetterTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignAdmissionLetterTemplateMutation, Types.AssignAdmissionLetterTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignAdmissionLetterTemplateMutation, Types.AssignAdmissionLetterTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignAdmissionLetterTemplateMutation, Types.AssignAdmissionLetterTemplateMutationVariables>(AssignAdmissionLetterTemplateDocument, options);
}
export type AssignAdmissionLetterTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignAdmissionLetterTemplateMutation, Types.AssignAdmissionLetterTemplateMutationVariables>;
export const UploadAdmissionLetterWatermarkDocument = gql`
    mutation UploadAdmissionLetterWatermark($id: ID!, $image: Upload!) {
  uploadAdmissionLetterWatermark(id: $id, image: $image) {
    ...AdmissionLetterTemplateFields
  }
}
    ${AdmissionLetterTemplateFieldsFragmentDoc}`;

/**
 * __useUploadAdmissionLetterWatermarkMutation__
 *
 * To run a mutation, you first call `useUploadAdmissionLetterWatermarkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdmissionLetterWatermarkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadAdmissionLetterWatermarkMutation({
 *   variables: {
 *     id: // value for 'id'
 *     image: // value for 'image'
 *   },
 * });
 */
export function useUploadAdmissionLetterWatermarkMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterWatermarkMutation, Types.UploadAdmissionLetterWatermarkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterWatermarkMutation, Types.UploadAdmissionLetterWatermarkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadAdmissionLetterWatermarkMutation, Types.UploadAdmissionLetterWatermarkMutationVariables>(UploadAdmissionLetterWatermarkDocument, options);
}
export type UploadAdmissionLetterWatermarkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadAdmissionLetterWatermarkMutation, Types.UploadAdmissionLetterWatermarkMutationVariables>;
export const MatchAdmissionLetterDocument = gql`
    mutation MatchAdmissionLetter($text: String!, $preset_id: ID) {
  matchAdmissionLetter(text: $text, preset_id: $preset_id) {
    id
    name
    layout
    show_logo
    show_qr_code
    letter_title
    header_text
    body
    footer_text
    conditions
    signatures {
      name
      title
      detail
    }
    details {
      label
      value
      full_width
    }
    sections {
      type
      heading
      text
      height_mm
    }
    design {
      ...AdmissionLetterDesignFields
    }
  }
}
    ${AdmissionLetterDesignFieldsFragmentDoc}`;

/**
 * __useMatchAdmissionLetterMutation__
 *
 * To run a mutation, you first call `useMatchAdmissionLetterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMatchAdmissionLetterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMatchAdmissionLetterMutation({
 *   variables: {
 *     text: // value for 'text'
 *     preset_id: // value for 'preset_id'
 *   },
 * });
 */
export function useMatchAdmissionLetterMutation(options: VueApolloComposable.UseMutationOptions<Types.MatchAdmissionLetterMutation, Types.MatchAdmissionLetterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MatchAdmissionLetterMutation, Types.MatchAdmissionLetterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MatchAdmissionLetterMutation, Types.MatchAdmissionLetterMutationVariables>(MatchAdmissionLetterDocument, options);
}
export type MatchAdmissionLetterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MatchAdmissionLetterMutation, Types.MatchAdmissionLetterMutationVariables>;
export const UploadAdmissionLetterLetterheadDocument = gql`
    mutation UploadAdmissionLetterLetterhead($id: ID!, $image: Upload!) {
  uploadAdmissionLetterLetterhead(id: $id, image: $image) {
    ...AdmissionLetterTemplateFields
  }
}
    ${AdmissionLetterTemplateFieldsFragmentDoc}`;

/**
 * __useUploadAdmissionLetterLetterheadMutation__
 *
 * To run a mutation, you first call `useUploadAdmissionLetterLetterheadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdmissionLetterLetterheadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadAdmissionLetterLetterheadMutation({
 *   variables: {
 *     id: // value for 'id'
 *     image: // value for 'image'
 *   },
 * });
 */
export function useUploadAdmissionLetterLetterheadMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterLetterheadMutation, Types.UploadAdmissionLetterLetterheadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterLetterheadMutation, Types.UploadAdmissionLetterLetterheadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadAdmissionLetterLetterheadMutation, Types.UploadAdmissionLetterLetterheadMutationVariables>(UploadAdmissionLetterLetterheadDocument, options);
}
export type UploadAdmissionLetterLetterheadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadAdmissionLetterLetterheadMutation, Types.UploadAdmissionLetterLetterheadMutationVariables>;
export const AdmissionLetterSignatureImagesDocument = gql`
    query AdmissionLetterSignatureImages($ids: [ID!]!) {
  admissionLetterSignatureImages(ids: $ids) {
    id
    image
  }
}
    `;

/**
 * __useAdmissionLetterSignatureImagesQuery__
 *
 * To run a query within a Vue component, call `useAdmissionLetterSignatureImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdmissionLetterSignatureImagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdmissionLetterSignatureImagesQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useAdmissionLetterSignatureImagesQuery(variables: Types.AdmissionLetterSignatureImagesQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterSignatureImagesQueryVariables> | ReactiveFunction<Types.AdmissionLetterSignatureImagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>(AdmissionLetterSignatureImagesDocument, variables, options);
}
export function useAdmissionLetterSignatureImagesLazyQuery(variables?: Types.AdmissionLetterSignatureImagesQueryVariables | VueCompositionApi.Ref<Types.AdmissionLetterSignatureImagesQueryVariables> | ReactiveFunction<Types.AdmissionLetterSignatureImagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>(AdmissionLetterSignatureImagesDocument, variables, options);
}
export type AdmissionLetterSignatureImagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AdmissionLetterSignatureImagesQuery, Types.AdmissionLetterSignatureImagesQueryVariables>;
export const UploadAdmissionLetterSignatureDocument = gql`
    mutation UploadAdmissionLetterSignature($image: Upload!, $source: AdmissionLetterSignatureSource!) {
  uploadAdmissionLetterSignature(image: $image, source: $source) {
    id
    source
    width
    height
    image
  }
}
    `;

/**
 * __useUploadAdmissionLetterSignatureMutation__
 *
 * To run a mutation, you first call `useUploadAdmissionLetterSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadAdmissionLetterSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadAdmissionLetterSignatureMutation({
 *   variables: {
 *     image: // value for 'image'
 *     source: // value for 'source'
 *   },
 * });
 */
export function useUploadAdmissionLetterSignatureMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterSignatureMutation, Types.UploadAdmissionLetterSignatureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadAdmissionLetterSignatureMutation, Types.UploadAdmissionLetterSignatureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadAdmissionLetterSignatureMutation, Types.UploadAdmissionLetterSignatureMutationVariables>(UploadAdmissionLetterSignatureDocument, options);
}
export type UploadAdmissionLetterSignatureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadAdmissionLetterSignatureMutation, Types.UploadAdmissionLetterSignatureMutationVariables>;
export const RemoveAdmissionLetterLetterheadDocument = gql`
    mutation RemoveAdmissionLetterLetterhead($id: ID!) {
  removeAdmissionLetterLetterhead(id: $id) {
    ...AdmissionLetterTemplateFields
  }
}
    ${AdmissionLetterTemplateFieldsFragmentDoc}`;

/**
 * __useRemoveAdmissionLetterLetterheadMutation__
 *
 * To run a mutation, you first call `useRemoveAdmissionLetterLetterheadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdmissionLetterLetterheadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveAdmissionLetterLetterheadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAdmissionLetterLetterheadMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveAdmissionLetterLetterheadMutation, Types.RemoveAdmissionLetterLetterheadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveAdmissionLetterLetterheadMutation, Types.RemoveAdmissionLetterLetterheadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveAdmissionLetterLetterheadMutation, Types.RemoveAdmissionLetterLetterheadMutationVariables>(RemoveAdmissionLetterLetterheadDocument, options);
}
export type RemoveAdmissionLetterLetterheadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveAdmissionLetterLetterheadMutation, Types.RemoveAdmissionLetterLetterheadMutationVariables>;
export const SendAdmissionLetterDocument = gql`
    mutation SendAdmissionLetter($submission_id: ID!) {
  sendAdmissionLetter(submission_id: $submission_id) {
    ...AdmissionLetterStatusFields
  }
}
    ${AdmissionLetterStatusFieldsFragmentDoc}`;

/**
 * __useSendAdmissionLetterMutation__
 *
 * To run a mutation, you first call `useSendAdmissionLetterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendAdmissionLetterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendAdmissionLetterMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *   },
 * });
 */
export function useSendAdmissionLetterMutation(options: VueApolloComposable.UseMutationOptions<Types.SendAdmissionLetterMutation, Types.SendAdmissionLetterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SendAdmissionLetterMutation, Types.SendAdmissionLetterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SendAdmissionLetterMutation, Types.SendAdmissionLetterMutationVariables>(SendAdmissionLetterDocument, options);
}
export type SendAdmissionLetterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SendAdmissionLetterMutation, Types.SendAdmissionLetterMutationVariables>;
export const RegenerateAdmissionLetterDocument = gql`
    mutation RegenerateAdmissionLetter($submission_id: ID!) {
  regenerateAdmissionLetter(submission_id: $submission_id) {
    ...AdmissionLetterStatusFields
  }
}
    ${AdmissionLetterStatusFieldsFragmentDoc}`;

/**
 * __useRegenerateAdmissionLetterMutation__
 *
 * To run a mutation, you first call `useRegenerateAdmissionLetterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAdmissionLetterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegenerateAdmissionLetterMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *   },
 * });
 */
export function useRegenerateAdmissionLetterMutation(options: VueApolloComposable.UseMutationOptions<Types.RegenerateAdmissionLetterMutation, Types.RegenerateAdmissionLetterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RegenerateAdmissionLetterMutation, Types.RegenerateAdmissionLetterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RegenerateAdmissionLetterMutation, Types.RegenerateAdmissionLetterMutationVariables>(RegenerateAdmissionLetterDocument, options);
}
export type RegenerateAdmissionLetterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RegenerateAdmissionLetterMutation, Types.RegenerateAdmissionLetterMutationVariables>;
export const ExportAdmissionLettersDocument = gql`
    mutation ExportAdmissionLetters($submission_ids: [ID!]!, $generate_missing: Boolean!) {
  exportAdmissionLetters(
    submission_ids: $submission_ids
    generate_missing: $generate_missing
  ) {
    id
    status
  }
}
    `;

/**
 * __useExportAdmissionLettersMutation__
 *
 * To run a mutation, you first call `useExportAdmissionLettersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportAdmissionLettersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportAdmissionLettersMutation({
 *   variables: {
 *     submission_ids: // value for 'submission_ids'
 *     generate_missing: // value for 'generate_missing'
 *   },
 * });
 */
export function useExportAdmissionLettersMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportAdmissionLettersMutation, Types.ExportAdmissionLettersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportAdmissionLettersMutation, Types.ExportAdmissionLettersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportAdmissionLettersMutation, Types.ExportAdmissionLettersMutationVariables>(ExportAdmissionLettersDocument, options);
}
export type ExportAdmissionLettersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportAdmissionLettersMutation, Types.ExportAdmissionLettersMutationVariables>;
export const SaveDraftDocument = gql`
    mutation SaveDraft($slug: String!, $data: JSON!, $tracking_code: String, $token: String, $references: [ReferenceNominationInput!], $applicant_email: String) {
  saveDraft(
    slug: $slug
    data: $data
    tracking_code: $tracking_code
    token: $token
    references: $references
    applicant_email: $applicant_email
  ) {
    id
    status
    current_stage
    tracking_code
    applicant_email
    submitted_at
  }
}
    `;

/**
 * __useSaveDraftMutation__
 *
 * To run a mutation, you first call `useSaveDraftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveDraftMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     data: // value for 'data'
 *     tracking_code: // value for 'tracking_code'
 *     token: // value for 'token'
 *     references: // value for 'references'
 *     applicant_email: // value for 'applicant_email'
 *   },
 * });
 */
export function useSaveDraftMutation(options: VueApolloComposable.UseMutationOptions<Types.SaveDraftMutation, Types.SaveDraftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SaveDraftMutation, Types.SaveDraftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SaveDraftMutation, Types.SaveDraftMutationVariables>(SaveDraftDocument, options);
}
export type SaveDraftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SaveDraftMutation, Types.SaveDraftMutationVariables>;
export const SubmitStageDocument = gql`
    mutation SubmitStage($tracking_code: String!, $token: String!, $waiver_code: String, $email_verification_token: String) {
  submitStage(
    tracking_code: $tracking_code
    token: $token
    waiver_code: $waiver_code
    email_verification_token: $email_verification_token
  ) {
    id
    status
    current_stage
    tracking_code
    submitted_at
    pdf_url
    payment_waived_at
    bill {
      id
      amount
      status
      billable_id
      billable_type
      billDetails {
        id
        amount
      }
    }
  }
}
    `;

/**
 * __useSubmitStageMutation__
 *
 * To run a mutation, you first call `useSubmitStageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitStageMutation({
 *   variables: {
 *     tracking_code: // value for 'tracking_code'
 *     token: // value for 'token'
 *     waiver_code: // value for 'waiver_code'
 *     email_verification_token: // value for 'email_verification_token'
 *   },
 * });
 */
export function useSubmitStageMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitStageMutation, Types.SubmitStageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitStageMutation, Types.SubmitStageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitStageMutation, Types.SubmitStageMutationVariables>(SubmitStageDocument, options);
}
export type SubmitStageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitStageMutation, Types.SubmitStageMutationVariables>;
export const GetFormBillItemsDocument = gql`
    query GetFormBillItems {
  billItemTemplates {
    id
    name
    default_amount
  }
}
    `;

/**
 * __useGetFormBillItemsQuery__
 *
 * To run a query within a Vue component, call `useGetFormBillItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormBillItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFormBillItemsQuery();
 */
export function useGetFormBillItemsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>(GetFormBillItemsDocument, {}, options);
}
export function useGetFormBillItemsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>(GetFormBillItemsDocument, {}, options);
}
export type GetFormBillItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFormBillItemsQuery, Types.GetFormBillItemsQueryVariables>;
export const GetSchoolPaymentProviderDocument = gql`
    query GetSchoolPaymentProvider($slug: String!) {
  publicPaymentProvider(form_slug: $slug) {
    name
    is_active
    publicKey
  }
}
    `;

/**
 * __useGetSchoolPaymentProviderQuery__
 *
 * To run a query within a Vue component, call `useGetSchoolPaymentProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolPaymentProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchoolPaymentProviderQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useGetSchoolPaymentProviderQuery(variables: Types.GetSchoolPaymentProviderQueryVariables | VueCompositionApi.Ref<Types.GetSchoolPaymentProviderQueryVariables> | ReactiveFunction<Types.GetSchoolPaymentProviderQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>(GetSchoolPaymentProviderDocument, variables, options);
}
export function useGetSchoolPaymentProviderLazyQuery(variables?: Types.GetSchoolPaymentProviderQueryVariables | VueCompositionApi.Ref<Types.GetSchoolPaymentProviderQueryVariables> | ReactiveFunction<Types.GetSchoolPaymentProviderQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>(GetSchoolPaymentProviderDocument, variables, options);
}
export type GetSchoolPaymentProviderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSchoolPaymentProviderQuery, Types.GetSchoolPaymentProviderQueryVariables>;
export const ListFormsDocument = gql`
    query ListForms {
  forms {
    id
    title
    slug
    public_url
    is_active
    is_public
    form_type
    created_at
    submissions(first: 1) {
      paginatorInfo {
        total
      }
    }
  }
}
    `;

/**
 * __useListFormsQuery__
 *
 * To run a query within a Vue component, call `useListFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListFormsQuery();
 */
export function useListFormsQuery(options: VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListFormsQuery, Types.ListFormsQueryVariables>(ListFormsDocument, {}, options);
}
export function useListFormsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListFormsQuery, Types.ListFormsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListFormsQuery, Types.ListFormsQueryVariables>(ListFormsDocument, {}, options);
}
export type ListFormsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListFormsQuery, Types.ListFormsQueryVariables>;
export const GetFormDetailsDocument = gql`
    query GetFormDetails($id: ID!) {
  form(id: $id) {
    ...FormFragment
    fields {
      ...FormFieldFragment
    }
    publicOptions {
      classroomSections {
        id
        label
      }
      programmes {
        id
        program_name
      }
      dataSources {
        source
        options {
          id
          label
        }
      }
    }
  }
}
    ${FormFragmentDoc}
${FormFieldFragmentDoc}`;

/**
 * __useGetFormDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetFormDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFormDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFormDetailsQuery(variables: Types.GetFormDetailsQueryVariables | VueCompositionApi.Ref<Types.GetFormDetailsQueryVariables> | ReactiveFunction<Types.GetFormDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>(GetFormDetailsDocument, variables, options);
}
export function useGetFormDetailsLazyQuery(variables?: Types.GetFormDetailsQueryVariables | VueCompositionApi.Ref<Types.GetFormDetailsQueryVariables> | ReactiveFunction<Types.GetFormDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>(GetFormDetailsDocument, variables, options);
}
export type GetFormDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFormDetailsQuery, Types.GetFormDetailsQueryVariables>;
export const GetFormDetailsWithCountsDocument = gql`
    query GetFormDetailsWithCounts($id: ID!) {
  form(id: $id) {
    ...FormFragment
    fields {
      ...FormFieldFragment
    }
    publicOptions {
      classroomSections {
        id
        label
      }
      programmes {
        id
        program_name
      }
      dataSources {
        source
        options {
          id
          label
        }
      }
    }
    submissionCounts {
      total
      draft
      pending
      approved
      rejected
      converted
    }
  }
}
    ${FormFragmentDoc}
${FormFieldFragmentDoc}`;

/**
 * __useGetFormDetailsWithCountsQuery__
 *
 * To run a query within a Vue component, call `useGetFormDetailsWithCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormDetailsWithCountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFormDetailsWithCountsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetFormDetailsWithCountsQuery(variables: Types.GetFormDetailsWithCountsQueryVariables | VueCompositionApi.Ref<Types.GetFormDetailsWithCountsQueryVariables> | ReactiveFunction<Types.GetFormDetailsWithCountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>(GetFormDetailsWithCountsDocument, variables, options);
}
export function useGetFormDetailsWithCountsLazyQuery(variables?: Types.GetFormDetailsWithCountsQueryVariables | VueCompositionApi.Ref<Types.GetFormDetailsWithCountsQueryVariables> | ReactiveFunction<Types.GetFormDetailsWithCountsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>(GetFormDetailsWithCountsDocument, variables, options);
}
export type GetFormDetailsWithCountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFormDetailsWithCountsQuery, Types.GetFormDetailsWithCountsQueryVariables>;
export const ListFormSubmissionsDocument = gql`
    query ListFormSubmissions($form_id: ID!, $page: Int, $first: Int, $status: FormSubmissionStatus, $search: String, $assigned_to_me: Boolean, $assignment: SubmissionAssignmentFilter) {
  formSubmissions(
    form_id: $form_id
    page: $page
    first: $first
    status: $status
    search: $search
    assigned_to_me: $assigned_to_me
    assignment: $assignment
  ) {
    data {
      id
      data
      resolved_answers {
        field_name
        field_label
        field_type
        display
        raw
      }
      files {
        field_name
        original_name
        url
      }
      status
      tracking_code
      applicant_email
      review_note
      converted_student_id
      reviewed_at
      assigned_reviewer_at
      duplicate_of_submission_id
      duplicateOf {
        id
        tracking_code
        status
        created_at
      }
      awaiting_payment
      pdf_url
      payment_waived_at
      email_verified_at
      paymentWaivedBy {
        id
        name
      }
      waiverCode {
        id
        batch_label
        generatedBy {
          id
          name
        }
      }
      convertedStudent {
        id
        first_name
        surname
        matric_no
      }
      reviewedBy {
        id
        name
        email
      }
      assignedReviewer {
        id
        name
        email
      }
      created_at
      user {
        id
        email
        name
      }
    }
    paginatorInfo {
      total
      count
      perPage
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useListFormSubmissionsQuery__
 *
 * To run a query within a Vue component, call `useListFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormSubmissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListFormSubmissionsQuery({
 *   form_id: // value for 'form_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   status: // value for 'status'
 *   search: // value for 'search'
 *   assigned_to_me: // value for 'assigned_to_me'
 *   assignment: // value for 'assignment'
 * });
 */
export function useListFormSubmissionsQuery(variables: Types.ListFormSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ListFormSubmissionsQueryVariables> | ReactiveFunction<Types.ListFormSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>(ListFormSubmissionsDocument, variables, options);
}
export function useListFormSubmissionsLazyQuery(variables?: Types.ListFormSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ListFormSubmissionsQueryVariables> | ReactiveFunction<Types.ListFormSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>(ListFormSubmissionsDocument, variables, options);
}
export type ListFormSubmissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListFormSubmissionsQuery, Types.ListFormSubmissionsQueryVariables>;
export const ListSubmissionReferenceProgressDocument = gql`
    query ListSubmissionReferenceProgress($form_id: ID!, $page: Int, $first: Int, $status: FormSubmissionStatus, $search: String, $assigned_to_me: Boolean) {
  formSubmissions(
    form_id: $form_id
    page: $page
    first: $first
    status: $status
    search: $search
    assigned_to_me: $assigned_to_me
  ) {
    data {
      id
      reference_progress {
        total_required
        total_received
        complete
      }
    }
  }
}
    `;

/**
 * __useListSubmissionReferenceProgressQuery__
 *
 * To run a query within a Vue component, call `useListSubmissionReferenceProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubmissionReferenceProgressQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSubmissionReferenceProgressQuery({
 *   form_id: // value for 'form_id'
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   status: // value for 'status'
 *   search: // value for 'search'
 *   assigned_to_me: // value for 'assigned_to_me'
 * });
 */
export function useListSubmissionReferenceProgressQuery(variables: Types.ListSubmissionReferenceProgressQueryVariables | VueCompositionApi.Ref<Types.ListSubmissionReferenceProgressQueryVariables> | ReactiveFunction<Types.ListSubmissionReferenceProgressQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>(ListSubmissionReferenceProgressDocument, variables, options);
}
export function useListSubmissionReferenceProgressLazyQuery(variables?: Types.ListSubmissionReferenceProgressQueryVariables | VueCompositionApi.Ref<Types.ListSubmissionReferenceProgressQueryVariables> | ReactiveFunction<Types.ListSubmissionReferenceProgressQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>(ListSubmissionReferenceProgressDocument, variables, options);
}
export type ListSubmissionReferenceProgressQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSubmissionReferenceProgressQuery, Types.ListSubmissionReferenceProgressQueryVariables>;
export const GetSubmissionDetailsDocument = gql`
    query GetSubmissionDetails($id: ID!) {
  formSubmission(id: $id) {
    id
    data
    resolved_answers {
      field_name
      field_label
      field_type
      display
      raw
    }
    files {
      field_name
      field_label
      id
      original_name
      mime_type
      size
      url
      download_url
    }
    status
    reference_progress {
      total_required
      total_received
      complete
      requirements {
        key
        label
        required
        received
      }
    }
    referenceRequests {
      id
      requirement_key
      referee_name
      referee_email
      referee_phone
      referee_relationship
      status
      declined_reason
      reminder_count
      invited_at
      last_reminded_at
      submitted_at
      expires_at
      created_at
      answers {
        label
        value
      }
      pdf_url
    }
    tracking_code
    applicant_email
    review_note
    reviewed_at
    assigned_reviewer_at
    ip_address
    user_agent
    created_at
    duplicate_of_submission_id
    duplicateOf {
      id
      tracking_code
      status
      created_at
    }
    awaiting_payment
    pdf_url
    payment_waived_at
    paymentWaivedBy {
      id
      name
    }
    convertedStudent {
      id
      first_name
      surname
      matric_no
    }
    reviewedBy {
      id
      name
      email
    }
    assignedReviewer {
      id
      name
      email
    }
    user {
      id
      email
      name
    }
    bill {
      id
      amount
      status
    }
    activities {
      id
      type
      content
      old_status
      new_status
      is_visible_to_applicant
      metadata
      resolved_at
      is_editable
      created_at
      user {
        id
        name
      }
      attachments {
        id
        original_name
        mime_type
        size
        url
      }
    }
  }
}
    `;

/**
 * __useGetSubmissionDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetSubmissionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSubmissionDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetSubmissionDetailsQuery(variables: Types.GetSubmissionDetailsQueryVariables | VueCompositionApi.Ref<Types.GetSubmissionDetailsQueryVariables> | ReactiveFunction<Types.GetSubmissionDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>(GetSubmissionDetailsDocument, variables, options);
}
export function useGetSubmissionDetailsLazyQuery(variables?: Types.GetSubmissionDetailsQueryVariables | VueCompositionApi.Ref<Types.GetSubmissionDetailsQueryVariables> | ReactiveFunction<Types.GetSubmissionDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>(GetSubmissionDetailsDocument, variables, options);
}
export type GetSubmissionDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSubmissionDetailsQuery, Types.GetSubmissionDetailsQueryVariables>;
export const ExportApplicationPdfsDocument = gql`
    mutation ExportApplicationPdfs($submission_ids: [ID!]!) {
  exportApplicationPdfs(submission_ids: $submission_ids) {
    id
    status
    type
  }
}
    `;

/**
 * __useExportApplicationPdfsMutation__
 *
 * To run a mutation, you first call `useExportApplicationPdfsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportApplicationPdfsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportApplicationPdfsMutation({
 *   variables: {
 *     submission_ids: // value for 'submission_ids'
 *   },
 * });
 */
export function useExportApplicationPdfsMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportApplicationPdfsMutation, Types.ExportApplicationPdfsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportApplicationPdfsMutation, Types.ExportApplicationPdfsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportApplicationPdfsMutation, Types.ExportApplicationPdfsMutationVariables>(ExportApplicationPdfsDocument, options);
}
export type ExportApplicationPdfsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportApplicationPdfsMutation, Types.ExportApplicationPdfsMutationVariables>;
export const WaiveSubmissionPaymentDocument = gql`
    mutation WaiveSubmissionPayment($submission_id: ID!, $reason: String!) {
  waiveSubmissionPayment(submission_id: $submission_id, reason: $reason) {
    id
    awaiting_payment
    payment_waived_at
    paymentWaivedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useWaiveSubmissionPaymentMutation__
 *
 * To run a mutation, you first call `useWaiveSubmissionPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWaiveSubmissionPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWaiveSubmissionPaymentMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useWaiveSubmissionPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.WaiveSubmissionPaymentMutation, Types.WaiveSubmissionPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.WaiveSubmissionPaymentMutation, Types.WaiveSubmissionPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.WaiveSubmissionPaymentMutation, Types.WaiveSubmissionPaymentMutationVariables>(WaiveSubmissionPaymentDocument, options);
}
export type WaiveSubmissionPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.WaiveSubmissionPaymentMutation, Types.WaiveSubmissionPaymentMutationVariables>;
export const AssignSubmissionReviewerDocument = gql`
    mutation AssignSubmissionReviewer($submission_id: ID!, $user_id: ID) {
  assignSubmissionReviewer(submission_id: $submission_id, user_id: $user_id) {
    id
    assigned_reviewer_at
    assignedReviewer {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useAssignSubmissionReviewerMutation__
 *
 * To run a mutation, you first call `useAssignSubmissionReviewerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignSubmissionReviewerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignSubmissionReviewerMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     user_id: // value for 'user_id'
 *   },
 * });
 */
export function useAssignSubmissionReviewerMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignSubmissionReviewerMutation, Types.AssignSubmissionReviewerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignSubmissionReviewerMutation, Types.AssignSubmissionReviewerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignSubmissionReviewerMutation, Types.AssignSubmissionReviewerMutationVariables>(AssignSubmissionReviewerDocument, options);
}
export type AssignSubmissionReviewerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignSubmissionReviewerMutation, Types.AssignSubmissionReviewerMutationVariables>;
export const UnassignSubmissionReviewerDocument = gql`
    mutation UnassignSubmissionReviewer($submission_id: ID!) {
  unassignSubmissionReviewer(submission_id: $submission_id) {
    id
    assigned_reviewer_at
    assignedReviewer {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useUnassignSubmissionReviewerMutation__
 *
 * To run a mutation, you first call `useUnassignSubmissionReviewerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnassignSubmissionReviewerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnassignSubmissionReviewerMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *   },
 * });
 */
export function useUnassignSubmissionReviewerMutation(options: VueApolloComposable.UseMutationOptions<Types.UnassignSubmissionReviewerMutation, Types.UnassignSubmissionReviewerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UnassignSubmissionReviewerMutation, Types.UnassignSubmissionReviewerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UnassignSubmissionReviewerMutation, Types.UnassignSubmissionReviewerMutationVariables>(UnassignSubmissionReviewerDocument, options);
}
export type UnassignSubmissionReviewerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UnassignSubmissionReviewerMutation, Types.UnassignSubmissionReviewerMutationVariables>;
export const GetPublicFormDocument = gql`
    query GetPublicForm($slug: String!) {
  publicForm(slug: $slug) {
    id
    title
    description
    form_type
    admission_field_mapping
    application_deadline
    declaration_text
    reference_requirements {
      key
      label
      description
      count
      reference_form_id
      stage_id
    }
    school {
      slug
      name
      logo
    }
    billItem {
      id
      name
      default_amount
    }
    fields {
      ...FormFieldFragment
    }
    sections {
      id
      title
      description
      order
    }
    stages {
      id
      title
      description
      order
      field_names
      fee_bill_item_template_id
      gate
    }
    branding {
      cover_image_url
      logo_url
      logo_position
      primary_color
      accent_color
      background_color
      background_image_url
      font_family
      layout_preset
      theme_preset
    }
    publicOptions {
      classroomSections {
        id
        label
      }
      programmes {
        id
        program_name
      }
      dataSources {
        source
        options {
          id
          label
        }
      }
    }
  }
}
    ${FormFieldFragmentDoc}`;

/**
 * __useGetPublicFormQuery__
 *
 * To run a query within a Vue component, call `useGetPublicFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPublicFormQuery({
 *   slug: // value for 'slug'
 * });
 */
export function useGetPublicFormQuery(variables: Types.GetPublicFormQueryVariables | VueCompositionApi.Ref<Types.GetPublicFormQueryVariables> | ReactiveFunction<Types.GetPublicFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>(GetPublicFormDocument, variables, options);
}
export function useGetPublicFormLazyQuery(variables?: Types.GetPublicFormQueryVariables | VueCompositionApi.Ref<Types.GetPublicFormQueryVariables> | ReactiveFunction<Types.GetPublicFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>(GetPublicFormDocument, variables, options);
}
export type GetPublicFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPublicFormQuery, Types.GetPublicFormQueryVariables>;
export const CreateFormDocument = gql`
    mutation CreateForm($input: CreateFormInput!) {
  createForm(input: $input) {
    ...FormFragment
  }
}
    ${FormFragmentDoc}`;

/**
 * __useCreateFormMutation__
 *
 * To run a mutation, you first call `useCreateFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFormMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateFormMutation, Types.CreateFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateFormMutation, Types.CreateFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateFormMutation, Types.CreateFormMutationVariables>(CreateFormDocument, options);
}
export type CreateFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateFormMutation, Types.CreateFormMutationVariables>;
export const UpdateFormDocument = gql`
    mutation UpdateForm($input: UpdateFormInput!) {
  updateForm(input: $input) {
    ...FormFragment
  }
}
    ${FormFragmentDoc}`;

/**
 * __useUpdateFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFormMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateFormMutation, Types.UpdateFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateFormMutation, Types.UpdateFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateFormMutation, Types.UpdateFormMutationVariables>(UpdateFormDocument, options);
}
export type UpdateFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateFormMutation, Types.UpdateFormMutationVariables>;
export const DeleteFormDocument = gql`
    mutation DeleteForm($id: ID!) {
  deleteForm(id: $id)
}
    `;

/**
 * __useDeleteFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFormMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteFormMutation, Types.DeleteFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteFormMutation, Types.DeleteFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteFormMutation, Types.DeleteFormMutationVariables>(DeleteFormDocument, options);
}
export type DeleteFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteFormMutation, Types.DeleteFormMutationVariables>;
export const ValidateFormWaiverCodeDocument = gql`
    mutation ValidateFormWaiverCode($slug: String!, $code: String!) {
  validateFormWaiverCode(slug: $slug, code: $code)
}
    `;

/**
 * __useValidateFormWaiverCodeMutation__
 *
 * To run a mutation, you first call `useValidateFormWaiverCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useValidateFormWaiverCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useValidateFormWaiverCodeMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     code: // value for 'code'
 *   },
 * });
 */
export function useValidateFormWaiverCodeMutation(options: VueApolloComposable.UseMutationOptions<Types.ValidateFormWaiverCodeMutation, Types.ValidateFormWaiverCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ValidateFormWaiverCodeMutation, Types.ValidateFormWaiverCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ValidateFormWaiverCodeMutation, Types.ValidateFormWaiverCodeMutationVariables>(ValidateFormWaiverCodeDocument, options);
}
export type ValidateFormWaiverCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ValidateFormWaiverCodeMutation, Types.ValidateFormWaiverCodeMutationVariables>;
export const RequestFormEmailVerificationDocument = gql`
    mutation RequestFormEmailVerification($slug: String!, $email: String!) {
  requestFormEmailVerification(slug: $slug, email: $email)
}
    `;

/**
 * __useRequestFormEmailVerificationMutation__
 *
 * To run a mutation, you first call `useRequestFormEmailVerificationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestFormEmailVerificationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestFormEmailVerificationMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useRequestFormEmailVerificationMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestFormEmailVerificationMutation, Types.RequestFormEmailVerificationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestFormEmailVerificationMutation, Types.RequestFormEmailVerificationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestFormEmailVerificationMutation, Types.RequestFormEmailVerificationMutationVariables>(RequestFormEmailVerificationDocument, options);
}
export type RequestFormEmailVerificationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestFormEmailVerificationMutation, Types.RequestFormEmailVerificationMutationVariables>;
export const VerifyFormEmailOtpDocument = gql`
    mutation VerifyFormEmailOtp($slug: String!, $email: String!, $otp: String!) {
  verifyFormEmailOtp(slug: $slug, email: $email, otp: $otp) {
    token
    expires_at
  }
}
    `;

/**
 * __useVerifyFormEmailOtpMutation__
 *
 * To run a mutation, you first call `useVerifyFormEmailOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyFormEmailOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyFormEmailOtpMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     email: // value for 'email'
 *     otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyFormEmailOtpMutation(options: VueApolloComposable.UseMutationOptions<Types.VerifyFormEmailOtpMutation, Types.VerifyFormEmailOtpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.VerifyFormEmailOtpMutation, Types.VerifyFormEmailOtpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.VerifyFormEmailOtpMutation, Types.VerifyFormEmailOtpMutationVariables>(VerifyFormEmailOtpDocument, options);
}
export type VerifyFormEmailOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.VerifyFormEmailOtpMutation, Types.VerifyFormEmailOtpMutationVariables>;
export const SubmitPublicFormDocument = gql`
    mutation SubmitPublicForm($slug: String!, $data: JSON!, $references: [ReferenceNominationInput!], $waiver_code: String, $email_verification_token: String) {
  submitPublicForm(
    slug: $slug
    data: $data
    references: $references
    waiver_code: $waiver_code
    email_verification_token: $email_verification_token
  ) {
    id
    tracking_code
    pdf_url
    payment_waived_at
    bill {
      id
      amount
      status
      billable_id
      billable_type
      billDetails {
        id
        amount
      }
    }
  }
}
    `;

/**
 * __useSubmitPublicFormMutation__
 *
 * To run a mutation, you first call `useSubmitPublicFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPublicFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitPublicFormMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     data: // value for 'data'
 *     references: // value for 'references'
 *     waiver_code: // value for 'waiver_code'
 *     email_verification_token: // value for 'email_verification_token'
 *   },
 * });
 */
export function useSubmitPublicFormMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitPublicFormMutation, Types.SubmitPublicFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitPublicFormMutation, Types.SubmitPublicFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitPublicFormMutation, Types.SubmitPublicFormMutationVariables>(SubmitPublicFormDocument, options);
}
export type SubmitPublicFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitPublicFormMutation, Types.SubmitPublicFormMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!) {
  uploadFile(file: $file) {
    id
    url
    original_name
    mime_type
  }
}
    `;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadFileMutation({
 *   variables: {
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadFileMutation, Types.UploadFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadFileMutation, Types.UploadFileMutationVariables>(UploadFileDocument, options);
}
export type UploadFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadFileMutation, Types.UploadFileMutationVariables>;
export const UploadPublicFormFileDocument = gql`
    mutation UploadPublicFormFile($slug: String!, $field_name: String!, $file: Upload!) {
  uploadPublicFormFile(slug: $slug, field_name: $field_name, file: $file) {
    id
    url
    original_name
    mime_type
    size
  }
}
    `;

/**
 * __useUploadPublicFormFileMutation__
 *
 * To run a mutation, you first call `useUploadPublicFormFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadPublicFormFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadPublicFormFileMutation({
 *   variables: {
 *     slug: // value for 'slug'
 *     field_name: // value for 'field_name'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadPublicFormFileMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadPublicFormFileMutation, Types.UploadPublicFormFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadPublicFormFileMutation, Types.UploadPublicFormFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadPublicFormFileMutation, Types.UploadPublicFormFileMutationVariables>(UploadPublicFormFileDocument, options);
}
export type UploadPublicFormFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadPublicFormFileMutation, Types.UploadPublicFormFileMutationVariables>;
export const UploadReferenceFileDocument = gql`
    mutation UploadReferenceFile($token: String!, $field_name: String!, $file: Upload!) {
  uploadReferenceFile(token: $token, field_name: $field_name, file: $file) {
    id
    url
    original_name
    mime_type
    size
  }
}
    `;

/**
 * __useUploadReferenceFileMutation__
 *
 * To run a mutation, you first call `useUploadReferenceFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadReferenceFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadReferenceFileMutation({
 *   variables: {
 *     token: // value for 'token'
 *     field_name: // value for 'field_name'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadReferenceFileMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadReferenceFileMutation, Types.UploadReferenceFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadReferenceFileMutation, Types.UploadReferenceFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadReferenceFileMutation, Types.UploadReferenceFileMutationVariables>(UploadReferenceFileDocument, options);
}
export type UploadReferenceFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadReferenceFileMutation, Types.UploadReferenceFileMutationVariables>;
export const InitiatePublicPaymentDocument = gql`
    mutation InitiatePublicPayment($bill_id: ID!, $processor: String!, $payment_method: String) {
  initiatePublicPayment(
    bill_id: $bill_id
    processor: $processor
    payment_method: $payment_method
  ) {
    paymentUrl
    rrr
    hash
    convenienceFee
    baseAmount
    totalAmount
    merchantCode
    payItemId
    transactionReference
    amountInKobo
    currency
    customerEmail
    customerId
    customerName
    inlineCheckoutUrl
    mode
    splitAccounts
  }
}
    `;

/**
 * __useInitiatePublicPaymentMutation__
 *
 * To run a mutation, you first call `useInitiatePublicPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePublicPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitiatePublicPaymentMutation({
 *   variables: {
 *     bill_id: // value for 'bill_id'
 *     processor: // value for 'processor'
 *     payment_method: // value for 'payment_method'
 *   },
 * });
 */
export function useInitiatePublicPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.InitiatePublicPaymentMutation, Types.InitiatePublicPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.InitiatePublicPaymentMutation, Types.InitiatePublicPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.InitiatePublicPaymentMutation, Types.InitiatePublicPaymentMutationVariables>(InitiatePublicPaymentDocument, options);
}
export type InitiatePublicPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.InitiatePublicPaymentMutation, Types.InitiatePublicPaymentMutationVariables>;
export const ResolvePublicPaymentDocument = gql`
    mutation ResolvePublicPayment($order_id: String!, $processor: String, $transaction_id: String) {
  resolvePublicPayment(
    order_id: $order_id
    processor: $processor
    transaction_id: $transaction_id
  ) {
    id
    status
    amount
  }
}
    `;

/**
 * __useResolvePublicPaymentMutation__
 *
 * To run a mutation, you first call `useResolvePublicPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolvePublicPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolvePublicPaymentMutation({
 *   variables: {
 *     order_id: // value for 'order_id'
 *     processor: // value for 'processor'
 *     transaction_id: // value for 'transaction_id'
 *   },
 * });
 */
export function useResolvePublicPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.ResolvePublicPaymentMutation, Types.ResolvePublicPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResolvePublicPaymentMutation, Types.ResolvePublicPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResolvePublicPaymentMutation, Types.ResolvePublicPaymentMutationVariables>(ResolvePublicPaymentDocument, options);
}
export type ResolvePublicPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResolvePublicPaymentMutation, Types.ResolvePublicPaymentMutationVariables>;
export const ReviewFormSubmissionDocument = gql`
    mutation ReviewFormSubmission($submission_id: ID!, $status: FormSubmissionStatus!, $note: String) {
  reviewFormSubmission(
    submission_id: $submission_id
    status: $status
    note: $note
  ) {
    id
    status
    review_note
    reviewed_at
    reviewedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useReviewFormSubmissionMutation__
 *
 * To run a mutation, you first call `useReviewFormSubmissionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReviewFormSubmissionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReviewFormSubmissionMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     status: // value for 'status'
 *     note: // value for 'note'
 *   },
 * });
 */
export function useReviewFormSubmissionMutation(options: VueApolloComposable.UseMutationOptions<Types.ReviewFormSubmissionMutation, Types.ReviewFormSubmissionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReviewFormSubmissionMutation, Types.ReviewFormSubmissionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReviewFormSubmissionMutation, Types.ReviewFormSubmissionMutationVariables>(ReviewFormSubmissionDocument, options);
}
export type ReviewFormSubmissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReviewFormSubmissionMutation, Types.ReviewFormSubmissionMutationVariables>;
export const AddSubmissionNoteDocument = gql`
    mutation AddSubmissionNote($submission_id: ID!, $content: String!, $type: SubmissionActivityType, $is_visible_to_applicant: Boolean, $metadata: JSON) {
  addSubmissionNote(
    submission_id: $submission_id
    content: $content
    type: $type
    is_visible_to_applicant: $is_visible_to_applicant
    metadata: $metadata
  ) {
    id
    type
    content
    is_visible_to_applicant
    metadata
    created_at
  }
}
    `;

/**
 * __useAddSubmissionNoteMutation__
 *
 * To run a mutation, you first call `useAddSubmissionNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSubmissionNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSubmissionNoteMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     content: // value for 'content'
 *     type: // value for 'type'
 *     is_visible_to_applicant: // value for 'is_visible_to_applicant'
 *     metadata: // value for 'metadata'
 *   },
 * });
 */
export function useAddSubmissionNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.AddSubmissionNoteMutation, Types.AddSubmissionNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddSubmissionNoteMutation, Types.AddSubmissionNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddSubmissionNoteMutation, Types.AddSubmissionNoteMutationVariables>(AddSubmissionNoteDocument, options);
}
export type AddSubmissionNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddSubmissionNoteMutation, Types.AddSubmissionNoteMutationVariables>;
export const UpdateSubmissionNoteDocument = gql`
    mutation UpdateSubmissionNote($id: ID!, $content: String, $is_visible_to_applicant: Boolean) {
  updateSubmissionNote(
    id: $id
    content: $content
    is_visible_to_applicant: $is_visible_to_applicant
  ) {
    id
    type
    content
    is_visible_to_applicant
    metadata
    resolved_at
    is_editable
    created_at
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateSubmissionNoteMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSubmissionNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     content: // value for 'content'
 *     is_visible_to_applicant: // value for 'is_visible_to_applicant'
 *   },
 * });
 */
export function useUpdateSubmissionNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSubmissionNoteMutation, Types.UpdateSubmissionNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSubmissionNoteMutation, Types.UpdateSubmissionNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSubmissionNoteMutation, Types.UpdateSubmissionNoteMutationVariables>(UpdateSubmissionNoteDocument, options);
}
export type UpdateSubmissionNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSubmissionNoteMutation, Types.UpdateSubmissionNoteMutationVariables>;
export const DeleteSubmissionNoteDocument = gql`
    mutation DeleteSubmissionNote($id: ID!) {
  deleteSubmissionNote(id: $id)
}
    `;

/**
 * __useDeleteSubmissionNoteMutation__
 *
 * To run a mutation, you first call `useDeleteSubmissionNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubmissionNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSubmissionNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubmissionNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSubmissionNoteMutation, Types.DeleteSubmissionNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSubmissionNoteMutation, Types.DeleteSubmissionNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSubmissionNoteMutation, Types.DeleteSubmissionNoteMutationVariables>(DeleteSubmissionNoteDocument, options);
}
export type DeleteSubmissionNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSubmissionNoteMutation, Types.DeleteSubmissionNoteMutationVariables>;
export const ApplicantStatusDocument = gql`
    query ApplicantStatus($tracking_code: String!) {
  applicantStatus(tracking_code: $tracking_code) {
    tracking_code
    form_title
    form_type
    status
    submitted_at
    reviewed_at
    review_note
    activities {
      id
      type
      content
      old_status
      new_status
      is_visible_to_applicant
      resolved_at
      created_at
    }
    has_bill
    bill_status
    bill_amount
    payment_state
  }
}
    `;

/**
 * __useApplicantStatusQuery__
 *
 * To run a query within a Vue component, call `useApplicantStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useApplicantStatusQuery({
 *   tracking_code: // value for 'tracking_code'
 * });
 */
export function useApplicantStatusQuery(variables: Types.ApplicantStatusQueryVariables | VueCompositionApi.Ref<Types.ApplicantStatusQueryVariables> | ReactiveFunction<Types.ApplicantStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>(ApplicantStatusDocument, variables, options);
}
export function useApplicantStatusLazyQuery(variables?: Types.ApplicantStatusQueryVariables | VueCompositionApi.Ref<Types.ApplicantStatusQueryVariables> | ReactiveFunction<Types.ApplicantStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>(ApplicantStatusDocument, variables, options);
}
export type ApplicantStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ApplicantStatusQuery, Types.ApplicantStatusQueryVariables>;
export const ConvertSubmissionToStudentDocument = gql`
    mutation ConvertSubmissionToStudent($submission_id: ID!, $field_mapping: JSON!, $classroom_section_id: ID, $programme_id: Int, $matric_no: String, $campus_id: ID, $target_school_id: ID) {
  convertSubmissionToStudent(
    submission_id: $submission_id
    field_mapping: $field_mapping
    classroom_section_id: $classroom_section_id
    programme_id: $programme_id
    matric_no: $matric_no
    campus_id: $campus_id
    target_school_id: $target_school_id
  ) {
    id
    first_name
    surname
    matric_no
  }
}
    `;

/**
 * __useConvertSubmissionToStudentMutation__
 *
 * To run a mutation, you first call `useConvertSubmissionToStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConvertSubmissionToStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConvertSubmissionToStudentMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     field_mapping: // value for 'field_mapping'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     programme_id: // value for 'programme_id'
 *     matric_no: // value for 'matric_no'
 *     campus_id: // value for 'campus_id'
 *     target_school_id: // value for 'target_school_id'
 *   },
 * });
 */
export function useConvertSubmissionToStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.ConvertSubmissionToStudentMutation, Types.ConvertSubmissionToStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ConvertSubmissionToStudentMutation, Types.ConvertSubmissionToStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ConvertSubmissionToStudentMutation, Types.ConvertSubmissionToStudentMutationVariables>(ConvertSubmissionToStudentDocument, options);
}
export type ConvertSubmissionToStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ConvertSubmissionToStudentMutation, Types.ConvertSubmissionToStudentMutationVariables>;
export const ApplicantProgrammeDocument = gql`
    query ApplicantProgramme($id: ID!) {
  formSubmission(id: $id) {
    id
    applicant_programme {
      programme_id
      answer
    }
  }
}
    `;

/**
 * __useApplicantProgrammeQuery__
 *
 * To run a query within a Vue component, call `useApplicantProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantProgrammeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useApplicantProgrammeQuery({
 *   id: // value for 'id'
 * });
 */
export function useApplicantProgrammeQuery(variables: Types.ApplicantProgrammeQueryVariables | VueCompositionApi.Ref<Types.ApplicantProgrammeQueryVariables> | ReactiveFunction<Types.ApplicantProgrammeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>(ApplicantProgrammeDocument, variables, options);
}
export function useApplicantProgrammeLazyQuery(variables?: Types.ApplicantProgrammeQueryVariables | VueCompositionApi.Ref<Types.ApplicantProgrammeQueryVariables> | ReactiveFunction<Types.ApplicantProgrammeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>(ApplicantProgrammeDocument, variables, options);
}
export type ApplicantProgrammeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ApplicantProgrammeQuery, Types.ApplicantProgrammeQueryVariables>;
export const ChildSchoolConversionOptionsDocument = gql`
    query ChildSchoolConversionOptions($school_id: ID!) {
  childSchoolConversionOptions(school_id: $school_id) {
    classroom_sections {
      id
      name
      classroom {
        id
        name
      }
      section {
        id
        name
      }
    }
    programmes {
      id
      program_name
    }
    campuses {
      id
      name
    }
    has_auto_matric
  }
}
    `;

/**
 * __useChildSchoolConversionOptionsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolConversionOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolConversionOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolConversionOptionsQuery({
 *   school_id: // value for 'school_id'
 * });
 */
export function useChildSchoolConversionOptionsQuery(variables: Types.ChildSchoolConversionOptionsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolConversionOptionsQueryVariables> | ReactiveFunction<Types.ChildSchoolConversionOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>(ChildSchoolConversionOptionsDocument, variables, options);
}
export function useChildSchoolConversionOptionsLazyQuery(variables?: Types.ChildSchoolConversionOptionsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolConversionOptionsQueryVariables> | ReactiveFunction<Types.ChildSchoolConversionOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>(ChildSchoolConversionOptionsDocument, variables, options);
}
export type ChildSchoolConversionOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolConversionOptionsQuery, Types.ChildSchoolConversionOptionsQueryVariables>;
export const StudentFormsDocument = gql`
    query StudentForms($first: Int = 20, $page: Int = 1) {
  studentForms(first: $first, page: $page) {
    data {
      id
      title
      description
      form_type
      billItem {
        id
        name
        default_amount
      }
      fields {
        ...FormFieldFragment
      }
      my_draft {
        id
        updated_at
      }
    }
    paginatorInfo {
      total
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    ${FormFieldFragmentDoc}`;

/**
 * __useStudentFormsQuery__
 *
 * To run a query within a Vue component, call `useStudentFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentFormsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentFormsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useStudentFormsQuery(variables: Types.StudentFormsQueryVariables | VueCompositionApi.Ref<Types.StudentFormsQueryVariables> | ReactiveFunction<Types.StudentFormsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>(StudentFormsDocument, variables, options);
}
export function useStudentFormsLazyQuery(variables: Types.StudentFormsQueryVariables | VueCompositionApi.Ref<Types.StudentFormsQueryVariables> | ReactiveFunction<Types.StudentFormsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>(StudentFormsDocument, variables, options);
}
export type StudentFormsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentFormsQuery, Types.StudentFormsQueryVariables>;
export const StudentFormDraftDocument = gql`
    query StudentFormDraft($id: ID!) {
  form(id: $id) {
    id
    my_draft {
      id
      status
      data
      updated_at
      draft_nominations {
        requirement_key
        name
        email
        phone
        relationship
      }
    }
  }
}
    `;

/**
 * __useStudentFormDraftQuery__
 *
 * To run a query within a Vue component, call `useStudentFormDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentFormDraftQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentFormDraftQuery({
 *   id: // value for 'id'
 * });
 */
export function useStudentFormDraftQuery(variables: Types.StudentFormDraftQueryVariables | VueCompositionApi.Ref<Types.StudentFormDraftQueryVariables> | ReactiveFunction<Types.StudentFormDraftQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>(StudentFormDraftDocument, variables, options);
}
export function useStudentFormDraftLazyQuery(variables?: Types.StudentFormDraftQueryVariables | VueCompositionApi.Ref<Types.StudentFormDraftQueryVariables> | ReactiveFunction<Types.StudentFormDraftQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>(StudentFormDraftDocument, variables, options);
}
export type StudentFormDraftQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentFormDraftQuery, Types.StudentFormDraftQueryVariables>;
export const SaveStudentFormDraftDocument = gql`
    mutation SaveStudentFormDraft($form_id: ID!, $data: JSON!, $references: [ReferenceNominationInput!]) {
  saveStudentFormDraft(form_id: $form_id, data: $data, references: $references) {
    id
    status
    data
    updated_at
  }
}
    `;

/**
 * __useSaveStudentFormDraftMutation__
 *
 * To run a mutation, you first call `useSaveStudentFormDraftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveStudentFormDraftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveStudentFormDraftMutation({
 *   variables: {
 *     form_id: // value for 'form_id'
 *     data: // value for 'data'
 *     references: // value for 'references'
 *   },
 * });
 */
export function useSaveStudentFormDraftMutation(options: VueApolloComposable.UseMutationOptions<Types.SaveStudentFormDraftMutation, Types.SaveStudentFormDraftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SaveStudentFormDraftMutation, Types.SaveStudentFormDraftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SaveStudentFormDraftMutation, Types.SaveStudentFormDraftMutationVariables>(SaveStudentFormDraftDocument, options);
}
export type SaveStudentFormDraftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SaveStudentFormDraftMutation, Types.SaveStudentFormDraftMutationVariables>;
export const SubmitFormDocument = gql`
    mutation SubmitForm($form_id: ID!, $data: JSON!, $references: [ReferenceNominationInput!], $waiver_code: String) {
  submitForm(
    form_id: $form_id
    data: $data
    references: $references
    waiver_code: $waiver_code
  ) {
    id
    data
    status
    tracking_code
    created_at
    bill {
      id
      amount
      status
      billDetails {
        id
        amount
      }
    }
  }
}
    `;

/**
 * __useSubmitFormMutation__
 *
 * To run a mutation, you first call `useSubmitFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitFormMutation({
 *   variables: {
 *     form_id: // value for 'form_id'
 *     data: // value for 'data'
 *     references: // value for 'references'
 *     waiver_code: // value for 'waiver_code'
 *   },
 * });
 */
export function useSubmitFormMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitFormMutation, Types.SubmitFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitFormMutation, Types.SubmitFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitFormMutation, Types.SubmitFormMutationVariables>(SubmitFormDocument, options);
}
export type SubmitFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitFormMutation, Types.SubmitFormMutationVariables>;
export const ExportFormSubmissionsDocument = gql`
    query ExportFormSubmissions($form_id: ID!, $status: FormSubmissionStatus) {
  exportFormSubmissions(form_id: $form_id, status: $status) {
    headers
    rows
    filename
  }
}
    `;

/**
 * __useExportFormSubmissionsQuery__
 *
 * To run a query within a Vue component, call `useExportFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportFormSubmissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportFormSubmissionsQuery({
 *   form_id: // value for 'form_id'
 *   status: // value for 'status'
 * });
 */
export function useExportFormSubmissionsQuery(variables: Types.ExportFormSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ExportFormSubmissionsQueryVariables> | ReactiveFunction<Types.ExportFormSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>(ExportFormSubmissionsDocument, variables, options);
}
export function useExportFormSubmissionsLazyQuery(variables?: Types.ExportFormSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ExportFormSubmissionsQueryVariables> | ReactiveFunction<Types.ExportFormSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>(ExportFormSubmissionsDocument, variables, options);
}
export type ExportFormSubmissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ExportFormSubmissionsQuery, Types.ExportFormSubmissionsQueryVariables>;
export const BulkConvertSubmissionsDocument = gql`
    mutation BulkConvertSubmissions($submission_ids: [ID!]!, $field_mapping: JSON!, $classroom_section_id: ID, $programme_id: Int, $campus_id: ID, $target_school_id: ID) {
  bulkConvertSubmissions(
    submission_ids: $submission_ids
    field_mapping: $field_mapping
    classroom_section_id: $classroom_section_id
    programme_id: $programme_id
    campus_id: $campus_id
    target_school_id: $target_school_id
  ) {
    converted
    failed
    errors
  }
}
    `;

/**
 * __useBulkConvertSubmissionsMutation__
 *
 * To run a mutation, you first call `useBulkConvertSubmissionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkConvertSubmissionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkConvertSubmissionsMutation({
 *   variables: {
 *     submission_ids: // value for 'submission_ids'
 *     field_mapping: // value for 'field_mapping'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     programme_id: // value for 'programme_id'
 *     campus_id: // value for 'campus_id'
 *     target_school_id: // value for 'target_school_id'
 *   },
 * });
 */
export function useBulkConvertSubmissionsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkConvertSubmissionsMutation, Types.BulkConvertSubmissionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkConvertSubmissionsMutation, Types.BulkConvertSubmissionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkConvertSubmissionsMutation, Types.BulkConvertSubmissionsMutationVariables>(BulkConvertSubmissionsDocument, options);
}
export type BulkConvertSubmissionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkConvertSubmissionsMutation, Types.BulkConvertSubmissionsMutationVariables>;
export const RequestApplicantOtpDocument = gql`
    mutation RequestApplicantOtp($email: String!, $school_slug: String, $tracking_code: String) {
  requestApplicantOtp(
    email: $email
    school_slug: $school_slug
    tracking_code: $tracking_code
  )
}
    `;

/**
 * __useRequestApplicantOtpMutation__
 *
 * To run a mutation, you first call `useRequestApplicantOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestApplicantOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestApplicantOtpMutation({
 *   variables: {
 *     email: // value for 'email'
 *     school_slug: // value for 'school_slug'
 *     tracking_code: // value for 'tracking_code'
 *   },
 * });
 */
export function useRequestApplicantOtpMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestApplicantOtpMutation, Types.RequestApplicantOtpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestApplicantOtpMutation, Types.RequestApplicantOtpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestApplicantOtpMutation, Types.RequestApplicantOtpMutationVariables>(RequestApplicantOtpDocument, options);
}
export type RequestApplicantOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestApplicantOtpMutation, Types.RequestApplicantOtpMutationVariables>;
export const VerifyApplicantOtpDocument = gql`
    mutation VerifyApplicantOtp($email: String!, $otp: String!, $school_slug: String, $tracking_code: String) {
  verifyApplicantOtp(
    email: $email
    otp: $otp
    school_slug: $school_slug
    tracking_code: $tracking_code
  ) {
    token
    expires_at
  }
}
    `;

/**
 * __useVerifyApplicantOtpMutation__
 *
 * To run a mutation, you first call `useVerifyApplicantOtpMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVerifyApplicantOtpMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVerifyApplicantOtpMutation({
 *   variables: {
 *     email: // value for 'email'
 *     otp: // value for 'otp'
 *     school_slug: // value for 'school_slug'
 *     tracking_code: // value for 'tracking_code'
 *   },
 * });
 */
export function useVerifyApplicantOtpMutation(options: VueApolloComposable.UseMutationOptions<Types.VerifyApplicantOtpMutation, Types.VerifyApplicantOtpMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.VerifyApplicantOtpMutation, Types.VerifyApplicantOtpMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.VerifyApplicantOtpMutation, Types.VerifyApplicantOtpMutationVariables>(VerifyApplicantOtpDocument, options);
}
export type VerifyApplicantOtpMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.VerifyApplicantOtpMutation, Types.VerifyApplicantOtpMutationVariables>;
export const ApplicantSubmissionsDocument = gql`
    query ApplicantSubmissions($token: String!) {
  applicantSubmissions(token: $token) {
    tracking_code
    form_title
    references {
      key
      label
      required
      received
      referees {
        id
        name
        email
        status
        submitted_at
        answers {
          label
          value
        }
      }
    }
    form_type
    form_slug
    data
    current_stage
    status
    submitted_at
    reviewed_at
    review_note
    pdf_url
    admission_letter_url
    activities {
      id
      type
      content
      old_status
      new_status
      is_visible_to_applicant
      resolved_at
      created_at
      metadata
      attachments {
        id
        original_name
        mime_type
        size
        url
      }
    }
    has_bill
    bill {
      id
      amount
      status
      billable_id
      billable_type
      details {
        id
        amount
      }
    }
    bill_status
    bill_amount
    payment_state
    has_action_required
  }
}
    `;

/**
 * __useApplicantSubmissionsQuery__
 *
 * To run a query within a Vue component, call `useApplicantSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantSubmissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useApplicantSubmissionsQuery({
 *   token: // value for 'token'
 * });
 */
export function useApplicantSubmissionsQuery(variables: Types.ApplicantSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ApplicantSubmissionsQueryVariables> | ReactiveFunction<Types.ApplicantSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>(ApplicantSubmissionsDocument, variables, options);
}
export function useApplicantSubmissionsLazyQuery(variables?: Types.ApplicantSubmissionsQueryVariables | VueCompositionApi.Ref<Types.ApplicantSubmissionsQueryVariables> | ReactiveFunction<Types.ApplicantSubmissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>(ApplicantSubmissionsDocument, variables, options);
}
export type ApplicantSubmissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ApplicantSubmissionsQuery, Types.ApplicantSubmissionsQueryVariables>;
export const ApplicantReplyDocument = gql`
    mutation ApplicantReply($tracking_code: String!, $content: String!, $token: String!, $file_ids: [ID!], $activity_id: ID) {
  applicantReply(
    tracking_code: $tracking_code
    content: $content
    token: $token
    file_ids: $file_ids
    activity_id: $activity_id
  ) {
    id
    type
    content
    created_at
  }
}
    `;

/**
 * __useApplicantReplyMutation__
 *
 * To run a mutation, you first call `useApplicantReplyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplicantReplyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplicantReplyMutation({
 *   variables: {
 *     tracking_code: // value for 'tracking_code'
 *     content: // value for 'content'
 *     token: // value for 'token'
 *     file_ids: // value for 'file_ids'
 *     activity_id: // value for 'activity_id'
 *   },
 * });
 */
export function useApplicantReplyMutation(options: VueApolloComposable.UseMutationOptions<Types.ApplicantReplyMutation, Types.ApplicantReplyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApplicantReplyMutation, Types.ApplicantReplyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApplicantReplyMutation, Types.ApplicantReplyMutationVariables>(ApplicantReplyDocument, options);
}
export type ApplicantReplyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApplicantReplyMutation, Types.ApplicantReplyMutationVariables>;
export const ApplicantUploadFileDocument = gql`
    mutation ApplicantUploadFile($token: String!, $file: Upload!) {
  applicantUploadFile(token: $token, file: $file) {
    id
    original_name
    mime_type
    size
    url
  }
}
    `;

/**
 * __useApplicantUploadFileMutation__
 *
 * To run a mutation, you first call `useApplicantUploadFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplicantUploadFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplicantUploadFileMutation({
 *   variables: {
 *     token: // value for 'token'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useApplicantUploadFileMutation(options: VueApolloComposable.UseMutationOptions<Types.ApplicantUploadFileMutation, Types.ApplicantUploadFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApplicantUploadFileMutation, Types.ApplicantUploadFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApplicantUploadFileMutation, Types.ApplicantUploadFileMutationVariables>(ApplicantUploadFileDocument, options);
}
export type ApplicantUploadFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApplicantUploadFileMutation, Types.ApplicantUploadFileMutationVariables>;
export const ApplicantUpdateFieldDocument = gql`
    mutation ApplicantUpdateField($tracking_code: String!, $token: String!, $activity_id: ID!, $new_value: JSON) {
  applicantUpdateField(
    tracking_code: $tracking_code
    token: $token
    activity_id: $activity_id
    new_value: $new_value
  ) {
    id
    type
    content
    created_at
  }
}
    `;

/**
 * __useApplicantUpdateFieldMutation__
 *
 * To run a mutation, you first call `useApplicantUpdateFieldMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplicantUpdateFieldMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplicantUpdateFieldMutation({
 *   variables: {
 *     tracking_code: // value for 'tracking_code'
 *     token: // value for 'token'
 *     activity_id: // value for 'activity_id'
 *     new_value: // value for 'new_value'
 *   },
 * });
 */
export function useApplicantUpdateFieldMutation(options: VueApolloComposable.UseMutationOptions<Types.ApplicantUpdateFieldMutation, Types.ApplicantUpdateFieldMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApplicantUpdateFieldMutation, Types.ApplicantUpdateFieldMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApplicantUpdateFieldMutation, Types.ApplicantUpdateFieldMutationVariables>(ApplicantUpdateFieldDocument, options);
}
export type ApplicantUpdateFieldMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApplicantUpdateFieldMutation, Types.ApplicantUpdateFieldMutationVariables>;
export const GetReferenceRequestDocument = gql`
    query GetReferenceRequest($token: String!) {
  referenceRequest(token: $token) {
    status
    referee_name
    applicant_name
    form_title
    school_name
    expires_at
    applicant_can_view
    draft_data
    referenceForm {
      id
      title
      description
      fields {
        ...FormFieldFragment
      }
      sections {
        id
        title
        description
        order
      }
      branding {
        cover_image_url
        logo_url
        logo_position
        primary_color
        accent_color
        background_color
        background_image_url
        font_family
        layout_preset
        theme_preset
      }
      publicOptions {
        classroomSections {
          id
          label
        }
        programmes {
          id
          program_name
        }
        dataSources {
          source
          options {
            id
            label
          }
        }
      }
    }
  }
}
    ${FormFieldFragmentDoc}`;

/**
 * __useGetReferenceRequestQuery__
 *
 * To run a query within a Vue component, call `useGetReferenceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferenceRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetReferenceRequestQuery({
 *   token: // value for 'token'
 * });
 */
export function useGetReferenceRequestQuery(variables: Types.GetReferenceRequestQueryVariables | VueCompositionApi.Ref<Types.GetReferenceRequestQueryVariables> | ReactiveFunction<Types.GetReferenceRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>(GetReferenceRequestDocument, variables, options);
}
export function useGetReferenceRequestLazyQuery(variables?: Types.GetReferenceRequestQueryVariables | VueCompositionApi.Ref<Types.GetReferenceRequestQueryVariables> | ReactiveFunction<Types.GetReferenceRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>(GetReferenceRequestDocument, variables, options);
}
export type GetReferenceRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetReferenceRequestQuery, Types.GetReferenceRequestQueryVariables>;
export const SubmitReferenceDocument = gql`
    mutation SubmitReference($token: String!, $data: JSON!) {
  submitReference(token: $token, data: $data)
}
    `;

/**
 * __useSubmitReferenceMutation__
 *
 * To run a mutation, you first call `useSubmitReferenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReferenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitReferenceMutation({
 *   variables: {
 *     token: // value for 'token'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSubmitReferenceMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitReferenceMutation, Types.SubmitReferenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitReferenceMutation, Types.SubmitReferenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitReferenceMutation, Types.SubmitReferenceMutationVariables>(SubmitReferenceDocument, options);
}
export type SubmitReferenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitReferenceMutation, Types.SubmitReferenceMutationVariables>;
export const DeclineReferenceDocument = gql`
    mutation DeclineReference($token: String!, $reason: String) {
  declineReference(token: $token, reason: $reason)
}
    `;

/**
 * __useDeclineReferenceMutation__
 *
 * To run a mutation, you first call `useDeclineReferenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeclineReferenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeclineReferenceMutation({
 *   variables: {
 *     token: // value for 'token'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useDeclineReferenceMutation(options: VueApolloComposable.UseMutationOptions<Types.DeclineReferenceMutation, Types.DeclineReferenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeclineReferenceMutation, Types.DeclineReferenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeclineReferenceMutation, Types.DeclineReferenceMutationVariables>(DeclineReferenceDocument, options);
}
export type DeclineReferenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeclineReferenceMutation, Types.DeclineReferenceMutationVariables>;
export const SaveReferenceDraftDocument = gql`
    mutation SaveReferenceDraft($token: String!, $data: JSON!) {
  saveReferenceDraft(token: $token, data: $data)
}
    `;

/**
 * __useSaveReferenceDraftMutation__
 *
 * To run a mutation, you first call `useSaveReferenceDraftMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveReferenceDraftMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveReferenceDraftMutation({
 *   variables: {
 *     token: // value for 'token'
 *     data: // value for 'data'
 *   },
 * });
 */
export function useSaveReferenceDraftMutation(options: VueApolloComposable.UseMutationOptions<Types.SaveReferenceDraftMutation, Types.SaveReferenceDraftMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SaveReferenceDraftMutation, Types.SaveReferenceDraftMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SaveReferenceDraftMutation, Types.SaveReferenceDraftMutationVariables>(SaveReferenceDraftDocument, options);
}
export type SaveReferenceDraftMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SaveReferenceDraftMutation, Types.SaveReferenceDraftMutationVariables>;
export const ReplaceReferenceRefereeDocument = gql`
    mutation ReplaceReferenceReferee($tracking_code: String!, $token: String!, $request_id: ID!, $name: String!, $email: String!, $phone: String, $relationship: String) {
  replaceReferenceReferee(
    tracking_code: $tracking_code
    token: $token
    request_id: $request_id
    name: $name
    email: $email
    phone: $phone
    relationship: $relationship
  )
}
    `;

/**
 * __useReplaceReferenceRefereeMutation__
 *
 * To run a mutation, you first call `useReplaceReferenceRefereeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplaceReferenceRefereeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplaceReferenceRefereeMutation({
 *   variables: {
 *     tracking_code: // value for 'tracking_code'
 *     token: // value for 'token'
 *     request_id: // value for 'request_id'
 *     name: // value for 'name'
 *     email: // value for 'email'
 *     phone: // value for 'phone'
 *     relationship: // value for 'relationship'
 *   },
 * });
 */
export function useReplaceReferenceRefereeMutation(options: VueApolloComposable.UseMutationOptions<Types.ReplaceReferenceRefereeMutation, Types.ReplaceReferenceRefereeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReplaceReferenceRefereeMutation, Types.ReplaceReferenceRefereeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReplaceReferenceRefereeMutation, Types.ReplaceReferenceRefereeMutationVariables>(ReplaceReferenceRefereeDocument, options);
}
export type ReplaceReferenceRefereeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReplaceReferenceRefereeMutation, Types.ReplaceReferenceRefereeMutationVariables>;
export const AddReferenceRequestDocument = gql`
    mutation AddReferenceRequest($submission_id: ID!, $requirement_key: String!, $referee_name: String!, $referee_email: String!, $referee_phone: String, $referee_relationship: String) {
  addReferenceRequest(
    submission_id: $submission_id
    requirement_key: $requirement_key
    referee_name: $referee_name
    referee_email: $referee_email
    referee_phone: $referee_phone
    referee_relationship: $referee_relationship
  ) {
    id
    status
    referee_name
    referee_email
  }
}
    `;

/**
 * __useAddReferenceRequestMutation__
 *
 * To run a mutation, you first call `useAddReferenceRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddReferenceRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddReferenceRequestMutation({
 *   variables: {
 *     submission_id: // value for 'submission_id'
 *     requirement_key: // value for 'requirement_key'
 *     referee_name: // value for 'referee_name'
 *     referee_email: // value for 'referee_email'
 *     referee_phone: // value for 'referee_phone'
 *     referee_relationship: // value for 'referee_relationship'
 *   },
 * });
 */
export function useAddReferenceRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.AddReferenceRequestMutation, Types.AddReferenceRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddReferenceRequestMutation, Types.AddReferenceRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddReferenceRequestMutation, Types.AddReferenceRequestMutationVariables>(AddReferenceRequestDocument, options);
}
export type AddReferenceRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddReferenceRequestMutation, Types.AddReferenceRequestMutationVariables>;
export const CancelReferenceRequestDocument = gql`
    mutation CancelReferenceRequest($id: ID!) {
  cancelReferenceRequest(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useCancelReferenceRequestMutation__
 *
 * To run a mutation, you first call `useCancelReferenceRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelReferenceRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelReferenceRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCancelReferenceRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.CancelReferenceRequestMutation, Types.CancelReferenceRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CancelReferenceRequestMutation, Types.CancelReferenceRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CancelReferenceRequestMutation, Types.CancelReferenceRequestMutationVariables>(CancelReferenceRequestDocument, options);
}
export type CancelReferenceRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CancelReferenceRequestMutation, Types.CancelReferenceRequestMutationVariables>;
export const UpdateReferenceRequestDocument = gql`
    mutation UpdateReferenceRequest($id: ID!, $referee_name: String, $referee_email: String) {
  updateReferenceRequest(
    id: $id
    referee_name: $referee_name
    referee_email: $referee_email
  ) {
    id
    referee_name
    referee_email
    status
  }
}
    `;

/**
 * __useUpdateReferenceRequestMutation__
 *
 * To run a mutation, you first call `useUpdateReferenceRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferenceRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateReferenceRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     referee_name: // value for 'referee_name'
 *     referee_email: // value for 'referee_email'
 *   },
 * });
 */
export function useUpdateReferenceRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateReferenceRequestMutation, Types.UpdateReferenceRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateReferenceRequestMutation, Types.UpdateReferenceRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateReferenceRequestMutation, Types.UpdateReferenceRequestMutationVariables>(UpdateReferenceRequestDocument, options);
}
export type UpdateReferenceRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateReferenceRequestMutation, Types.UpdateReferenceRequestMutationVariables>;
export const ResendReferenceInviteDocument = gql`
    mutation ResendReferenceInvite($id: ID!) {
  resendReferenceInvite(id: $id) {
    id
    status
    invited_at
    expires_at
  }
}
    `;

/**
 * __useResendReferenceInviteMutation__
 *
 * To run a mutation, you first call `useResendReferenceInviteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendReferenceInviteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendReferenceInviteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResendReferenceInviteMutation(options: VueApolloComposable.UseMutationOptions<Types.ResendReferenceInviteMutation, Types.ResendReferenceInviteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResendReferenceInviteMutation, Types.ResendReferenceInviteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResendReferenceInviteMutation, Types.ResendReferenceInviteMutationVariables>(ResendReferenceInviteDocument, options);
}
export type ResendReferenceInviteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResendReferenceInviteMutation, Types.ResendReferenceInviteMutationVariables>;
export const FormWaiverCodesDocument = gql`
    query FormWaiverCodes($form_id: ID!, $academic_calendar_id: ID, $status: FormWaiverCodeStatus, $first: Int, $page: Int) {
  formWaiverCodes(
    form_id: $form_id
    academic_calendar_id: $academic_calendar_id
    status: $status
    first: $first
    page: $page
  ) {
    data {
      id
      form_id
      academic_calendar_id
      status
      batch_label
      used_by_email
      used_at
      revoked_at
      generatedBy {
        id
        name
      }
      academicCalendar {
        id
        session {
          name
        }
        termStructure {
          name
        }
      }
      usedBySubmission {
        id
        tracking_code
      }
      revokedBy {
        id
        name
      }
      created_at
      campus {
        id
        name
      }
    }
    paginatorInfo {
      currentPage
      lastPage
      total
    }
  }
}
    `;

/**
 * __useFormWaiverCodesQuery__
 *
 * To run a query within a Vue component, call `useFormWaiverCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormWaiverCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormWaiverCodesQuery({
 *   form_id: // value for 'form_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   status: // value for 'status'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useFormWaiverCodesQuery(variables: Types.FormWaiverCodesQueryVariables | VueCompositionApi.Ref<Types.FormWaiverCodesQueryVariables> | ReactiveFunction<Types.FormWaiverCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>(FormWaiverCodesDocument, variables, options);
}
export function useFormWaiverCodesLazyQuery(variables?: Types.FormWaiverCodesQueryVariables | VueCompositionApi.Ref<Types.FormWaiverCodesQueryVariables> | ReactiveFunction<Types.FormWaiverCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>(FormWaiverCodesDocument, variables, options);
}
export type FormWaiverCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.FormWaiverCodesQuery, Types.FormWaiverCodesQueryVariables>;
export const GenerateFormWaiverCodesDocument = gql`
    mutation GenerateFormWaiverCodes($form_id: ID!, $academic_calendar_id: ID!, $quantity: Int!, $batch_label: String, $campus_id: ID) {
  generateFormWaiverCodes(
    form_id: $form_id
    academic_calendar_id: $academic_calendar_id
    quantity: $quantity
    batch_label: $batch_label
    campus_id: $campus_id
  ) {
    codes
    count
  }
}
    `;

/**
 * __useGenerateFormWaiverCodesMutation__
 *
 * To run a mutation, you first call `useGenerateFormWaiverCodesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFormWaiverCodesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateFormWaiverCodesMutation({
 *   variables: {
 *     form_id: // value for 'form_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     quantity: // value for 'quantity'
 *     batch_label: // value for 'batch_label'
 *     campus_id: // value for 'campus_id'
 *   },
 * });
 */
export function useGenerateFormWaiverCodesMutation(options: VueApolloComposable.UseMutationOptions<Types.GenerateFormWaiverCodesMutation, Types.GenerateFormWaiverCodesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GenerateFormWaiverCodesMutation, Types.GenerateFormWaiverCodesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GenerateFormWaiverCodesMutation, Types.GenerateFormWaiverCodesMutationVariables>(GenerateFormWaiverCodesDocument, options);
}
export type GenerateFormWaiverCodesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GenerateFormWaiverCodesMutation, Types.GenerateFormWaiverCodesMutationVariables>;
export const RevokeFormWaiverCodeDocument = gql`
    mutation RevokeFormWaiverCode($id: ID!) {
  revokeFormWaiverCode(id: $id) {
    id
    status
    revoked_at
  }
}
    `;

/**
 * __useRevokeFormWaiverCodeMutation__
 *
 * To run a mutation, you first call `useRevokeFormWaiverCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeFormWaiverCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeFormWaiverCodeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRevokeFormWaiverCodeMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeFormWaiverCodeMutation, Types.RevokeFormWaiverCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeFormWaiverCodeMutation, Types.RevokeFormWaiverCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeFormWaiverCodeMutation, Types.RevokeFormWaiverCodeMutationVariables>(RevokeFormWaiverCodeDocument, options);
}
export type RevokeFormWaiverCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeFormWaiverCodeMutation, Types.RevokeFormWaiverCodeMutationVariables>;
export const RevokeAllFormWaiverCodesDocument = gql`
    mutation RevokeAllFormWaiverCodes($form_id: ID!, $batch_label: String, $academic_calendar_id: ID) {
  revokeAllFormWaiverCodes(
    form_id: $form_id
    batch_label: $batch_label
    academic_calendar_id: $academic_calendar_id
  )
}
    `;

/**
 * __useRevokeAllFormWaiverCodesMutation__
 *
 * To run a mutation, you first call `useRevokeAllFormWaiverCodesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAllFormWaiverCodesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeAllFormWaiverCodesMutation({
 *   variables: {
 *     form_id: // value for 'form_id'
 *     batch_label: // value for 'batch_label'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useRevokeAllFormWaiverCodesMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeAllFormWaiverCodesMutation, Types.RevokeAllFormWaiverCodesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeAllFormWaiverCodesMutation, Types.RevokeAllFormWaiverCodesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeAllFormWaiverCodesMutation, Types.RevokeAllFormWaiverCodesMutationVariables>(RevokeAllFormWaiverCodesDocument, options);
}
export type RevokeAllFormWaiverCodesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeAllFormWaiverCodesMutation, Types.RevokeAllFormWaiverCodesMutationVariables>;
export const WaiverCodesDocument = gql`
    query WaiverCodes($form_id: ID, $campus_id: ID, $without_campus: Boolean, $academic_calendar_id: ID, $status: FormWaiverCodeStatus, $batch_label: String, $paid_after_waiver: Boolean, $first: Int, $page: Int) {
  waiverCodes(
    form_id: $form_id
    campus_id: $campus_id
    without_campus: $without_campus
    academic_calendar_id: $academic_calendar_id
    status: $status
    batch_label: $batch_label
    paid_after_waiver: $paid_after_waiver
    first: $first
    page: $page
  ) {
    data {
      ...WaiverCodeRow
    }
    paginatorInfo {
      currentPage
      lastPage
      total
    }
  }
}
    ${WaiverCodeRowFragmentDoc}`;

/**
 * __useWaiverCodesQuery__
 *
 * To run a query within a Vue component, call `useWaiverCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaiverCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWaiverCodesQuery({
 *   form_id: // value for 'form_id'
 *   campus_id: // value for 'campus_id'
 *   without_campus: // value for 'without_campus'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   status: // value for 'status'
 *   batch_label: // value for 'batch_label'
 *   paid_after_waiver: // value for 'paid_after_waiver'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useWaiverCodesQuery(variables: Types.WaiverCodesQueryVariables | VueCompositionApi.Ref<Types.WaiverCodesQueryVariables> | ReactiveFunction<Types.WaiverCodesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>(WaiverCodesDocument, variables, options);
}
export function useWaiverCodesLazyQuery(variables: Types.WaiverCodesQueryVariables | VueCompositionApi.Ref<Types.WaiverCodesQueryVariables> | ReactiveFunction<Types.WaiverCodesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>(WaiverCodesDocument, variables, options);
}
export type WaiverCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.WaiverCodesQuery, Types.WaiverCodesQueryVariables>;
export const WaiverCodeStatsDocument = gql`
    query WaiverCodeStats($form_id: ID, $academic_calendar_id: ID) {
  waiverCodeStats(form_id: $form_id, academic_calendar_id: $academic_calendar_id) {
    total
    available
    used
    revoked
    paid_after_waiver
    campuses {
      campus_id
      campus_name
      total
      available
      used
      revoked
    }
    forms {
      form_id
      form_title
      total
      available
      used
      revoked
    }
  }
}
    `;

/**
 * __useWaiverCodeStatsQuery__
 *
 * To run a query within a Vue component, call `useWaiverCodeStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaiverCodeStatsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWaiverCodeStatsQuery({
 *   form_id: // value for 'form_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useWaiverCodeStatsQuery(variables: Types.WaiverCodeStatsQueryVariables | VueCompositionApi.Ref<Types.WaiverCodeStatsQueryVariables> | ReactiveFunction<Types.WaiverCodeStatsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>(WaiverCodeStatsDocument, variables, options);
}
export function useWaiverCodeStatsLazyQuery(variables: Types.WaiverCodeStatsQueryVariables | VueCompositionApi.Ref<Types.WaiverCodeStatsQueryVariables> | ReactiveFunction<Types.WaiverCodeStatsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>(WaiverCodeStatsDocument, variables, options);
}
export type WaiverCodeStatsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.WaiverCodeStatsQuery, Types.WaiverCodeStatsQueryVariables>;
export const LookupWaiverCodeDocument = gql`
    query LookupWaiverCode($code: String!) {
  lookupWaiverCode(code: $code) {
    ...WaiverCodeRow
  }
}
    ${WaiverCodeRowFragmentDoc}`;

/**
 * __useLookupWaiverCodeQuery__
 *
 * To run a query within a Vue component, call `useLookupWaiverCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupWaiverCodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLookupWaiverCodeQuery({
 *   code: // value for 'code'
 * });
 */
export function useLookupWaiverCodeQuery(variables: Types.LookupWaiverCodeQueryVariables | VueCompositionApi.Ref<Types.LookupWaiverCodeQueryVariables> | ReactiveFunction<Types.LookupWaiverCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>(LookupWaiverCodeDocument, variables, options);
}
export function useLookupWaiverCodeLazyQuery(variables?: Types.LookupWaiverCodeQueryVariables | VueCompositionApi.Ref<Types.LookupWaiverCodeQueryVariables> | ReactiveFunction<Types.LookupWaiverCodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>(LookupWaiverCodeDocument, variables, options);
}
export type LookupWaiverCodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.LookupWaiverCodeQuery, Types.LookupWaiverCodeQueryVariables>;
export const SetWaiverCodesCampusDocument = gql`
    mutation SetWaiverCodesCampus($ids: [ID!]!, $campus_id: ID) {
  setWaiverCodesCampus(ids: $ids, campus_id: $campus_id)
}
    `;

/**
 * __useSetWaiverCodesCampusMutation__
 *
 * To run a mutation, you first call `useSetWaiverCodesCampusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetWaiverCodesCampusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetWaiverCodesCampusMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *     campus_id: // value for 'campus_id'
 *   },
 * });
 */
export function useSetWaiverCodesCampusMutation(options: VueApolloComposable.UseMutationOptions<Types.SetWaiverCodesCampusMutation, Types.SetWaiverCodesCampusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetWaiverCodesCampusMutation, Types.SetWaiverCodesCampusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetWaiverCodesCampusMutation, Types.SetWaiverCodesCampusMutationVariables>(SetWaiverCodesCampusDocument, options);
}
export type SetWaiverCodesCampusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetWaiverCodesCampusMutation, Types.SetWaiverCodesCampusMutationVariables>;
export const RedeemWaiverCodeAtCheckoutDocument = gql`
    mutation RedeemWaiverCodeAtCheckout($bill_id: ID!, $tracking_code: String!, $code: String!) {
  redeemWaiverCodeAtCheckout(
    bill_id: $bill_id
    tracking_code: $tracking_code
    code: $code
  ) {
    tracking_code
    payment_waived_at
  }
}
    `;

/**
 * __useRedeemWaiverCodeAtCheckoutMutation__
 *
 * To run a mutation, you first call `useRedeemWaiverCodeAtCheckoutMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRedeemWaiverCodeAtCheckoutMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRedeemWaiverCodeAtCheckoutMutation({
 *   variables: {
 *     bill_id: // value for 'bill_id'
 *     tracking_code: // value for 'tracking_code'
 *     code: // value for 'code'
 *   },
 * });
 */
export function useRedeemWaiverCodeAtCheckoutMutation(options: VueApolloComposable.UseMutationOptions<Types.RedeemWaiverCodeAtCheckoutMutation, Types.RedeemWaiverCodeAtCheckoutMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RedeemWaiverCodeAtCheckoutMutation, Types.RedeemWaiverCodeAtCheckoutMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RedeemWaiverCodeAtCheckoutMutation, Types.RedeemWaiverCodeAtCheckoutMutationVariables>(RedeemWaiverCodeAtCheckoutDocument, options);
}
export type RedeemWaiverCodeAtCheckoutMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RedeemWaiverCodeAtCheckoutMutation, Types.RedeemWaiverCodeAtCheckoutMutationVariables>;
export const FormWaiverCodeSummaryDocument = gql`
    query FormWaiverCodeSummary($form_id: ID!) {
  form(id: $form_id) {
    id
    waiverCodeSummary {
      total
      available
      used
      revoked
    }
  }
}
    `;

/**
 * __useFormWaiverCodeSummaryQuery__
 *
 * To run a query within a Vue component, call `useFormWaiverCodeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormWaiverCodeSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFormWaiverCodeSummaryQuery({
 *   form_id: // value for 'form_id'
 * });
 */
export function useFormWaiverCodeSummaryQuery(variables: Types.FormWaiverCodeSummaryQueryVariables | VueCompositionApi.Ref<Types.FormWaiverCodeSummaryQueryVariables> | ReactiveFunction<Types.FormWaiverCodeSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>(FormWaiverCodeSummaryDocument, variables, options);
}
export function useFormWaiverCodeSummaryLazyQuery(variables?: Types.FormWaiverCodeSummaryQueryVariables | VueCompositionApi.Ref<Types.FormWaiverCodeSummaryQueryVariables> | ReactiveFunction<Types.FormWaiverCodeSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>(FormWaiverCodeSummaryDocument, variables, options);
}
export type FormWaiverCodeSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.FormWaiverCodeSummaryQuery, Types.FormWaiverCodeSummaryQueryVariables>;
export const GetClassroomTimetableDocument = gql`
    query GetClassroomTimetable($id: ID!) {
  timetable(id: $id) {
    id
    title
    template {
      id
      name
      timeSlots {
        id
        name
        start_time
        end_time
        type
        color
      }
    }
    entries {
      id
      day_of_week
      teachable {
        __typename
        ... on Subject {
          id
          name
        }
        ... on Course {
          id
          course_code
          course_title
        }
      }
      staff {
        id
        user {
          id
          name
        }
      }
      timeSlot {
        id
        name
        start_time
        end_time
      }
      room_name
      custom_title
    }
  }
}
    `;

/**
 * __useGetClassroomTimetableQuery__
 *
 * To run a query within a Vue component, call `useGetClassroomTimetableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomTimetableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClassroomTimetableQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetClassroomTimetableQuery(variables: Types.GetClassroomTimetableQueryVariables | VueCompositionApi.Ref<Types.GetClassroomTimetableQueryVariables> | ReactiveFunction<Types.GetClassroomTimetableQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>(GetClassroomTimetableDocument, variables, options);
}
export function useGetClassroomTimetableLazyQuery(variables?: Types.GetClassroomTimetableQueryVariables | VueCompositionApi.Ref<Types.GetClassroomTimetableQueryVariables> | ReactiveFunction<Types.GetClassroomTimetableQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>(GetClassroomTimetableDocument, variables, options);
}
export type GetClassroomTimetableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetClassroomTimetableQuery, Types.GetClassroomTimetableQueryVariables>;
export const GetAllStaffDocument = gql`
    query GetAllStaff {
  getStaff(first: 1000) {
    data {
      id
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAllStaffQuery__
 *
 * To run a query within a Vue component, call `useGetAllStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllStaffQuery();
 */
export function useGetAllStaffQuery(options: VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>(GetAllStaffDocument, {}, options);
}
export function useGetAllStaffLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>(GetAllStaffDocument, {}, options);
}
export type GetAllStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetAllStaffQuery, Types.GetAllStaffQueryVariables>;
export const GetAllSubjectsDocument = gql`
    query GetAllSubjects {
  listSchoolSubjects {
    id
    name
  }
}
    `;

/**
 * __useGetAllSubjectsQuery__
 *
 * To run a query within a Vue component, call `useGetAllSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSubjectsQuery();
 */
export function useGetAllSubjectsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>(GetAllSubjectsDocument, {}, options);
}
export function useGetAllSubjectsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>(GetAllSubjectsDocument, {}, options);
}
export type GetAllSubjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetAllSubjectsQuery, Types.GetAllSubjectsQueryVariables>;
export const GetAllCoursesDocument = gql`
    query GetAllCourses($first: Int = 100, $page: Int = 1) {
  listSchoolCourses(first: $first, page: $page) {
    data {
      id
      course_code
      course_title
    }
  }
}
    `;

/**
 * __useGetAllCoursesQuery__
 *
 * To run a query within a Vue component, call `useGetAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCoursesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetAllCoursesQuery(variables: Types.GetAllCoursesQueryVariables | VueCompositionApi.Ref<Types.GetAllCoursesQueryVariables> | ReactiveFunction<Types.GetAllCoursesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>(GetAllCoursesDocument, variables, options);
}
export function useGetAllCoursesLazyQuery(variables: Types.GetAllCoursesQueryVariables | VueCompositionApi.Ref<Types.GetAllCoursesQueryVariables> | ReactiveFunction<Types.GetAllCoursesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>(GetAllCoursesDocument, variables, options);
}
export type GetAllCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetAllCoursesQuery, Types.GetAllCoursesQueryVariables>;
export const GetTimetableTemplatesDocument = gql`
    query GetTimetableTemplates {
  timetableTemplates {
    id
    name
    timeSlots {
      id
      name
      start_time
      end_time
      type
      color
    }
  }
}
    `;

/**
 * __useGetTimetableTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetTimetableTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimetableTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTimetableTemplatesQuery();
 */
export function useGetTimetableTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>(GetTimetableTemplatesDocument, {}, options);
}
export function useGetTimetableTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>(GetTimetableTemplatesDocument, {}, options);
}
export type GetTimetableTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTimetableTemplatesQuery, Types.GetTimetableTemplatesQueryVariables>;
export const GetTimetablesDocument = gql`
    query GetTimetables($first: Int, $page: Int, $timeable_id: ID, $timeable_type: TimetableTimeableType) {
  timetables(
    first: $first
    page: $page
    timeable_id: $timeable_id
    timeable_type: $timeable_type
  ) {
    data {
      id
      title
      template {
        id
        name
        timeSlots {
          id
          name
          start_time
          end_time
          type
          color
        }
      }
      entries {
        id
        day_of_week
        teachable {
          __typename
          ... on Subject {
            id
            name
          }
          ... on Course {
            id
            course_code
            course_title
          }
        }
        staff {
          id
          user {
            id
            name
          }
        }
        timeSlot {
          id
          name
          start_time
          end_time
        }
        room_name
        custom_title
      }
      timeable {
        ... on Classroom {
          id
          classroomName: name
        }
        ... on ClassroomSection {
          id
          sectionName: name
          classroom {
            id
            name
          }
          section {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTimetablesQuery__
 *
 * To run a query within a Vue component, call `useGetTimetablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimetablesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTimetablesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   timeable_id: // value for 'timeable_id'
 *   timeable_type: // value for 'timeable_type'
 * });
 */
export function useGetTimetablesQuery(variables: Types.GetTimetablesQueryVariables | VueCompositionApi.Ref<Types.GetTimetablesQueryVariables> | ReactiveFunction<Types.GetTimetablesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>(GetTimetablesDocument, variables, options);
}
export function useGetTimetablesLazyQuery(variables: Types.GetTimetablesQueryVariables | VueCompositionApi.Ref<Types.GetTimetablesQueryVariables> | ReactiveFunction<Types.GetTimetablesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>(GetTimetablesDocument, variables, options);
}
export type GetTimetablesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTimetablesQuery, Types.GetTimetablesQueryVariables>;
export const ArchivedStudentsDocument = gql`
    query ArchivedStudents($search: String, $page: Int, $per_page: Int) {
  archivedStudents(search: $search, page: $page, per_page: $per_page) {
    data {
      id
      student_id
      first_name
      surname
      other_name
      matric_no
      gender
      school_id
      school_name
      deleted_at
      transfer {
        target_school_name
        target_matric_no
        transferred_at
        reason
      }
    }
    total
    current_page
    per_page
  }
}
    `;

/**
 * __useArchivedStudentsQuery__
 *
 * To run a query within a Vue component, call `useArchivedStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedStudentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useArchivedStudentsQuery({
 *   search: // value for 'search'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useArchivedStudentsQuery(variables: Types.ArchivedStudentsQueryVariables | VueCompositionApi.Ref<Types.ArchivedStudentsQueryVariables> | ReactiveFunction<Types.ArchivedStudentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>(ArchivedStudentsDocument, variables, options);
}
export function useArchivedStudentsLazyQuery(variables: Types.ArchivedStudentsQueryVariables | VueCompositionApi.Ref<Types.ArchivedStudentsQueryVariables> | ReactiveFunction<Types.ArchivedStudentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>(ArchivedStudentsDocument, variables, options);
}
export type ArchivedStudentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ArchivedStudentsQuery, Types.ArchivedStudentsQueryVariables>;
export const RestoreStudentDocument = gql`
    mutation RestoreStudent($student_id: ID!) {
  restoreStudent(student_id: $student_id) {
    success
    message
  }
}
    `;

/**
 * __useRestoreStudentMutation__
 *
 * To run a mutation, you first call `useRestoreStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreStudentMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *   },
 * });
 */
export function useRestoreStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.RestoreStudentMutation, Types.RestoreStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RestoreStudentMutation, Types.RestoreStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RestoreStudentMutation, Types.RestoreStudentMutationVariables>(RestoreStudentDocument, options);
}
export type RestoreStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RestoreStudentMutation, Types.RestoreStudentMutationVariables>;
export const PermanentlyDeleteStudentDocument = gql`
    mutation PermanentlyDeleteStudent($student_id: ID!) {
  permanentlyDeleteStudent(student_id: $student_id) {
    success
    message
  }
}
    `;

/**
 * __usePermanentlyDeleteStudentMutation__
 *
 * To run a mutation, you first call `usePermanentlyDeleteStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePermanentlyDeleteStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePermanentlyDeleteStudentMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *   },
 * });
 */
export function usePermanentlyDeleteStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.PermanentlyDeleteStudentMutation, Types.PermanentlyDeleteStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PermanentlyDeleteStudentMutation, Types.PermanentlyDeleteStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PermanentlyDeleteStudentMutation, Types.PermanentlyDeleteStudentMutationVariables>(PermanentlyDeleteStudentDocument, options);
}
export type PermanentlyDeleteStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PermanentlyDeleteStudentMutation, Types.PermanentlyDeleteStudentMutationVariables>;
export const GetSchoolAssessmentTypesDocument = gql`
    query GetSchoolAssessmentTypes($academic_calendar_id: ID, $subject_id: ID, $is_ca: Boolean, $is_exam: Boolean, $include_reusable: Boolean) {
  schoolAssessmentTypes(
    academic_calendar_id: $academic_calendar_id
    subject_id: $subject_id
    is_ca: $is_ca
    is_exam: $is_exam
    include_reusable: $include_reusable
  ) {
    id
    name
    description
    max_score
    is_ca
    is_exam
    sequence
    subject_id
    academic_calendar_id
    subject {
      id
      name
    }
    academicCalendar {
      id
      session {
        name
      }
      termStructure {
        name
      }
    }
  }
}
    `;

/**
 * __useGetSchoolAssessmentTypesQuery__
 *
 * To run a query within a Vue component, call `useGetSchoolAssessmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolAssessmentTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchoolAssessmentTypesQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   subject_id: // value for 'subject_id'
 *   is_ca: // value for 'is_ca'
 *   is_exam: // value for 'is_exam'
 *   include_reusable: // value for 'include_reusable'
 * });
 */
export function useGetSchoolAssessmentTypesQuery(variables: Types.GetSchoolAssessmentTypesQueryVariables | VueCompositionApi.Ref<Types.GetSchoolAssessmentTypesQueryVariables> | ReactiveFunction<Types.GetSchoolAssessmentTypesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>(GetSchoolAssessmentTypesDocument, variables, options);
}
export function useGetSchoolAssessmentTypesLazyQuery(variables: Types.GetSchoolAssessmentTypesQueryVariables | VueCompositionApi.Ref<Types.GetSchoolAssessmentTypesQueryVariables> | ReactiveFunction<Types.GetSchoolAssessmentTypesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>(GetSchoolAssessmentTypesDocument, variables, options);
}
export type GetSchoolAssessmentTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSchoolAssessmentTypesQuery, Types.GetSchoolAssessmentTypesQueryVariables>;
export const GetBillsByStudentDocument = gql`
    query getBillsByStudent($billable_id: ID, $billable_type: String) {
  bills(filters: {billable_id: $billable_id, billable_type: $billable_type}) {
    id
    invoice_number
    amount
    net_amount
    due_date
    status
    balance
    amount_paid
    session {
      id
      name
    }
    academicCalendar {
      id
      termStructure {
        id
        name
      }
    }
    billDetails {
      id
      item_name
      amount
      net_amount
      billItemTemplate {
        id
        name
      }
    }
    paymentStatusDetails {
      total_amount
      amount_paid
      balance
      payment_status
    }
  }
}
    `;

/**
 * __useGetBillsByStudentQuery__
 *
 * To run a query within a Vue component, call `useGetBillsByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillsByStudentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillsByStudentQuery({
 *   billable_id: // value for 'billable_id'
 *   billable_type: // value for 'billable_type'
 * });
 */
export function useGetBillsByStudentQuery(variables: Types.GetBillsByStudentQueryVariables | VueCompositionApi.Ref<Types.GetBillsByStudentQueryVariables> | ReactiveFunction<Types.GetBillsByStudentQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>(GetBillsByStudentDocument, variables, options);
}
export function useGetBillsByStudentLazyQuery(variables: Types.GetBillsByStudentQueryVariables | VueCompositionApi.Ref<Types.GetBillsByStudentQueryVariables> | ReactiveFunction<Types.GetBillsByStudentQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>(GetBillsByStudentDocument, variables, options);
}
export type GetBillsByStudentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillsByStudentQuery, Types.GetBillsByStudentQueryVariables>;
export const GetBillDetailsDocument = gql`
    query getBillDetails($id: ID!) {
  bill(id: $id) {
    id
    amount
    net_amount
    due_date
    status
    balance
    billable {
      ... on Student {
        id
        first_name
        surname
      }
    }
  }
}
    `;

/**
 * __useGetBillDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetBillDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillDetailsQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetBillDetailsQuery(variables: Types.GetBillDetailsQueryVariables | VueCompositionApi.Ref<Types.GetBillDetailsQueryVariables> | ReactiveFunction<Types.GetBillDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>(GetBillDetailsDocument, variables, options);
}
export function useGetBillDetailsLazyQuery(variables?: Types.GetBillDetailsQueryVariables | VueCompositionApi.Ref<Types.GetBillDetailsQueryVariables> | ReactiveFunction<Types.GetBillDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>(GetBillDetailsDocument, variables, options);
}
export type GetBillDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillDetailsQuery, Types.GetBillDetailsQueryVariables>;
export const GetStudentPaymentsDocument = gql`
    query getStudentPayments($student_id: ID) {
  payments(student_id: $student_id) {
    id
    amount
    payment_date
    payment_method
    status
  }
}
    `;

/**
 * __useGetStudentPaymentsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentPaymentsQuery({
 *   student_id: // value for 'student_id'
 * });
 */
export function useGetStudentPaymentsQuery(variables: Types.GetStudentPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetStudentPaymentsQueryVariables> | ReactiveFunction<Types.GetStudentPaymentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>(GetStudentPaymentsDocument, variables, options);
}
export function useGetStudentPaymentsLazyQuery(variables: Types.GetStudentPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetStudentPaymentsQueryVariables> | ReactiveFunction<Types.GetStudentPaymentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>(GetStudentPaymentsDocument, variables, options);
}
export type GetStudentPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentPaymentsQuery, Types.GetStudentPaymentsQueryVariables>;
export const GetStudentFinancialOverviewDocument = gql`
    query getStudentFinancialOverview($id: ID!) {
  student(id: $id) {
    id
    first_name
    surname
    other_name
    currentClassroomSection {
      name
    }
  }
}
    `;

/**
 * __useGetStudentFinancialOverviewQuery__
 *
 * To run a query within a Vue component, call `useGetStudentFinancialOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentFinancialOverviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentFinancialOverviewQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetStudentFinancialOverviewQuery(variables: Types.GetStudentFinancialOverviewQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialOverviewQueryVariables> | ReactiveFunction<Types.GetStudentFinancialOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>(GetStudentFinancialOverviewDocument, variables, options);
}
export function useGetStudentFinancialOverviewLazyQuery(variables?: Types.GetStudentFinancialOverviewQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialOverviewQueryVariables> | ReactiveFunction<Types.GetStudentFinancialOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>(GetStudentFinancialOverviewDocument, variables, options);
}
export type GetStudentFinancialOverviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentFinancialOverviewQuery, Types.GetStudentFinancialOverviewQueryVariables>;
export const ResolveSchoolDocument = gql`
    query ResolveSchool($slug: String, $domain: String) {
  resolveSchool(slug: $slug, domain: $domain) {
    school_id
    school_name
    logo
    app_name
    primary_color
    accent_color
    favicon_url
    login_bg_url
    hide_gradeverse_branding
    frontend_url
  }
}
    `;

/**
 * __useResolveSchoolQuery__
 *
 * To run a query within a Vue component, call `useResolveSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveSchoolQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResolveSchoolQuery({
 *   slug: // value for 'slug'
 *   domain: // value for 'domain'
 * });
 */
export function useResolveSchoolQuery(variables: Types.ResolveSchoolQueryVariables | VueCompositionApi.Ref<Types.ResolveSchoolQueryVariables> | ReactiveFunction<Types.ResolveSchoolQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>(ResolveSchoolDocument, variables, options);
}
export function useResolveSchoolLazyQuery(variables: Types.ResolveSchoolQueryVariables | VueCompositionApi.Ref<Types.ResolveSchoolQueryVariables> | ReactiveFunction<Types.ResolveSchoolQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>(ResolveSchoolDocument, variables, options);
}
export type ResolveSchoolQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ResolveSchoolQuery, Types.ResolveSchoolQueryVariables>;
export const GetBroadsheetTemplatesDocument = gql`
    query GetBroadsheetTemplates {
  broadsheetTemplates(first: 100) {
    data {
      id
      name
      description
      properties
      school {
        id
        name
      }
      columns {
        id
        label
        key
        type
        sequence
        is_visible
        calculation_function
        calculation_arguments
      }
    }
  }
}
    `;

/**
 * __useGetBroadsheetTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetBroadsheetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadsheetTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBroadsheetTemplatesQuery();
 */
export function useGetBroadsheetTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>(GetBroadsheetTemplatesDocument, {}, options);
}
export function useGetBroadsheetTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>(GetBroadsheetTemplatesDocument, {}, options);
}
export type GetBroadsheetTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBroadsheetTemplatesQuery, Types.GetBroadsheetTemplatesQueryVariables>;
export const GetBroadsheetDocument = gql`
    query GetBroadsheet($classId: ID, $calId: ID!, $templateId: ID!, $programmeId: ID, $level: String, $student_status: String) {
  broadsheetReport(
    classroom_id: $classId
    academic_calendar_id: $calId
    broadsheet_template_id: $templateId
    programme_id: $programmeId
    level: $level
    student_status: $student_status
  ) {
    headers
    data
    summary
    course_legend
    grade_legend
    meta {
      program_name
      department_name
      faculty_name
      session
      semester
      level
      classroom_name
    }
  }
}
    `;

/**
 * __useGetBroadsheetQuery__
 *
 * To run a query within a Vue component, call `useGetBroadsheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadsheetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBroadsheetQuery({
 *   classId: // value for 'classId'
 *   calId: // value for 'calId'
 *   templateId: // value for 'templateId'
 *   programmeId: // value for 'programmeId'
 *   level: // value for 'level'
 *   student_status: // value for 'student_status'
 * });
 */
export function useGetBroadsheetQuery(variables: Types.GetBroadsheetQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetQueryVariables> | ReactiveFunction<Types.GetBroadsheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>(GetBroadsheetDocument, variables, options);
}
export function useGetBroadsheetLazyQuery(variables?: Types.GetBroadsheetQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetQueryVariables> | ReactiveFunction<Types.GetBroadsheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>(GetBroadsheetDocument, variables, options);
}
export type GetBroadsheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBroadsheetQuery, Types.GetBroadsheetQueryVariables>;
export const GetBroadsheetExcelUrlDocument = gql`
    query GetBroadsheetExcelUrl($classId: ID, $calId: ID!, $templateId: ID!, $sectionId: ID, $programmeId: ID, $level: String, $student_status: String) {
  broadsheetExcelUrl(
    classroom_id: $classId
    academic_calendar_id: $calId
    broadsheet_template_id: $templateId
    section_id: $sectionId
    programme_id: $programmeId
    level: $level
    student_status: $student_status
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useGetBroadsheetExcelUrlQuery__
 *
 * To run a query within a Vue component, call `useGetBroadsheetExcelUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadsheetExcelUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBroadsheetExcelUrlQuery({
 *   classId: // value for 'classId'
 *   calId: // value for 'calId'
 *   templateId: // value for 'templateId'
 *   sectionId: // value for 'sectionId'
 *   programmeId: // value for 'programmeId'
 *   level: // value for 'level'
 *   student_status: // value for 'student_status'
 * });
 */
export function useGetBroadsheetExcelUrlQuery(variables: Types.GetBroadsheetExcelUrlQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetExcelUrlQueryVariables> | ReactiveFunction<Types.GetBroadsheetExcelUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>(GetBroadsheetExcelUrlDocument, variables, options);
}
export function useGetBroadsheetExcelUrlLazyQuery(variables?: Types.GetBroadsheetExcelUrlQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetExcelUrlQueryVariables> | ReactiveFunction<Types.GetBroadsheetExcelUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>(GetBroadsheetExcelUrlDocument, variables, options);
}
export type GetBroadsheetExcelUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBroadsheetExcelUrlQuery, Types.GetBroadsheetExcelUrlQueryVariables>;
export const GetBroadsheetPdfUrlDocument = gql`
    query GetBroadsheetPdfUrl($classId: ID, $calId: ID!, $templateId: ID!, $sectionId: ID, $programmeId: ID, $level: String, $student_status: String) {
  broadsheetPdfUrl(
    classroom_id: $classId
    academic_calendar_id: $calId
    broadsheet_template_id: $templateId
    section_id: $sectionId
    programme_id: $programmeId
    level: $level
    student_status: $student_status
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useGetBroadsheetPdfUrlQuery__
 *
 * To run a query within a Vue component, call `useGetBroadsheetPdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadsheetPdfUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBroadsheetPdfUrlQuery({
 *   classId: // value for 'classId'
 *   calId: // value for 'calId'
 *   templateId: // value for 'templateId'
 *   sectionId: // value for 'sectionId'
 *   programmeId: // value for 'programmeId'
 *   level: // value for 'level'
 *   student_status: // value for 'student_status'
 * });
 */
export function useGetBroadsheetPdfUrlQuery(variables: Types.GetBroadsheetPdfUrlQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetPdfUrlQueryVariables> | ReactiveFunction<Types.GetBroadsheetPdfUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>(GetBroadsheetPdfUrlDocument, variables, options);
}
export function useGetBroadsheetPdfUrlLazyQuery(variables?: Types.GetBroadsheetPdfUrlQueryVariables | VueCompositionApi.Ref<Types.GetBroadsheetPdfUrlQueryVariables> | ReactiveFunction<Types.GetBroadsheetPdfUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>(GetBroadsheetPdfUrlDocument, variables, options);
}
export type GetBroadsheetPdfUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBroadsheetPdfUrlQuery, Types.GetBroadsheetPdfUrlQueryVariables>;
export const GetQuestionBanksDocument = gql`
    query GetQuestionBanks($name: String, $first: Int = 10, $page: Int) {
  listQuestionBanks(name: $name, first: $first, page: $page) {
    data {
      id
      name
      questions {
        id
        question
      }
    }
    paginatorInfo {
      ...PaginatorParts
    }
  }
}
    ${PaginatorPartsFragmentDoc}`;

/**
 * __useGetQuestionBanksQuery__
 *
 * To run a query within a Vue component, call `useGetQuestionBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionBanksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetQuestionBanksQuery({
 *   name: // value for 'name'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetQuestionBanksQuery(variables: Types.GetQuestionBanksQueryVariables | VueCompositionApi.Ref<Types.GetQuestionBanksQueryVariables> | ReactiveFunction<Types.GetQuestionBanksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>(GetQuestionBanksDocument, variables, options);
}
export function useGetQuestionBanksLazyQuery(variables: Types.GetQuestionBanksQueryVariables | VueCompositionApi.Ref<Types.GetQuestionBanksQueryVariables> | ReactiveFunction<Types.GetQuestionBanksQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>(GetQuestionBanksDocument, variables, options);
}
export type GetQuestionBanksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetQuestionBanksQuery, Types.GetQuestionBanksQueryVariables>;
export const ListCbtTestsDocument = gql`
    query ListCBTTests($first: Int!, $page: Int, $filter: CbtTestFilterInput) {
  listCBTTests(first: $first, page: $page, filter: $filter) {
    paginatorInfo {
      ...PaginatorParts
    }
    data {
      id
      title
      description
      duration
      start_time
      end_time
      school {
        id
        name
      }
      questionBanks {
        id
        name
      }
      question_count
      questions {
        id
        question
      }
      questionable {
        __typename
        ... on ClassroomSection {
          id
          name
          classroom {
            name
          }
        }
        ... on Student {
          id
          surname
          first_name
        }
        ... on Course {
          id
          course_code
          course_title
          unit
          course_instance_id
          course_instance_year
        }
      }
      linkedAssessmentType {
        id
        name
        max_score
        is_ca
        is_exam
      }
    }
  }
}
    ${PaginatorPartsFragmentDoc}`;

/**
 * __useListCbtTestsQuery__
 *
 * To run a query within a Vue component, call `useListCbtTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCbtTestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCbtTestsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   filter: // value for 'filter'
 * });
 */
export function useListCbtTestsQuery(variables: Types.ListCbtTestsQueryVariables | VueCompositionApi.Ref<Types.ListCbtTestsQueryVariables> | ReactiveFunction<Types.ListCbtTestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>(ListCbtTestsDocument, variables, options);
}
export function useListCbtTestsLazyQuery(variables?: Types.ListCbtTestsQueryVariables | VueCompositionApi.Ref<Types.ListCbtTestsQueryVariables> | ReactiveFunction<Types.ListCbtTestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>(ListCbtTestsDocument, variables, options);
}
export type ListCbtTestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListCbtTestsQuery, Types.ListCbtTestsQueryVariables>;
export const ListQuestionsDocument = gql`
    query ListQuestions($bankId: ID!) {
  listQuestions(bankId: $bankId) {
    id
    question
    question_type
    marks
    correct_answer_guidelines
    correct_answer_prose
    images {
      url
    }
    options {
      option
      is_correct
      images {
        url
      }
    }
    questionBank {
      id
      name
    }
  }
}
    `;

/**
 * __useListQuestionsQuery__
 *
 * To run a query within a Vue component, call `useListQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListQuestionsQuery({
 *   bankId: // value for 'bankId'
 * });
 */
export function useListQuestionsQuery(variables: Types.ListQuestionsQueryVariables | VueCompositionApi.Ref<Types.ListQuestionsQueryVariables> | ReactiveFunction<Types.ListQuestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>(ListQuestionsDocument, variables, options);
}
export function useListQuestionsLazyQuery(variables?: Types.ListQuestionsQueryVariables | VueCompositionApi.Ref<Types.ListQuestionsQueryVariables> | ReactiveFunction<Types.ListQuestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>(ListQuestionsDocument, variables, options);
}
export type ListQuestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListQuestionsQuery, Types.ListQuestionsQueryVariables>;
export const ListStudentCbtTestSessionsDocument = gql`
    query ListStudentCBTTestSessions($first: Int! = 100, $page: Int, $studentId: ID) {
  listStudentCBTTestSessions(first: $first, page: $page, studentId: $studentId) {
    paginatorInfo {
      ...PaginatorParts
    }
    data {
      id
      status
      score
      start_time
      end_time
      createdAt
      updatedAt
      cbtTest {
        id
        title
        duration
        subject {
          id
          name
        }
      }
      student {
        id
        first_name
      }
      school {
        id
        name
      }
    }
  }
}
    ${PaginatorPartsFragmentDoc}`;

/**
 * __useListStudentCbtTestSessionsQuery__
 *
 * To run a query within a Vue component, call `useListStudentCbtTestSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStudentCbtTestSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListStudentCbtTestSessionsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   studentId: // value for 'studentId'
 * });
 */
export function useListStudentCbtTestSessionsQuery(variables: Types.ListStudentCbtTestSessionsQueryVariables | VueCompositionApi.Ref<Types.ListStudentCbtTestSessionsQueryVariables> | ReactiveFunction<Types.ListStudentCbtTestSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>(ListStudentCbtTestSessionsDocument, variables, options);
}
export function useListStudentCbtTestSessionsLazyQuery(variables?: Types.ListStudentCbtTestSessionsQueryVariables | VueCompositionApi.Ref<Types.ListStudentCbtTestSessionsQueryVariables> | ReactiveFunction<Types.ListStudentCbtTestSessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>(ListStudentCbtTestSessionsDocument, variables, options);
}
export type ListStudentCbtTestSessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListStudentCbtTestSessionsQuery, Types.ListStudentCbtTestSessionsQueryVariables>;
export const GetCbtTestDocument = gql`
    query GetCBTTest($id: ID!) {
  getCBTTest(id: $id) {
    id
    title
    description
    duration
    start_time
    end_time
    track_progress
    question_count
    questionBanks {
      id
      name
    }
    questions {
      id
      question
      question_type
      options {
        id
        option
        question {
          id
          question
        }
      }
    }
    questionable {
      __typename
      ... on ClassroomSection {
        id
        name
        classroom {
          name
        }
      }
      ... on Student {
        id
        surname
        first_name
      }
      ... on Course {
        id
        course_code
        course_title
      }
      ... on Subject {
        id
        subject_name: name
      }
    }
    narrowClassroom {
      id
      name
    }
    narrowClassroomSection {
      id
      name
    }
    linkedAssessmentType {
      id
      name
      max_score
      is_ca
      is_exam
    }
  }
}
    `;

/**
 * __useGetCbtTestQuery__
 *
 * To run a query within a Vue component, call `useGetCbtTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCbtTestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCbtTestQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCbtTestQuery(variables: Types.GetCbtTestQueryVariables | VueCompositionApi.Ref<Types.GetCbtTestQueryVariables> | ReactiveFunction<Types.GetCbtTestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>(GetCbtTestDocument, variables, options);
}
export function useGetCbtTestLazyQuery(variables?: Types.GetCbtTestQueryVariables | VueCompositionApi.Ref<Types.GetCbtTestQueryVariables> | ReactiveFunction<Types.GetCbtTestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>(GetCbtTestDocument, variables, options);
}
export type GetCbtTestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCbtTestQuery, Types.GetCbtTestQueryVariables>;
export const GetTestResultsDocument = gql`
    query GetTestResults($testId: ID!, $first: Int!, $page: Int, $search: String) {
  getTestResults(testId: $testId, first: $first, page: $page, search: $search) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      student {
        id
        matric_no
        first_name
        surname
      }
      score
      maxScoreSetOnTest
      cbtSession {
        id
        status
        start_time
        end_time
      }
    }
  }
}
    `;

/**
 * __useGetTestResultsQuery__
 *
 * To run a query within a Vue component, call `useGetTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTestResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTestResultsQuery({
 *   testId: // value for 'testId'
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   search: // value for 'search'
 * });
 */
export function useGetTestResultsQuery(variables: Types.GetTestResultsQueryVariables | VueCompositionApi.Ref<Types.GetTestResultsQueryVariables> | ReactiveFunction<Types.GetTestResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>(GetTestResultsDocument, variables, options);
}
export function useGetTestResultsLazyQuery(variables?: Types.GetTestResultsQueryVariables | VueCompositionApi.Ref<Types.GetTestResultsQueryVariables> | ReactiveFunction<Types.GetTestResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>(GetTestResultsDocument, variables, options);
}
export type GetTestResultsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTestResultsQuery, Types.GetTestResultsQueryVariables>;
export const GetCbtTestSessionDocument = gql`
    query GetCBTTestSession($id: ID!) {
  getCBTTestSessionResult(id: $id) {
    id
    status
    score
    start_time
    end_time
    selected_question_ids
    cbtTest {
      id
      title
      duration
      questions {
        id
        question
        question_type
        marks
        correct_answer_guidelines
        correct_answer_prose
        images {
          url
        }
        options {
          id
          option
          images {
            url
          }
        }
      }
    }
    student {
      id
      first_name
      surname
    }
    progress {
      id
      question {
        id
        question
        question_type
      }
      selectedOption {
        id
        option
      }
    }
    theoryQuestionAnswers {
      ai_grade
      feedback
      grading_mode
      id
      instructor_attestation
      instructor_grade
      question {
        id
        question
        question_type
        marks
        correct_answer_guidelines
      }
      student_answer
    }
  }
}
    `;

/**
 * __useGetCbtTestSessionQuery__
 *
 * To run a query within a Vue component, call `useGetCbtTestSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCbtTestSessionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCbtTestSessionQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCbtTestSessionQuery(variables: Types.GetCbtTestSessionQueryVariables | VueCompositionApi.Ref<Types.GetCbtTestSessionQueryVariables> | ReactiveFunction<Types.GetCbtTestSessionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>(GetCbtTestSessionDocument, variables, options);
}
export function useGetCbtTestSessionLazyQuery(variables?: Types.GetCbtTestSessionQueryVariables | VueCompositionApi.Ref<Types.GetCbtTestSessionQueryVariables> | ReactiveFunction<Types.GetCbtTestSessionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>(GetCbtTestSessionDocument, variables, options);
}
export type GetCbtTestSessionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCbtTestSessionQuery, Types.GetCbtTestSessionQueryVariables>;
export const DownloadCbtResultDocument = gql`
    query DownloadCBTResult($cbt_test_session_id: ID!) {
  downloadCBTResult(cbt_test_session_id: $cbt_test_session_id)
}
    `;

/**
 * __useDownloadCbtResultQuery__
 *
 * To run a query within a Vue component, call `useDownloadCbtResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCbtResultQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadCbtResultQuery({
 *   cbt_test_session_id: // value for 'cbt_test_session_id'
 * });
 */
export function useDownloadCbtResultQuery(variables: Types.DownloadCbtResultQueryVariables | VueCompositionApi.Ref<Types.DownloadCbtResultQueryVariables> | ReactiveFunction<Types.DownloadCbtResultQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>(DownloadCbtResultDocument, variables, options);
}
export function useDownloadCbtResultLazyQuery(variables?: Types.DownloadCbtResultQueryVariables | VueCompositionApi.Ref<Types.DownloadCbtResultQueryVariables> | ReactiveFunction<Types.DownloadCbtResultQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>(DownloadCbtResultDocument, variables, options);
}
export type DownloadCbtResultQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadCbtResultQuery, Types.DownloadCbtResultQueryVariables>;
export const DownloadAllCbtTestResultsDocument = gql`
    query DownloadAllCBTTestResults($cbt_test_id: ID!) {
  downloadAllCBTTestResults(cbt_test_id: $cbt_test_id) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useDownloadAllCbtTestResultsQuery__
 *
 * To run a query within a Vue component, call `useDownloadAllCbtTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadAllCbtTestResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadAllCbtTestResultsQuery({
 *   cbt_test_id: // value for 'cbt_test_id'
 * });
 */
export function useDownloadAllCbtTestResultsQuery(variables: Types.DownloadAllCbtTestResultsQueryVariables | VueCompositionApi.Ref<Types.DownloadAllCbtTestResultsQueryVariables> | ReactiveFunction<Types.DownloadAllCbtTestResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>(DownloadAllCbtTestResultsDocument, variables, options);
}
export function useDownloadAllCbtTestResultsLazyQuery(variables?: Types.DownloadAllCbtTestResultsQueryVariables | VueCompositionApi.Ref<Types.DownloadAllCbtTestResultsQueryVariables> | ReactiveFunction<Types.DownloadAllCbtTestResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>(DownloadAllCbtTestResultsDocument, variables, options);
}
export type DownloadAllCbtTestResultsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadAllCbtTestResultsQuery, Types.DownloadAllCbtTestResultsQueryVariables>;
export const DownloadTheoryAnswersDocument = gql`
    query DownloadTheoryAnswers($cbt_test_id: ID!) {
  downloadTheoryAnswers(cbt_test_id: $cbt_test_id) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useDownloadTheoryAnswersQuery__
 *
 * To run a query within a Vue component, call `useDownloadTheoryAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTheoryAnswersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadTheoryAnswersQuery({
 *   cbt_test_id: // value for 'cbt_test_id'
 * });
 */
export function useDownloadTheoryAnswersQuery(variables: Types.DownloadTheoryAnswersQueryVariables | VueCompositionApi.Ref<Types.DownloadTheoryAnswersQueryVariables> | ReactiveFunction<Types.DownloadTheoryAnswersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>(DownloadTheoryAnswersDocument, variables, options);
}
export function useDownloadTheoryAnswersLazyQuery(variables?: Types.DownloadTheoryAnswersQueryVariables | VueCompositionApi.Ref<Types.DownloadTheoryAnswersQueryVariables> | ReactiveFunction<Types.DownloadTheoryAnswersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>(DownloadTheoryAnswersDocument, variables, options);
}
export type DownloadTheoryAnswersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadTheoryAnswersQuery, Types.DownloadTheoryAnswersQueryVariables>;
export const DownloadStudentCbtReportDocument = gql`
    query DownloadStudentCbtReport($student_id: ID!, $cbt_test_ids: [ID!]) {
  downloadStudentCbtReport(student_id: $student_id, cbt_test_ids: $cbt_test_ids) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useDownloadStudentCbtReportQuery__
 *
 * To run a query within a Vue component, call `useDownloadStudentCbtReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadStudentCbtReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadStudentCbtReportQuery({
 *   student_id: // value for 'student_id'
 *   cbt_test_ids: // value for 'cbt_test_ids'
 * });
 */
export function useDownloadStudentCbtReportQuery(variables: Types.DownloadStudentCbtReportQueryVariables | VueCompositionApi.Ref<Types.DownloadStudentCbtReportQueryVariables> | ReactiveFunction<Types.DownloadStudentCbtReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>(DownloadStudentCbtReportDocument, variables, options);
}
export function useDownloadStudentCbtReportLazyQuery(variables?: Types.DownloadStudentCbtReportQueryVariables | VueCompositionApi.Ref<Types.DownloadStudentCbtReportQueryVariables> | ReactiveFunction<Types.DownloadStudentCbtReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>(DownloadStudentCbtReportDocument, variables, options);
}
export type DownloadStudentCbtReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadStudentCbtReportQuery, Types.DownloadStudentCbtReportQueryVariables>;
export const ChatChannelsDocument = gql`
    query ChatChannels {
  chatChannels {
    data {
      id
      school_id
      type
      name
      description
      members {
        user_id
        user_name
        user_email
        role
      }
      last_message {
        id
        sender_name
        body
        created_at
      }
      unread_count
      created_at
    }
    total
  }
}
    `;

/**
 * __useChatChannelsQuery__
 *
 * To run a query within a Vue component, call `useChatChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatChannelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatChannelsQuery();
 */
export function useChatChannelsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>(ChatChannelsDocument, {}, options);
}
export function useChatChannelsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>(ChatChannelsDocument, {}, options);
}
export type ChatChannelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChatChannelsQuery, Types.ChatChannelsQueryVariables>;
export const ChatMessagesDocument = gql`
    query ChatMessages($chat_channel_id: ID!, $cursor: String, $limit: Int) {
  chatMessages(chat_channel_id: $chat_channel_id, cursor: $cursor, limit: $limit) {
    data {
      id
      chat_channel_id
      sender_id
      sender_name
      body
      metadata
      created_at
    }
    has_more
    next_cursor
  }
}
    `;

/**
 * __useChatMessagesQuery__
 *
 * To run a query within a Vue component, call `useChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessagesQuery({
 *   chat_channel_id: // value for 'chat_channel_id'
 *   cursor: // value for 'cursor'
 *   limit: // value for 'limit'
 * });
 */
export function useChatMessagesQuery(variables: Types.ChatMessagesQueryVariables | VueCompositionApi.Ref<Types.ChatMessagesQueryVariables> | ReactiveFunction<Types.ChatMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>(ChatMessagesDocument, variables, options);
}
export function useChatMessagesLazyQuery(variables?: Types.ChatMessagesQueryVariables | VueCompositionApi.Ref<Types.ChatMessagesQueryVariables> | ReactiveFunction<Types.ChatMessagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>(ChatMessagesDocument, variables, options);
}
export type ChatMessagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChatMessagesQuery, Types.ChatMessagesQueryVariables>;
export const ChatContactsDocument = gql`
    query ChatContacts {
  chatContacts {
    user_id
    name
    email
  }
}
    `;

/**
 * __useChatContactsQuery__
 *
 * To run a query within a Vue component, call `useChatContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatContactsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatContactsQuery();
 */
export function useChatContactsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>(ChatContactsDocument, {}, options);
}
export function useChatContactsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>(ChatContactsDocument, {}, options);
}
export type ChatContactsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChatContactsQuery, Types.ChatContactsQueryVariables>;
export const ChatUnreadSummaryDocument = gql`
    query ChatUnreadSummary {
  chatUnreadSummary {
    total_unread
    channels {
      channel_id
      channel_type
      unread_count
    }
  }
}
    `;

/**
 * __useChatUnreadSummaryQuery__
 *
 * To run a query within a Vue component, call `useChatUnreadSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatUnreadSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatUnreadSummaryQuery();
 */
export function useChatUnreadSummaryQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>(ChatUnreadSummaryDocument, {}, options);
}
export function useChatUnreadSummaryLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>(ChatUnreadSummaryDocument, {}, options);
}
export type ChatUnreadSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChatUnreadSummaryQuery, Types.ChatUnreadSummaryQueryVariables>;
export const ChildSchoolChannelsDocument = gql`
    query ChildSchoolChannels {
  childSchoolChannels {
    id
    school_id
    type
    name
    members {
      user_id
      user_name
      role
    }
    last_message {
      id
      sender_name
      body
      created_at
    }
    unread_count
    created_at
  }
}
    `;

/**
 * __useChildSchoolChannelsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolChannelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolChannelsQuery();
 */
export function useChildSchoolChannelsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>(ChildSchoolChannelsDocument, {}, options);
}
export function useChildSchoolChannelsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>(ChildSchoolChannelsDocument, {}, options);
}
export type ChildSchoolChannelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolChannelsQuery, Types.ChildSchoolChannelsQueryVariables>;
export const ParentSchoolGeneralChannelDocument = gql`
    query ParentSchoolGeneralChannel {
  parentSchoolGeneralChannel {
    id
    school_id
    type
    name
    description
    members {
      user_id
      user_name
      role
    }
    last_message {
      id
      sender_name
      body
      created_at
    }
    unread_count
    created_at
  }
}
    `;

/**
 * __useParentSchoolGeneralChannelQuery__
 *
 * To run a query within a Vue component, call `useParentSchoolGeneralChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentSchoolGeneralChannelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useParentSchoolGeneralChannelQuery();
 */
export function useParentSchoolGeneralChannelQuery(options: VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>(ParentSchoolGeneralChannelDocument, {}, options);
}
export function useParentSchoolGeneralChannelLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>(ParentSchoolGeneralChannelDocument, {}, options);
}
export type ParentSchoolGeneralChannelQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ParentSchoolGeneralChannelQuery, Types.ParentSchoolGeneralChannelQueryVariables>;
export const CreateDirectChannelDocument = gql`
    mutation CreateDirectChannel($input: CreateDirectChannelInput!) {
  createDirectChannel(input: $input) {
    id
    type
    name
    members {
      user_id
      user_name
      user_email
      role
    }
    unread_count
    created_at
  }
}
    `;

/**
 * __useCreateDirectChannelMutation__
 *
 * To run a mutation, you first call `useCreateDirectChannelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectChannelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDirectChannelMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectChannelMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateDirectChannelMutation, Types.CreateDirectChannelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateDirectChannelMutation, Types.CreateDirectChannelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateDirectChannelMutation, Types.CreateDirectChannelMutationVariables>(CreateDirectChannelDocument, options);
}
export type CreateDirectChannelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateDirectChannelMutation, Types.CreateDirectChannelMutationVariables>;
export const CreateGroupChannelDocument = gql`
    mutation CreateGroupChannel($input: CreateGroupChannelInput!) {
  createGroupChannel(input: $input) {
    id
    type
    name
    members {
      user_id
      user_name
      user_email
      role
    }
    unread_count
    created_at
  }
}
    `;

/**
 * __useCreateGroupChannelMutation__
 *
 * To run a mutation, you first call `useCreateGroupChannelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupChannelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGroupChannelMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupChannelMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateGroupChannelMutation, Types.CreateGroupChannelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateGroupChannelMutation, Types.CreateGroupChannelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateGroupChannelMutation, Types.CreateGroupChannelMutationVariables>(CreateGroupChannelDocument, options);
}
export type CreateGroupChannelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateGroupChannelMutation, Types.CreateGroupChannelMutationVariables>;
export const ChatShareCardsDocument = gql`
    query ChatShareCards($refs: [ChatShareRefInput!]!) {
  chatShareCards(refs: $refs) {
    type
    id
    access
    title
    subtitle
    detail
    status
    image_url
  }
}
    `;

/**
 * __useChatShareCardsQuery__
 *
 * To run a query within a Vue component, call `useChatShareCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatShareCardsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatShareCardsQuery({
 *   refs: // value for 'refs'
 * });
 */
export function useChatShareCardsQuery(variables: Types.ChatShareCardsQueryVariables | VueCompositionApi.Ref<Types.ChatShareCardsQueryVariables> | ReactiveFunction<Types.ChatShareCardsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>(ChatShareCardsDocument, variables, options);
}
export function useChatShareCardsLazyQuery(variables?: Types.ChatShareCardsQueryVariables | VueCompositionApi.Ref<Types.ChatShareCardsQueryVariables> | ReactiveFunction<Types.ChatShareCardsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>(ChatShareCardsDocument, variables, options);
}
export type ChatShareCardsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChatShareCardsQuery, Types.ChatShareCardsQueryVariables>;
export const SendChatMessageDocument = gql`
    mutation SendChatMessage($input: SendChatMessageInput!) {
  sendChatMessage(input: $input) {
    id
    chat_channel_id
    sender_id
    sender_name
    body
    metadata
    created_at
  }
}
    `;

/**
 * __useSendChatMessageMutation__
 *
 * To run a mutation, you first call `useSendChatMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendChatMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendChatMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendChatMessageMutation(options: VueApolloComposable.UseMutationOptions<Types.SendChatMessageMutation, Types.SendChatMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SendChatMessageMutation, Types.SendChatMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SendChatMessageMutation, Types.SendChatMessageMutationVariables>(SendChatMessageDocument, options);
}
export type SendChatMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SendChatMessageMutation, Types.SendChatMessageMutationVariables>;
export const BroadcastMessageDocument = gql`
    mutation BroadcastMessage($input: BroadcastMessageInput!) {
  broadcastMessage(input: $input) {
    id
    chat_channel_id
    sender_id
    sender_name
    body
    created_at
  }
}
    `;

/**
 * __useBroadcastMessageMutation__
 *
 * To run a mutation, you first call `useBroadcastMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBroadcastMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBroadcastMessageMutation(options: VueApolloComposable.UseMutationOptions<Types.BroadcastMessageMutation, Types.BroadcastMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BroadcastMessageMutation, Types.BroadcastMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BroadcastMessageMutation, Types.BroadcastMessageMutationVariables>(BroadcastMessageDocument, options);
}
export type BroadcastMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BroadcastMessageMutation, Types.BroadcastMessageMutationVariables>;
export const ChatMessageSentDocument = gql`
    subscription ChatMessageSent($chat_channel_id: ID!) {
  chatMessageSent(chat_channel_id: $chat_channel_id) {
    id
    chat_channel_id
    sender_id
    sender_name
    body
    metadata
    created_at
  }
}
    `;

/**
 * __useChatMessageSentSubscription__
 *
 * To run a query within a Vue component, call `useChatMessageSentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatMessageSentSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useChatMessageSentSubscription({
 *   chat_channel_id: // value for 'chat_channel_id'
 * });
 */
export function useChatMessageSentSubscription(variables: Types.ChatMessageSentSubscriptionVariables | VueCompositionApi.Ref<Types.ChatMessageSentSubscriptionVariables> | ReactiveFunction<Types.ChatMessageSentSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.ChatMessageSentSubscription, Types.ChatMessageSentSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.ChatMessageSentSubscription, Types.ChatMessageSentSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.ChatMessageSentSubscription, Types.ChatMessageSentSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.ChatMessageSentSubscription, Types.ChatMessageSentSubscriptionVariables>(ChatMessageSentDocument, variables, options);
}
export type ChatMessageSentSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.ChatMessageSentSubscription, Types.ChatMessageSentSubscriptionVariables>;
export const RegisterPushSubscriptionDocument = gql`
    mutation RegisterPushSubscription($input: RegisterPushSubscriptionInput!) {
  registerPushSubscription(input: $input)
}
    `;

/**
 * __useRegisterPushSubscription__
 *
 * To run a mutation, you first call `useRegisterPushSubscription` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPushSubscription` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterPushSubscription({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPushSubscription(options: VueApolloComposable.UseMutationOptions<Types.RegisterPushSubscriptionMutation, Types.RegisterPushSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RegisterPushSubscriptionMutation, Types.RegisterPushSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RegisterPushSubscriptionMutation, Types.RegisterPushSubscriptionMutationVariables>(RegisterPushSubscriptionDocument, options);
}
export type RegisterPushSubscriptionCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RegisterPushSubscriptionMutation, Types.RegisterPushSubscriptionMutationVariables>;
export const UnregisterPushSubscriptionDocument = gql`
    mutation UnregisterPushSubscription($endpoint: String!) {
  unregisterPushSubscription(endpoint: $endpoint)
}
    `;

/**
 * __useUnregisterPushSubscription__
 *
 * To run a mutation, you first call `useUnregisterPushSubscription` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterPushSubscription` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnregisterPushSubscription({
 *   variables: {
 *     endpoint: // value for 'endpoint'
 *   },
 * });
 */
export function useUnregisterPushSubscription(options: VueApolloComposable.UseMutationOptions<Types.UnregisterPushSubscriptionMutation, Types.UnregisterPushSubscriptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UnregisterPushSubscriptionMutation, Types.UnregisterPushSubscriptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UnregisterPushSubscriptionMutation, Types.UnregisterPushSubscriptionMutationVariables>(UnregisterPushSubscriptionDocument, options);
}
export type UnregisterPushSubscriptionCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UnregisterPushSubscriptionMutation, Types.UnregisterPushSubscriptionMutationVariables>;
export const MarkChannelReadDocument = gql`
    mutation MarkChannelRead($input: MarkChannelReadInput!) {
  markChannelRead(input: $input) {
    chat_channel_id
    last_read_message_id
    read_at
  }
}
    `;

/**
 * __useMarkChannelReadMutation__
 *
 * To run a mutation, you first call `useMarkChannelReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkChannelReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkChannelReadMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useMarkChannelReadMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkChannelReadMutation, Types.MarkChannelReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkChannelReadMutation, Types.MarkChannelReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkChannelReadMutation, Types.MarkChannelReadMutationVariables>(MarkChannelReadDocument, options);
}
export type MarkChannelReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkChannelReadMutation, Types.MarkChannelReadMutationVariables>;
export const ListCourseOutstandingExemptionsDocument = gql`
    query ListCourseOutstandingExemptions($filter: CourseOutstandingExemptionFilterInput) {
  listCourseOutstandingExemptions(filter: $filter) {
    id
    school_id
    student_id
    course_id
    deleted
    createdAt
    updatedAt
    student {
      id
      first_name
      surname
      matric_no
    }
    course {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useListCourseOutstandingExemptionsQuery__
 *
 * To run a query within a Vue component, call `useListCourseOutstandingExemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCourseOutstandingExemptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCourseOutstandingExemptionsQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useListCourseOutstandingExemptionsQuery(variables: Types.ListCourseOutstandingExemptionsQueryVariables | VueCompositionApi.Ref<Types.ListCourseOutstandingExemptionsQueryVariables> | ReactiveFunction<Types.ListCourseOutstandingExemptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>(ListCourseOutstandingExemptionsDocument, variables, options);
}
export function useListCourseOutstandingExemptionsLazyQuery(variables: Types.ListCourseOutstandingExemptionsQueryVariables | VueCompositionApi.Ref<Types.ListCourseOutstandingExemptionsQueryVariables> | ReactiveFunction<Types.ListCourseOutstandingExemptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>(ListCourseOutstandingExemptionsDocument, variables, options);
}
export type ListCourseOutstandingExemptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListCourseOutstandingExemptionsQuery, Types.ListCourseOutstandingExemptionsQueryVariables>;
export const GetCourseOutstandingExemptionDocument = gql`
    query GetCourseOutstandingExemption($id: ID!) {
  getCourseOutstandingExemption(id: $id) {
    id
    school_id
    student_id
    course_id
    deleted
    createdAt
    updatedAt
    student {
      id
      first_name
      surname
      matric_no
    }
    course {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useGetCourseOutstandingExemptionQuery__
 *
 * To run a query within a Vue component, call `useGetCourseOutstandingExemptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseOutstandingExemptionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCourseOutstandingExemptionQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCourseOutstandingExemptionQuery(variables: Types.GetCourseOutstandingExemptionQueryVariables | VueCompositionApi.Ref<Types.GetCourseOutstandingExemptionQueryVariables> | ReactiveFunction<Types.GetCourseOutstandingExemptionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>(GetCourseOutstandingExemptionDocument, variables, options);
}
export function useGetCourseOutstandingExemptionLazyQuery(variables?: Types.GetCourseOutstandingExemptionQueryVariables | VueCompositionApi.Ref<Types.GetCourseOutstandingExemptionQueryVariables> | ReactiveFunction<Types.GetCourseOutstandingExemptionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>(GetCourseOutstandingExemptionDocument, variables, options);
}
export type GetCourseOutstandingExemptionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCourseOutstandingExemptionQuery, Types.GetCourseOutstandingExemptionQueryVariables>;
export const GetCourseRegistrationFinancialClearanceDocument = gql`
    query GetCourseRegistrationFinancialClearance {
  getCourseRegistrationFinancialClearance {
    required
    cleared
    outstanding_balance
    mode
    basis
    pegs {
      bill_id
      bill_label
      percentage_required
      percentage_achieved
      amount_required
      amount_counted
      cleared
    }
  }
}
    `;

/**
 * __useGetCourseRegistrationFinancialClearanceQuery__
 *
 * To run a query within a Vue component, call `useGetCourseRegistrationFinancialClearanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseRegistrationFinancialClearanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCourseRegistrationFinancialClearanceQuery();
 */
export function useGetCourseRegistrationFinancialClearanceQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>(GetCourseRegistrationFinancialClearanceDocument, {}, options);
}
export function useGetCourseRegistrationFinancialClearanceLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>(GetCourseRegistrationFinancialClearanceDocument, {}, options);
}
export type GetCourseRegistrationFinancialClearanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCourseRegistrationFinancialClearanceQuery, Types.GetCourseRegistrationFinancialClearanceQueryVariables>;
export const LessonNoteResourcesDocument = gql`
    query lessonNoteResources($lessonNoteId: ID!) {
  lessonNoteResources(lessonNoteId: $lessonNoteId) {
    id
    title
    description
    resourceType
    accessLevel
    externalUrl
    sortOrder
    createdAt
    updatedAt
    file {
      id
      url
      original_name
      mime_type
      extension
      size
    }
    createdBy {
      id
      name
    }
  }
}
    `;

/**
 * __useLessonNoteResourcesQuery__
 *
 * To run a query within a Vue component, call `useLessonNoteResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonNoteResourcesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLessonNoteResourcesQuery({
 *   lessonNoteId: // value for 'lessonNoteId'
 * });
 */
export function useLessonNoteResourcesQuery(variables: Types.LessonNoteResourcesQueryVariables | VueCompositionApi.Ref<Types.LessonNoteResourcesQueryVariables> | ReactiveFunction<Types.LessonNoteResourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>(LessonNoteResourcesDocument, variables, options);
}
export function useLessonNoteResourcesLazyQuery(variables?: Types.LessonNoteResourcesQueryVariables | VueCompositionApi.Ref<Types.LessonNoteResourcesQueryVariables> | ReactiveFunction<Types.LessonNoteResourcesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>(LessonNoteResourcesDocument, variables, options);
}
export type LessonNoteResourcesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.LessonNoteResourcesQuery, Types.LessonNoteResourcesQueryVariables>;
export const GetFileExportsDocument = gql`
    query GetFileExports($first: Int!, $page: Int) {
  fileExports(first: $first, page: $page) {
    data {
      id
      type
      status
      progress
      file_name
      error_message
      file_url
      file_size
      metadata
      expires_at
      created_at
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      hasMorePages
    }
  }
}
    `;

/**
 * __useGetFileExportsQuery__
 *
 * To run a query within a Vue component, call `useGetFileExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileExportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFileExportsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetFileExportsQuery(variables: Types.GetFileExportsQueryVariables | VueCompositionApi.Ref<Types.GetFileExportsQueryVariables> | ReactiveFunction<Types.GetFileExportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>(GetFileExportsDocument, variables, options);
}
export function useGetFileExportsLazyQuery(variables?: Types.GetFileExportsQueryVariables | VueCompositionApi.Ref<Types.GetFileExportsQueryVariables> | ReactiveFunction<Types.GetFileExportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>(GetFileExportsDocument, variables, options);
}
export type GetFileExportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFileExportsQuery, Types.GetFileExportsQueryVariables>;
export const DownloadScoreSheetDocument = gql`
    query DownloadScoreSheet($classroom_id: ID, $subject_id: ID!, $academic_calendar_id: ID!, $programme_id: ID, $level: String) {
  downloadScoreSheet(
    classroom_id: $classroom_id
    subject_id: $subject_id
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useDownloadScoreSheetQuery__
 *
 * To run a query within a Vue component, call `useDownloadScoreSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadScoreSheetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadScoreSheetQuery({
 *   classroom_id: // value for 'classroom_id'
 *   subject_id: // value for 'subject_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 * });
 */
export function useDownloadScoreSheetQuery(variables: Types.DownloadScoreSheetQueryVariables | VueCompositionApi.Ref<Types.DownloadScoreSheetQueryVariables> | ReactiveFunction<Types.DownloadScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>(DownloadScoreSheetDocument, variables, options);
}
export function useDownloadScoreSheetLazyQuery(variables?: Types.DownloadScoreSheetQueryVariables | VueCompositionApi.Ref<Types.DownloadScoreSheetQueryVariables> | ReactiveFunction<Types.DownloadScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>(DownloadScoreSheetDocument, variables, options);
}
export type DownloadScoreSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadScoreSheetQuery, Types.DownloadScoreSheetQueryVariables>;
export const DeleteExportDocument = gql`
    mutation DeleteExport($id: ID!) {
  deleteExport(id: $id)
}
    `;

/**
 * __useDeleteExportMutation__
 *
 * To run a mutation, you first call `useDeleteExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteExportMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExportMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteExportMutation, Types.DeleteExportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteExportMutation, Types.DeleteExportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteExportMutation, Types.DeleteExportMutationVariables>(DeleteExportDocument, options);
}
export type DeleteExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteExportMutation, Types.DeleteExportMutationVariables>;
export const RetryExportDocument = gql`
    mutation RetryExport($id: ID!) {
  retryExport(id: $id) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useRetryExportMutation__
 *
 * To run a mutation, you first call `useRetryExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryExportMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRetryExportMutation(options: VueApolloComposable.UseMutationOptions<Types.RetryExportMutation, Types.RetryExportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RetryExportMutation, Types.RetryExportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RetryExportMutation, Types.RetryExportMutationVariables>(RetryExportDocument, options);
}
export type RetryExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RetryExportMutation, Types.RetryExportMutationVariables>;
export const ProcessExportNowDocument = gql`
    mutation ProcessExportNow($id: ID!) {
  processExportNow(id: $id) {
    id
    type
    status
    progress
    file_name
    file_url
    file_size
    error_message
    created_at
  }
}
    `;

/**
 * __useProcessExportNowMutation__
 *
 * To run a mutation, you first call `useProcessExportNowMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProcessExportNowMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProcessExportNowMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useProcessExportNowMutation(options: VueApolloComposable.UseMutationOptions<Types.ProcessExportNowMutation, Types.ProcessExportNowMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ProcessExportNowMutation, Types.ProcessExportNowMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ProcessExportNowMutation, Types.ProcessExportNowMutationVariables>(ProcessExportNowDocument, options);
}
export type ProcessExportNowMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ProcessExportNowMutation, Types.ProcessExportNowMutationVariables>;
export const DownloadBulkScoreSheetDocument = gql`
    query DownloadBulkScoreSheet($academic_calendar_id: ID!, $programme_id: ID, $level: String, $classroom_id: ID, $classroom_section_id: ID) {
  downloadBulkScoreSheet(
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
    classroom_id: $classroom_id
    classroom_section_id: $classroom_section_id
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useDownloadBulkScoreSheetQuery__
 *
 * To run a query within a Vue component, call `useDownloadBulkScoreSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBulkScoreSheetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadBulkScoreSheetQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 *   classroom_id: // value for 'classroom_id'
 *   classroom_section_id: // value for 'classroom_section_id'
 * });
 */
export function useDownloadBulkScoreSheetQuery(variables: Types.DownloadBulkScoreSheetQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkScoreSheetQueryVariables> | ReactiveFunction<Types.DownloadBulkScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>(DownloadBulkScoreSheetDocument, variables, options);
}
export function useDownloadBulkScoreSheetLazyQuery(variables?: Types.DownloadBulkScoreSheetQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkScoreSheetQueryVariables> | ReactiveFunction<Types.DownloadBulkScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>(DownloadBulkScoreSheetDocument, variables, options);
}
export type DownloadBulkScoreSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadBulkScoreSheetQuery, Types.DownloadBulkScoreSheetQueryVariables>;
export const DownloadBulkCbtScoresDocument = gql`
    query DownloadBulkCbtScores($academic_calendar_id: ID!, $programme_id: ID, $level: String) {
  downloadBulkCbtScores(
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useDownloadBulkCbtScoresQuery__
 *
 * To run a query within a Vue component, call `useDownloadBulkCbtScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBulkCbtScoresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadBulkCbtScoresQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 * });
 */
export function useDownloadBulkCbtScoresQuery(variables: Types.DownloadBulkCbtScoresQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkCbtScoresQueryVariables> | ReactiveFunction<Types.DownloadBulkCbtScoresQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>(DownloadBulkCbtScoresDocument, variables, options);
}
export function useDownloadBulkCbtScoresLazyQuery(variables?: Types.DownloadBulkCbtScoresQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkCbtScoresQueryVariables> | ReactiveFunction<Types.DownloadBulkCbtScoresQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>(DownloadBulkCbtScoresDocument, variables, options);
}
export type DownloadBulkCbtScoresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadBulkCbtScoresQuery, Types.DownloadBulkCbtScoresQueryVariables>;
export const DownloadBulkScoreSheetWithCbtDocument = gql`
    query DownloadBulkScoreSheetWithCbt($academic_calendar_id: ID!, $programme_id: ID, $level: String, $classroom_id: ID, $classroom_section_id: ID) {
  downloadBulkScoreSheetWithCbt(
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
    classroom_id: $classroom_id
    classroom_section_id: $classroom_section_id
  ) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useDownloadBulkScoreSheetWithCbtQuery__
 *
 * To run a query within a Vue component, call `useDownloadBulkScoreSheetWithCbtQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBulkScoreSheetWithCbtQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadBulkScoreSheetWithCbtQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 *   classroom_id: // value for 'classroom_id'
 *   classroom_section_id: // value for 'classroom_section_id'
 * });
 */
export function useDownloadBulkScoreSheetWithCbtQuery(variables: Types.DownloadBulkScoreSheetWithCbtQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkScoreSheetWithCbtQueryVariables> | ReactiveFunction<Types.DownloadBulkScoreSheetWithCbtQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>(DownloadBulkScoreSheetWithCbtDocument, variables, options);
}
export function useDownloadBulkScoreSheetWithCbtLazyQuery(variables?: Types.DownloadBulkScoreSheetWithCbtQueryVariables | VueCompositionApi.Ref<Types.DownloadBulkScoreSheetWithCbtQueryVariables> | ReactiveFunction<Types.DownloadBulkScoreSheetWithCbtQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>(DownloadBulkScoreSheetWithCbtDocument, variables, options);
}
export type DownloadBulkScoreSheetWithCbtQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadBulkScoreSheetWithCbtQuery, Types.DownloadBulkScoreSheetWithCbtQueryVariables>;
export const PreviewBulkScoreSheetDocument = gql`
    query PreviewBulkScoreSheet($academic_calendar_id: ID!, $programme_id: ID, $level: String, $classroom_id: ID, $classroom_section_id: ID) {
  previewBulkScoreSheet(
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
    classroom_id: $classroom_id
    classroom_section_id: $classroom_section_id
  ) {
    items {
      course_code
      course_title
      student_count
    }
    total_courses
    has_template
  }
}
    `;

/**
 * __usePreviewBulkScoreSheetQuery__
 *
 * To run a query within a Vue component, call `usePreviewBulkScoreSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewBulkScoreSheetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePreviewBulkScoreSheetQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 *   classroom_id: // value for 'classroom_id'
 *   classroom_section_id: // value for 'classroom_section_id'
 * });
 */
export function usePreviewBulkScoreSheetQuery(variables: Types.PreviewBulkScoreSheetQueryVariables | VueCompositionApi.Ref<Types.PreviewBulkScoreSheetQueryVariables> | ReactiveFunction<Types.PreviewBulkScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>(PreviewBulkScoreSheetDocument, variables, options);
}
export function usePreviewBulkScoreSheetLazyQuery(variables?: Types.PreviewBulkScoreSheetQueryVariables | VueCompositionApi.Ref<Types.PreviewBulkScoreSheetQueryVariables> | ReactiveFunction<Types.PreviewBulkScoreSheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>(PreviewBulkScoreSheetDocument, variables, options);
}
export type PreviewBulkScoreSheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PreviewBulkScoreSheetQuery, Types.PreviewBulkScoreSheetQueryVariables>;
export const PreviewBulkCbtScoresDocument = gql`
    query PreviewBulkCbtScores($academic_calendar_id: ID!, $programme_id: ID, $level: String) {
  previewBulkCbtScores(
    academic_calendar_id: $academic_calendar_id
    programme_id: $programme_id
    level: $level
  ) {
    items {
      course_code
      course_title
      tests {
        test_title
        session_count
      }
      student_count
    }
    unlinked_count
    total_tests
  }
}
    `;

/**
 * __usePreviewBulkCbtScoresQuery__
 *
 * To run a query within a Vue component, call `usePreviewBulkCbtScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewBulkCbtScoresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePreviewBulkCbtScoresQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 * });
 */
export function usePreviewBulkCbtScoresQuery(variables: Types.PreviewBulkCbtScoresQueryVariables | VueCompositionApi.Ref<Types.PreviewBulkCbtScoresQueryVariables> | ReactiveFunction<Types.PreviewBulkCbtScoresQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>(PreviewBulkCbtScoresDocument, variables, options);
}
export function usePreviewBulkCbtScoresLazyQuery(variables?: Types.PreviewBulkCbtScoresQueryVariables | VueCompositionApi.Ref<Types.PreviewBulkCbtScoresQueryVariables> | ReactiveFunction<Types.PreviewBulkCbtScoresQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>(PreviewBulkCbtScoresDocument, variables, options);
}
export type PreviewBulkCbtScoresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PreviewBulkCbtScoresQuery, Types.PreviewBulkCbtScoresQueryVariables>;
export const ImportBulkScoreSheetDocument = gql`
    mutation ImportBulkScoreSheet($file: Upload!, $classroom_id: ID!, $academic_calendar_id: ID!) {
  importBulkScoreSheet(
    file: $file
    classroom_id: $classroom_id
    academic_calendar_id: $academic_calendar_id
  ) {
    success
    message
    code
  }
}
    `;

/**
 * __useImportBulkScoreSheetMutation__
 *
 * To run a mutation, you first call `useImportBulkScoreSheetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportBulkScoreSheetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportBulkScoreSheetMutation({
 *   variables: {
 *     file: // value for 'file'
 *     classroom_id: // value for 'classroom_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useImportBulkScoreSheetMutation(options: VueApolloComposable.UseMutationOptions<Types.ImportBulkScoreSheetMutation, Types.ImportBulkScoreSheetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ImportBulkScoreSheetMutation, Types.ImportBulkScoreSheetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ImportBulkScoreSheetMutation, Types.ImportBulkScoreSheetMutationVariables>(ImportBulkScoreSheetDocument, options);
}
export type ImportBulkScoreSheetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ImportBulkScoreSheetMutation, Types.ImportBulkScoreSheetMutationVariables>;
export const ExportStatusUpdatedDocument = gql`
    subscription ExportStatusUpdated($user_id: ID!) {
  exportStatusUpdated(user_id: $user_id) {
    id
    type
    status
    progress
    file_name
    error_message
    file_url
    file_size
    metadata
    expires_at
    created_at
  }
}
    `;

/**
 * __useExportStatusUpdatedSubscription__
 *
 * To run a query within a Vue component, call `useExportStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useExportStatusUpdatedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useExportStatusUpdatedSubscription({
 *   user_id: // value for 'user_id'
 * });
 */
export function useExportStatusUpdatedSubscription(variables: Types.ExportStatusUpdatedSubscriptionVariables | VueCompositionApi.Ref<Types.ExportStatusUpdatedSubscriptionVariables> | ReactiveFunction<Types.ExportStatusUpdatedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.ExportStatusUpdatedSubscription, Types.ExportStatusUpdatedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.ExportStatusUpdatedSubscription, Types.ExportStatusUpdatedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.ExportStatusUpdatedSubscription, Types.ExportStatusUpdatedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.ExportStatusUpdatedSubscription, Types.ExportStatusUpdatedSubscriptionVariables>(ExportStatusUpdatedDocument, variables, options);
}
export type ExportStatusUpdatedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.ExportStatusUpdatedSubscription, Types.ExportStatusUpdatedSubscriptionVariables>;
export const GetSchoolGradeGroupsDocument = gql`
    query GetSchoolGradeGroups {
  getSchoolGradeGroups {
    id
    name
    description
    gradeBands {
      id
      name
      grade
      minimum
      maximum
      point
      group
    }
  }
}
    `;

/**
 * __useGetSchoolGradeGroupsQuery__
 *
 * To run a query within a Vue component, call `useGetSchoolGradeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchoolGradeGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchoolGradeGroupsQuery();
 */
export function useGetSchoolGradeGroupsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>(GetSchoolGradeGroupsDocument, {}, options);
}
export function useGetSchoolGradeGroupsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>(GetSchoolGradeGroupsDocument, {}, options);
}
export type GetSchoolGradeGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSchoolGradeGroupsQuery, Types.GetSchoolGradeGroupsQueryVariables>;
export const GuardiansDocument = gql`
    query guardians($classroomId: ID, $programmeId: ID, $departmentId: ID, $facultyId: ID, $hasStudentLinks: Boolean) {
  guardians(
    classroomId: $classroomId
    programmeId: $programmeId
    departmentId: $departmentId
    facultyId: $facultyId
    hasStudentLinks: $hasStudentLinks
  ) {
    ...GuardianFields
  }
}
    ${GuardianFieldsFragmentDoc}`;

/**
 * __useGuardiansQuery__
 *
 * To run a query within a Vue component, call `useGuardiansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardiansQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardiansQuery({
 *   classroomId: // value for 'classroomId'
 *   programmeId: // value for 'programmeId'
 *   departmentId: // value for 'departmentId'
 *   facultyId: // value for 'facultyId'
 *   hasStudentLinks: // value for 'hasStudentLinks'
 * });
 */
export function useGuardiansQuery(variables: Types.GuardiansQueryVariables | VueCompositionApi.Ref<Types.GuardiansQueryVariables> | ReactiveFunction<Types.GuardiansQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardiansQuery, Types.GuardiansQueryVariables>(GuardiansDocument, variables, options);
}
export function useGuardiansLazyQuery(variables: Types.GuardiansQueryVariables | VueCompositionApi.Ref<Types.GuardiansQueryVariables> | ReactiveFunction<Types.GuardiansQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardiansQuery, Types.GuardiansQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardiansQuery, Types.GuardiansQueryVariables>(GuardiansDocument, variables, options);
}
export type GuardiansQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardiansQuery, Types.GuardiansQueryVariables>;
export const GuardianFilterOptionsDocument = gql`
    query GuardianFilterOptions {
  getSchool {
    id
    classrooms {
      id
      name
    }
  }
  listSchoolFaculties(first: 100) {
    data {
      id
      faculty_name
      departments {
        id
        department_name
        programmes {
          id
          program_name
        }
      }
    }
  }
}
    `;

/**
 * __useGuardianFilterOptionsQuery__
 *
 * To run a query within a Vue component, call `useGuardianFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianFilterOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianFilterOptionsQuery();
 */
export function useGuardianFilterOptionsQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>(GuardianFilterOptionsDocument, {}, options);
}
export function useGuardianFilterOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>(GuardianFilterOptionsDocument, {}, options);
}
export type GuardianFilterOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianFilterOptionsQuery, Types.GuardianFilterOptionsQueryVariables>;
export const GuardianDocument = gql`
    query guardian($id: ID!) {
  guardian(id: $id) {
    ...GuardianFields
  }
}
    ${GuardianFieldsFragmentDoc}`;

/**
 * __useGuardianQuery__
 *
 * To run a query within a Vue component, call `useGuardianQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianQuery({
 *   id: // value for 'id'
 * });
 */
export function useGuardianQuery(variables: Types.GuardianQueryVariables | VueCompositionApi.Ref<Types.GuardianQueryVariables> | ReactiveFunction<Types.GuardianQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianQuery, Types.GuardianQueryVariables>(GuardianDocument, variables, options);
}
export function useGuardianLazyQuery(variables?: Types.GuardianQueryVariables | VueCompositionApi.Ref<Types.GuardianQueryVariables> | ReactiveFunction<Types.GuardianQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianQuery, Types.GuardianQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianQuery, Types.GuardianQueryVariables>(GuardianDocument, variables, options);
}
export type GuardianQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianQuery, Types.GuardianQueryVariables>;
export const GuardiansByStudentDocument = gql`
    query guardiansByStudent($studentId: ID!) {
  guardiansByStudent(studentId: $studentId) {
    ...GuardianFields
  }
}
    ${GuardianFieldsFragmentDoc}`;

/**
 * __useGuardiansByStudentQuery__
 *
 * To run a query within a Vue component, call `useGuardiansByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardiansByStudentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardiansByStudentQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardiansByStudentQuery(variables: Types.GuardiansByStudentQueryVariables | VueCompositionApi.Ref<Types.GuardiansByStudentQueryVariables> | ReactiveFunction<Types.GuardiansByStudentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>(GuardiansByStudentDocument, variables, options);
}
export function useGuardiansByStudentLazyQuery(variables?: Types.GuardiansByStudentQueryVariables | VueCompositionApi.Ref<Types.GuardiansByStudentQueryVariables> | ReactiveFunction<Types.GuardiansByStudentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>(GuardiansByStudentDocument, variables, options);
}
export type GuardiansByStudentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardiansByStudentQuery, Types.GuardiansByStudentQueryVariables>;
export const LessonNotesDocument = gql`
    query lessonNotes($subjectId: ID, $classroomId: ID, $schemeWeekId: ID, $schemeOfWorkId: ID, $status: LessonNoteStatus) {
  lessonNotes(
    subjectId: $subjectId
    classroomId: $classroomId
    schemeWeekId: $schemeWeekId
    schemeOfWorkId: $schemeOfWorkId
    status: $status
  ) {
    id
    title
    status
    aiGenerated
    aiModel
    aiGeneratedAt
    createdAt
    updatedAt
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    schemeWeek {
      id
      weekNumber
      topic
      schemeOfWork {
        id
        title
      }
    }
    createdBy {
      id
      name
    }
    resources {
      id
    }
  }
}
    `;

/**
 * __useLessonNotesQuery__
 *
 * To run a query within a Vue component, call `useLessonNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonNotesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLessonNotesQuery({
 *   subjectId: // value for 'subjectId'
 *   classroomId: // value for 'classroomId'
 *   schemeWeekId: // value for 'schemeWeekId'
 *   schemeOfWorkId: // value for 'schemeOfWorkId'
 *   status: // value for 'status'
 * });
 */
export function useLessonNotesQuery(variables: Types.LessonNotesQueryVariables | VueCompositionApi.Ref<Types.LessonNotesQueryVariables> | ReactiveFunction<Types.LessonNotesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>(LessonNotesDocument, variables, options);
}
export function useLessonNotesLazyQuery(variables: Types.LessonNotesQueryVariables | VueCompositionApi.Ref<Types.LessonNotesQueryVariables> | ReactiveFunction<Types.LessonNotesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>(LessonNotesDocument, variables, options);
}
export type LessonNotesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.LessonNotesQuery, Types.LessonNotesQueryVariables>;
export const LessonNoteApprovalModeDocument = gql`
    query lessonNoteApprovalMode {
  lessonNoteApprovalMode
}
    `;

/**
 * __useLessonNoteApprovalModeQuery__
 *
 * To run a query within a Vue component, call `useLessonNoteApprovalModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonNoteApprovalModeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLessonNoteApprovalModeQuery();
 */
export function useLessonNoteApprovalModeQuery(options: VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>(LessonNoteApprovalModeDocument, {}, options);
}
export function useLessonNoteApprovalModeLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>(LessonNoteApprovalModeDocument, {}, options);
}
export type LessonNoteApprovalModeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.LessonNoteApprovalModeQuery, Types.LessonNoteApprovalModeQueryVariables>;
export const LessonNoteDocument = gql`
    query lessonNote($id: ID!) {
  lessonNote(id: $id) {
    id
    title
    body
    status
    aiGenerated
    aiModel
    aiGeneratedAt
    submittedAt
    reviewedAt
    reviewNotes
    createdAt
    updatedAt
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    schemeWeek {
      id
      weekNumber
      topic
      learningObjectives
      schemeOfWork {
        id
        title
      }
    }
    createdBy {
      id
      name
    }
    submittedBy {
      id
      name
    }
    reviewedBy {
      id
      name
    }
    resources {
      id
      title
      description
      resourceType
      accessLevel
      externalUrl
      sortOrder
      createdAt
      updatedAt
      file {
        id
        url
        original_name
        mime_type
        extension
        size
      }
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useLessonNoteQuery__
 *
 * To run a query within a Vue component, call `useLessonNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonNoteQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLessonNoteQuery({
 *   id: // value for 'id'
 * });
 */
export function useLessonNoteQuery(variables: Types.LessonNoteQueryVariables | VueCompositionApi.Ref<Types.LessonNoteQueryVariables> | ReactiveFunction<Types.LessonNoteQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>(LessonNoteDocument, variables, options);
}
export function useLessonNoteLazyQuery(variables?: Types.LessonNoteQueryVariables | VueCompositionApi.Ref<Types.LessonNoteQueryVariables> | ReactiveFunction<Types.LessonNoteQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>(LessonNoteDocument, variables, options);
}
export type LessonNoteQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.LessonNoteQuery, Types.LessonNoteQueryVariables>;
export const ModuleCloneCurriculumDocument = gql`
    query ModuleCloneCurriculum($programmeId: Int!) {
  listCurriculumsByProgram(prog_id: $programmeId) {
    id
    course_registration_level
    semester
    course {
      id
      course_code
      course_title
    }
  }
}
    `;

/**
 * __useModuleCloneCurriculumQuery__
 *
 * To run a query within a Vue component, call `useModuleCloneCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleCloneCurriculumQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useModuleCloneCurriculumQuery({
 *   programmeId: // value for 'programmeId'
 * });
 */
export function useModuleCloneCurriculumQuery(variables: Types.ModuleCloneCurriculumQueryVariables | VueCompositionApi.Ref<Types.ModuleCloneCurriculumQueryVariables> | ReactiveFunction<Types.ModuleCloneCurriculumQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>(ModuleCloneCurriculumDocument, variables, options);
}
export function useModuleCloneCurriculumLazyQuery(variables?: Types.ModuleCloneCurriculumQueryVariables | VueCompositionApi.Ref<Types.ModuleCloneCurriculumQueryVariables> | ReactiveFunction<Types.ModuleCloneCurriculumQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>(ModuleCloneCurriculumDocument, variables, options);
}
export type ModuleCloneCurriculumQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ModuleCloneCurriculumQuery, Types.ModuleCloneCurriculumQueryVariables>;
export const ModuleElectiveOfferingsDocument = gql`
    query ModuleElectiveOfferings($moduleId: ID!) {
  moduleElectiveOfferings(module_id: $moduleId) {
    id
    course_id
    academic_calendar_id
    course {
      id
      course_code
      course_title
      unit
    }
    academicCalendar {
      id
      termStructure {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useModuleElectiveOfferingsQuery__
 *
 * To run a query within a Vue component, call `useModuleElectiveOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleElectiveOfferingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useModuleElectiveOfferingsQuery({
 *   moduleId: // value for 'moduleId'
 * });
 */
export function useModuleElectiveOfferingsQuery(variables: Types.ModuleElectiveOfferingsQueryVariables | VueCompositionApi.Ref<Types.ModuleElectiveOfferingsQueryVariables> | ReactiveFunction<Types.ModuleElectiveOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>(ModuleElectiveOfferingsDocument, variables, options);
}
export function useModuleElectiveOfferingsLazyQuery(variables?: Types.ModuleElectiveOfferingsQueryVariables | VueCompositionApi.Ref<Types.ModuleElectiveOfferingsQueryVariables> | ReactiveFunction<Types.ModuleElectiveOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>(ModuleElectiveOfferingsDocument, variables, options);
}
export type ModuleElectiveOfferingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ModuleElectiveOfferingsQuery, Types.ModuleElectiveOfferingsQueryVariables>;
export const ModuleElectiveCandidatesDocument = gql`
    query ModuleElectiveCandidates($moduleId: ID!, $calendarId: ID!, $query: String) {
  moduleElectiveCandidates(
    module_id: $moduleId
    academic_calendar_id: $calendarId
    query: $query
    first: 100
  ) {
    id
    course_code
    course_title
    unit
  }
}
    `;

/**
 * __useModuleElectiveCandidatesQuery__
 *
 * To run a query within a Vue component, call `useModuleElectiveCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleElectiveCandidatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useModuleElectiveCandidatesQuery({
 *   moduleId: // value for 'moduleId'
 *   calendarId: // value for 'calendarId'
 *   query: // value for 'query'
 * });
 */
export function useModuleElectiveCandidatesQuery(variables: Types.ModuleElectiveCandidatesQueryVariables | VueCompositionApi.Ref<Types.ModuleElectiveCandidatesQueryVariables> | ReactiveFunction<Types.ModuleElectiveCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>(ModuleElectiveCandidatesDocument, variables, options);
}
export function useModuleElectiveCandidatesLazyQuery(variables?: Types.ModuleElectiveCandidatesQueryVariables | VueCompositionApi.Ref<Types.ModuleElectiveCandidatesQueryVariables> | ReactiveFunction<Types.ModuleElectiveCandidatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>(ModuleElectiveCandidatesDocument, variables, options);
}
export type ModuleElectiveCandidatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ModuleElectiveCandidatesQuery, Types.ModuleElectiveCandidatesQueryVariables>;
export const SearchModuleElectivesDocument = gql`
    query SearchModuleElectives($moduleId: ID!, $query: String) {
  searchModuleElectiveCourses(module_id: $moduleId, query: $query, first: 100) {
    module_id
    courses {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useSearchModuleElectivesQuery__
 *
 * To run a query within a Vue component, call `useSearchModuleElectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchModuleElectivesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchModuleElectivesQuery({
 *   moduleId: // value for 'moduleId'
 *   query: // value for 'query'
 * });
 */
export function useSearchModuleElectivesQuery(variables: Types.SearchModuleElectivesQueryVariables | VueCompositionApi.Ref<Types.SearchModuleElectivesQueryVariables> | ReactiveFunction<Types.SearchModuleElectivesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>(SearchModuleElectivesDocument, variables, options);
}
export function useSearchModuleElectivesLazyQuery(variables?: Types.SearchModuleElectivesQueryVariables | VueCompositionApi.Ref<Types.SearchModuleElectivesQueryVariables> | ReactiveFunction<Types.SearchModuleElectivesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>(SearchModuleElectivesDocument, variables, options);
}
export type SearchModuleElectivesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SearchModuleElectivesQuery, Types.SearchModuleElectivesQueryVariables>;
export const ModuleRegistrationPaymentsDocument = gql`
    query ModuleRegistrationPayments($module_ids: [ID!]!) {
  moduleRegistrationPayments(module_ids: $module_ids) {
    amount
    paid
    outstanding
    cleared
    modules {
      module_id
      module_name
      bill_id
      amount
      paid
      outstanding
      cleared
      attempt_number
    }
  }
}
    `;

/**
 * __useModuleRegistrationPaymentsQuery__
 *
 * To run a query within a Vue component, call `useModuleRegistrationPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleRegistrationPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useModuleRegistrationPaymentsQuery({
 *   module_ids: // value for 'module_ids'
 * });
 */
export function useModuleRegistrationPaymentsQuery(variables: Types.ModuleRegistrationPaymentsQueryVariables | VueCompositionApi.Ref<Types.ModuleRegistrationPaymentsQueryVariables> | ReactiveFunction<Types.ModuleRegistrationPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>(ModuleRegistrationPaymentsDocument, variables, options);
}
export function useModuleRegistrationPaymentsLazyQuery(variables?: Types.ModuleRegistrationPaymentsQueryVariables | VueCompositionApi.Ref<Types.ModuleRegistrationPaymentsQueryVariables> | ReactiveFunction<Types.ModuleRegistrationPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>(ModuleRegistrationPaymentsDocument, variables, options);
}
export type ModuleRegistrationPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ModuleRegistrationPaymentsQuery, Types.ModuleRegistrationPaymentsQueryVariables>;
export const ChildSchoolsSummaryDocument = gql`
    query ChildSchoolsSummary {
  childSchoolsSummary {
    children {
      school {
        id
        name
        school_type
      }
      total_students
      male_students
      female_students
      total_staff
      active_calendar
    }
    totals {
      total_students
      total_staff
      total_schools
    }
  }
}
    `;

/**
 * __useChildSchoolsSummaryQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolsSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolsSummaryQuery();
 */
export function useChildSchoolsSummaryQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>(ChildSchoolsSummaryDocument, {}, options);
}
export function useChildSchoolsSummaryLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>(ChildSchoolsSummaryDocument, {}, options);
}
export type ChildSchoolsSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolsSummaryQuery, Types.ChildSchoolsSummaryQueryVariables>;
export const ChildSchoolFinancialsDocument = gql`
    query ChildSchoolFinancials {
  childSchoolFinancials {
    children {
      school {
        id
        name
      }
      total_billed
      total_paid
      total_outstanding
      collection_rate
      hq_share
      campus_share
    }
    totals {
      total_billed
      total_paid
      total_outstanding
      collection_rate
      hq_share
      campus_share
    }
  }
}
    `;

/**
 * __useChildSchoolFinancialsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolFinancialsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolFinancialsQuery();
 */
export function useChildSchoolFinancialsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>(ChildSchoolFinancialsDocument, {}, options);
}
export function useChildSchoolFinancialsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>(ChildSchoolFinancialsDocument, {}, options);
}
export type ChildSchoolFinancialsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolFinancialsQuery, Types.ChildSchoolFinancialsQueryVariables>;
export const ChildSchoolStaffDocument = gql`
    query ChildSchoolStaff {
  childSchoolStaff {
    school {
      id
      name
    }
    user_id
    user_name
    email
    status
  }
}
    `;

/**
 * __useChildSchoolStaffQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolStaffQuery();
 */
export function useChildSchoolStaffQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>(ChildSchoolStaffDocument, {}, options);
}
export function useChildSchoolStaffLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>(ChildSchoolStaffDocument, {}, options);
}
export type ChildSchoolStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolStaffQuery, Types.ChildSchoolStaffQueryVariables>;
export const ChildSchoolsAttendanceDocument = gql`
    query ChildSchoolsAttendance($date: Date) {
  childSchoolsAttendance(date: $date) {
    children {
      school {
        id
        name
      }
      present
      absent
      late
      excused
      total
      percentage
    }
    totals {
      present
      absent
      late
      excused
      total
      percentage
    }
  }
}
    `;

/**
 * __useChildSchoolsAttendanceQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolsAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolsAttendanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolsAttendanceQuery({
 *   date: // value for 'date'
 * });
 */
export function useChildSchoolsAttendanceQuery(variables: Types.ChildSchoolsAttendanceQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolsAttendanceQueryVariables> | ReactiveFunction<Types.ChildSchoolsAttendanceQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>(ChildSchoolsAttendanceDocument, variables, options);
}
export function useChildSchoolsAttendanceLazyQuery(variables: Types.ChildSchoolsAttendanceQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolsAttendanceQueryVariables> | ReactiveFunction<Types.ChildSchoolsAttendanceQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>(ChildSchoolsAttendanceDocument, variables, options);
}
export type ChildSchoolsAttendanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolsAttendanceQuery, Types.ChildSchoolsAttendanceQueryVariables>;
export const ChildSchoolsResultsDocument = gql`
    query ChildSchoolsResults {
  childSchoolsResults {
    children {
      school {
        id
        name
      }
      total_published
      total_not_published
    }
    totals {
      total_published
      total_not_published
    }
  }
}
    `;

/**
 * __useChildSchoolsResultsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolsResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolsResultsQuery();
 */
export function useChildSchoolsResultsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>(ChildSchoolsResultsDocument, {}, options);
}
export function useChildSchoolsResultsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>(ChildSchoolsResultsDocument, {}, options);
}
export type ChildSchoolsResultsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolsResultsQuery, Types.ChildSchoolsResultsQueryVariables>;
export const AssignStaffToChildSchoolsDocument = gql`
    mutation AssignStaffToChildSchools($input: AssignStaffToChildSchoolsInput!) {
  assignStaffToChildSchools(input: $input) {
    success
    message
    assigned_count
    skipped_schools
  }
}
    `;

/**
 * __useAssignStaffToChildSchoolsMutation__
 *
 * To run a mutation, you first call `useAssignStaffToChildSchoolsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignStaffToChildSchoolsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignStaffToChildSchoolsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignStaffToChildSchoolsMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignStaffToChildSchoolsMutation, Types.AssignStaffToChildSchoolsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignStaffToChildSchoolsMutation, Types.AssignStaffToChildSchoolsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignStaffToChildSchoolsMutation, Types.AssignStaffToChildSchoolsMutationVariables>(AssignStaffToChildSchoolsDocument, options);
}
export type AssignStaffToChildSchoolsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignStaffToChildSchoolsMutation, Types.AssignStaffToChildSchoolsMutationVariables>;
export const CopySchoolTemplatesDocument = gql`
    mutation CopySchoolTemplates($input: CopySchoolTemplatesInput!) {
  copySchoolTemplates(input: $input) {
    success
    message
    copied
  }
}
    `;

/**
 * __useCopySchoolTemplatesMutation__
 *
 * To run a mutation, you first call `useCopySchoolTemplatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopySchoolTemplatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopySchoolTemplatesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCopySchoolTemplatesMutation(options: VueApolloComposable.UseMutationOptions<Types.CopySchoolTemplatesMutation, Types.CopySchoolTemplatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CopySchoolTemplatesMutation, Types.CopySchoolTemplatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CopySchoolTemplatesMutation, Types.CopySchoolTemplatesMutationVariables>(CopySchoolTemplatesDocument, options);
}
export type CopySchoolTemplatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CopySchoolTemplatesMutation, Types.CopySchoolTemplatesMutationVariables>;
export const ChildSchoolsDocument = gql`
    query ChildSchools {
  childSchools {
    id
    name
    school_type
    email
    mobile
    address
    fee_split_enabled
    attendance_type
    settings
  }
}
    `;

/**
 * __useChildSchoolsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolsQuery();
 */
export function useChildSchoolsQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>(ChildSchoolsDocument, {}, options);
}
export function useChildSchoolsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>(ChildSchoolsDocument, {}, options);
}
export type ChildSchoolsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolsQuery, Types.ChildSchoolsQueryVariables>;
export const ChildSchoolStudentBreakdownDocument = gql`
    query ChildSchoolStudentBreakdown($school_id: ID!, $academic_calendar_id: ID) {
  childSchoolStudentBreakdown(
    school_id: $school_id
    academic_calendar_id: $academic_calendar_id
  ) {
    school {
      id
      name
      school_type
    }
    school_type
    academic_calendar_name
    classrooms {
      classroom_id
      classroom_name
      total
      enrolled
      promoted
      graduated
      suspended
      withdrawn
      other
    }
    programmes {
      programme_id
      programme_name
      department_name
      faculty_name
      total
      enrolled
      graduated
      other
      levels {
        classroom_id
        level
        total
        enrolled
        graduated
        other
      }
    }
    status_summary {
      enrolled
      promoted
      graduated
      suspended
      withdrawn
      transferred
      expelled
      left
      total
    }
  }
}
    `;

/**
 * __useChildSchoolStudentBreakdownQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolStudentBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolStudentBreakdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolStudentBreakdownQuery({
 *   school_id: // value for 'school_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useChildSchoolStudentBreakdownQuery(variables: Types.ChildSchoolStudentBreakdownQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentBreakdownQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>(ChildSchoolStudentBreakdownDocument, variables, options);
}
export function useChildSchoolStudentBreakdownLazyQuery(variables?: Types.ChildSchoolStudentBreakdownQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentBreakdownQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentBreakdownQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>(ChildSchoolStudentBreakdownDocument, variables, options);
}
export type ChildSchoolStudentBreakdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolStudentBreakdownQuery, Types.ChildSchoolStudentBreakdownQueryVariables>;
export const ChildSchoolStudentsDocument = gql`
    query ChildSchoolStudents($school_id: ID!, $academic_calendar_id: ID, $status: EnrollmentStatusEnum, $classroom_id: ID, $programme_id: ID, $search: String, $page: Int, $per_page: Int) {
  childSchoolStudents(
    school_id: $school_id
    academic_calendar_id: $academic_calendar_id
    status: $status
    classroom_id: $classroom_id
    programme_id: $programme_id
    search: $search
    page: $page
    per_page: $per_page
  ) {
    data {
      student_id
      first_name
      surname
      other_name
      matric_no
      gender
      email
      phone
      is_active
      status
      classroom_name
      programme_name
    }
    total
    per_page
    current_page
  }
}
    `;

/**
 * __useChildSchoolStudentsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolStudentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolStudentsQuery({
 *   school_id: // value for 'school_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   status: // value for 'status'
 *   classroom_id: // value for 'classroom_id'
 *   programme_id: // value for 'programme_id'
 *   search: // value for 'search'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useChildSchoolStudentsQuery(variables: Types.ChildSchoolStudentsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentsQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>(ChildSchoolStudentsDocument, variables, options);
}
export function useChildSchoolStudentsLazyQuery(variables?: Types.ChildSchoolStudentsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentsQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>(ChildSchoolStudentsDocument, variables, options);
}
export type ChildSchoolStudentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolStudentsQuery, Types.ChildSchoolStudentsQueryVariables>;
export const ChildSchoolAcademicCalendarsDocument = gql`
    query ChildSchoolAcademicCalendars($school_id: ID!) {
  childSchoolAcademicCalendars(school_id: $school_id) {
    id
    name
    is_active
  }
}
    `;

/**
 * __useChildSchoolAcademicCalendarsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolAcademicCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolAcademicCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolAcademicCalendarsQuery({
 *   school_id: // value for 'school_id'
 * });
 */
export function useChildSchoolAcademicCalendarsQuery(variables: Types.ChildSchoolAcademicCalendarsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolAcademicCalendarsQueryVariables> | ReactiveFunction<Types.ChildSchoolAcademicCalendarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>(ChildSchoolAcademicCalendarsDocument, variables, options);
}
export function useChildSchoolAcademicCalendarsLazyQuery(variables?: Types.ChildSchoolAcademicCalendarsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolAcademicCalendarsQueryVariables> | ReactiveFunction<Types.ChildSchoolAcademicCalendarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>(ChildSchoolAcademicCalendarsDocument, variables, options);
}
export type ChildSchoolAcademicCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolAcademicCalendarsQuery, Types.ChildSchoolAcademicCalendarsQueryVariables>;
export const AllChildSchoolsDocument = gql`
    query AllChildSchools {
  allChildSchools {
    id
    name
    school_type
  }
}
    `;

/**
 * __useAllChildSchoolsQuery__
 *
 * To run a query within a Vue component, call `useAllChildSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChildSchoolsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllChildSchoolsQuery();
 */
export function useAllChildSchoolsQuery(options: VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>(AllChildSchoolsDocument, {}, options);
}
export function useAllChildSchoolsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>(AllChildSchoolsDocument, {}, options);
}
export type AllChildSchoolsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AllChildSchoolsQuery, Types.AllChildSchoolsQueryVariables>;
export const HierarchySchoolsDocument = gql`
    query HierarchySchools {
  hierarchySchools {
    id
    name
    school_type
  }
}
    `;

/**
 * __useHierarchySchoolsQuery__
 *
 * To run a query within a Vue component, call `useHierarchySchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHierarchySchoolsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHierarchySchoolsQuery();
 */
export function useHierarchySchoolsQuery(options: VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>(HierarchySchoolsDocument, {}, options);
}
export function useHierarchySchoolsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>(HierarchySchoolsDocument, {}, options);
}
export type HierarchySchoolsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.HierarchySchoolsQuery, Types.HierarchySchoolsQueryVariables>;
export const ChildSchoolStudentProfileDocument = gql`
    query ChildSchoolStudentProfile($school_id: ID!, $student_id: ID!) {
  childSchoolStudentProfile(school_id: $school_id, student_id: $student_id) {
    student_id
    matric_no
    first_name
    surname
    other_name
    dob
    gender
    email
    phone
    home_address
    nationality
    state
    city
    religion
    photo
    is_active
    status
    classroom_name
    programme_name
    department_name
    faculty_name
    academic_calendar_name
    guardians {
      name
      email
      phone
      relationship_type
    }
    enrollment_history {
      academic_calendar_name
      status
      classroom_name
      programme_name
    }
  }
}
    `;

/**
 * __useChildSchoolStudentProfileQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolStudentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolStudentProfileQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolStudentProfileQuery({
 *   school_id: // value for 'school_id'
 *   student_id: // value for 'student_id'
 * });
 */
export function useChildSchoolStudentProfileQuery(variables: Types.ChildSchoolStudentProfileQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentProfileQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentProfileQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>(ChildSchoolStudentProfileDocument, variables, options);
}
export function useChildSchoolStudentProfileLazyQuery(variables?: Types.ChildSchoolStudentProfileQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolStudentProfileQueryVariables> | ReactiveFunction<Types.ChildSchoolStudentProfileQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>(ChildSchoolStudentProfileDocument, variables, options);
}
export type ChildSchoolStudentProfileQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolStudentProfileQuery, Types.ChildSchoolStudentProfileQueryVariables>;
export const CreateChildSchoolDocument = gql`
    mutation CreateChildSchool($input: CreateChildSchoolInput!) {
  createChildSchool(input: $input) {
    success
    message
    copied
    school {
      id
      name
      school_type
    }
  }
}
    `;

/**
 * __useCreateChildSchoolMutation__
 *
 * To run a mutation, you first call `useCreateChildSchoolMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateChildSchoolMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateChildSchoolMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateChildSchoolMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateChildSchoolMutation, Types.CreateChildSchoolMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateChildSchoolMutation, Types.CreateChildSchoolMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateChildSchoolMutation, Types.CreateChildSchoolMutationVariables>(CreateChildSchoolDocument, options);
}
export type CreateChildSchoolMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateChildSchoolMutation, Types.CreateChildSchoolMutationVariables>;
export const RevokeStaffFromChildSchoolsDocument = gql`
    mutation RevokeStaffFromChildSchools($input: RevokeStaffFromChildSchoolsInput!) {
  revokeStaffFromChildSchools(input: $input) {
    success
    message
    revoked_count
    skipped_schools
  }
}
    `;

/**
 * __useRevokeStaffFromChildSchoolsMutation__
 *
 * To run a mutation, you first call `useRevokeStaffFromChildSchoolsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeStaffFromChildSchoolsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeStaffFromChildSchoolsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRevokeStaffFromChildSchoolsMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeStaffFromChildSchoolsMutation, Types.RevokeStaffFromChildSchoolsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeStaffFromChildSchoolsMutation, Types.RevokeStaffFromChildSchoolsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeStaffFromChildSchoolsMutation, Types.RevokeStaffFromChildSchoolsMutationVariables>(RevokeStaffFromChildSchoolsDocument, options);
}
export type RevokeStaffFromChildSchoolsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeStaffFromChildSchoolsMutation, Types.RevokeStaffFromChildSchoolsMutationVariables>;
export const TransferStudentDocument = gql`
    mutation TransferStudent($input: TransferStudentInput!) {
  transferStudent(input: $input) {
    success
    message
    transfer {
      id
      student_name
      source_matric_no
      target_matric_no
      status
      transferred_at
    }
  }
}
    `;

/**
 * __useTransferStudentMutation__
 *
 * To run a mutation, you first call `useTransferStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTransferStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTransferStudentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useTransferStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.TransferStudentMutation, Types.TransferStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.TransferStudentMutation, Types.TransferStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.TransferStudentMutation, Types.TransferStudentMutationVariables>(TransferStudentDocument, options);
}
export type TransferStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.TransferStudentMutation, Types.TransferStudentMutationVariables>;
export const BulkTransferStudentsDocument = gql`
    mutation BulkTransferStudents($input: BulkTransferStudentsInput!) {
  bulkTransferStudents(input: $input) {
    success
    message
    transferred_count
    failed_count
    transfers {
      id
      student_name
      source_matric_no
      target_matric_no
      status
      transferred_at
    }
    errors
  }
}
    `;

/**
 * __useBulkTransferStudentsMutation__
 *
 * To run a mutation, you first call `useBulkTransferStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkTransferStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkTransferStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkTransferStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkTransferStudentsMutation, Types.BulkTransferStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkTransferStudentsMutation, Types.BulkTransferStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkTransferStudentsMutation, Types.BulkTransferStudentsMutationVariables>(BulkTransferStudentsDocument, options);
}
export type BulkTransferStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkTransferStudentsMutation, Types.BulkTransferStudentsMutationVariables>;
export const ChildSchoolTransfersDocument = gql`
    query ChildSchoolTransfers($school_id: ID, $page: Int, $per_page: Int) {
  childSchoolTransfers(school_id: $school_id, page: $page, per_page: $per_page) {
    data {
      id
      source_school {
        id
        name
      }
      target_school {
        id
        name
      }
      student_name
      source_matric_no
      target_matric_no
      reason
      status
      transferred_at
    }
    total
    per_page
    current_page
  }
}
    `;

/**
 * __useChildSchoolTransfersQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolTransfersQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolTransfersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolTransfersQuery({
 *   school_id: // value for 'school_id'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useChildSchoolTransfersQuery(variables: Types.ChildSchoolTransfersQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolTransfersQueryVariables> | ReactiveFunction<Types.ChildSchoolTransfersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>(ChildSchoolTransfersDocument, variables, options);
}
export function useChildSchoolTransfersLazyQuery(variables: Types.ChildSchoolTransfersQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolTransfersQueryVariables> | ReactiveFunction<Types.ChildSchoolTransfersQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>(ChildSchoolTransfersDocument, variables, options);
}
export type ChildSchoolTransfersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolTransfersQuery, Types.ChildSchoolTransfersQueryVariables>;
export const ReverseTransferDocument = gql`
    mutation ReverseTransfer($transfer_id: ID!) {
  reverseTransfer(transfer_id: $transfer_id) {
    success
    message
  }
}
    `;

/**
 * __useReverseTransferMutation__
 *
 * To run a mutation, you first call `useReverseTransferMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReverseTransferMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReverseTransferMutation({
 *   variables: {
 *     transfer_id: // value for 'transfer_id'
 *   },
 * });
 */
export function useReverseTransferMutation(options: VueApolloComposable.UseMutationOptions<Types.ReverseTransferMutation, Types.ReverseTransferMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReverseTransferMutation, Types.ReverseTransferMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReverseTransferMutation, Types.ReverseTransferMutationVariables>(ReverseTransferDocument, options);
}
export type ReverseTransferMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReverseTransferMutation, Types.ReverseTransferMutationVariables>;
export const ChildSchoolClassroomsDocument = gql`
    query ChildSchoolClassrooms($school_id: ID!) {
  childSchoolClassrooms(school_id: $school_id) {
    id
    name
  }
}
    `;

/**
 * __useChildSchoolClassroomsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolClassroomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolClassroomsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolClassroomsQuery({
 *   school_id: // value for 'school_id'
 * });
 */
export function useChildSchoolClassroomsQuery(variables: Types.ChildSchoolClassroomsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolClassroomsQueryVariables> | ReactiveFunction<Types.ChildSchoolClassroomsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>(ChildSchoolClassroomsDocument, variables, options);
}
export function useChildSchoolClassroomsLazyQuery(variables?: Types.ChildSchoolClassroomsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolClassroomsQueryVariables> | ReactiveFunction<Types.ChildSchoolClassroomsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>(ChildSchoolClassroomsDocument, variables, options);
}
export type ChildSchoolClassroomsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolClassroomsQuery, Types.ChildSchoolClassroomsQueryVariables>;
export const ChildSchoolClassroomSectionsDocument = gql`
    query ChildSchoolClassroomSections($school_id: ID!) {
  childSchoolClassroomSections(school_id: $school_id) {
    id
    name
  }
}
    `;

/**
 * __useChildSchoolClassroomSectionsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolClassroomSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolClassroomSectionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolClassroomSectionsQuery({
 *   school_id: // value for 'school_id'
 * });
 */
export function useChildSchoolClassroomSectionsQuery(variables: Types.ChildSchoolClassroomSectionsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolClassroomSectionsQueryVariables> | ReactiveFunction<Types.ChildSchoolClassroomSectionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>(ChildSchoolClassroomSectionsDocument, variables, options);
}
export function useChildSchoolClassroomSectionsLazyQuery(variables?: Types.ChildSchoolClassroomSectionsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolClassroomSectionsQueryVariables> | ReactiveFunction<Types.ChildSchoolClassroomSectionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>(ChildSchoolClassroomSectionsDocument, variables, options);
}
export type ChildSchoolClassroomSectionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolClassroomSectionsQuery, Types.ChildSchoolClassroomSectionsQueryVariables>;
export const ChildSchoolProgrammesDocument = gql`
    query ChildSchoolProgrammes($school_id: ID!) {
  childSchoolProgrammes(school_id: $school_id) {
    id
    name
  }
}
    `;

/**
 * __useChildSchoolProgrammesQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolProgrammesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolProgrammesQuery({
 *   school_id: // value for 'school_id'
 * });
 */
export function useChildSchoolProgrammesQuery(variables: Types.ChildSchoolProgrammesQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolProgrammesQueryVariables> | ReactiveFunction<Types.ChildSchoolProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>(ChildSchoolProgrammesDocument, variables, options);
}
export function useChildSchoolProgrammesLazyQuery(variables?: Types.ChildSchoolProgrammesQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolProgrammesQueryVariables> | ReactiveFunction<Types.ChildSchoolProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>(ChildSchoolProgrammesDocument, variables, options);
}
export type ChildSchoolProgrammesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolProgrammesQuery, Types.ChildSchoolProgrammesQueryVariables>;
export const ConsolidatedExportDocument = gql`
    mutation ConsolidatedExport($input: ConsolidatedExportInput!) {
  consolidatedExport(input: $input) {
    id
    type
    status
    progress
    file_name
    file_url
  }
}
    `;

/**
 * __useConsolidatedExportMutation__
 *
 * To run a mutation, you first call `useConsolidatedExportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConsolidatedExportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConsolidatedExportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useConsolidatedExportMutation(options: VueApolloComposable.UseMutationOptions<Types.ConsolidatedExportMutation, Types.ConsolidatedExportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ConsolidatedExportMutation, Types.ConsolidatedExportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ConsolidatedExportMutation, Types.ConsolidatedExportMutationVariables>(ConsolidatedExportDocument, options);
}
export type ConsolidatedExportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ConsolidatedExportMutation, Types.ConsolidatedExportMutationVariables>;
export const ChildSchoolArchivedStudentsDocument = gql`
    query ChildSchoolArchivedStudents($school_id: ID, $search: String, $page: Int, $per_page: Int) {
  childSchoolArchivedStudents(
    school_id: $school_id
    search: $search
    page: $page
    per_page: $per_page
  ) {
    data {
      id
      student_id
      first_name
      surname
      other_name
      matric_no
      gender
      school_id
      school_name
      deleted_at
      transfer {
        target_school_name
        target_matric_no
        transferred_at
        reason
      }
    }
    total
    current_page
    per_page
  }
}
    `;

/**
 * __useChildSchoolArchivedStudentsQuery__
 *
 * To run a query within a Vue component, call `useChildSchoolArchivedStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildSchoolArchivedStudentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChildSchoolArchivedStudentsQuery({
 *   school_id: // value for 'school_id'
 *   search: // value for 'search'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useChildSchoolArchivedStudentsQuery(variables: Types.ChildSchoolArchivedStudentsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolArchivedStudentsQueryVariables> | ReactiveFunction<Types.ChildSchoolArchivedStudentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>(ChildSchoolArchivedStudentsDocument, variables, options);
}
export function useChildSchoolArchivedStudentsLazyQuery(variables: Types.ChildSchoolArchivedStudentsQueryVariables | VueCompositionApi.Ref<Types.ChildSchoolArchivedStudentsQueryVariables> | ReactiveFunction<Types.ChildSchoolArchivedStudentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>(ChildSchoolArchivedStudentsDocument, variables, options);
}
export type ChildSchoolArchivedStudentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ChildSchoolArchivedStudentsQuery, Types.ChildSchoolArchivedStudentsQueryVariables>;
export const RestoreArchivedStudentDocument = gql`
    mutation RestoreArchivedStudent($student_id: ID!, $school_id: ID!) {
  restoreArchivedStudent(student_id: $student_id, school_id: $school_id) {
    success
    message
  }
}
    `;

/**
 * __useRestoreArchivedStudentMutation__
 *
 * To run a mutation, you first call `useRestoreArchivedStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRestoreArchivedStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRestoreArchivedStudentMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *     school_id: // value for 'school_id'
 *   },
 * });
 */
export function useRestoreArchivedStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.RestoreArchivedStudentMutation, Types.RestoreArchivedStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RestoreArchivedStudentMutation, Types.RestoreArchivedStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RestoreArchivedStudentMutation, Types.RestoreArchivedStudentMutationVariables>(RestoreArchivedStudentDocument, options);
}
export type RestoreArchivedStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RestoreArchivedStudentMutation, Types.RestoreArchivedStudentMutationVariables>;
export const PermanentlyDeleteArchivedStudentDocument = gql`
    mutation PermanentlyDeleteArchivedStudent($student_id: ID!, $school_id: ID!) {
  permanentlyDeleteArchivedStudent(student_id: $student_id, school_id: $school_id) {
    success
    message
  }
}
    `;

/**
 * __usePermanentlyDeleteArchivedStudentMutation__
 *
 * To run a mutation, you first call `usePermanentlyDeleteArchivedStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePermanentlyDeleteArchivedStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePermanentlyDeleteArchivedStudentMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *     school_id: // value for 'school_id'
 *   },
 * });
 */
export function usePermanentlyDeleteArchivedStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.PermanentlyDeleteArchivedStudentMutation, Types.PermanentlyDeleteArchivedStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PermanentlyDeleteArchivedStudentMutation, Types.PermanentlyDeleteArchivedStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PermanentlyDeleteArchivedStudentMutation, Types.PermanentlyDeleteArchivedStudentMutationVariables>(PermanentlyDeleteArchivedStudentDocument, options);
}
export type PermanentlyDeleteArchivedStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PermanentlyDeleteArchivedStudentMutation, Types.PermanentlyDeleteArchivedStudentMutationVariables>;
export const ActivePaymentProviderDocument = gql`
    query ActivePaymentProvider {
  activePaymentProvider {
    id
    name
    is_active
  }
}
    `;

/**
 * __useActivePaymentProviderQuery__
 *
 * To run a query within a Vue component, call `useActivePaymentProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePaymentProviderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivePaymentProviderQuery();
 */
export function useActivePaymentProviderQuery(options: VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>(ActivePaymentProviderDocument, {}, options);
}
export function useActivePaymentProviderLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>(ActivePaymentProviderDocument, {}, options);
}
export type ActivePaymentProviderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ActivePaymentProviderQuery, Types.ActivePaymentProviderQueryVariables>;
export const ActivePaymentProvidersDocument = gql`
    query ActivePaymentProviders {
  activePaymentProviders {
    id
    name
    is_active
  }
}
    `;

/**
 * __useActivePaymentProvidersQuery__
 *
 * To run a query within a Vue component, call `useActivePaymentProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePaymentProvidersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActivePaymentProvidersQuery();
 */
export function useActivePaymentProvidersQuery(options: VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>(ActivePaymentProvidersDocument, {}, options);
}
export function useActivePaymentProvidersLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>(ActivePaymentProvidersDocument, {}, options);
}
export type ActivePaymentProvidersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ActivePaymentProvidersQuery, Types.ActivePaymentProvidersQueryVariables>;
export const InterswitchChargesDocument = gql`
    query InterswitchCharges {
  interswitchCharges {
    cardCharge
    otherCharge
  }
}
    `;

/**
 * __useInterswitchChargesQuery__
 *
 * To run a query within a Vue component, call `useInterswitchChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterswitchChargesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useInterswitchChargesQuery();
 */
export function useInterswitchChargesQuery(options: VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>(InterswitchChargesDocument, {}, options);
}
export function useInterswitchChargesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>(InterswitchChargesDocument, {}, options);
}
export type InterswitchChargesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.InterswitchChargesQuery, Types.InterswitchChargesQueryVariables>;
export const PaymentProviderStatusDocument = gql`
    query PaymentProviderStatus {
  paymentProviderStatus {
    name
    isConfigured
    missingFields
    fields {
      key
      label
      required
      secret
      present
    }
  }
}
    `;

/**
 * __usePaymentProviderStatusQuery__
 *
 * To run a query within a Vue component, call `usePaymentProviderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentProviderStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePaymentProviderStatusQuery();
 */
export function usePaymentProviderStatusQuery(options: VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>(PaymentProviderStatusDocument, {}, options);
}
export function usePaymentProviderStatusLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>(PaymentProviderStatusDocument, {}, options);
}
export type PaymentProviderStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PaymentProviderStatusQuery, Types.PaymentProviderStatusQueryVariables>;
export const GetPermissionAuditLogsDocument = gql`
    query GetPermissionAuditLogs($first: Int!, $page: Int, $actor_id: ID, $target_user_id: ID, $events: [PermissionAuditEvent!], $from: Date, $to: Date) {
  permissionAuditLogs(
    first: $first
    page: $page
    actor_id: $actor_id
    target_user_id: $target_user_id
    events: $events
    from: $from
    to: $to
  ) {
    data {
      id
      event
      auditable_type
      auditable_id
      auditable_label
      old_values
      new_values
      created_at
      user {
        id
        name
        email
      }
    }
    paginatorInfo {
      total
      perPage
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useGetPermissionAuditLogsQuery__
 *
 * To run a query within a Vue component, call `useGetPermissionAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionAuditLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPermissionAuditLogsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   actor_id: // value for 'actor_id'
 *   target_user_id: // value for 'target_user_id'
 *   events: // value for 'events'
 *   from: // value for 'from'
 *   to: // value for 'to'
 * });
 */
export function useGetPermissionAuditLogsQuery(variables: Types.GetPermissionAuditLogsQueryVariables | VueCompositionApi.Ref<Types.GetPermissionAuditLogsQueryVariables> | ReactiveFunction<Types.GetPermissionAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>(GetPermissionAuditLogsDocument, variables, options);
}
export function useGetPermissionAuditLogsLazyQuery(variables?: Types.GetPermissionAuditLogsQueryVariables | VueCompositionApi.Ref<Types.GetPermissionAuditLogsQueryVariables> | ReactiveFunction<Types.GetPermissionAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>(GetPermissionAuditLogsDocument, variables, options);
}
export type GetPermissionAuditLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPermissionAuditLogsQuery, Types.GetPermissionAuditLogsQueryVariables>;
export const GetPermissionGroupsDocument = gql`
    query GetPermissionGroups {
  permissionGroups(first: 1000) {
    data {
      id
      name
      description
      permissions {
        id
        action
        resource
        key
      }
      users {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPermissionGroupsQuery__
 *
 * To run a query within a Vue component, call `useGetPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPermissionGroupsQuery();
 */
export function useGetPermissionGroupsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(GetPermissionGroupsDocument, {}, options);
}
export function useGetPermissionGroupsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(GetPermissionGroupsDocument, {}, options);
}
export type GetPermissionGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($first: Int!, $page: Int!, $search: String) {
  users(first: $first, page: $page, search: $search) {
    data {
      id
      name
      email
      permissions {
        id
        action
        resource
        key
      }
      permissionGroup {
        id
        name
      }
      activeGrants {
        id
        grant_type
        status
        is_primary
        permission {
          id
          key
          resource
          action
        }
        permissionGroup {
          id
          name
        }
        scopes {
          id
          scope_type
          scope_id
          scope_value
        }
        scope_description
      }
    }
    paginatorInfo {
      total
      perPage
      currentPage
      lastPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a Vue component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUsersQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   search: // value for 'search'
 * });
 */
export function useGetUsersQuery(variables: Types.GetUsersQueryVariables | VueCompositionApi.Ref<Types.GetUsersQueryVariables> | ReactiveFunction<Types.GetUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, variables, options);
}
export function useGetUsersLazyQuery(variables?: Types.GetUsersQueryVariables | VueCompositionApi.Ref<Types.GetUsersQueryVariables> | ReactiveFunction<Types.GetUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetUsersQuery, Types.GetUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetUsersQuery, Types.GetUsersQueryVariables>(GetUsersDocument, variables, options);
}
export type GetUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetUsersQuery, Types.GetUsersQueryVariables>;
export const GetMyRoleRequestsDocument = gql`
    query GetMyRoleRequests {
  myRoleRequests {
    id
    grant_type
    status
    category
    scope_description
    is_active
    is_primary
    starts_at
    ends_at
    requested_at
    reviewed_at
    granted_by {
      id
      name
    }
    reviewed_by {
      id
      name
    }
    permissionGroup {
      id
      name
      description
    }
    scopes {
      id
      scope_type
      scope_id
      scope_value
    }
  }
}
    `;

/**
 * __useGetMyRoleRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyRoleRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyRoleRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyRoleRequestsQuery();
 */
export function useGetMyRoleRequestsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>(GetMyRoleRequestsDocument, {}, options);
}
export function useGetMyRoleRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>(GetMyRoleRequestsDocument, {}, options);
}
export type GetMyRoleRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetMyRoleRequestsQuery, Types.GetMyRoleRequestsQueryVariables>;
export const GetPendingRoleApprovalsDocument = gql`
    query GetPendingRoleApprovals {
  pendingRoleApprovals {
    id
    grant_type
    status
    category
    scope_description
    is_active
    is_primary
    starts_at
    ends_at
    requested_at
    reviewed_at
    user {
      id
      name
      email
    }
    granted_by {
      id
      name
    }
    reviewed_by {
      id
      name
    }
    permissionGroup {
      id
      name
      description
    }
    scopes {
      id
      scope_type
      scope_id
      scope_value
    }
  }
}
    `;

/**
 * __useGetPendingRoleApprovalsQuery__
 *
 * To run a query within a Vue component, call `useGetPendingRoleApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingRoleApprovalsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPendingRoleApprovalsQuery();
 */
export function useGetPendingRoleApprovalsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>(GetPendingRoleApprovalsDocument, {}, options);
}
export function useGetPendingRoleApprovalsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>(GetPendingRoleApprovalsDocument, {}, options);
}
export type GetPendingRoleApprovalsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPendingRoleApprovalsQuery, Types.GetPendingRoleApprovalsQueryVariables>;
export const GetPermissionScopeOptionsDocument = gql`
    query GetPermissionScopeOptions($scope_types: [PermissionScopeTypeEnum!]) {
  permissionScopeOptions(scope_types: $scope_types) {
    scope_type
    options {
      value
      label
    }
  }
}
    `;

/**
 * __useGetPermissionScopeOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetPermissionScopeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionScopeOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPermissionScopeOptionsQuery({
 *   scope_types: // value for 'scope_types'
 * });
 */
export function useGetPermissionScopeOptionsQuery(variables: Types.GetPermissionScopeOptionsQueryVariables | VueCompositionApi.Ref<Types.GetPermissionScopeOptionsQueryVariables> | ReactiveFunction<Types.GetPermissionScopeOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>(GetPermissionScopeOptionsDocument, variables, options);
}
export function useGetPermissionScopeOptionsLazyQuery(variables: Types.GetPermissionScopeOptionsQueryVariables | VueCompositionApi.Ref<Types.GetPermissionScopeOptionsQueryVariables> | ReactiveFunction<Types.GetPermissionScopeOptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>(GetPermissionScopeOptionsDocument, variables, options);
}
export type GetPermissionScopeOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPermissionScopeOptionsQuery, Types.GetPermissionScopeOptionsQueryVariables>;
export const GetProgrammeDocument = gql`
    query GetProgramme($id: ID!) {
  getProgramme(id: $id) {
    id
    program_name
    prog_code
    degree
    type
    duration
    min_units
    department_id
    is_active
    resultTemplates {
      id
      name
      code
      grade_group {
        id
        name
        gradeBands {
          id
          grade
          minimum
          maximum
          point
          name
        }
      }
      columns {
        id
        label
        key
        type
        sequence
        is_visible
        calculation_function
        calculation_arguments
        school_assessment_type {
          id
          name
          max_score
        }
      }
    }
  }
}
    `;

/**
 * __useGetProgrammeQuery__
 *
 * To run a query within a Vue component, call `useGetProgrammeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgrammeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProgrammeQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetProgrammeQuery(variables: Types.GetProgrammeQueryVariables | VueCompositionApi.Ref<Types.GetProgrammeQueryVariables> | ReactiveFunction<Types.GetProgrammeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>(GetProgrammeDocument, variables, options);
}
export function useGetProgrammeLazyQuery(variables?: Types.GetProgrammeQueryVariables | VueCompositionApi.Ref<Types.GetProgrammeQueryVariables> | ReactiveFunction<Types.GetProgrammeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>(GetProgrammeDocument, variables, options);
}
export type GetProgrammeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetProgrammeQuery, Types.GetProgrammeQueryVariables>;
export const ListSchoolProgrammesWithTemplatesDocument = gql`
    query ListSchoolProgrammesWithTemplates($first: Int! = 10, $page: Int, $filter: programmeFilterInput, $academic_calendar_id: ID) {
  listSchoolProgrammes(filter: $filter, first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      program_name
      prog_code
      degree
      type
      duration
      min_units
      department_id
      is_active
      resultTemplates {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useListSchoolProgrammesWithTemplatesQuery__
 *
 * To run a query within a Vue component, call `useListSchoolProgrammesWithTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolProgrammesWithTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolProgrammesWithTemplatesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   filter: // value for 'filter'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useListSchoolProgrammesWithTemplatesQuery(variables: Types.ListSchoolProgrammesWithTemplatesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolProgrammesWithTemplatesQueryVariables> | ReactiveFunction<Types.ListSchoolProgrammesWithTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>(ListSchoolProgrammesWithTemplatesDocument, variables, options);
}
export function useListSchoolProgrammesWithTemplatesLazyQuery(variables?: Types.ListSchoolProgrammesWithTemplatesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolProgrammesWithTemplatesQueryVariables> | ReactiveFunction<Types.ListSchoolProgrammesWithTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>(ListSchoolProgrammesWithTemplatesDocument, variables, options);
}
export type ListSchoolProgrammesWithTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolProgrammesWithTemplatesQuery, Types.ListSchoolProgrammesWithTemplatesQueryVariables>;
export const GetStudentResultTertiaryDocument = gql`
    query GetStudentResultTertiary($student_id: ID!, $academic_calendar_id: ID!) {
  studentResult(
    student_id: $student_id
    academic_calendar_id: $academic_calendar_id
  ) {
    status
    summary
    data
    headers {
      label
      key
      type
      is_visible
    }
    student {
      id
      surname
      firstName: first_name
      other_name
      matric_no
      email
      phone
      photo
    }
    programme {
      id
      program_name
      prog_code
      degree
    }
    academic_calendar {
      id
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
    template {
      id
      name
      code
      grade_group {
        id
        name
      }
    }
    result_feedbacks {
      id
      result_template_feedback {
        id
        label
        code
        input_type
        rating_max
      }
      comment
      rating
      rating_label
    }
  }
}
    `;

/**
 * __useGetStudentResultTertiaryQuery__
 *
 * To run a query within a Vue component, call `useGetStudentResultTertiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentResultTertiaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentResultTertiaryQuery({
 *   student_id: // value for 'student_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetStudentResultTertiaryQuery(variables: Types.GetStudentResultTertiaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentResultTertiaryQueryVariables> | ReactiveFunction<Types.GetStudentResultTertiaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>(GetStudentResultTertiaryDocument, variables, options);
}
export function useGetStudentResultTertiaryLazyQuery(variables?: Types.GetStudentResultTertiaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentResultTertiaryQueryVariables> | ReactiveFunction<Types.GetStudentResultTertiaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>(GetStudentResultTertiaryDocument, variables, options);
}
export type GetStudentResultTertiaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentResultTertiaryQuery, Types.GetStudentResultTertiaryQueryVariables>;
export const GetStudentCourseRegistrationsDocument = gql`
    query GetStudentCourseRegistrations($studentId: Int!) {
  getCourseRegistrationsForStudent(student_id: $studentId) {
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      is_transferred
      accepted_for_programme_id
      accepted_at
      acceptedForProgramme {
        id
        program_name
      }
      acceptedByUser {
        id
        name
      }
      course {
        id
        course_code
        course_title
        unit
      }
      scores {
        id
        score
        school_assessment_type_id
        approval_status
      }
    }
  }
}
    `;

/**
 * __useGetStudentCourseRegistrationsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentCourseRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseRegistrationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentCourseRegistrationsQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGetStudentCourseRegistrationsQuery(variables: Types.GetStudentCourseRegistrationsQueryVariables | VueCompositionApi.Ref<Types.GetStudentCourseRegistrationsQueryVariables> | ReactiveFunction<Types.GetStudentCourseRegistrationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>(GetStudentCourseRegistrationsDocument, variables, options);
}
export function useGetStudentCourseRegistrationsLazyQuery(variables?: Types.GetStudentCourseRegistrationsQueryVariables | VueCompositionApi.Ref<Types.GetStudentCourseRegistrationsQueryVariables> | ReactiveFunction<Types.GetStudentCourseRegistrationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>(GetStudentCourseRegistrationsDocument, variables, options);
}
export type GetStudentCourseRegistrationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentCourseRegistrationsQuery, Types.GetStudentCourseRegistrationsQueryVariables>;
export const ResultTemplatesDocument = gql`
    query ResultTemplates($page: Int, $first: Int, $academic_calendar_id: ID, $include_programmes: Boolean = false) {
  resultTemplates(page: $page, first: $first) {
    data {
      id
      name
      code
      style_code
      grade_group {
        id
        name
      }
      properties
      classrooms(academic_calendar_id: $academic_calendar_id) {
        id
        name
      }
      programmes(academic_calendar_id: $academic_calendar_id) @include(if: $include_programmes) {
        id
        program_name
        prog_code
      }
      default_for_programmes @include(if: $include_programmes) {
        id
        program_name
        prog_code
      }
      columns {
        id
        label
        key
        type
        sequence
        is_visible
        calculation_function
        calculation_arguments
        school_assessment_type {
          id
          name
          max_score
          is_ca
          is_exam
        }
      }
      feedbacks {
        id
        label
        code
        category
        sequence
        input_type
        rating_max
        rating_labels
        rating_scale_labels
      }
      created_at
      updated_at
    }
    paginatorInfo {
      count
      currentPage
      hasMorePages
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useResultTemplatesQuery__
 *
 * To run a query within a Vue component, call `useResultTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResultTemplatesQuery({
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   include_programmes: // value for 'include_programmes'
 * });
 */
export function useResultTemplatesQuery(variables: Types.ResultTemplatesQueryVariables | VueCompositionApi.Ref<Types.ResultTemplatesQueryVariables> | ReactiveFunction<Types.ResultTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>(ResultTemplatesDocument, variables, options);
}
export function useResultTemplatesLazyQuery(variables: Types.ResultTemplatesQueryVariables | VueCompositionApi.Ref<Types.ResultTemplatesQueryVariables> | ReactiveFunction<Types.ResultTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>(ResultTemplatesDocument, variables, options);
}
export type ResultTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ResultTemplatesQuery, Types.ResultTemplatesQueryVariables>;
export const GetAssessmentTypesDocument = gql`
    query GetAssessmentTypes($academic_calendar_id: ID, $include_reusable: Boolean, $subject_id: ID, $is_ca: Boolean, $is_exam: Boolean) {
  schoolAssessmentTypes(
    academic_calendar_id: $academic_calendar_id
    include_reusable: $include_reusable
    subject_id: $subject_id
    is_ca: $is_ca
    is_exam: $is_exam
  ) {
    id
    name
    description
    max_score
    is_ca
    is_exam
    subject_id
    academic_calendar_id
    sequence
  }
}
    `;

/**
 * __useGetAssessmentTypesQuery__
 *
 * To run a query within a Vue component, call `useGetAssessmentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAssessmentTypesQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   include_reusable: // value for 'include_reusable'
 *   subject_id: // value for 'subject_id'
 *   is_ca: // value for 'is_ca'
 *   is_exam: // value for 'is_exam'
 * });
 */
export function useGetAssessmentTypesQuery(variables: Types.GetAssessmentTypesQueryVariables | VueCompositionApi.Ref<Types.GetAssessmentTypesQueryVariables> | ReactiveFunction<Types.GetAssessmentTypesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>(GetAssessmentTypesDocument, variables, options);
}
export function useGetAssessmentTypesLazyQuery(variables: Types.GetAssessmentTypesQueryVariables | VueCompositionApi.Ref<Types.GetAssessmentTypesQueryVariables> | ReactiveFunction<Types.GetAssessmentTypesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>(GetAssessmentTypesDocument, variables, options);
}
export type GetAssessmentTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetAssessmentTypesQuery, Types.GetAssessmentTypesQueryVariables>;
export const SchemesOfWorkDocument = gql`
    query schemesOfWork($subjectId: ID, $classroomId: ID, $termStructureId: ID) {
  schemesOfWork(
    subjectId: $subjectId
    classroomId: $classroomId
    termStructureId: $termStructureId
  ) {
    id
    title
    description
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    termStructure {
      id
      name
    }
    createdBy {
      id
      name
    }
    weeks {
      id
      weekNumber
      topic
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSchemesOfWorkQuery__
 *
 * To run a query within a Vue component, call `useSchemesOfWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemesOfWorkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchemesOfWorkQuery({
 *   subjectId: // value for 'subjectId'
 *   classroomId: // value for 'classroomId'
 *   termStructureId: // value for 'termStructureId'
 * });
 */
export function useSchemesOfWorkQuery(variables: Types.SchemesOfWorkQueryVariables | VueCompositionApi.Ref<Types.SchemesOfWorkQueryVariables> | ReactiveFunction<Types.SchemesOfWorkQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>(SchemesOfWorkDocument, variables, options);
}
export function useSchemesOfWorkLazyQuery(variables: Types.SchemesOfWorkQueryVariables | VueCompositionApi.Ref<Types.SchemesOfWorkQueryVariables> | ReactiveFunction<Types.SchemesOfWorkQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>(SchemesOfWorkDocument, variables, options);
}
export type SchemesOfWorkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchemesOfWorkQuery, Types.SchemesOfWorkQueryVariables>;
export const SchemeOfWorkDocument = gql`
    query schemeOfWork($id: ID!) {
  schemeOfWork(id: $id) {
    id
    title
    description
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    termStructure {
      id
      name
    }
    createdBy {
      id
      name
    }
    weeks {
      id
      weekNumber
      topic
      learningObjectives
      keyConcepts
      suggestedActivities
      suggestedResources
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSchemeOfWorkQuery__
 *
 * To run a query within a Vue component, call `useSchemeOfWorkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeOfWorkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchemeOfWorkQuery({
 *   id: // value for 'id'
 * });
 */
export function useSchemeOfWorkQuery(variables: Types.SchemeOfWorkQueryVariables | VueCompositionApi.Ref<Types.SchemeOfWorkQueryVariables> | ReactiveFunction<Types.SchemeOfWorkQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>(SchemeOfWorkDocument, variables, options);
}
export function useSchemeOfWorkLazyQuery(variables?: Types.SchemeOfWorkQueryVariables | VueCompositionApi.Ref<Types.SchemeOfWorkQueryVariables> | ReactiveFunction<Types.SchemeOfWorkQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>(SchemeOfWorkDocument, variables, options);
}
export type SchemeOfWorkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchemeOfWorkQuery, Types.SchemeOfWorkQueryVariables>;
export const SchemeOfWorkForContextDocument = gql`
    query schemeOfWorkForContext($subjectId: ID!, $classroomId: ID!, $termStructureId: ID!) {
  schemeOfWorkForContext(
    subjectId: $subjectId
    classroomId: $classroomId
    termStructureId: $termStructureId
  ) {
    id
    title
    description
    weeks {
      id
      weekNumber
      topic
      learningObjectives
      keyConcepts
      suggestedActivities
      suggestedResources
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSchemeOfWorkForContextQuery__
 *
 * To run a query within a Vue component, call `useSchemeOfWorkForContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemeOfWorkForContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchemeOfWorkForContextQuery({
 *   subjectId: // value for 'subjectId'
 *   classroomId: // value for 'classroomId'
 *   termStructureId: // value for 'termStructureId'
 * });
 */
export function useSchemeOfWorkForContextQuery(variables: Types.SchemeOfWorkForContextQueryVariables | VueCompositionApi.Ref<Types.SchemeOfWorkForContextQueryVariables> | ReactiveFunction<Types.SchemeOfWorkForContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>(SchemeOfWorkForContextDocument, variables, options);
}
export function useSchemeOfWorkForContextLazyQuery(variables?: Types.SchemeOfWorkForContextQueryVariables | VueCompositionApi.Ref<Types.SchemeOfWorkForContextQueryVariables> | ReactiveFunction<Types.SchemeOfWorkForContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>(SchemeOfWorkForContextDocument, variables, options);
}
export type SchemeOfWorkForContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchemeOfWorkForContextQuery, Types.SchemeOfWorkForContextQueryVariables>;
export const GetSubjectEnrollmentsDocument = gql`
    query GetSubjectEnrollments($subjectId: ID!, $classroomId: ID, $academicCalendarId: ID, $first: Int!, $page: Int) {
  getSubjectEnrollments(
    subjectId: $subjectId
    classroomId: $classroomId
    academicCalendarId: $academicCalendarId
    first: $first
    page: $page
  ) {
    data {
      id
      student_id
      subject_id
      academic_calendar_id
      enrollment_date
      student {
        id
        first_name
        surname
        other_name
        matric_no
        gender
      }
      studentScores {
        id
        score
        school_assessment_type_id
        recorded_at
        comments
      }
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
  }
}
    `;

/**
 * __useGetSubjectEnrollmentsQuery__
 *
 * To run a query within a Vue component, call `useGetSubjectEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectEnrollmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSubjectEnrollmentsQuery({
 *   subjectId: // value for 'subjectId'
 *   classroomId: // value for 'classroomId'
 *   academicCalendarId: // value for 'academicCalendarId'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetSubjectEnrollmentsQuery(variables: Types.GetSubjectEnrollmentsQueryVariables | VueCompositionApi.Ref<Types.GetSubjectEnrollmentsQueryVariables> | ReactiveFunction<Types.GetSubjectEnrollmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>(GetSubjectEnrollmentsDocument, variables, options);
}
export function useGetSubjectEnrollmentsLazyQuery(variables?: Types.GetSubjectEnrollmentsQueryVariables | VueCompositionApi.Ref<Types.GetSubjectEnrollmentsQueryVariables> | ReactiveFunction<Types.GetSubjectEnrollmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>(GetSubjectEnrollmentsDocument, variables, options);
}
export type GetSubjectEnrollmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSubjectEnrollmentsQuery, Types.GetSubjectEnrollmentsQueryVariables>;
export const ResultAmendmentHistoryDocument = gql`
    query ResultAmendmentHistory($student_id: ID!, $academic_calendar_id: ID!) {
  resultAmendmentHistory(
    student_id: $student_id
    academic_calendar_id: $academic_calendar_id
  ) {
    id
    assessment_name
    old_score
    new_score
    reason
    created_at
    actor {
      id
      name
    }
  }
}
    `;

/**
 * __useResultAmendmentHistoryQuery__
 *
 * To run a query within a Vue component, call `useResultAmendmentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResultAmendmentHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useResultAmendmentHistoryQuery({
 *   student_id: // value for 'student_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useResultAmendmentHistoryQuery(variables: Types.ResultAmendmentHistoryQueryVariables | VueCompositionApi.Ref<Types.ResultAmendmentHistoryQueryVariables> | ReactiveFunction<Types.ResultAmendmentHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>(ResultAmendmentHistoryDocument, variables, options);
}
export function useResultAmendmentHistoryLazyQuery(variables?: Types.ResultAmendmentHistoryQueryVariables | VueCompositionApi.Ref<Types.ResultAmendmentHistoryQueryVariables> | ReactiveFunction<Types.ResultAmendmentHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>(ResultAmendmentHistoryDocument, variables, options);
}
export type ResultAmendmentHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ResultAmendmentHistoryQuery, Types.ResultAmendmentHistoryQueryVariables>;
export const GetStudentImportDocument = gql`
    query GetStudentImport($id: ID!) {
  studentImport(id: $id) {
    id
    status
    progress
    total_rows
    successful_rows
    failed_rows
    errors
    error_message
    started_at
    finished_at
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetStudentImportQuery__
 *
 * To run a query within a Vue component, call `useGetStudentImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentImportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentImportQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetStudentImportQuery(variables: Types.GetStudentImportQueryVariables | VueCompositionApi.Ref<Types.GetStudentImportQueryVariables> | ReactiveFunction<Types.GetStudentImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>(GetStudentImportDocument, variables, options);
}
export function useGetStudentImportLazyQuery(variables?: Types.GetStudentImportQueryVariables | VueCompositionApi.Ref<Types.GetStudentImportQueryVariables> | ReactiveFunction<Types.GetStudentImportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>(GetStudentImportDocument, variables, options);
}
export type GetStudentImportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentImportQuery, Types.GetStudentImportQueryVariables>;
export const GetStudentImportsDocument = gql`
    query GetStudentImports($first: Int!, $page: Int) {
  studentImports(first: $first, page: $page) {
    data {
      id
      status
      progress
      total_rows
      successful_rows
      failed_rows
      error_message
      started_at
      finished_at
      created_at
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      hasMorePages
    }
  }
}
    `;

/**
 * __useGetStudentImportsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentImportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentImportsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetStudentImportsQuery(variables: Types.GetStudentImportsQueryVariables | VueCompositionApi.Ref<Types.GetStudentImportsQueryVariables> | ReactiveFunction<Types.GetStudentImportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>(GetStudentImportsDocument, variables, options);
}
export function useGetStudentImportsLazyQuery(variables?: Types.GetStudentImportsQueryVariables | VueCompositionApi.Ref<Types.GetStudentImportsQueryVariables> | ReactiveFunction<Types.GetStudentImportsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>(GetStudentImportsDocument, variables, options);
}
export type GetStudentImportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentImportsQuery, Types.GetStudentImportsQueryVariables>;
export const GetStudentListReportDocument = gql`
    query GetStudentListReport($page: Int!, $first: Int!, $filter: StudentFilter, $withOrigin: Boolean = false, $withCustomFields: Boolean = false) {
  students(page: $page, first: $first, filter: $filter) {
    data {
      id
      first_name
      surname
      other_name
      matric_no
      gender
      nationality @include(if: $withOrigin)
      customFieldValues @include(if: $withCustomFields) {
        value
        field {
          key
        }
      }
      studentAcademicCalendars {
        academic_calendar_id
        status
        classroomSection {
          classroom {
            name
          }
        }
        programme {
          id
          program_name
          department_id
        }
      }
    }
    paginatorInfo {
      currentPage
      total
      perPage
      lastPage
    }
  }
}
    `;

/**
 * __useGetStudentListReportQuery__
 *
 * To run a query within a Vue component, call `useGetStudentListReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentListReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentListReportQuery({
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   filter: // value for 'filter'
 *   withOrigin: // value for 'withOrigin'
 *   withCustomFields: // value for 'withCustomFields'
 * });
 */
export function useGetStudentListReportQuery(variables: Types.GetStudentListReportQueryVariables | VueCompositionApi.Ref<Types.GetStudentListReportQueryVariables> | ReactiveFunction<Types.GetStudentListReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>(GetStudentListReportDocument, variables, options);
}
export function useGetStudentListReportLazyQuery(variables?: Types.GetStudentListReportQueryVariables | VueCompositionApi.Ref<Types.GetStudentListReportQueryVariables> | ReactiveFunction<Types.GetStudentListReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>(GetStudentListReportDocument, variables, options);
}
export type GetStudentListReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentListReportQuery, Types.GetStudentListReportQueryVariables>;
export const SubjectOfferingsDocument = gql`
    query subjectOfferings($subjectId: ID!) {
  subjectOfferings(subjectId: $subjectId) {
    id
    status
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    section {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSubjectOfferingsQuery__
 *
 * To run a query within a Vue component, call `useSubjectOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectOfferingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubjectOfferingsQuery({
 *   subjectId: // value for 'subjectId'
 * });
 */
export function useSubjectOfferingsQuery(variables: Types.SubjectOfferingsQueryVariables | VueCompositionApi.Ref<Types.SubjectOfferingsQueryVariables> | ReactiveFunction<Types.SubjectOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>(SubjectOfferingsDocument, variables, options);
}
export function useSubjectOfferingsLazyQuery(variables?: Types.SubjectOfferingsQueryVariables | VueCompositionApi.Ref<Types.SubjectOfferingsQueryVariables> | ReactiveFunction<Types.SubjectOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>(SubjectOfferingsDocument, variables, options);
}
export type SubjectOfferingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SubjectOfferingsQuery, Types.SubjectOfferingsQueryVariables>;
export const ClassroomOfferingsDocument = gql`
    query classroomOfferings($classroom_id: ID!, $section_id: ID) {
  classroomOfferings(classroom_id: $classroom_id, section_id: $section_id) {
    id
    status
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    section {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useClassroomOfferingsQuery__
 *
 * To run a query within a Vue component, call `useClassroomOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassroomOfferingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClassroomOfferingsQuery({
 *   classroom_id: // value for 'classroom_id'
 *   section_id: // value for 'section_id'
 * });
 */
export function useClassroomOfferingsQuery(variables: Types.ClassroomOfferingsQueryVariables | VueCompositionApi.Ref<Types.ClassroomOfferingsQueryVariables> | ReactiveFunction<Types.ClassroomOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>(ClassroomOfferingsDocument, variables, options);
}
export function useClassroomOfferingsLazyQuery(variables?: Types.ClassroomOfferingsQueryVariables | VueCompositionApi.Ref<Types.ClassroomOfferingsQueryVariables> | ReactiveFunction<Types.ClassroomOfferingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>(ClassroomOfferingsDocument, variables, options);
}
export type ClassroomOfferingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ClassroomOfferingsQuery, Types.ClassroomOfferingsQueryVariables>;
export const GetSummaryTemplatesDocument = gql`
    query GetSummaryTemplates {
  summaryTemplates(first: 100) {
    data {
      id
      name
      description
      school {
        id
        name
      }
      properties
      columns {
        id
        label
        key
        type
        group
        sequence
        is_visible
        calculation_function
        calculation_arguments
      }
    }
  }
}
    `;

/**
 * __useGetSummaryTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetSummaryTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSummaryTemplatesQuery();
 */
export function useGetSummaryTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>(GetSummaryTemplatesDocument, {}, options);
}
export function useGetSummaryTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>(GetSummaryTemplatesDocument, {}, options);
}
export type GetSummaryTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSummaryTemplatesQuery, Types.GetSummaryTemplatesQueryVariables>;
export const GetSummaryReportDocument = gql`
    query GetSummaryReport($templateId: ID!, $calId: ID!, $programmeId: ID, $classroomId: ID, $level: String, $calculationMethod: String, $retakeMethod: String, $student_status: String) {
  summaryReport(
    summary_template_id: $templateId
    academic_calendar_id: $calId
    programme_id: $programmeId
    classroom_id: $classroomId
    level: $level
    calculation_method: $calculationMethod
    retake_method: $retakeMethod
    student_status: $student_status
  ) {
    headers
    data
    summary
    meta
    failed_courses
    course_headers
    course_legend
  }
}
    `;

/**
 * __useGetSummaryReportQuery__
 *
 * To run a query within a Vue component, call `useGetSummaryReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSummaryReportQuery({
 *   templateId: // value for 'templateId'
 *   calId: // value for 'calId'
 *   programmeId: // value for 'programmeId'
 *   classroomId: // value for 'classroomId'
 *   level: // value for 'level'
 *   calculationMethod: // value for 'calculationMethod'
 *   retakeMethod: // value for 'retakeMethod'
 *   student_status: // value for 'student_status'
 * });
 */
export function useGetSummaryReportQuery(variables: Types.GetSummaryReportQueryVariables | VueCompositionApi.Ref<Types.GetSummaryReportQueryVariables> | ReactiveFunction<Types.GetSummaryReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>(GetSummaryReportDocument, variables, options);
}
export function useGetSummaryReportLazyQuery(variables?: Types.GetSummaryReportQueryVariables | VueCompositionApi.Ref<Types.GetSummaryReportQueryVariables> | ReactiveFunction<Types.GetSummaryReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>(GetSummaryReportDocument, variables, options);
}
export type GetSummaryReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSummaryReportQuery, Types.GetSummaryReportQueryVariables>;
export const GetSummaryExcelUrlDocument = gql`
    query GetSummaryExcelUrl($templateId: ID!, $calId: ID!, $programmeId: ID!, $level: String, $calculationMethod: String, $retakeMethod: String) {
  summaryExcelUrl(
    summary_template_id: $templateId
    academic_calendar_id: $calId
    programme_id: $programmeId
    level: $level
    calculation_method: $calculationMethod
    retake_method: $retakeMethod
  ) {
    id
    status
    file_name
    file_url
  }
}
    `;

/**
 * __useGetSummaryExcelUrlQuery__
 *
 * To run a query within a Vue component, call `useGetSummaryExcelUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryExcelUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSummaryExcelUrlQuery({
 *   templateId: // value for 'templateId'
 *   calId: // value for 'calId'
 *   programmeId: // value for 'programmeId'
 *   level: // value for 'level'
 *   calculationMethod: // value for 'calculationMethod'
 *   retakeMethod: // value for 'retakeMethod'
 * });
 */
export function useGetSummaryExcelUrlQuery(variables: Types.GetSummaryExcelUrlQueryVariables | VueCompositionApi.Ref<Types.GetSummaryExcelUrlQueryVariables> | ReactiveFunction<Types.GetSummaryExcelUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>(GetSummaryExcelUrlDocument, variables, options);
}
export function useGetSummaryExcelUrlLazyQuery(variables?: Types.GetSummaryExcelUrlQueryVariables | VueCompositionApi.Ref<Types.GetSummaryExcelUrlQueryVariables> | ReactiveFunction<Types.GetSummaryExcelUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>(GetSummaryExcelUrlDocument, variables, options);
}
export type GetSummaryExcelUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSummaryExcelUrlQuery, Types.GetSummaryExcelUrlQueryVariables>;
export const GetSummaryPdfUrlDocument = gql`
    query GetSummaryPdfUrl($templateId: ID!, $calId: ID!, $programmeId: ID!, $level: String, $calculationMethod: String, $retakeMethod: String) {
  summaryPdfUrl(
    summary_template_id: $templateId
    academic_calendar_id: $calId
    programme_id: $programmeId
    level: $level
    calculation_method: $calculationMethod
    retake_method: $retakeMethod
  ) {
    id
    status
    file_name
    file_url
  }
}
    `;

/**
 * __useGetSummaryPdfUrlQuery__
 *
 * To run a query within a Vue component, call `useGetSummaryPdfUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSummaryPdfUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSummaryPdfUrlQuery({
 *   templateId: // value for 'templateId'
 *   calId: // value for 'calId'
 *   programmeId: // value for 'programmeId'
 *   level: // value for 'level'
 *   calculationMethod: // value for 'calculationMethod'
 *   retakeMethod: // value for 'retakeMethod'
 * });
 */
export function useGetSummaryPdfUrlQuery(variables: Types.GetSummaryPdfUrlQueryVariables | VueCompositionApi.Ref<Types.GetSummaryPdfUrlQueryVariables> | ReactiveFunction<Types.GetSummaryPdfUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>(GetSummaryPdfUrlDocument, variables, options);
}
export function useGetSummaryPdfUrlLazyQuery(variables?: Types.GetSummaryPdfUrlQueryVariables | VueCompositionApi.Ref<Types.GetSummaryPdfUrlQueryVariables> | ReactiveFunction<Types.GetSummaryPdfUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>(GetSummaryPdfUrlDocument, variables, options);
}
export type GetSummaryPdfUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSummaryPdfUrlQuery, Types.GetSummaryPdfUrlQueryVariables>;
export const ListSchoolFacultiesDocument = gql`
    query ListSchoolFaculties($first: Int!, $page: Int) {
  listSchoolFaculties(first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      faculty_name
      school_id
      type
      is_active
      createdAt
      updatedAt
      departments {
        id
        department_name
      }
    }
  }
}
    `;

/**
 * __useListSchoolFacultiesQuery__
 *
 * To run a query within a Vue component, call `useListSchoolFacultiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolFacultiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolFacultiesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useListSchoolFacultiesQuery(variables: Types.ListSchoolFacultiesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolFacultiesQueryVariables> | ReactiveFunction<Types.ListSchoolFacultiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>(ListSchoolFacultiesDocument, variables, options);
}
export function useListSchoolFacultiesLazyQuery(variables?: Types.ListSchoolFacultiesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolFacultiesQueryVariables> | ReactiveFunction<Types.ListSchoolFacultiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>(ListSchoolFacultiesDocument, variables, options);
}
export type ListSchoolFacultiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolFacultiesQuery, Types.ListSchoolFacultiesQueryVariables>;
export const ListSchoolDepartmentsDocument = gql`
    query ListSchoolDepartments($first: Int! = 100, $page: Int) {
  listSchoolDepartments(first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      department_name
      faculty_id
      type
      is_active
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useListSchoolDepartmentsQuery__
 *
 * To run a query within a Vue component, call `useListSchoolDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolDepartmentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolDepartmentsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useListSchoolDepartmentsQuery(variables: Types.ListSchoolDepartmentsQueryVariables | VueCompositionApi.Ref<Types.ListSchoolDepartmentsQueryVariables> | ReactiveFunction<Types.ListSchoolDepartmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>(ListSchoolDepartmentsDocument, variables, options);
}
export function useListSchoolDepartmentsLazyQuery(variables?: Types.ListSchoolDepartmentsQueryVariables | VueCompositionApi.Ref<Types.ListSchoolDepartmentsQueryVariables> | ReactiveFunction<Types.ListSchoolDepartmentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>(ListSchoolDepartmentsDocument, variables, options);
}
export type ListSchoolDepartmentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolDepartmentsQuery, Types.ListSchoolDepartmentsQueryVariables>;
export const ListSchoolProgrammesDocument = gql`
    query ListSchoolProgrammes($filter: programmeFilterInput, $first: Int! = 10, $page: Int) {
  listSchoolProgrammes(filter: $filter, first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      program_name
      prog_code
      degree
      type
      duration
      min_units
      calculation_method
      delivery_mode
      min_units_per_registration
      max_units_per_registration
      module_result_mode
      progression_type
      outstanding_mode
      compulsory_mode
      enforce_prerequisites
      graduation_criteria
      department_id
      is_active
      default_transcript_template_id
      default_transcript_template {
        id
        name
        style_code
      }
      default_result_template_id
      default_result_template {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useListSchoolProgrammesQuery__
 *
 * To run a query within a Vue component, call `useListSchoolProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolProgrammesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolProgrammesQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useListSchoolProgrammesQuery(variables: Types.ListSchoolProgrammesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolProgrammesQueryVariables> | ReactiveFunction<Types.ListSchoolProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>(ListSchoolProgrammesDocument, variables, options);
}
export function useListSchoolProgrammesLazyQuery(variables?: Types.ListSchoolProgrammesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolProgrammesQueryVariables> | ReactiveFunction<Types.ListSchoolProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>(ListSchoolProgrammesDocument, variables, options);
}
export type ListSchoolProgrammesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolProgrammesQuery, Types.ListSchoolProgrammesQueryVariables>;
export const ListSchoolCoursesDocument = gql`
    query ListSchoolCourses($first: Int!, $page: Int, $filter: CourseFilterInput) {
  listSchoolCourses(first: $first, page: $page, filter: $filter) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      course_title
      course_code
      unit
      is_active
      course_instance_id
      course_instance_year
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useListSchoolCoursesQuery__
 *
 * To run a query within a Vue component, call `useListSchoolCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolCoursesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   filter: // value for 'filter'
 * });
 */
export function useListSchoolCoursesQuery(variables: Types.ListSchoolCoursesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCoursesQueryVariables> | ReactiveFunction<Types.ListSchoolCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>(ListSchoolCoursesDocument, variables, options);
}
export function useListSchoolCoursesLazyQuery(variables?: Types.ListSchoolCoursesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCoursesQueryVariables> | ReactiveFunction<Types.ListSchoolCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>(ListSchoolCoursesDocument, variables, options);
}
export type ListSchoolCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolCoursesQuery, Types.ListSchoolCoursesQueryVariables>;
export const GetCourseByIdDocument = gql`
    query GetCourseById($id: ID!) {
  getCourse(id: $id) {
    id
    course_title
    course_code
    unit
    is_active
    course_instance_id
    course_instance_year
    school_id
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetCourseByIdQuery__
 *
 * To run a query within a Vue component, call `useGetCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCourseByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCourseByIdQuery(variables: Types.GetCourseByIdQueryVariables | VueCompositionApi.Ref<Types.GetCourseByIdQueryVariables> | ReactiveFunction<Types.GetCourseByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>(GetCourseByIdDocument, variables, options);
}
export function useGetCourseByIdLazyQuery(variables?: Types.GetCourseByIdQueryVariables | VueCompositionApi.Ref<Types.GetCourseByIdQueryVariables> | ReactiveFunction<Types.GetCourseByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>(GetCourseByIdDocument, variables, options);
}
export type GetCourseByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCourseByIdQuery, Types.GetCourseByIdQueryVariables>;
export const GetCourseLecturersInSemesterDocument = gql`
    query GetCourseLecturersInSemester($course_id: Int!, $academic_calendar_id: Int) {
  getCourseLecturersInSemester(
    course_id: $course_id
    academic_calendar_id: $academic_calendar_id
  ) {
    id
    course_id
    academic_calendar_id
    school_id
    is_approved
    approved_by_id
    approved_at
    denied_by_id
    denied_at
    created_at
    updated_at
    user {
      id
      name
      email
    }
    course {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useGetCourseLecturersInSemesterQuery__
 *
 * To run a query within a Vue component, call `useGetCourseLecturersInSemesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseLecturersInSemesterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCourseLecturersInSemesterQuery({
 *   course_id: // value for 'course_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetCourseLecturersInSemesterQuery(variables: Types.GetCourseLecturersInSemesterQueryVariables | VueCompositionApi.Ref<Types.GetCourseLecturersInSemesterQueryVariables> | ReactiveFunction<Types.GetCourseLecturersInSemesterQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>(GetCourseLecturersInSemesterDocument, variables, options);
}
export function useGetCourseLecturersInSemesterLazyQuery(variables?: Types.GetCourseLecturersInSemesterQueryVariables | VueCompositionApi.Ref<Types.GetCourseLecturersInSemesterQueryVariables> | ReactiveFunction<Types.GetCourseLecturersInSemesterQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>(GetCourseLecturersInSemesterDocument, variables, options);
}
export type GetCourseLecturersInSemesterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCourseLecturersInSemesterQuery, Types.GetCourseLecturersInSemesterQueryVariables>;
export const ListSchoolCurriculumsDocument = gql`
    query ListSchoolCurriculums($filter: curriculumFilterInput, $first: Int! = 10, $page: Int) {
  listSchoolCurriculums(filter: $filter, first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      course_id
      programme_id
      status
      course_registration_level
      semester
      moduleOfferings {
        id
        name
        session_id
      }
      programme_module_id
      course {
        id
        course_code
        course_title
        course_code
        course_instance_id
        course_instance_year
        unit
      }
      programme {
        id
        prog_code
        program_name
        degree
        type
        duration
        min_units
        department_id
        delivery_mode
        min_units_per_registration
        max_units_per_registration
        progression_type
      }
      programmeModule {
        id
        name
        sequence
      }
    }
  }
}
    `;

/**
 * __useListSchoolCurriculumsQuery__
 *
 * To run a query within a Vue component, call `useListSchoolCurriculumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolCurriculumsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolCurriculumsQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useListSchoolCurriculumsQuery(variables: Types.ListSchoolCurriculumsQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCurriculumsQueryVariables> | ReactiveFunction<Types.ListSchoolCurriculumsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>(ListSchoolCurriculumsDocument, variables, options);
}
export function useListSchoolCurriculumsLazyQuery(variables?: Types.ListSchoolCurriculumsQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCurriculumsQueryVariables> | ReactiveFunction<Types.ListSchoolCurriculumsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>(ListSchoolCurriculumsDocument, variables, options);
}
export type ListSchoolCurriculumsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolCurriculumsQuery, Types.ListSchoolCurriculumsQueryVariables>;
export const UsersWithCourseLecturersDocument = gql`
    query UsersWithCourseLecturers($filter: lecturerCourseFilterInput, $first: Int! = 10, $page: Int) {
  usersWithCourseLecturers(filter: $filter, first: $first, page: $page) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useUsersWithCourseLecturersQuery__
 *
 * To run a query within a Vue component, call `useUsersWithCourseLecturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithCourseLecturersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUsersWithCourseLecturersQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useUsersWithCourseLecturersQuery(variables: Types.UsersWithCourseLecturersQueryVariables | VueCompositionApi.Ref<Types.UsersWithCourseLecturersQueryVariables> | ReactiveFunction<Types.UsersWithCourseLecturersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>(UsersWithCourseLecturersDocument, variables, options);
}
export function useUsersWithCourseLecturersLazyQuery(variables?: Types.UsersWithCourseLecturersQueryVariables | VueCompositionApi.Ref<Types.UsersWithCourseLecturersQueryVariables> | ReactiveFunction<Types.UsersWithCourseLecturersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>(UsersWithCourseLecturersDocument, variables, options);
}
export type UsersWithCourseLecturersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.UsersWithCourseLecturersQuery, Types.UsersWithCourseLecturersQueryVariables>;
export const GetLecturerCoursesInSemesterDocument = gql`
    query GetLecturerCoursesInSemester($input: lecturerGetCoursesInSemesterInput!) {
  getLecturerCoursesInSemesterByAdmin(input: $input) {
    id
    course_id
    academic_calendar_id
    school_id
    is_approved
    approved_by_id
    approved_at
    denied_by_id
    denied_at
    created_at
    updated_at
    user {
      id
      name
      email
    }
    course {
      id
      course_code
      course_title
      course_instance_id
      course_instance_year
      unit
    }
  }
}
    `;

/**
 * __useGetLecturerCoursesInSemesterQuery__
 *
 * To run a query within a Vue component, call `useGetLecturerCoursesInSemesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLecturerCoursesInSemesterQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLecturerCoursesInSemesterQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetLecturerCoursesInSemesterQuery(variables: Types.GetLecturerCoursesInSemesterQueryVariables | VueCompositionApi.Ref<Types.GetLecturerCoursesInSemesterQueryVariables> | ReactiveFunction<Types.GetLecturerCoursesInSemesterQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>(GetLecturerCoursesInSemesterDocument, variables, options);
}
export function useGetLecturerCoursesInSemesterLazyQuery(variables?: Types.GetLecturerCoursesInSemesterQueryVariables | VueCompositionApi.Ref<Types.GetLecturerCoursesInSemesterQueryVariables> | ReactiveFunction<Types.GetLecturerCoursesInSemesterQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>(GetLecturerCoursesInSemesterDocument, variables, options);
}
export type GetLecturerCoursesInSemesterQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetLecturerCoursesInSemesterQuery, Types.GetLecturerCoursesInSemesterQueryVariables>;
export const GetLecturerCoursesDocument = gql`
    query GetLecturerCourses($input: lecturerGetCoursesInSemesterInput!) {
  getLecturerCoursesInSemesterByAdmin(input: $input) {
    id
    course_id
    academic_calendar_id
    school_id
    is_approved
    approved_by_id
    approved_at
    denied_by_id
    denied_at
    created_at
    updated_at
    user {
      id
      name
    }
    course {
      id
      course_code
      course_title
      course_instance_id
      course_instance_year
      unit
    }
  }
}
    `;

/**
 * __useGetLecturerCoursesQuery__
 *
 * To run a query within a Vue component, call `useGetLecturerCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLecturerCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLecturerCoursesQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetLecturerCoursesQuery(variables: Types.GetLecturerCoursesQueryVariables | VueCompositionApi.Ref<Types.GetLecturerCoursesQueryVariables> | ReactiveFunction<Types.GetLecturerCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>(GetLecturerCoursesDocument, variables, options);
}
export function useGetLecturerCoursesLazyQuery(variables?: Types.GetLecturerCoursesQueryVariables | VueCompositionApi.Ref<Types.GetLecturerCoursesQueryVariables> | ReactiveFunction<Types.GetLecturerCoursesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>(GetLecturerCoursesDocument, variables, options);
}
export type GetLecturerCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetLecturerCoursesQuery, Types.GetLecturerCoursesQueryVariables>;
export const SchoolCourseRegistrationDocument = gql`
    query SchoolCourseRegistration($academic_calendar_id: Int, $filter: courseRegistrationFilterInput, $first: Int!, $page: Int) {
  schoolCourseRegistration(
    academic_calendar_id: $academic_calendar_id
    filter: $filter
    first: $first
    page: $page
  ) {
    paginatorInfo {
      currentPage
      lastPage
      perPage
      total
      hasMorePages
    }
    data {
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      academic_calendar_id
      authorization_status
      approval_status
      senate_approval_status
      rejection_reason
      createdAt
      updatedAt
      student {
        id
        first_name
        surname
        matric_no
      }
      programme {
        id
        program_name
      }
      coursesRegistered {
        programme_module_id
        module_name
        module_sequence
        id
        course_id
        course {
          id
          course_title
          course_instance_id
          course_instance_year
          course_code
          unit
        }
        scores {
          id
          score
          comments
          approval_status
        }
      }
    }
  }
}
    `;

/**
 * __useSchoolCourseRegistrationQuery__
 *
 * To run a query within a Vue component, call `useSchoolCourseRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolCourseRegistrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolCourseRegistrationQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useSchoolCourseRegistrationQuery(variables: Types.SchoolCourseRegistrationQueryVariables | VueCompositionApi.Ref<Types.SchoolCourseRegistrationQueryVariables> | ReactiveFunction<Types.SchoolCourseRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>(SchoolCourseRegistrationDocument, variables, options);
}
export function useSchoolCourseRegistrationLazyQuery(variables?: Types.SchoolCourseRegistrationQueryVariables | VueCompositionApi.Ref<Types.SchoolCourseRegistrationQueryVariables> | ReactiveFunction<Types.SchoolCourseRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>(SchoolCourseRegistrationDocument, variables, options);
}
export type SchoolCourseRegistrationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchoolCourseRegistrationQuery, Types.SchoolCourseRegistrationQueryVariables>;
export const PendingCourseRegistrationsForApprovalDocument = gql`
    query PendingCourseRegistrationsForApproval($filter: CourseRegistrationApprovalFilterInput) {
  pendingCourseRegistrationsForApproval(filter: $filter) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      student {
        id
        surname
        first_name
        matric_no
      }
      academic_calendar {
        id
        session {
          id
          name
        }
        termStructure {
          id
          name
        }
      }
      session
      semester
      level
      programme
      registrations {
        id
        authorization_status
        approval_status
        coursesRegistered {
          programme_module_id
          module_name
          module_sequence
          id
          course_id
          course_status
          course {
            id
            course_code
            course_title
            unit
          }
        }
      }
      total_units
      course_count
      level_adviser {
        id
        name
      }
      level_adviser_approved_at
    }
  }
}
    `;

/**
 * __usePendingCourseRegistrationsForApprovalQuery__
 *
 * To run a query within a Vue component, call `usePendingCourseRegistrationsForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingCourseRegistrationsForApprovalQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePendingCourseRegistrationsForApprovalQuery({
 *   filter: // value for 'filter'
 * });
 */
export function usePendingCourseRegistrationsForApprovalQuery(variables: Types.PendingCourseRegistrationsForApprovalQueryVariables | VueCompositionApi.Ref<Types.PendingCourseRegistrationsForApprovalQueryVariables> | ReactiveFunction<Types.PendingCourseRegistrationsForApprovalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>(PendingCourseRegistrationsForApprovalDocument, variables, options);
}
export function usePendingCourseRegistrationsForApprovalLazyQuery(variables: Types.PendingCourseRegistrationsForApprovalQueryVariables | VueCompositionApi.Ref<Types.PendingCourseRegistrationsForApprovalQueryVariables> | ReactiveFunction<Types.PendingCourseRegistrationsForApprovalQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>(PendingCourseRegistrationsForApprovalDocument, variables, options);
}
export type PendingCourseRegistrationsForApprovalQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PendingCourseRegistrationsForApprovalQuery, Types.PendingCourseRegistrationsForApprovalQueryVariables>;
export const GetCourseRegistrationsForStudentDocument = gql`
    query GetCourseRegistrationsForStudent($student_id: Int!) {
  getCourseRegistrationsForStudent(student_id: $student_id) {
    academicCalendar {
      id
      session_id
    }
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    academic_calendar_id
    authorization_status
    approval_status
    rejection_reason
    school_id
    createdAt
    updatedAt
    student {
      id
      first_name
      surname
      other_name
      matric_no
      email
      phone
      photo
      gender
      currentClassroomSection {
        id
        name
        classroom {
          id
          name
        }
      }
      studentAcademicCalendar {
        id
        min_units_per_registration
        max_units_per_registration
      }
    }
    programme {
      id
      program_name
      degree
      delivery_mode
    }
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      accepted_for_programme_id
      course {
        id
        course_title
        course_instance_id
        course_instance_year
        course_code
        unit
      }
      scores {
        id
        score
        comments
        school_assessment_type_id
        schoolAssessmentType {
          id
          name
        }
        approval_status
      }
    }
  }
}
    `;

/**
 * __useGetCourseRegistrationsForStudentQuery__
 *
 * To run a query within a Vue component, call `useGetCourseRegistrationsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseRegistrationsForStudentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCourseRegistrationsForStudentQuery({
 *   student_id: // value for 'student_id'
 * });
 */
export function useGetCourseRegistrationsForStudentQuery(variables: Types.GetCourseRegistrationsForStudentQueryVariables | VueCompositionApi.Ref<Types.GetCourseRegistrationsForStudentQueryVariables> | ReactiveFunction<Types.GetCourseRegistrationsForStudentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>(GetCourseRegistrationsForStudentDocument, variables, options);
}
export function useGetCourseRegistrationsForStudentLazyQuery(variables?: Types.GetCourseRegistrationsForStudentQueryVariables | VueCompositionApi.Ref<Types.GetCourseRegistrationsForStudentQueryVariables> | ReactiveFunction<Types.GetCourseRegistrationsForStudentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>(GetCourseRegistrationsForStudentDocument, variables, options);
}
export type GetCourseRegistrationsForStudentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCourseRegistrationsForStudentQuery, Types.GetCourseRegistrationsForStudentQueryVariables>;
export const PendingCourseRegistrationsForEndorsementDocument = gql`
    query PendingCourseRegistrationsForEndorsement($filter: CourseRegistrationApprovalFilterInput) {
  pendingCourseRegistrationsForEndorsement(filter: $filter) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      student {
        id
        surname
        first_name
        matric_no
      }
      academic_calendar {
        id
        session {
          id
          name
        }
        termStructure {
          id
          name
        }
      }
      session
      semester
      level
      programme
      registrations {
        id
        authorization_status
        approval_status
        coursesRegistered {
          programme_module_id
          module_name
          module_sequence
          id
          course_id
          course_status
          course {
            id
            course_code
            course_title
            unit
          }
        }
      }
      total_units
      course_count
      level_adviser {
        id
        name
      }
      level_adviser_approved_at
    }
  }
}
    `;

/**
 * __usePendingCourseRegistrationsForEndorsementQuery__
 *
 * To run a query within a Vue component, call `usePendingCourseRegistrationsForEndorsementQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingCourseRegistrationsForEndorsementQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePendingCourseRegistrationsForEndorsementQuery({
 *   filter: // value for 'filter'
 * });
 */
export function usePendingCourseRegistrationsForEndorsementQuery(variables: Types.PendingCourseRegistrationsForEndorsementQueryVariables | VueCompositionApi.Ref<Types.PendingCourseRegistrationsForEndorsementQueryVariables> | ReactiveFunction<Types.PendingCourseRegistrationsForEndorsementQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>(PendingCourseRegistrationsForEndorsementDocument, variables, options);
}
export function usePendingCourseRegistrationsForEndorsementLazyQuery(variables: Types.PendingCourseRegistrationsForEndorsementQueryVariables | VueCompositionApi.Ref<Types.PendingCourseRegistrationsForEndorsementQueryVariables> | ReactiveFunction<Types.PendingCourseRegistrationsForEndorsementQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>(PendingCourseRegistrationsForEndorsementDocument, variables, options);
}
export type PendingCourseRegistrationsForEndorsementQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PendingCourseRegistrationsForEndorsementQuery, Types.PendingCourseRegistrationsForEndorsementQueryVariables>;
export const GetRegistrationsForCourseInCurrentCalendarDocument = gql`
    query GetRegistrationsForCourseInCurrentCalendar($course_id: Int!, $academic_calendar_id: Int) {
  getRegistrationsForCourseInCurrentCalendar(
    course_id: $course_id
    academic_calendar_id: $academic_calendar_id
  ) {
    id
    student_id
    programme_id
    academic_calendar_id
    registration_level
    semester
    academic_session
    approval_status
    authorization_status
    student {
      id
      first_name
      surname
      other_name
      matric_no
      email
      phone
      photo
    }
    programme {
      id
      program_name
      prog_code
    }
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      scores {
        id
        school_assessment_type_id
        schoolAssessmentType {
          id
          name
        }
        score
        approval_status
      }
    }
  }
}
    `;

/**
 * __useGetRegistrationsForCourseInCurrentCalendarQuery__
 *
 * To run a query within a Vue component, call `useGetRegistrationsForCourseInCurrentCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationsForCourseInCurrentCalendarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRegistrationsForCourseInCurrentCalendarQuery({
 *   course_id: // value for 'course_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetRegistrationsForCourseInCurrentCalendarQuery(variables: Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables | VueCompositionApi.Ref<Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables> | ReactiveFunction<Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>(GetRegistrationsForCourseInCurrentCalendarDocument, variables, options);
}
export function useGetRegistrationsForCourseInCurrentCalendarLazyQuery(variables?: Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables | VueCompositionApi.Ref<Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables> | ReactiveFunction<Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>(GetRegistrationsForCourseInCurrentCalendarDocument, variables, options);
}
export type GetRegistrationsForCourseInCurrentCalendarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetRegistrationsForCourseInCurrentCalendarQuery, Types.GetRegistrationsForCourseInCurrentCalendarQueryVariables>;
export const ListSchoolCampusesDocument = gql`
    query ListSchoolCampuses($filter: campusFilterInput) {
  listSchoolCampuses(filter: $filter, first: 100) {
    data {
      id
      name
      student_count
    }
  }
}
    `;

/**
 * __useListSchoolCampusesQuery__
 *
 * To run a query within a Vue component, call `useListSchoolCampusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSchoolCampusesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListSchoolCampusesQuery({
 *   filter: // value for 'filter'
 * });
 */
export function useListSchoolCampusesQuery(variables: Types.ListSchoolCampusesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCampusesQueryVariables> | ReactiveFunction<Types.ListSchoolCampusesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>(ListSchoolCampusesDocument, variables, options);
}
export function useListSchoolCampusesLazyQuery(variables: Types.ListSchoolCampusesQueryVariables | VueCompositionApi.Ref<Types.ListSchoolCampusesQueryVariables> | ReactiveFunction<Types.ListSchoolCampusesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>(ListSchoolCampusesDocument, variables, options);
}
export type ListSchoolCampusesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListSchoolCampusesQuery, Types.ListSchoolCampusesQueryVariables>;
export const GetStudentResultBasicTertiaryDocument = gql`
    query GetStudentResultBasicTertiary($studentId: ID!, $calendarId: ID!) {
  studentResult(student_id: $studentId, academic_calendar_id: $calendarId) {
    status
    headers {
      label
      key
      type
      is_visible
    }
    data
    student {
      id
      surname
      first_name
      matric_no
    }
    academic_calendar {
      id
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
    template {
      id
      name
    }
  }
}
    `;

/**
 * __useGetStudentResultBasicTertiaryQuery__
 *
 * To run a query within a Vue component, call `useGetStudentResultBasicTertiaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentResultBasicTertiaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentResultBasicTertiaryQuery({
 *   studentId: // value for 'studentId'
 *   calendarId: // value for 'calendarId'
 * });
 */
export function useGetStudentResultBasicTertiaryQuery(variables: Types.GetStudentResultBasicTertiaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentResultBasicTertiaryQueryVariables> | ReactiveFunction<Types.GetStudentResultBasicTertiaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>(GetStudentResultBasicTertiaryDocument, variables, options);
}
export function useGetStudentResultBasicTertiaryLazyQuery(variables?: Types.GetStudentResultBasicTertiaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentResultBasicTertiaryQueryVariables> | ReactiveFunction<Types.GetStudentResultBasicTertiaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>(GetStudentResultBasicTertiaryDocument, variables, options);
}
export type GetStudentResultBasicTertiaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentResultBasicTertiaryQuery, Types.GetStudentResultBasicTertiaryQueryVariables>;
export const GetTertiaryResultSummarySheetDocument = gql`
    query GetTertiaryResultSummarySheet($input: ResultSummarySheetInput!) {
  getTertiaryResultSummarySheet(input: $input) {
    header {
      session
      semester
      program_name
      department_name
      faculty_name
      level
    }
    summary {
      excellent
      very_good
      good
      fair
      pass
      poor
      fail
      first_class
      second_class_upper
      second_class_lower
      third_class
      other
      average
    }
    students {
      sn
      student_id
      matric_number
      names
      prev_tcp
      prev_tnup
      prev_tnur
      prev_cgpa
      curr_tcp
      curr_tnup
      curr_tnur
      curr_gpa
      cum_tcp
      cum_tnup
      cum_tnur
      cum_cgpa
      status
      failed_compulsory_courses_list
      degree_class
    }
  }
}
    `;

/**
 * __useGetTertiaryResultSummarySheetQuery__
 *
 * To run a query within a Vue component, call `useGetTertiaryResultSummarySheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTertiaryResultSummarySheetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTertiaryResultSummarySheetQuery({
 *   input: // value for 'input'
 * });
 */
export function useGetTertiaryResultSummarySheetQuery(variables: Types.GetTertiaryResultSummarySheetQueryVariables | VueCompositionApi.Ref<Types.GetTertiaryResultSummarySheetQueryVariables> | ReactiveFunction<Types.GetTertiaryResultSummarySheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>(GetTertiaryResultSummarySheetDocument, variables, options);
}
export function useGetTertiaryResultSummarySheetLazyQuery(variables?: Types.GetTertiaryResultSummarySheetQueryVariables | VueCompositionApi.Ref<Types.GetTertiaryResultSummarySheetQueryVariables> | ReactiveFunction<Types.GetTertiaryResultSummarySheetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>(GetTertiaryResultSummarySheetDocument, variables, options);
}
export type GetTertiaryResultSummarySheetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTertiaryResultSummarySheetQuery, Types.GetTertiaryResultSummarySheetQueryVariables>;
export const GetLecturerStudentAllocationsDocument = gql`
    query GetLecturerStudentAllocations($course_id: ID!, $academic_calendar_id: ID) {
  getLecturerStudentAllocations(
    course_id: $course_id
    academic_calendar_id: $academic_calendar_id
  ) {
    course_lecturer_id
    lecturer_name
    school_staff_id
    allocated_count
    students {
      id
      course_id
      studentCourseRegistration {
        id
        student_id
        registration_level
        programme {
          id
          program_name
          prog_code
        }
        student {
          id
          first_name
          surname
          matric_no
        }
      }
    }
  }
}
    `;

/**
 * __useGetLecturerStudentAllocationsQuery__
 *
 * To run a query within a Vue component, call `useGetLecturerStudentAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLecturerStudentAllocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLecturerStudentAllocationsQuery({
 *   course_id: // value for 'course_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetLecturerStudentAllocationsQuery(variables: Types.GetLecturerStudentAllocationsQueryVariables | VueCompositionApi.Ref<Types.GetLecturerStudentAllocationsQueryVariables> | ReactiveFunction<Types.GetLecturerStudentAllocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>(GetLecturerStudentAllocationsDocument, variables, options);
}
export function useGetLecturerStudentAllocationsLazyQuery(variables?: Types.GetLecturerStudentAllocationsQueryVariables | VueCompositionApi.Ref<Types.GetLecturerStudentAllocationsQueryVariables> | ReactiveFunction<Types.GetLecturerStudentAllocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>(GetLecturerStudentAllocationsDocument, variables, options);
}
export type GetLecturerStudentAllocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetLecturerStudentAllocationsQuery, Types.GetLecturerStudentAllocationsQueryVariables>;
export const GetUnallocatedStudentsDocument = gql`
    query GetUnallocatedStudents($course_id: ID!, $academic_calendar_id: ID) {
  getUnallocatedStudents(
    course_id: $course_id
    academic_calendar_id: $academic_calendar_id
  ) {
    id
    course_id
    studentCourseRegistration {
      id
      student_id
      registration_level
      programme {
        id
        program_name
        prog_code
      }
      student {
        id
        first_name
        surname
        matric_no
      }
    }
  }
}
    `;

/**
 * __useGetUnallocatedStudentsQuery__
 *
 * To run a query within a Vue component, call `useGetUnallocatedStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnallocatedStudentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUnallocatedStudentsQuery({
 *   course_id: // value for 'course_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetUnallocatedStudentsQuery(variables: Types.GetUnallocatedStudentsQueryVariables | VueCompositionApi.Ref<Types.GetUnallocatedStudentsQueryVariables> | ReactiveFunction<Types.GetUnallocatedStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>(GetUnallocatedStudentsDocument, variables, options);
}
export function useGetUnallocatedStudentsLazyQuery(variables?: Types.GetUnallocatedStudentsQueryVariables | VueCompositionApi.Ref<Types.GetUnallocatedStudentsQueryVariables> | ReactiveFunction<Types.GetUnallocatedStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>(GetUnallocatedStudentsDocument, variables, options);
}
export type GetUnallocatedStudentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetUnallocatedStudentsQuery, Types.GetUnallocatedStudentsQueryVariables>;
export const PendingApprovalNotificationPreferenceDocument = gql`
    query PendingApprovalNotificationPreference {
  pendingApprovalNotificationSubscription {
    topic
    subscribed
    scopes {
      id
      schoolWide
      departmentId
      departmentName
      programmeId
      programmeName
    }
  }
}
    `;

/**
 * __usePendingApprovalNotificationPreferenceQuery__
 *
 * To run a query within a Vue component, call `usePendingApprovalNotificationPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingApprovalNotificationPreferenceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePendingApprovalNotificationPreferenceQuery();
 */
export function usePendingApprovalNotificationPreferenceQuery(options: VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>(PendingApprovalNotificationPreferenceDocument, {}, options);
}
export function usePendingApprovalNotificationPreferenceLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>(PendingApprovalNotificationPreferenceDocument, {}, options);
}
export type PendingApprovalNotificationPreferenceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PendingApprovalNotificationPreferenceQuery, Types.PendingApprovalNotificationPreferenceQueryVariables>;
export const ListProgrammeModulesDocument = gql`
    query ListProgrammeModules($programme_id: ID!, $session_id: ID, $academic_calendar_id: ID) {
  listProgrammeModules(
    programme_id: $programme_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    id
    programme_id
    session_id
    academic_calendar_id
    name
    registration_fee
    retake_fee
    registration_fee_item_template_id
    retake_fee_item_template_id
    sequence
    min_units_per_registration
    max_units_per_registration
    started_at
    ended_at
    is_active
    is_open
    session {
      id
      name
    }
    academicCalendar {
      id
      term_structure_id
    }
  }
}
    `;

/**
 * __useListProgrammeModulesQuery__
 *
 * To run a query within a Vue component, call `useListProgrammeModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProgrammeModulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListProgrammeModulesQuery({
 *   programme_id: // value for 'programme_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useListProgrammeModulesQuery(variables: Types.ListProgrammeModulesQueryVariables | VueCompositionApi.Ref<Types.ListProgrammeModulesQueryVariables> | ReactiveFunction<Types.ListProgrammeModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>(ListProgrammeModulesDocument, variables, options);
}
export function useListProgrammeModulesLazyQuery(variables?: Types.ListProgrammeModulesQueryVariables | VueCompositionApi.Ref<Types.ListProgrammeModulesQueryVariables> | ReactiveFunction<Types.ListProgrammeModulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>(ListProgrammeModulesDocument, variables, options);
}
export type ListProgrammeModulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListProgrammeModulesQuery, Types.ListProgrammeModulesQueryVariables>;
export const SessionsWithCalendarsDocument = gql`
    query SessionsWithCalendars {
  schoolSessions {
    id
    name
    academicCalendars {
      id
      termStructure {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSessionsWithCalendarsQuery__
 *
 * To run a query within a Vue component, call `useSessionsWithCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsWithCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSessionsWithCalendarsQuery();
 */
export function useSessionsWithCalendarsQuery(options: VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>(SessionsWithCalendarsDocument, {}, options);
}
export function useSessionsWithCalendarsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>(SessionsWithCalendarsDocument, {}, options);
}
export type SessionsWithCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SessionsWithCalendarsQuery, Types.SessionsWithCalendarsQueryVariables>;
export const ListCoursesWithPrerequisitesDocument = gql`
    query ListCoursesWithPrerequisites($first: Int!, $page: Int, $filter: CourseFilterInput) {
  listSchoolCourses(first: $first, page: $page, filter: $filter) {
    paginatorInfo {
      currentPage
      lastPage
      total
      perPage
    }
    data {
      id
      course_title
      course_code
      unit
      is_active
      prerequisites {
        id
        prerequisite_course_id
        prerequisiteCourse {
          id
          course_code
          course_title
          unit
        }
      }
    }
  }
}
    `;

/**
 * __useListCoursesWithPrerequisitesQuery__
 *
 * To run a query within a Vue component, call `useListCoursesWithPrerequisitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCoursesWithPrerequisitesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useListCoursesWithPrerequisitesQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   filter: // value for 'filter'
 * });
 */
export function useListCoursesWithPrerequisitesQuery(variables: Types.ListCoursesWithPrerequisitesQueryVariables | VueCompositionApi.Ref<Types.ListCoursesWithPrerequisitesQueryVariables> | ReactiveFunction<Types.ListCoursesWithPrerequisitesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>(ListCoursesWithPrerequisitesDocument, variables, options);
}
export function useListCoursesWithPrerequisitesLazyQuery(variables?: Types.ListCoursesWithPrerequisitesQueryVariables | VueCompositionApi.Ref<Types.ListCoursesWithPrerequisitesQueryVariables> | ReactiveFunction<Types.ListCoursesWithPrerequisitesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>(ListCoursesWithPrerequisitesDocument, variables, options);
}
export type ListCoursesWithPrerequisitesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ListCoursesWithPrerequisitesQuery, Types.ListCoursesWithPrerequisitesQueryVariables>;
export const GetTicketCategoriesDocument = gql`
    query GetTicketCategories {
  ticketCategories {
    id
    name
    priority
    auto_response
    is_active
  }
}
    `;

/**
 * __useGetTicketCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetTicketCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTicketCategoriesQuery();
 */
export function useGetTicketCategoriesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>(GetTicketCategoriesDocument, {}, options);
}
export function useGetTicketCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>(GetTicketCategoriesDocument, {}, options);
}
export type GetTicketCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTicketCategoriesQuery, Types.GetTicketCategoriesQueryVariables>;
export const GetTicketsDocument = gql`
    query GetTickets($status: TicketStatus, $priority: TicketPriority, $category_id: ID, $page: Int) {
  tickets(
    status: $status
    priority: $priority
    ticket_category_id: $category_id
    page: $page
  ) {
    data {
      ...TicketFragment
    }
    paginatorInfo {
      total
      currentPage
      hasMorePages
      lastPage
    }
  }
}
    ${TicketFragmentDoc}`;

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a Vue component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTicketsQuery({
 *   status: // value for 'status'
 *   priority: // value for 'priority'
 *   category_id: // value for 'category_id'
 *   page: // value for 'page'
 * });
 */
export function useGetTicketsQuery(variables: Types.GetTicketsQueryVariables | VueCompositionApi.Ref<Types.GetTicketsQueryVariables> | ReactiveFunction<Types.GetTicketsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>(GetTicketsDocument, variables, options);
}
export function useGetTicketsLazyQuery(variables: Types.GetTicketsQueryVariables | VueCompositionApi.Ref<Types.GetTicketsQueryVariables> | ReactiveFunction<Types.GetTicketsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>(GetTicketsDocument, variables, options);
}
export type GetTicketsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTicketsQuery, Types.GetTicketsQueryVariables>;
export const GetTicketDocument = gql`
    query GetTicket($id: ID!) {
  ticket(id: $id) {
    ...TicketFragment
    description
    attachments {
      id
      file {
        url
        original_name
        mime_type
      }
    }
    messages {
      id
      message
      created_at
      scheduled_at
      status
      sender {
        ... on User {
          id
          name
        }
        ... on Student {
          id
          surname
          first_name
        }
      }
      attachments {
        id
        file {
          url
          original_name
          mime_type
        }
      }
    }
  }
}
    ${TicketFragmentDoc}`;

/**
 * __useGetTicketQuery__
 *
 * To run a query within a Vue component, call `useGetTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTicketQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTicketQuery(variables: Types.GetTicketQueryVariables | VueCompositionApi.Ref<Types.GetTicketQueryVariables> | ReactiveFunction<Types.GetTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTicketQuery, Types.GetTicketQueryVariables>(GetTicketDocument, variables, options);
}
export function useGetTicketLazyQuery(variables?: Types.GetTicketQueryVariables | VueCompositionApi.Ref<Types.GetTicketQueryVariables> | ReactiveFunction<Types.GetTicketQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTicketQuery, Types.GetTicketQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTicketQuery, Types.GetTicketQueryVariables>(GetTicketDocument, variables, options);
}
export type GetTicketQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTicketQuery, Types.GetTicketQueryVariables>;
export const AiPendingActionDocument = gql`
    query AiPendingAction($id: ID!) {
  aiPendingAction(id: $id) {
    ...AiPendingActionFields
  }
}
    ${AiPendingActionFieldsFragmentDoc}`;

/**
 * __useAiPendingActionQuery__
 *
 * To run a query within a Vue component, call `useAiPendingActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiPendingActionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAiPendingActionQuery({
 *   id: // value for 'id'
 * });
 */
export function useAiPendingActionQuery(variables: Types.AiPendingActionQueryVariables | VueCompositionApi.Ref<Types.AiPendingActionQueryVariables> | ReactiveFunction<Types.AiPendingActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>(AiPendingActionDocument, variables, options);
}
export function useAiPendingActionLazyQuery(variables?: Types.AiPendingActionQueryVariables | VueCompositionApi.Ref<Types.AiPendingActionQueryVariables> | ReactiveFunction<Types.AiPendingActionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>(AiPendingActionDocument, variables, options);
}
export type AiPendingActionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AiPendingActionQuery, Types.AiPendingActionQueryVariables>;
export const AiSelectionDocument = gql`
    query AiSelection($id: ID!) {
  aiSelection(id: $id) {
    id
    sourceKey
    label
    count
    filters {
      label
      value
    }
    breakdowns {
      label
      buckets {
        label
        count
      }
    }
    sample {
      ...AiPreviewRowFields
    }
    expiresAt
    openRoute
    openParams
  }
}
    ${AiPreviewRowFieldsFragmentDoc}`;

/**
 * __useAiSelectionQuery__
 *
 * To run a query within a Vue component, call `useAiSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiSelectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAiSelectionQuery({
 *   id: // value for 'id'
 * });
 */
export function useAiSelectionQuery(variables: Types.AiSelectionQueryVariables | VueCompositionApi.Ref<Types.AiSelectionQueryVariables> | ReactiveFunction<Types.AiSelectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>(AiSelectionDocument, variables, options);
}
export function useAiSelectionLazyQuery(variables?: Types.AiSelectionQueryVariables | VueCompositionApi.Ref<Types.AiSelectionQueryVariables> | ReactiveFunction<Types.AiSelectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>(AiSelectionDocument, variables, options);
}
export type AiSelectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AiSelectionQuery, Types.AiSelectionQueryVariables>;
export const AiActionRunDocument = gql`
    query AiActionRun($id: ID!, $first: Int, $page: Int) {
  aiActionRun(id: $id) {
    ...AiActionRunFields
    problems(first: $first, page: $page) {
      subjectId
      label
      status
      reasonCode
      message
    }
  }
}
    ${AiActionRunFieldsFragmentDoc}`;

/**
 * __useAiActionRunQuery__
 *
 * To run a query within a Vue component, call `useAiActionRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiActionRunQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAiActionRunQuery({
 *   id: // value for 'id'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useAiActionRunQuery(variables: Types.AiActionRunQueryVariables | VueCompositionApi.Ref<Types.AiActionRunQueryVariables> | ReactiveFunction<Types.AiActionRunQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>(AiActionRunDocument, variables, options);
}
export function useAiActionRunLazyQuery(variables?: Types.AiActionRunQueryVariables | VueCompositionApi.Ref<Types.AiActionRunQueryVariables> | ReactiveFunction<Types.AiActionRunQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>(AiActionRunDocument, variables, options);
}
export type AiActionRunQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AiActionRunQuery, Types.AiActionRunQueryVariables>;
export const ConfirmAiPendingActionDocument = gql`
    mutation ConfirmAiPendingAction($id: ID!) {
  confirmAiPendingAction(id: $id) {
    ...AiPendingActionFields
  }
}
    ${AiPendingActionFieldsFragmentDoc}`;

/**
 * __useConfirmAiPendingActionMutation__
 *
 * To run a mutation, you first call `useConfirmAiPendingActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAiPendingActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmAiPendingActionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useConfirmAiPendingActionMutation(options: VueApolloComposable.UseMutationOptions<Types.ConfirmAiPendingActionMutation, Types.ConfirmAiPendingActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ConfirmAiPendingActionMutation, Types.ConfirmAiPendingActionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ConfirmAiPendingActionMutation, Types.ConfirmAiPendingActionMutationVariables>(ConfirmAiPendingActionDocument, options);
}
export type ConfirmAiPendingActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ConfirmAiPendingActionMutation, Types.ConfirmAiPendingActionMutationVariables>;
export const CancelAiPendingActionDocument = gql`
    mutation CancelAiPendingAction($id: ID!) {
  cancelAiPendingAction(id: $id) {
    ...AiPendingActionFields
  }
}
    ${AiPendingActionFieldsFragmentDoc}`;

/**
 * __useCancelAiPendingActionMutation__
 *
 * To run a mutation, you first call `useCancelAiPendingActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCancelAiPendingActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCancelAiPendingActionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCancelAiPendingActionMutation(options: VueApolloComposable.UseMutationOptions<Types.CancelAiPendingActionMutation, Types.CancelAiPendingActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CancelAiPendingActionMutation, Types.CancelAiPendingActionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CancelAiPendingActionMutation, Types.CancelAiPendingActionMutationVariables>(CancelAiPendingActionDocument, options);
}
export type CancelAiPendingActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CancelAiPendingActionMutation, Types.CancelAiPendingActionMutationVariables>;
export const AiAssistantSchoolFlagsDocument = gql`
    query AiAssistantSchoolFlags {
  getSchool {
    id
    aiAssistantEnabled
    aiStudentAccess
  }
}
    `;

/**
 * __useAiAssistantSchoolFlagsQuery__
 *
 * To run a query within a Vue component, call `useAiAssistantSchoolFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAssistantSchoolFlagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAiAssistantSchoolFlagsQuery();
 */
export function useAiAssistantSchoolFlagsQuery(options: VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>(AiAssistantSchoolFlagsDocument, {}, options);
}
export function useAiAssistantSchoolFlagsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>(AiAssistantSchoolFlagsDocument, {}, options);
}
export type AiAssistantSchoolFlagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AiAssistantSchoolFlagsQuery, Types.AiAssistantSchoolFlagsQueryVariables>;
export const AiAssistantStudentFlagsDocument = gql`
    query AiAssistantStudentFlags {
  me {
    __typename
    ... on Student {
      id
      school {
        id
        aiAssistantEnabled
        aiStudentAccess
      }
    }
  }
}
    `;

/**
 * __useAiAssistantStudentFlagsQuery__
 *
 * To run a query within a Vue component, call `useAiAssistantStudentFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiAssistantStudentFlagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAiAssistantStudentFlagsQuery();
 */
export function useAiAssistantStudentFlagsQuery(options: VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>(AiAssistantStudentFlagsDocument, {}, options);
}
export function useAiAssistantStudentFlagsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>(AiAssistantStudentFlagsDocument, {}, options);
}
export type AiAssistantStudentFlagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AiAssistantStudentFlagsQuery, Types.AiAssistantStudentFlagsQueryVariables>;
export const UpdateSchoolAiSettingsDocument = gql`
    mutation UpdateSchoolAiSettings($aiAssistantEnabled: Boolean!, $aiStudentAccess: Boolean!) {
  updateSchoolAiSettings(
    aiAssistantEnabled: $aiAssistantEnabled
    aiStudentAccess: $aiStudentAccess
  ) {
    id
    aiAssistantEnabled
    aiStudentAccess
  }
}
    `;

/**
 * __useUpdateSchoolAiSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolAiSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolAiSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolAiSettingsMutation({
 *   variables: {
 *     aiAssistantEnabled: // value for 'aiAssistantEnabled'
 *     aiStudentAccess: // value for 'aiStudentAccess'
 *   },
 * });
 */
export function useUpdateSchoolAiSettingsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolAiSettingsMutation, Types.UpdateSchoolAiSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolAiSettingsMutation, Types.UpdateSchoolAiSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolAiSettingsMutation, Types.UpdateSchoolAiSettingsMutationVariables>(UpdateSchoolAiSettingsDocument, options);
}
export type UpdateSchoolAiSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolAiSettingsMutation, Types.UpdateSchoolAiSettingsMutationVariables>;
export const SchoolAiUsageDocument = gql`
    query SchoolAiUsage {
  getSchool {
    id
    aiUsage {
      currency
      monthlyCap
      monthlySpend
      monthlyRemaining
      monthlyTokens
      dailyCap
      dailySpend
      dailyRemaining
      dailyTokens
      periodStart
      periodEnd
      capReached
      hasUnpricedUsage
    }
  }
}
    `;

/**
 * __useSchoolAiUsageQuery__
 *
 * To run a query within a Vue component, call `useSchoolAiUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAiUsageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolAiUsageQuery();
 */
export function useSchoolAiUsageQuery(options: VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>(SchoolAiUsageDocument, {}, options);
}
export function useSchoolAiUsageLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>(SchoolAiUsageDocument, {}, options);
}
export type SchoolAiUsageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchoolAiUsageQuery, Types.SchoolAiUsageQueryVariables>;
export const ActiveAnnouncementsDocument = gql`
    query ActiveAnnouncements {
  activeAnnouncements {
    id
    title
    body
    severity
    dismissible
    requires_ack
    cta_label
    cta_url
    display_from
    display_until
    published_at
  }
}
    `;

/**
 * __useActiveAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useActiveAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useActiveAnnouncementsQuery();
 */
export function useActiveAnnouncementsQuery(options: VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>(ActiveAnnouncementsDocument, {}, options);
}
export function useActiveAnnouncementsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>(ActiveAnnouncementsDocument, {}, options);
}
export type ActiveAnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ActiveAnnouncementsQuery, Types.ActiveAnnouncementsQueryVariables>;
export const AcknowledgeAnnouncementDocument = gql`
    mutation AcknowledgeAnnouncement($announcement_id: ID!) {
  acknowledgeAnnouncement(announcement_id: $announcement_id)
}
    `;

/**
 * __useAcknowledgeAnnouncementMutation__
 *
 * To run a mutation, you first call `useAcknowledgeAnnouncementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeAnnouncementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcknowledgeAnnouncementMutation({
 *   variables: {
 *     announcement_id: // value for 'announcement_id'
 *   },
 * });
 */
export function useAcknowledgeAnnouncementMutation(options: VueApolloComposable.UseMutationOptions<Types.AcknowledgeAnnouncementMutation, Types.AcknowledgeAnnouncementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AcknowledgeAnnouncementMutation, Types.AcknowledgeAnnouncementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AcknowledgeAnnouncementMutation, Types.AcknowledgeAnnouncementMutationVariables>(AcknowledgeAnnouncementDocument, options);
}
export type AcknowledgeAnnouncementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AcknowledgeAnnouncementMutation, Types.AcknowledgeAnnouncementMutationVariables>;
export const DismissAnnouncementDocument = gql`
    mutation DismissAnnouncement($announcement_id: ID!) {
  dismissAnnouncement(announcement_id: $announcement_id)
}
    `;

/**
 * __useDismissAnnouncementMutation__
 *
 * To run a mutation, you first call `useDismissAnnouncementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissAnnouncementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissAnnouncementMutation({
 *   variables: {
 *     announcement_id: // value for 'announcement_id'
 *   },
 * });
 */
export function useDismissAnnouncementMutation(options: VueApolloComposable.UseMutationOptions<Types.DismissAnnouncementMutation, Types.DismissAnnouncementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DismissAnnouncementMutation, Types.DismissAnnouncementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DismissAnnouncementMutation, Types.DismissAnnouncementMutationVariables>(DismissAnnouncementDocument, options);
}
export type DismissAnnouncementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DismissAnnouncementMutation, Types.DismissAnnouncementMutationVariables>;
export const MyAttendanceCoursesDocument = gql`
    query MyAttendanceCourses {
  myAttendanceCourses {
    id
    course_code
    course_title
  }
}
    `;

/**
 * __useMyAttendanceCoursesQuery__
 *
 * To run a query within a Vue component, call `useMyAttendanceCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAttendanceCoursesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyAttendanceCoursesQuery();
 */
export function useMyAttendanceCoursesQuery(options: VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>(MyAttendanceCoursesDocument, {}, options);
}
export function useMyAttendanceCoursesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>(MyAttendanceCoursesDocument, {}, options);
}
export type MyAttendanceCoursesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.MyAttendanceCoursesQuery, Types.MyAttendanceCoursesQueryVariables>;
export const CourseStudentAttendanceDocument = gql`
    query CourseStudentAttendance($course_id: ID!, $start_date: Date, $end_date: Date, $first: Int) {
  courseStudentAttendance(
    course_id: $course_id
    start_date: $start_date
    end_date: $end_date
    first: $first
  ) {
    data {
      student {
        id
        first_name
        surname
        other_name
        matric_no
        photo
      }
      summary {
        present
        absent
        late
        excused
        total
      }
    }
    paginatorInfo {
      total
    }
  }
}
    `;

/**
 * __useCourseStudentAttendanceQuery__
 *
 * To run a query within a Vue component, call `useCourseStudentAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseStudentAttendanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCourseStudentAttendanceQuery({
 *   course_id: // value for 'course_id'
 *   start_date: // value for 'start_date'
 *   end_date: // value for 'end_date'
 *   first: // value for 'first'
 * });
 */
export function useCourseStudentAttendanceQuery(variables: Types.CourseStudentAttendanceQueryVariables | VueCompositionApi.Ref<Types.CourseStudentAttendanceQueryVariables> | ReactiveFunction<Types.CourseStudentAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>(CourseStudentAttendanceDocument, variables, options);
}
export function useCourseStudentAttendanceLazyQuery(variables?: Types.CourseStudentAttendanceQueryVariables | VueCompositionApi.Ref<Types.CourseStudentAttendanceQueryVariables> | ReactiveFunction<Types.CourseStudentAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>(CourseStudentAttendanceDocument, variables, options);
}
export type CourseStudentAttendanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CourseStudentAttendanceQuery, Types.CourseStudentAttendanceQueryVariables>;
export const AttendanceEventsDocument = gql`
    query AttendanceEvents($academic_calendar_id: ID, $category: AttendanceEventCategory, $is_active: Boolean) {
  attendanceEvents(
    academic_calendar_id: $academic_calendar_id
    category: $category
    is_active: $is_active
  ) {
    ...AttendanceEventFields
  }
}
    ${AttendanceEventFieldsFragmentDoc}`;

/**
 * __useAttendanceEventsQuery__
 *
 * To run a query within a Vue component, call `useAttendanceEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttendanceEventsQuery({
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   category: // value for 'category'
 *   is_active: // value for 'is_active'
 * });
 */
export function useAttendanceEventsQuery(variables: Types.AttendanceEventsQueryVariables | VueCompositionApi.Ref<Types.AttendanceEventsQueryVariables> | ReactiveFunction<Types.AttendanceEventsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>(AttendanceEventsDocument, variables, options);
}
export function useAttendanceEventsLazyQuery(variables: Types.AttendanceEventsQueryVariables | VueCompositionApi.Ref<Types.AttendanceEventsQueryVariables> | ReactiveFunction<Types.AttendanceEventsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>(AttendanceEventsDocument, variables, options);
}
export type AttendanceEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AttendanceEventsQuery, Types.AttendanceEventsQueryVariables>;
export const AttendanceEventDocument = gql`
    query AttendanceEvent($id: ID!) {
  attendanceEvent(id: $id) {
    ...AttendanceEventFields
  }
}
    ${AttendanceEventFieldsFragmentDoc}`;

/**
 * __useAttendanceEventQuery__
 *
 * To run a query within a Vue component, call `useAttendanceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttendanceEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttendanceEventQuery({
 *   id: // value for 'id'
 * });
 */
export function useAttendanceEventQuery(variables: Types.AttendanceEventQueryVariables | VueCompositionApi.Ref<Types.AttendanceEventQueryVariables> | ReactiveFunction<Types.AttendanceEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>(AttendanceEventDocument, variables, options);
}
export function useAttendanceEventLazyQuery(variables?: Types.AttendanceEventQueryVariables | VueCompositionApi.Ref<Types.AttendanceEventQueryVariables> | ReactiveFunction<Types.AttendanceEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>(AttendanceEventDocument, variables, options);
}
export type AttendanceEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AttendanceEventQuery, Types.AttendanceEventQueryVariables>;
export const EventStudentAttendanceDocument = gql`
    query EventStudentAttendance($attendance_event_id: ID!, $start_date: Date, $end_date: Date, $page: Int, $first: Int) {
  eventStudentAttendance(
    attendance_event_id: $attendance_event_id
    start_date: $start_date
    end_date: $end_date
    page: $page
    first: $first
  ) {
    data {
      student {
        id
        first_name
        surname
        other_name
        matric_no
        photo
      }
      summary {
        present
        absent
        late
        excused
        total
      }
    }
    paginatorInfo {
      currentPage
      lastPage
      total
    }
  }
}
    `;

/**
 * __useEventStudentAttendanceQuery__
 *
 * To run a query within a Vue component, call `useEventStudentAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventStudentAttendanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventStudentAttendanceQuery({
 *   attendance_event_id: // value for 'attendance_event_id'
 *   start_date: // value for 'start_date'
 *   end_date: // value for 'end_date'
 *   page: // value for 'page'
 *   first: // value for 'first'
 * });
 */
export function useEventStudentAttendanceQuery(variables: Types.EventStudentAttendanceQueryVariables | VueCompositionApi.Ref<Types.EventStudentAttendanceQueryVariables> | ReactiveFunction<Types.EventStudentAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>(EventStudentAttendanceDocument, variables, options);
}
export function useEventStudentAttendanceLazyQuery(variables?: Types.EventStudentAttendanceQueryVariables | VueCompositionApi.Ref<Types.EventStudentAttendanceQueryVariables> | ReactiveFunction<Types.EventStudentAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>(EventStudentAttendanceDocument, variables, options);
}
export type EventStudentAttendanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.EventStudentAttendanceQuery, Types.EventStudentAttendanceQueryVariables>;
export const CreateAttendanceEventDocument = gql`
    mutation CreateAttendanceEvent($input: CreateAttendanceEventInput!) {
  createAttendanceEvent(input: $input) {
    ...AttendanceEventFields
  }
}
    ${AttendanceEventFieldsFragmentDoc}`;

/**
 * __useCreateAttendanceEventMutation__
 *
 * To run a mutation, you first call `useCreateAttendanceEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttendanceEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAttendanceEventMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttendanceEventMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateAttendanceEventMutation, Types.CreateAttendanceEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateAttendanceEventMutation, Types.CreateAttendanceEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateAttendanceEventMutation, Types.CreateAttendanceEventMutationVariables>(CreateAttendanceEventDocument, options);
}
export type CreateAttendanceEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateAttendanceEventMutation, Types.CreateAttendanceEventMutationVariables>;
export const UpdateAttendanceEventDocument = gql`
    mutation UpdateAttendanceEvent($id: ID!, $input: UpdateAttendanceEventInput!) {
  updateAttendanceEvent(id: $id, input: $input) {
    ...AttendanceEventFields
  }
}
    ${AttendanceEventFieldsFragmentDoc}`;

/**
 * __useUpdateAttendanceEventMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAttendanceEventMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttendanceEventMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateAttendanceEventMutation, Types.UpdateAttendanceEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateAttendanceEventMutation, Types.UpdateAttendanceEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateAttendanceEventMutation, Types.UpdateAttendanceEventMutationVariables>(UpdateAttendanceEventDocument, options);
}
export type UpdateAttendanceEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateAttendanceEventMutation, Types.UpdateAttendanceEventMutationVariables>;
export const DeleteAttendanceEventDocument = gql`
    mutation DeleteAttendanceEvent($id: ID!) {
  deleteAttendanceEvent(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteAttendanceEventMutation__
 *
 * To run a mutation, you first call `useDeleteAttendanceEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendanceEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAttendanceEventMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttendanceEventMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteAttendanceEventMutation, Types.DeleteAttendanceEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteAttendanceEventMutation, Types.DeleteAttendanceEventMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteAttendanceEventMutation, Types.DeleteAttendanceEventMutationVariables>(DeleteAttendanceEventDocument, options);
}
export type DeleteAttendanceEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteAttendanceEventMutation, Types.DeleteAttendanceEventMutationVariables>;
export const GetFeeSplitProfilesDocument = gql`
    query GetFeeSplitProfiles($is_active: Boolean) {
  feeSplitProfiles(is_active: $is_active) {
    ...FeeSplitProfileFields
  }
}
    ${FeeSplitProfileFieldsFragmentDoc}`;

/**
 * __useGetFeeSplitProfilesQuery__
 *
 * To run a query within a Vue component, call `useGetFeeSplitProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeSplitProfilesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFeeSplitProfilesQuery({
 *   is_active: // value for 'is_active'
 * });
 */
export function useGetFeeSplitProfilesQuery(variables: Types.GetFeeSplitProfilesQueryVariables | VueCompositionApi.Ref<Types.GetFeeSplitProfilesQueryVariables> | ReactiveFunction<Types.GetFeeSplitProfilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>(GetFeeSplitProfilesDocument, variables, options);
}
export function useGetFeeSplitProfilesLazyQuery(variables: Types.GetFeeSplitProfilesQueryVariables | VueCompositionApi.Ref<Types.GetFeeSplitProfilesQueryVariables> | ReactiveFunction<Types.GetFeeSplitProfilesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>(GetFeeSplitProfilesDocument, variables, options);
}
export type GetFeeSplitProfilesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFeeSplitProfilesQuery, Types.GetFeeSplitProfilesQueryVariables>;
export const GetSettlementAccountsDocument = gql`
    query GetSettlementAccounts($provider_name: String) {
  settlementAccounts(provider_name: $provider_name) {
    ...SettlementAccountFields
  }
}
    ${SettlementAccountFieldsFragmentDoc}`;

/**
 * __useGetSettlementAccountsQuery__
 *
 * To run a query within a Vue component, call `useGetSettlementAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettlementAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSettlementAccountsQuery({
 *   provider_name: // value for 'provider_name'
 * });
 */
export function useGetSettlementAccountsQuery(variables: Types.GetSettlementAccountsQueryVariables | VueCompositionApi.Ref<Types.GetSettlementAccountsQueryVariables> | ReactiveFunction<Types.GetSettlementAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>(GetSettlementAccountsDocument, variables, options);
}
export function useGetSettlementAccountsLazyQuery(variables: Types.GetSettlementAccountsQueryVariables | VueCompositionApi.Ref<Types.GetSettlementAccountsQueryVariables> | ReactiveFunction<Types.GetSettlementAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>(GetSettlementAccountsDocument, variables, options);
}
export type GetSettlementAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSettlementAccountsQuery, Types.GetSettlementAccountsQueryVariables>;
export const GetSplitSummaryDocument = gql`
    query GetSplitSummary($child_school_id: ID, $date_from: Date, $date_to: Date) {
  splitSummary(
    child_school_id: $child_school_id
    date_from: $date_from
    date_to: $date_to
  ) {
    total_amount
    total_hq_amount
    total_campus_amount
    record_count
    by_school {
      school_id
      school_name
      total_amount
      hq_amount
      campus_amount
      record_count
    }
  }
}
    `;

/**
 * __useGetSplitSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetSplitSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSplitSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSplitSummaryQuery({
 *   child_school_id: // value for 'child_school_id'
 *   date_from: // value for 'date_from'
 *   date_to: // value for 'date_to'
 * });
 */
export function useGetSplitSummaryQuery(variables: Types.GetSplitSummaryQueryVariables | VueCompositionApi.Ref<Types.GetSplitSummaryQueryVariables> | ReactiveFunction<Types.GetSplitSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>(GetSplitSummaryDocument, variables, options);
}
export function useGetSplitSummaryLazyQuery(variables: Types.GetSplitSummaryQueryVariables | VueCompositionApi.Ref<Types.GetSplitSummaryQueryVariables> | ReactiveFunction<Types.GetSplitSummaryQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>(GetSplitSummaryDocument, variables, options);
}
export type GetSplitSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetSplitSummaryQuery, Types.GetSplitSummaryQueryVariables>;
export const GetPaymentSplitRecordsDocument = gql`
    query GetPaymentSplitRecords($child_school_id: ID, $date_from: Date, $date_to: Date, $page: Int, $per_page: Int) {
  paymentSplitRecords(
    child_school_id: $child_school_id
    date_from: $date_from
    date_to: $date_to
    page: $page
    per_page: $per_page
  ) {
    data {
      id
      total_amount
      hq_amount
      campus_amount
      split_mode
      gateway_split_status
      created_at
      student_name
      student_matric_no
      payment_reference
      campusSchool {
        id
        name
      }
    }
    total
    current_page
    per_page
  }
}
    `;

/**
 * __useGetPaymentSplitRecordsQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentSplitRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentSplitRecordsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentSplitRecordsQuery({
 *   child_school_id: // value for 'child_school_id'
 *   date_from: // value for 'date_from'
 *   date_to: // value for 'date_to'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useGetPaymentSplitRecordsQuery(variables: Types.GetPaymentSplitRecordsQueryVariables | VueCompositionApi.Ref<Types.GetPaymentSplitRecordsQueryVariables> | ReactiveFunction<Types.GetPaymentSplitRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>(GetPaymentSplitRecordsDocument, variables, options);
}
export function useGetPaymentSplitRecordsLazyQuery(variables: Types.GetPaymentSplitRecordsQueryVariables | VueCompositionApi.Ref<Types.GetPaymentSplitRecordsQueryVariables> | ReactiveFunction<Types.GetPaymentSplitRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>(GetPaymentSplitRecordsDocument, variables, options);
}
export type GetPaymentSplitRecordsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPaymentSplitRecordsQuery, Types.GetPaymentSplitRecordsQueryVariables>;
export const CreateFeeSplitProfileDocument = gql`
    mutation CreateFeeSplitProfile($input: CreateFeeSplitProfileInput!) {
  createFeeSplitProfile(input: $input) {
    ...FeeSplitProfileFields
  }
}
    ${FeeSplitProfileFieldsFragmentDoc}`;

/**
 * __useCreateFeeSplitProfileMutation__
 *
 * To run a mutation, you first call `useCreateFeeSplitProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeSplitProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFeeSplitProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeeSplitProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitProfileMutation, Types.CreateFeeSplitProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitProfileMutation, Types.CreateFeeSplitProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateFeeSplitProfileMutation, Types.CreateFeeSplitProfileMutationVariables>(CreateFeeSplitProfileDocument, options);
}
export type CreateFeeSplitProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateFeeSplitProfileMutation, Types.CreateFeeSplitProfileMutationVariables>;
export const UpdateFeeSplitProfileDocument = gql`
    mutation UpdateFeeSplitProfile($input: UpdateFeeSplitProfileInput!) {
  updateFeeSplitProfile(input: $input) {
    ...FeeSplitProfileFields
  }
}
    ${FeeSplitProfileFieldsFragmentDoc}`;

/**
 * __useUpdateFeeSplitProfileMutation__
 *
 * To run a mutation, you first call `useUpdateFeeSplitProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeSplitProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFeeSplitProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeSplitProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitProfileMutation, Types.UpdateFeeSplitProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitProfileMutation, Types.UpdateFeeSplitProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateFeeSplitProfileMutation, Types.UpdateFeeSplitProfileMutationVariables>(UpdateFeeSplitProfileDocument, options);
}
export type UpdateFeeSplitProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateFeeSplitProfileMutation, Types.UpdateFeeSplitProfileMutationVariables>;
export const DeleteFeeSplitProfileDocument = gql`
    mutation DeleteFeeSplitProfile($id: ID!) {
  deleteFeeSplitProfile(id: $id)
}
    `;

/**
 * __useDeleteFeeSplitProfileMutation__
 *
 * To run a mutation, you first call `useDeleteFeeSplitProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeSplitProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFeeSplitProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeeSplitProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitProfileMutation, Types.DeleteFeeSplitProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitProfileMutation, Types.DeleteFeeSplitProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteFeeSplitProfileMutation, Types.DeleteFeeSplitProfileMutationVariables>(DeleteFeeSplitProfileDocument, options);
}
export type DeleteFeeSplitProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteFeeSplitProfileMutation, Types.DeleteFeeSplitProfileMutationVariables>;
export const CreateFeeSplitRuleDocument = gql`
    mutation CreateFeeSplitRule($input: CreateFeeSplitRuleInput!) {
  createFeeSplitRule(input: $input) {
    ...FeeSplitRuleFields
  }
}
    ${FeeSplitRuleFieldsFragmentDoc}`;

/**
 * __useCreateFeeSplitRuleMutation__
 *
 * To run a mutation, you first call `useCreateFeeSplitRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeSplitRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFeeSplitRuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeeSplitRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitRuleMutation, Types.CreateFeeSplitRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitRuleMutation, Types.CreateFeeSplitRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateFeeSplitRuleMutation, Types.CreateFeeSplitRuleMutationVariables>(CreateFeeSplitRuleDocument, options);
}
export type CreateFeeSplitRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateFeeSplitRuleMutation, Types.CreateFeeSplitRuleMutationVariables>;
export const UpdateFeeSplitRuleDocument = gql`
    mutation UpdateFeeSplitRule($input: UpdateFeeSplitRuleInput!) {
  updateFeeSplitRule(input: $input) {
    ...FeeSplitRuleFields
  }
}
    ${FeeSplitRuleFieldsFragmentDoc}`;

/**
 * __useUpdateFeeSplitRuleMutation__
 *
 * To run a mutation, you first call `useUpdateFeeSplitRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeSplitRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFeeSplitRuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeSplitRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitRuleMutation, Types.UpdateFeeSplitRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitRuleMutation, Types.UpdateFeeSplitRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateFeeSplitRuleMutation, Types.UpdateFeeSplitRuleMutationVariables>(UpdateFeeSplitRuleDocument, options);
}
export type UpdateFeeSplitRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateFeeSplitRuleMutation, Types.UpdateFeeSplitRuleMutationVariables>;
export const DeleteFeeSplitRuleDocument = gql`
    mutation DeleteFeeSplitRule($id: ID!) {
  deleteFeeSplitRule(id: $id)
}
    `;

/**
 * __useDeleteFeeSplitRuleMutation__
 *
 * To run a mutation, you first call `useDeleteFeeSplitRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeSplitRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFeeSplitRuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeeSplitRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitRuleMutation, Types.DeleteFeeSplitRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitRuleMutation, Types.DeleteFeeSplitRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteFeeSplitRuleMutation, Types.DeleteFeeSplitRuleMutationVariables>(DeleteFeeSplitRuleDocument, options);
}
export type DeleteFeeSplitRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteFeeSplitRuleMutation, Types.DeleteFeeSplitRuleMutationVariables>;
export const AssignFeeSplitProfileDocument = gql`
    mutation AssignFeeSplitProfile($input: AssignFeeSplitProfileInput!) {
  assignFeeSplitProfile(input: $input) {
    id
    fee_split_profile_id
    child_school_id
    is_active
    childSchool {
      id
      name
    }
  }
}
    `;

/**
 * __useAssignFeeSplitProfileMutation__
 *
 * To run a mutation, you first call `useAssignFeeSplitProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignFeeSplitProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignFeeSplitProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignFeeSplitProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignFeeSplitProfileMutation, Types.AssignFeeSplitProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignFeeSplitProfileMutation, Types.AssignFeeSplitProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignFeeSplitProfileMutation, Types.AssignFeeSplitProfileMutationVariables>(AssignFeeSplitProfileDocument, options);
}
export type AssignFeeSplitProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignFeeSplitProfileMutation, Types.AssignFeeSplitProfileMutationVariables>;
export const UnassignFeeSplitProfileDocument = gql`
    mutation UnassignFeeSplitProfile($id: ID!) {
  unassignFeeSplitProfile(id: $id)
}
    `;

/**
 * __useUnassignFeeSplitProfileMutation__
 *
 * To run a mutation, you first call `useUnassignFeeSplitProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnassignFeeSplitProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnassignFeeSplitProfileMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnassignFeeSplitProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.UnassignFeeSplitProfileMutation, Types.UnassignFeeSplitProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UnassignFeeSplitProfileMutation, Types.UnassignFeeSplitProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UnassignFeeSplitProfileMutation, Types.UnassignFeeSplitProfileMutationVariables>(UnassignFeeSplitProfileDocument, options);
}
export type UnassignFeeSplitProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UnassignFeeSplitProfileMutation, Types.UnassignFeeSplitProfileMutationVariables>;
export const CreateSettlementAccountDocument = gql`
    mutation CreateSettlementAccount($input: CreateSettlementAccountInput!) {
  createSettlementAccount(input: $input) {
    ...SettlementAccountFields
  }
}
    ${SettlementAccountFieldsFragmentDoc}`;

/**
 * __useCreateSettlementAccountMutation__
 *
 * To run a mutation, you first call `useCreateSettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSettlementAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSettlementAccountMutation, Types.CreateSettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSettlementAccountMutation, Types.CreateSettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSettlementAccountMutation, Types.CreateSettlementAccountMutationVariables>(CreateSettlementAccountDocument, options);
}
export type CreateSettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSettlementAccountMutation, Types.CreateSettlementAccountMutationVariables>;
export const UpdateSettlementAccountDocument = gql`
    mutation UpdateSettlementAccount($input: UpdateSettlementAccountInput!) {
  updateSettlementAccount(input: $input) {
    ...SettlementAccountFields
  }
}
    ${SettlementAccountFieldsFragmentDoc}`;

/**
 * __useUpdateSettlementAccountMutation__
 *
 * To run a mutation, you first call `useUpdateSettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSettlementAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSettlementAccountMutation, Types.UpdateSettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSettlementAccountMutation, Types.UpdateSettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSettlementAccountMutation, Types.UpdateSettlementAccountMutationVariables>(UpdateSettlementAccountDocument, options);
}
export type UpdateSettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSettlementAccountMutation, Types.UpdateSettlementAccountMutationVariables>;
export const DeleteSettlementAccountDocument = gql`
    mutation DeleteSettlementAccount($id: ID!) {
  deleteSettlementAccount(id: $id)
}
    `;

/**
 * __useDeleteSettlementAccountMutation__
 *
 * To run a mutation, you first call `useDeleteSettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSettlementAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSettlementAccountMutation, Types.DeleteSettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSettlementAccountMutation, Types.DeleteSettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSettlementAccountMutation, Types.DeleteSettlementAccountMutationVariables>(DeleteSettlementAccountDocument, options);
}
export type DeleteSettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSettlementAccountMutation, Types.DeleteSettlementAccountMutationVariables>;
export const CreateFeeSplitOverrideDocument = gql`
    mutation CreateFeeSplitOverride($input: CreateFeeSplitOverrideInput!) {
  createFeeSplitOverride(input: $input) {
    id
    fee_split_assignment_id
    fee_split_rule_id
    hq_amount
    campus_amount
    hq_percentage
    campus_percentage
    base_amount
    campus_price
  }
}
    `;

/**
 * __useCreateFeeSplitOverrideMutation__
 *
 * To run a mutation, you first call `useCreateFeeSplitOverrideMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeeSplitOverrideMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFeeSplitOverrideMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeeSplitOverrideMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitOverrideMutation, Types.CreateFeeSplitOverrideMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateFeeSplitOverrideMutation, Types.CreateFeeSplitOverrideMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateFeeSplitOverrideMutation, Types.CreateFeeSplitOverrideMutationVariables>(CreateFeeSplitOverrideDocument, options);
}
export type CreateFeeSplitOverrideMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateFeeSplitOverrideMutation, Types.CreateFeeSplitOverrideMutationVariables>;
export const UpdateFeeSplitOverrideDocument = gql`
    mutation UpdateFeeSplitOverride($input: UpdateFeeSplitOverrideInput!) {
  updateFeeSplitOverride(input: $input) {
    id
    hq_amount
    campus_amount
    hq_percentage
    campus_percentage
    base_amount
    campus_price
  }
}
    `;

/**
 * __useUpdateFeeSplitOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateFeeSplitOverrideMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeeSplitOverrideMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFeeSplitOverrideMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeeSplitOverrideMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitOverrideMutation, Types.UpdateFeeSplitOverrideMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateFeeSplitOverrideMutation, Types.UpdateFeeSplitOverrideMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateFeeSplitOverrideMutation, Types.UpdateFeeSplitOverrideMutationVariables>(UpdateFeeSplitOverrideDocument, options);
}
export type UpdateFeeSplitOverrideMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateFeeSplitOverrideMutation, Types.UpdateFeeSplitOverrideMutationVariables>;
export const DeleteFeeSplitOverrideDocument = gql`
    mutation DeleteFeeSplitOverride($id: ID!) {
  deleteFeeSplitOverride(id: $id)
}
    `;

/**
 * __useDeleteFeeSplitOverrideMutation__
 *
 * To run a mutation, you first call `useDeleteFeeSplitOverrideMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeSplitOverrideMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFeeSplitOverrideMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeeSplitOverrideMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitOverrideMutation, Types.DeleteFeeSplitOverrideMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteFeeSplitOverrideMutation, Types.DeleteFeeSplitOverrideMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteFeeSplitOverrideMutation, Types.DeleteFeeSplitOverrideMutationVariables>(DeleteFeeSplitOverrideDocument, options);
}
export type DeleteFeeSplitOverrideMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteFeeSplitOverrideMutation, Types.DeleteFeeSplitOverrideMutationVariables>;
export const GetFeeSplitFlagsDocument = gql`
    query GetFeeSplitFlags {
  getSchool {
    id
    is_child
    fee_split_enabled
    parent_features_enabled
    parentSchool {
      id
      name
      fee_split_enabled
    }
  }
}
    `;

/**
 * __useGetFeeSplitFlagsQuery__
 *
 * To run a query within a Vue component, call `useGetFeeSplitFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeSplitFlagsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFeeSplitFlagsQuery();
 */
export function useGetFeeSplitFlagsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>(GetFeeSplitFlagsDocument, {}, options);
}
export function useGetFeeSplitFlagsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>(GetFeeSplitFlagsDocument, {}, options);
}
export type GetFeeSplitFlagsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFeeSplitFlagsQuery, Types.GetFeeSplitFlagsQueryVariables>;
export const SetFeeSplitOptInDocument = gql`
    mutation SetFeeSplitOptIn($enabled: Boolean!) {
  setFeeSplitOptIn(enabled: $enabled) {
    id
    fee_split_enabled
  }
}
    `;

/**
 * __useSetFeeSplitOptInMutation__
 *
 * To run a mutation, you first call `useSetFeeSplitOptInMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetFeeSplitOptInMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetFeeSplitOptInMutation({
 *   variables: {
 *     enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetFeeSplitOptInMutation(options: VueApolloComposable.UseMutationOptions<Types.SetFeeSplitOptInMutation, Types.SetFeeSplitOptInMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetFeeSplitOptInMutation, Types.SetFeeSplitOptInMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetFeeSplitOptInMutation, Types.SetFeeSplitOptInMutationVariables>(SetFeeSplitOptInDocument, options);
}
export type SetFeeSplitOptInMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetFeeSplitOptInMutation, Types.SetFeeSplitOptInMutationVariables>;
export const GetFormFeeBillsDocument = gql`
    query GetFormFeeBills($session_id: ID, $academic_calendar_id: ID) {
  formFeeBills(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    form_id
    form_title
    form_slug
    payer_type
    bill_count
    paid_count
    total_billed
    total_paid
    total_outstanding
  }
}
    `;

/**
 * __useGetFormFeeBillsQuery__
 *
 * To run a query within a Vue component, call `useGetFormFeeBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFeeBillsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFormFeeBillsQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetFormFeeBillsQuery(variables: Types.GetFormFeeBillsQueryVariables | VueCompositionApi.Ref<Types.GetFormFeeBillsQueryVariables> | ReactiveFunction<Types.GetFormFeeBillsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>(GetFormFeeBillsDocument, variables, options);
}
export function useGetFormFeeBillsLazyQuery(variables: Types.GetFormFeeBillsQueryVariables | VueCompositionApi.Ref<Types.GetFormFeeBillsQueryVariables> | ReactiveFunction<Types.GetFormFeeBillsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>(GetFormFeeBillsDocument, variables, options);
}
export type GetFormFeeBillsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFormFeeBillsQuery, Types.GetFormFeeBillsQueryVariables>;
export const GetFormFeePayersDocument = gql`
    query GetFormFeePayers($form_id: ID!, $session_id: ID, $academic_calendar_id: ID) {
  formFeePayers(
    form_id: $form_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    submission_id
    bill_id
    tracking_code
    name
    email
    is_student
    student_id
    amount
    amount_paid
    balance
    bill_status
    waived
    submitted_at
  }
}
    `;

/**
 * __useGetFormFeePayersQuery__
 *
 * To run a query within a Vue component, call `useGetFormFeePayersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormFeePayersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetFormFeePayersQuery({
 *   form_id: // value for 'form_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetFormFeePayersQuery(variables: Types.GetFormFeePayersQueryVariables | VueCompositionApi.Ref<Types.GetFormFeePayersQueryVariables> | ReactiveFunction<Types.GetFormFeePayersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>(GetFormFeePayersDocument, variables, options);
}
export function useGetFormFeePayersLazyQuery(variables?: Types.GetFormFeePayersQueryVariables | VueCompositionApi.Ref<Types.GetFormFeePayersQueryVariables> | ReactiveFunction<Types.GetFormFeePayersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>(GetFormFeePayersDocument, variables, options);
}
export type GetFormFeePayersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetFormFeePayersQuery, Types.GetFormFeePayersQueryVariables>;
export const GetGatewaySettlementAccountsDocument = gql`
    query GetGatewaySettlementAccounts($payment_provider_id: ID) {
  gatewaySettlementAccounts(payment_provider_id: $payment_provider_id) {
    ...GatewaySettlementAccountFields
  }
}
    ${GatewaySettlementAccountFieldsFragmentDoc}`;

/**
 * __useGetGatewaySettlementAccountsQuery__
 *
 * To run a query within a Vue component, call `useGetGatewaySettlementAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGatewaySettlementAccountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGatewaySettlementAccountsQuery({
 *   payment_provider_id: // value for 'payment_provider_id'
 * });
 */
export function useGetGatewaySettlementAccountsQuery(variables: Types.GetGatewaySettlementAccountsQueryVariables | VueCompositionApi.Ref<Types.GetGatewaySettlementAccountsQueryVariables> | ReactiveFunction<Types.GetGatewaySettlementAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>(GetGatewaySettlementAccountsDocument, variables, options);
}
export function useGetGatewaySettlementAccountsLazyQuery(variables: Types.GetGatewaySettlementAccountsQueryVariables | VueCompositionApi.Ref<Types.GetGatewaySettlementAccountsQueryVariables> | ReactiveFunction<Types.GetGatewaySettlementAccountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>(GetGatewaySettlementAccountsDocument, variables, options);
}
export type GetGatewaySettlementAccountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGatewaySettlementAccountsQuery, Types.GetGatewaySettlementAccountsQueryVariables>;
export const CreateGatewaySettlementAccountDocument = gql`
    mutation CreateGatewaySettlementAccount($input: CreateGatewaySettlementAccountInput!) {
  createGatewaySettlementAccount(input: $input) {
    ...GatewaySettlementAccountFields
  }
}
    ${GatewaySettlementAccountFieldsFragmentDoc}`;

/**
 * __useCreateGatewaySettlementAccountMutation__
 *
 * To run a mutation, you first call `useCreateGatewaySettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGatewaySettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGatewaySettlementAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGatewaySettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateGatewaySettlementAccountMutation, Types.CreateGatewaySettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateGatewaySettlementAccountMutation, Types.CreateGatewaySettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateGatewaySettlementAccountMutation, Types.CreateGatewaySettlementAccountMutationVariables>(CreateGatewaySettlementAccountDocument, options);
}
export type CreateGatewaySettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateGatewaySettlementAccountMutation, Types.CreateGatewaySettlementAccountMutationVariables>;
export const UpdateGatewaySettlementAccountDocument = gql`
    mutation UpdateGatewaySettlementAccount($input: UpdateGatewaySettlementAccountInput!) {
  updateGatewaySettlementAccount(input: $input) {
    ...GatewaySettlementAccountFields
  }
}
    ${GatewaySettlementAccountFieldsFragmentDoc}`;

/**
 * __useUpdateGatewaySettlementAccountMutation__
 *
 * To run a mutation, you first call `useUpdateGatewaySettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGatewaySettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGatewaySettlementAccountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGatewaySettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateGatewaySettlementAccountMutation, Types.UpdateGatewaySettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateGatewaySettlementAccountMutation, Types.UpdateGatewaySettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateGatewaySettlementAccountMutation, Types.UpdateGatewaySettlementAccountMutationVariables>(UpdateGatewaySettlementAccountDocument, options);
}
export type UpdateGatewaySettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateGatewaySettlementAccountMutation, Types.UpdateGatewaySettlementAccountMutationVariables>;
export const DeleteGatewaySettlementAccountDocument = gql`
    mutation DeleteGatewaySettlementAccount($id: ID!) {
  deleteGatewaySettlementAccount(id: $id)
}
    `;

/**
 * __useDeleteGatewaySettlementAccountMutation__
 *
 * To run a mutation, you first call `useDeleteGatewaySettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGatewaySettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGatewaySettlementAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGatewaySettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteGatewaySettlementAccountMutation, Types.DeleteGatewaySettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteGatewaySettlementAccountMutation, Types.DeleteGatewaySettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteGatewaySettlementAccountMutation, Types.DeleteGatewaySettlementAccountMutationVariables>(DeleteGatewaySettlementAccountDocument, options);
}
export type DeleteGatewaySettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteGatewaySettlementAccountMutation, Types.DeleteGatewaySettlementAccountMutationVariables>;
export const SetDefaultGatewaySettlementAccountDocument = gql`
    mutation SetDefaultGatewaySettlementAccount($id: ID!) {
  setDefaultGatewaySettlementAccount(id: $id) {
    ...GatewaySettlementAccountFields
  }
}
    ${GatewaySettlementAccountFieldsFragmentDoc}`;

/**
 * __useSetDefaultGatewaySettlementAccountMutation__
 *
 * To run a mutation, you first call `useSetDefaultGatewaySettlementAccountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultGatewaySettlementAccountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetDefaultGatewaySettlementAccountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultGatewaySettlementAccountMutation(options: VueApolloComposable.UseMutationOptions<Types.SetDefaultGatewaySettlementAccountMutation, Types.SetDefaultGatewaySettlementAccountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetDefaultGatewaySettlementAccountMutation, Types.SetDefaultGatewaySettlementAccountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetDefaultGatewaySettlementAccountMutation, Types.SetDefaultGatewaySettlementAccountMutationVariables>(SetDefaultGatewaySettlementAccountDocument, options);
}
export type SetDefaultGatewaySettlementAccountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetDefaultGatewaySettlementAccountMutation, Types.SetDefaultGatewaySettlementAccountMutationVariables>;
export const GetCheckoutGroupsDocument = gql`
    query GetCheckoutGroups($bill_id: ID!) {
  checkoutGroups(bill_id: $bill_id) {
    settlement_account {
      id
      label
      gateway_identifier
      bank_name
      account_number
    }
    details {
      id
      item_name
      net_amount
      balance
    }
    subtotal
  }
}
    `;

/**
 * __useGetCheckoutGroupsQuery__
 *
 * To run a query within a Vue component, call `useGetCheckoutGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutGroupsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCheckoutGroupsQuery({
 *   bill_id: // value for 'bill_id'
 * });
 */
export function useGetCheckoutGroupsQuery(variables: Types.GetCheckoutGroupsQueryVariables | VueCompositionApi.Ref<Types.GetCheckoutGroupsQueryVariables> | ReactiveFunction<Types.GetCheckoutGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>(GetCheckoutGroupsDocument, variables, options);
}
export function useGetCheckoutGroupsLazyQuery(variables?: Types.GetCheckoutGroupsQueryVariables | VueCompositionApi.Ref<Types.GetCheckoutGroupsQueryVariables> | ReactiveFunction<Types.GetCheckoutGroupsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>(GetCheckoutGroupsDocument, variables, options);
}
export type GetCheckoutGroupsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCheckoutGroupsQuery, Types.GetCheckoutGroupsQueryVariables>;
export const CreateBillItemTemplateDocument = gql`
    mutation CreateBillItemTemplate($input: CreateBillItemTemplateInput!) {
  createBillItemTemplate(input: $input) {
    ...BillItemTemplateFields
  }
}
    ${BillItemTemplateFieldsFragmentDoc}`;

/**
 * __useCreateBillItemTemplateMutation__
 *
 * To run a mutation, you first call `useCreateBillItemTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillItemTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBillItemTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillItemTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateBillItemTemplateMutation, Types.CreateBillItemTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateBillItemTemplateMutation, Types.CreateBillItemTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateBillItemTemplateMutation, Types.CreateBillItemTemplateMutationVariables>(CreateBillItemTemplateDocument, options);
}
export type CreateBillItemTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateBillItemTemplateMutation, Types.CreateBillItemTemplateMutationVariables>;
export const UpdateBillItemTemplateDocument = gql`
    mutation UpdateBillItemTemplate($input: UpdateBillItemTemplateInput!) {
  updateBillItemTemplate(input: $input) {
    ...BillItemTemplateFields
  }
}
    ${BillItemTemplateFieldsFragmentDoc}`;

/**
 * __useUpdateBillItemTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateBillItemTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillItemTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBillItemTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillItemTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateBillItemTemplateMutation, Types.UpdateBillItemTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateBillItemTemplateMutation, Types.UpdateBillItemTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateBillItemTemplateMutation, Types.UpdateBillItemTemplateMutationVariables>(UpdateBillItemTemplateDocument, options);
}
export type UpdateBillItemTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateBillItemTemplateMutation, Types.UpdateBillItemTemplateMutationVariables>;
export const DeleteBillItemTemplateDocument = gql`
    mutation DeleteBillItemTemplate($id: ID!) {
  deleteBillItemTemplate(id: $id)
}
    `;

/**
 * __useDeleteBillItemTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteBillItemTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillItemTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteBillItemTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillItemTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteBillItemTemplateMutation, Types.DeleteBillItemTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteBillItemTemplateMutation, Types.DeleteBillItemTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteBillItemTemplateMutation, Types.DeleteBillItemTemplateMutationVariables>(DeleteBillItemTemplateDocument, options);
}
export type DeleteBillItemTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteBillItemTemplateMutation, Types.DeleteBillItemTemplateMutationVariables>;
export const CreateBillItemCategoryDocument = gql`
    mutation CreateBillItemCategory($input: CreateBillItemCategoryInput!) {
  createBillItemCategory(input: $input) {
    id
    name
    normalized_name
    description
    is_active
  }
}
    `;

/**
 * __useCreateBillItemCategoryMutation__
 *
 * To run a mutation, you first call `useCreateBillItemCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillItemCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBillItemCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillItemCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateBillItemCategoryMutation, Types.CreateBillItemCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateBillItemCategoryMutation, Types.CreateBillItemCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateBillItemCategoryMutation, Types.CreateBillItemCategoryMutationVariables>(CreateBillItemCategoryDocument, options);
}
export type CreateBillItemCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateBillItemCategoryMutation, Types.CreateBillItemCategoryMutationVariables>;
export const UpdateBillItemCategoryDocument = gql`
    mutation UpdateBillItemCategory($input: UpdateBillItemCategoryInput!) {
  updateBillItemCategory(input: $input) {
    id
    name
    normalized_name
    description
    is_active
  }
}
    `;

/**
 * __useUpdateBillItemCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateBillItemCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillItemCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBillItemCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillItemCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateBillItemCategoryMutation, Types.UpdateBillItemCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateBillItemCategoryMutation, Types.UpdateBillItemCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateBillItemCategoryMutation, Types.UpdateBillItemCategoryMutationVariables>(UpdateBillItemCategoryDocument, options);
}
export type UpdateBillItemCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateBillItemCategoryMutation, Types.UpdateBillItemCategoryMutationVariables>;
export const DeleteBillItemCategoryDocument = gql`
    mutation DeleteBillItemCategory($id: ID!) {
  deleteBillItemCategory(id: $id)
}
    `;

/**
 * __useDeleteBillItemCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteBillItemCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBillItemCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteBillItemCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBillItemCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteBillItemCategoryMutation, Types.DeleteBillItemCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteBillItemCategoryMutation, Types.DeleteBillItemCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteBillItemCategoryMutation, Types.DeleteBillItemCategoryMutationVariables>(DeleteBillItemCategoryDocument, options);
}
export type DeleteBillItemCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteBillItemCategoryMutation, Types.DeleteBillItemCategoryMutationVariables>;
export const CreateBillsDocument = gql`
    mutation CreateBills($input: CreateBillsInput!) {
  createBills(input: $input) {
    ...BillFields
  }
}
    ${BillFieldsFragmentDoc}`;

/**
 * __useCreateBillsMutation__
 *
 * To run a mutation, you first call `useCreateBillsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBillsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillsMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateBillsMutation, Types.CreateBillsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateBillsMutation, Types.CreateBillsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateBillsMutation, Types.CreateBillsMutationVariables>(CreateBillsDocument, options);
}
export type CreateBillsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateBillsMutation, Types.CreateBillsMutationVariables>;
export const UpdateBillDocument = gql`
    mutation UpdateBill($input: UpdateBillInput!) {
  updateBill(input: $input) {
    ...BillFields
  }
}
    ${BillFieldsFragmentDoc}`;

/**
 * __useUpdateBillMutation__
 *
 * To run a mutation, you first call `useUpdateBillMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBillMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBillMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateBillMutation, Types.UpdateBillMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateBillMutation, Types.UpdateBillMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateBillMutation, Types.UpdateBillMutationVariables>(UpdateBillDocument, options);
}
export type UpdateBillMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateBillMutation, Types.UpdateBillMutationVariables>;
export const PublishBillDocument = gql`
    mutation PublishBill($id: ID!) {
  publishBill(id: $id) {
    id
    status
  }
}
    `;

/**
 * __usePublishBillMutation__
 *
 * To run a mutation, you first call `usePublishBillMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishBillMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishBillMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePublishBillMutation(options: VueApolloComposable.UseMutationOptions<Types.PublishBillMutation, Types.PublishBillMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PublishBillMutation, Types.PublishBillMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PublishBillMutation, Types.PublishBillMutationVariables>(PublishBillDocument, options);
}
export type PublishBillMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PublishBillMutation, Types.PublishBillMutationVariables>;
export const VoidBillDocument = gql`
    mutation VoidBill($id: ID!) {
  voidBill(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useVoidBillMutation__
 *
 * To run a mutation, you first call `useVoidBillMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVoidBillMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVoidBillMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useVoidBillMutation(options: VueApolloComposable.UseMutationOptions<Types.VoidBillMutation, Types.VoidBillMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.VoidBillMutation, Types.VoidBillMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.VoidBillMutation, Types.VoidBillMutationVariables>(VoidBillDocument, options);
}
export type VoidBillMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.VoidBillMutation, Types.VoidBillMutationVariables>;
export const RecordPaymentDocument = gql`
    mutation RecordPayment($input: RecordPaymentInput!) {
  recordPayment(input: $input) {
    ...PaymentFields
    paymentAllocations {
      id
      amount
      billDetail {
        id
        item_name
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useRecordPaymentMutation__
 *
 * To run a mutation, you first call `useRecordPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordPaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRecordPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.RecordPaymentMutation, Types.RecordPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RecordPaymentMutation, Types.RecordPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RecordPaymentMutation, Types.RecordPaymentMutationVariables>(RecordPaymentDocument, options);
}
export type RecordPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RecordPaymentMutation, Types.RecordPaymentMutationVariables>;
export const VoidPaymentDocument = gql`
    mutation VoidPayment($id: ID!, $reason: String!) {
  voidPayment(id: $id, reason: $reason) {
    ...PaymentFields
    void_reason
    voided_at
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useVoidPaymentMutation__
 *
 * To run a mutation, you first call `useVoidPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVoidPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVoidPaymentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useVoidPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.VoidPaymentMutation, Types.VoidPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.VoidPaymentMutation, Types.VoidPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.VoidPaymentMutation, Types.VoidPaymentMutationVariables>(VoidPaymentDocument, options);
}
export type VoidPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.VoidPaymentMutation, Types.VoidPaymentMutationVariables>;
export const RequeryPaymentDocument = gql`
    mutation RequeryPayment($input: RequeryPaymentInput!) {
  requeryPayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useRequeryPaymentMutation__
 *
 * To run a mutation, you first call `useRequeryPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequeryPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequeryPaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequeryPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.RequeryPaymentMutation, Types.RequeryPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequeryPaymentMutation, Types.RequeryPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequeryPaymentMutation, Types.RequeryPaymentMutationVariables>(RequeryPaymentDocument, options);
}
export type RequeryPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequeryPaymentMutation, Types.RequeryPaymentMutationVariables>;
export const PayFromWalletDocument = gql`
    mutation PayFromWallet($input: PayFromWalletInput!) {
  payFromWallet(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __usePayFromWalletMutation__
 *
 * To run a mutation, you first call `usePayFromWalletMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePayFromWalletMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePayFromWalletMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePayFromWalletMutation(options: VueApolloComposable.UseMutationOptions<Types.PayFromWalletMutation, Types.PayFromWalletMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PayFromWalletMutation, Types.PayFromWalletMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PayFromWalletMutation, Types.PayFromWalletMutationVariables>(PayFromWalletDocument, options);
}
export type PayFromWalletMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PayFromWalletMutation, Types.PayFromWalletMutationVariables>;
export const AdjustWalletDocument = gql`
    mutation AdjustWallet($input: AdjustWalletInput!) {
  adjustWallet(input: $input) {
    id
    type
    amount
    balance_after
    description
    created_at
  }
}
    `;

/**
 * __useAdjustWalletMutation__
 *
 * To run a mutation, you first call `useAdjustWalletMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAdjustWalletMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAdjustWalletMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAdjustWalletMutation(options: VueApolloComposable.UseMutationOptions<Types.AdjustWalletMutation, Types.AdjustWalletMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AdjustWalletMutation, Types.AdjustWalletMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AdjustWalletMutation, Types.AdjustWalletMutationVariables>(AdjustWalletDocument, options);
}
export type AdjustWalletMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AdjustWalletMutation, Types.AdjustWalletMutationVariables>;
export const CreateDiscountCategoryDocument = gql`
    mutation CreateDiscountCategory($input: CreateDiscountCategoryInput!) {
  createDiscountCategory(input: $input) {
    id
    name
    description
    is_active
    discountRules {
      id
      apply_to
      target_template_id
      target_category_id
      exclude_template_ids
      discount_type
      discount_value
      max_discount_amount
      priority
      is_active
      deactivated_reason
    }
  }
}
    `;

/**
 * __useCreateDiscountCategoryMutation__
 *
 * To run a mutation, you first call `useCreateDiscountCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDiscountCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateDiscountCategoryMutation, Types.CreateDiscountCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateDiscountCategoryMutation, Types.CreateDiscountCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateDiscountCategoryMutation, Types.CreateDiscountCategoryMutationVariables>(CreateDiscountCategoryDocument, options);
}
export type CreateDiscountCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateDiscountCategoryMutation, Types.CreateDiscountCategoryMutationVariables>;
export const UpdateDiscountCategoryDocument = gql`
    mutation UpdateDiscountCategory($input: UpdateDiscountCategoryInput!) {
  updateDiscountCategory(input: $input) {
    id
    name
    description
    is_active
    discountRules {
      id
      apply_to
      target_template_id
      target_category_id
      exclude_template_ids
      discount_type
      discount_value
      max_discount_amount
      priority
      is_active
      deactivated_reason
    }
  }
}
    `;

/**
 * __useUpdateDiscountCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDiscountCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateDiscountCategoryMutation, Types.UpdateDiscountCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateDiscountCategoryMutation, Types.UpdateDiscountCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateDiscountCategoryMutation, Types.UpdateDiscountCategoryMutationVariables>(UpdateDiscountCategoryDocument, options);
}
export type UpdateDiscountCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateDiscountCategoryMutation, Types.UpdateDiscountCategoryMutationVariables>;
export const DeleteDiscountCategoryDocument = gql`
    mutation DeleteDiscountCategory($id: ID!) {
  deleteDiscountCategory(id: $id)
}
    `;

/**
 * __useDeleteDiscountCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDiscountCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteDiscountCategoryMutation, Types.DeleteDiscountCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteDiscountCategoryMutation, Types.DeleteDiscountCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteDiscountCategoryMutation, Types.DeleteDiscountCategoryMutationVariables>(DeleteDiscountCategoryDocument, options);
}
export type DeleteDiscountCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteDiscountCategoryMutation, Types.DeleteDiscountCategoryMutationVariables>;
export const CreateDiscountRuleDocument = gql`
    mutation CreateDiscountRule($input: CreateDiscountRuleInput!) {
  createDiscountRule(input: $input) {
    id
    apply_to
    target_template_id
    target_category_id
    exclude_template_ids
    discount_type
    discount_value
    max_discount_amount
    priority
    is_active
    deactivated_reason
    targetCategoryEntity {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateDiscountRuleMutation__
 *
 * To run a mutation, you first call `useCreateDiscountRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDiscountRuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscountRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateDiscountRuleMutation, Types.CreateDiscountRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateDiscountRuleMutation, Types.CreateDiscountRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateDiscountRuleMutation, Types.CreateDiscountRuleMutationVariables>(CreateDiscountRuleDocument, options);
}
export type CreateDiscountRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateDiscountRuleMutation, Types.CreateDiscountRuleMutationVariables>;
export const UpdateDiscountRuleDocument = gql`
    mutation UpdateDiscountRule($input: UpdateDiscountRuleInput!) {
  updateDiscountRule(input: $input) {
    id
    apply_to
    target_template_id
    target_category_id
    exclude_template_ids
    discount_type
    discount_value
    max_discount_amount
    priority
    is_active
    deactivated_reason
    targetCategoryEntity {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateDiscountRuleMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDiscountRuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDiscountRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateDiscountRuleMutation, Types.UpdateDiscountRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateDiscountRuleMutation, Types.UpdateDiscountRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateDiscountRuleMutation, Types.UpdateDiscountRuleMutationVariables>(UpdateDiscountRuleDocument, options);
}
export type UpdateDiscountRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateDiscountRuleMutation, Types.UpdateDiscountRuleMutationVariables>;
export const DeleteDiscountRuleDocument = gql`
    mutation DeleteDiscountRule($id: ID!) {
  deleteDiscountRule(id: $id)
}
    `;

/**
 * __useDeleteDiscountRuleMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountRuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountRuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDiscountRuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscountRuleMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteDiscountRuleMutation, Types.DeleteDiscountRuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteDiscountRuleMutation, Types.DeleteDiscountRuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteDiscountRuleMutation, Types.DeleteDiscountRuleMutationVariables>(DeleteDiscountRuleDocument, options);
}
export type DeleteDiscountRuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteDiscountRuleMutation, Types.DeleteDiscountRuleMutationVariables>;
export const ApplyManualDiscountDocument = gql`
    mutation ApplyManualDiscount($input: ApplyManualDiscountInput!) {
  applyManualDiscount(input: $input) {
    id
    amount
    discount_amount
    net_amount
    amount_paid
    balance
    billDiscounts {
      ...BillDiscountFields
    }
  }
}
    ${BillDiscountFieldsFragmentDoc}`;

/**
 * __useApplyManualDiscountMutation__
 *
 * To run a mutation, you first call `useApplyManualDiscountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyManualDiscountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyManualDiscountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApplyManualDiscountMutation(options: VueApolloComposable.UseMutationOptions<Types.ApplyManualDiscountMutation, Types.ApplyManualDiscountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApplyManualDiscountMutation, Types.ApplyManualDiscountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApplyManualDiscountMutation, Types.ApplyManualDiscountMutationVariables>(ApplyManualDiscountDocument, options);
}
export type ApplyManualDiscountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApplyManualDiscountMutation, Types.ApplyManualDiscountMutationVariables>;
export const VoidManualDiscountDocument = gql`
    mutation VoidManualDiscount($bill_discount_id: ID!, $reason: String!) {
  voidManualDiscount(bill_discount_id: $bill_discount_id, reason: $reason) {
    id
    amount
    discount_amount
    net_amount
    amount_paid
    balance
    billDiscounts {
      ...BillDiscountFields
    }
  }
}
    ${BillDiscountFieldsFragmentDoc}`;

/**
 * __useVoidManualDiscountMutation__
 *
 * To run a mutation, you first call `useVoidManualDiscountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useVoidManualDiscountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useVoidManualDiscountMutation({
 *   variables: {
 *     bill_discount_id: // value for 'bill_discount_id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useVoidManualDiscountMutation(options: VueApolloComposable.UseMutationOptions<Types.VoidManualDiscountMutation, Types.VoidManualDiscountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.VoidManualDiscountMutation, Types.VoidManualDiscountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.VoidManualDiscountMutation, Types.VoidManualDiscountMutationVariables>(VoidManualDiscountDocument, options);
}
export type VoidManualDiscountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.VoidManualDiscountMutation, Types.VoidManualDiscountMutationVariables>;
export const AssignDiscountDocument = gql`
    mutation AssignDiscount($input: AssignDiscountInput!) {
  assignDiscount(input: $input) {
    id
    discount_category_id
    entity_type
    entity_id
    academic_calendar_id
    session_id
    effective_from
    effective_until
    is_active
    notes
    created_at
    discountCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useAssignDiscountMutation__
 *
 * To run a mutation, you first call `useAssignDiscountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignDiscountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignDiscountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignDiscountMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignDiscountMutation, Types.AssignDiscountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignDiscountMutation, Types.AssignDiscountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignDiscountMutation, Types.AssignDiscountMutationVariables>(AssignDiscountDocument, options);
}
export type AssignDiscountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignDiscountMutation, Types.AssignDiscountMutationVariables>;
export const UpdateEntityDiscountDocument = gql`
    mutation UpdateEntityDiscount($input: UpdateEntityDiscountInput!) {
  updateEntityDiscount(input: $input) {
    id
    academic_calendar_id
    session_id
    effective_from
    effective_until
    is_active
    notes
  }
}
    `;

/**
 * __useUpdateEntityDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateEntityDiscountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityDiscountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEntityDiscountMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityDiscountMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateEntityDiscountMutation, Types.UpdateEntityDiscountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateEntityDiscountMutation, Types.UpdateEntityDiscountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateEntityDiscountMutation, Types.UpdateEntityDiscountMutationVariables>(UpdateEntityDiscountDocument, options);
}
export type UpdateEntityDiscountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateEntityDiscountMutation, Types.UpdateEntityDiscountMutationVariables>;
export const RemoveEntityDiscountDocument = gql`
    mutation RemoveEntityDiscount($id: ID!) {
  removeEntityDiscount(id: $id)
}
    `;

/**
 * __useRemoveEntityDiscountMutation__
 *
 * To run a mutation, you first call `useRemoveEntityDiscountMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEntityDiscountMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveEntityDiscountMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEntityDiscountMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveEntityDiscountMutation, Types.RemoveEntityDiscountMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveEntityDiscountMutation, Types.RemoveEntityDiscountMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveEntityDiscountMutation, Types.RemoveEntityDiscountMutationVariables>(RemoveEntityDiscountDocument, options);
}
export type RemoveEntityDiscountMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveEntityDiscountMutation, Types.RemoveEntityDiscountMutationVariables>;
export const RequestRefundDocument = gql`
    mutation RequestRefund($input: RequestRefundInput!) {
  requestRefund(input: $input) {
    id
    amount
    reason
    status
    refund_method
    notes
    created_at
    payment {
      id
      amount
      student {
        id
        first_name
        surname
      }
    }
    requestedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useRequestRefundMutation__
 *
 * To run a mutation, you first call `useRequestRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestRefundMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestRefundMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestRefundMutation, Types.RequestRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestRefundMutation, Types.RequestRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestRefundMutation, Types.RequestRefundMutationVariables>(RequestRefundDocument, options);
}
export type RequestRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestRefundMutation, Types.RequestRefundMutationVariables>;
export const ApproveRefundDocument = gql`
    mutation ApproveRefund($id: ID!) {
  approveRefund(id: $id) {
    id
    status
    approved_by
    approvedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useApproveRefundMutation__
 *
 * To run a mutation, you first call `useApproveRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveRefundMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveRefundMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveRefundMutation, Types.ApproveRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveRefundMutation, Types.ApproveRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveRefundMutation, Types.ApproveRefundMutationVariables>(ApproveRefundDocument, options);
}
export type ApproveRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveRefundMutation, Types.ApproveRefundMutationVariables>;
export const ProcessRefundDocument = gql`
    mutation ProcessRefund($id: ID!) {
  processRefund(id: $id) {
    id
    status
    processed_at
  }
}
    `;

/**
 * __useProcessRefundMutation__
 *
 * To run a mutation, you first call `useProcessRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useProcessRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useProcessRefundMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useProcessRefundMutation(options: VueApolloComposable.UseMutationOptions<Types.ProcessRefundMutation, Types.ProcessRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ProcessRefundMutation, Types.ProcessRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ProcessRefundMutation, Types.ProcessRefundMutationVariables>(ProcessRefundDocument, options);
}
export type ProcessRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ProcessRefundMutation, Types.ProcessRefundMutationVariables>;
export const RejectRefundDocument = gql`
    mutation RejectRefund($id: ID!, $reason: String) {
  rejectRefund(id: $id, reason: $reason) {
    id
    status
    notes
  }
}
    `;

/**
 * __useRejectRefundMutation__
 *
 * To run a mutation, you first call `useRejectRefundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectRefundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectRefundMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectRefundMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectRefundMutation, Types.RejectRefundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectRefundMutation, Types.RejectRefundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectRefundMutation, Types.RejectRefundMutationVariables>(RejectRefundDocument, options);
}
export type RejectRefundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectRefundMutation, Types.RejectRefundMutationVariables>;
export const RequestExemptionDocument = gql`
    mutation RequestExemption($input: RequestExemptionInput!) {
  requestExemption(input: $input) {
    id
    bill_id
    bill_detail_id
    entity_type
    entity_id
    exemption_type
    amount
    reason
    status
    created_at
    requestedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useRequestExemptionMutation__
 *
 * To run a mutation, you first call `useRequestExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestExemptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestExemptionMutation, Types.RequestExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestExemptionMutation, Types.RequestExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestExemptionMutation, Types.RequestExemptionMutationVariables>(RequestExemptionDocument, options);
}
export type RequestExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestExemptionMutation, Types.RequestExemptionMutationVariables>;
export const ApproveExemptionDocument = gql`
    mutation ApproveExemption($id: ID!) {
  approveExemption(id: $id) {
    id
    status
    approved_by
    approvedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useApproveExemptionMutation__
 *
 * To run a mutation, you first call `useApproveExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveExemptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveExemptionMutation, Types.ApproveExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveExemptionMutation, Types.ApproveExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveExemptionMutation, Types.ApproveExemptionMutationVariables>(ApproveExemptionDocument, options);
}
export type ApproveExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveExemptionMutation, Types.ApproveExemptionMutationVariables>;
export const RejectExemptionDocument = gql`
    mutation RejectExemption($id: ID!, $reason: String) {
  rejectExemption(id: $id, reason: $reason) {
    id
    status
  }
}
    `;

/**
 * __useRejectExemptionMutation__
 *
 * To run a mutation, you first call `useRejectExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectExemptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectExemptionMutation, Types.RejectExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectExemptionMutation, Types.RejectExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectExemptionMutation, Types.RejectExemptionMutationVariables>(RejectExemptionDocument, options);
}
export type RejectExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectExemptionMutation, Types.RejectExemptionMutationVariables>;
export const RevokeExemptionDocument = gql`
    mutation RevokeExemption($id: ID!, $reason: String) {
  revokeExemption(id: $id, reason: $reason) {
    id
    status
  }
}
    `;

/**
 * __useRevokeExemptionMutation__
 *
 * To run a mutation, you first call `useRevokeExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeExemptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRevokeExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeExemptionMutation, Types.RevokeExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeExemptionMutation, Types.RevokeExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeExemptionMutation, Types.RevokeExemptionMutationVariables>(RevokeExemptionDocument, options);
}
export type RevokeExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeExemptionMutation, Types.RevokeExemptionMutationVariables>;
export const ResolveSuccessfulPaymentDocument = gql`
    mutation ResolveSuccessfulPayment($input: ResolveSuccessfulPaymentInput!) {
  resolveSuccessfulPayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useResolveSuccessfulPaymentMutation__
 *
 * To run a mutation, you first call `useResolveSuccessfulPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveSuccessfulPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveSuccessfulPaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResolveSuccessfulPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.ResolveSuccessfulPaymentMutation, Types.ResolveSuccessfulPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResolveSuccessfulPaymentMutation, Types.ResolveSuccessfulPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResolveSuccessfulPaymentMutation, Types.ResolveSuccessfulPaymentMutationVariables>(ResolveSuccessfulPaymentDocument, options);
}
export type ResolveSuccessfulPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResolveSuccessfulPaymentMutation, Types.ResolveSuccessfulPaymentMutationVariables>;
export const GetBillItemTemplatesDocument = gql`
    query GetBillItemTemplates($bill_item_category_id: ID, $is_active: Boolean, $search: String) {
  billItemTemplates(
    filters: {bill_item_category_id: $bill_item_category_id, is_active: $is_active, search: $search}
  ) {
    ...BillItemTemplateFields
  }
}
    ${BillItemTemplateFieldsFragmentDoc}`;

/**
 * __useGetBillItemTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetBillItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillItemTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillItemTemplatesQuery({
 *   bill_item_category_id: // value for 'bill_item_category_id'
 *   is_active: // value for 'is_active'
 *   search: // value for 'search'
 * });
 */
export function useGetBillItemTemplatesQuery(variables: Types.GetBillItemTemplatesQueryVariables | VueCompositionApi.Ref<Types.GetBillItemTemplatesQueryVariables> | ReactiveFunction<Types.GetBillItemTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>(GetBillItemTemplatesDocument, variables, options);
}
export function useGetBillItemTemplatesLazyQuery(variables: Types.GetBillItemTemplatesQueryVariables | VueCompositionApi.Ref<Types.GetBillItemTemplatesQueryVariables> | ReactiveFunction<Types.GetBillItemTemplatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>(GetBillItemTemplatesDocument, variables, options);
}
export type GetBillItemTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillItemTemplatesQuery, Types.GetBillItemTemplatesQueryVariables>;
export const GetBillItemCategoriesDocument = gql`
    query GetBillItemCategories($is_active: Boolean, $search: String) {
  billItemCategories(is_active: $is_active, search: $search) {
    id
    name
    normalized_name
    description
    is_active
    templates_count
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetBillItemCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetBillItemCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillItemCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillItemCategoriesQuery({
 *   is_active: // value for 'is_active'
 *   search: // value for 'search'
 * });
 */
export function useGetBillItemCategoriesQuery(variables: Types.GetBillItemCategoriesQueryVariables | VueCompositionApi.Ref<Types.GetBillItemCategoriesQueryVariables> | ReactiveFunction<Types.GetBillItemCategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>(GetBillItemCategoriesDocument, variables, options);
}
export function useGetBillItemCategoriesLazyQuery(variables: Types.GetBillItemCategoriesQueryVariables | VueCompositionApi.Ref<Types.GetBillItemCategoriesQueryVariables> | ReactiveFunction<Types.GetBillItemCategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>(GetBillItemCategoriesDocument, variables, options);
}
export type GetBillItemCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillItemCategoriesQuery, Types.GetBillItemCategoriesQueryVariables>;
export const GetBillsDocument = gql`
    query GetBills($billable_type: String, $billable_id: ID, $classroom_id: ID, $session_id: ID, $academic_calendar_id: ID, $status: [String!], $search: String) {
  bills(
    filters: {billable_type: $billable_type, billable_id: $billable_id, classroom_id: $classroom_id, session_id: $session_id, academic_calendar_id: $academic_calendar_id, status: $status, search: $search}
  ) {
    ...BillFields
    payer_type
  }
}
    ${BillFieldsFragmentDoc}`;

/**
 * __useGetBillsQuery__
 *
 * To run a query within a Vue component, call `useGetBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillsQuery({
 *   billable_type: // value for 'billable_type'
 *   billable_id: // value for 'billable_id'
 *   classroom_id: // value for 'classroom_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   status: // value for 'status'
 *   search: // value for 'search'
 * });
 */
export function useGetBillsQuery(variables: Types.GetBillsQueryVariables | VueCompositionApi.Ref<Types.GetBillsQueryVariables> | ReactiveFunction<Types.GetBillsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillsQuery, Types.GetBillsQueryVariables>(GetBillsDocument, variables, options);
}
export function useGetBillsLazyQuery(variables: Types.GetBillsQueryVariables | VueCompositionApi.Ref<Types.GetBillsQueryVariables> | ReactiveFunction<Types.GetBillsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillsQuery, Types.GetBillsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillsQuery, Types.GetBillsQueryVariables>(GetBillsDocument, variables, options);
}
export type GetBillsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillsQuery, Types.GetBillsQueryVariables>;
export const CheckBillDuplicatesDocument = gql`
    query CheckBillDuplicates($input: CheckBillDuplicatesInput!) {
  checkBillDuplicates(input: $input) {
    billable_id
    item_name
    amount
    confidence
    score
    reason
    existing {
      bill_id
      invoice_number
      item_name
      amount
      source
    }
  }
}
    `;

/**
 * __useCheckBillDuplicatesQuery__
 *
 * To run a query within a Vue component, call `useCheckBillDuplicatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBillDuplicatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckBillDuplicatesQuery({
 *   input: // value for 'input'
 * });
 */
export function useCheckBillDuplicatesQuery(variables: Types.CheckBillDuplicatesQueryVariables | VueCompositionApi.Ref<Types.CheckBillDuplicatesQueryVariables> | ReactiveFunction<Types.CheckBillDuplicatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>(CheckBillDuplicatesDocument, variables, options);
}
export function useCheckBillDuplicatesLazyQuery(variables?: Types.CheckBillDuplicatesQueryVariables | VueCompositionApi.Ref<Types.CheckBillDuplicatesQueryVariables> | ReactiveFunction<Types.CheckBillDuplicatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>(CheckBillDuplicatesDocument, variables, options);
}
export type CheckBillDuplicatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CheckBillDuplicatesQuery, Types.CheckBillDuplicatesQueryVariables>;
export const GetBillDocument = gql`
    query GetBill($id: ID!) {
  bill(id: $id) {
    ...BillFields
    billDetails {
      ...BillDetailFields
      billItemTemplate {
        id
        name
      }
      billDiscounts {
        ...BillDiscountFields
      }
    }
    billDiscounts {
      ...BillDiscountFields
      discountCategory {
        id
        name
      }
    }
  }
}
    ${BillFieldsFragmentDoc}
${BillDetailFieldsFragmentDoc}
${BillDiscountFieldsFragmentDoc}`;

/**
 * __useGetBillQuery__
 *
 * To run a query within a Vue component, call `useGetBillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetBillQuery(variables: Types.GetBillQueryVariables | VueCompositionApi.Ref<Types.GetBillQueryVariables> | ReactiveFunction<Types.GetBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillQuery, Types.GetBillQueryVariables>(GetBillDocument, variables, options);
}
export function useGetBillLazyQuery(variables?: Types.GetBillQueryVariables | VueCompositionApi.Ref<Types.GetBillQueryVariables> | ReactiveFunction<Types.GetBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillQuery, Types.GetBillQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillQuery, Types.GetBillQueryVariables>(GetBillDocument, variables, options);
}
export type GetBillQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillQuery, Types.GetBillQueryVariables>;
export const GetPaymentsDocument = gql`
    query GetPayments($student_id: ID, $status: PaymentStatusEnum, $session_id: ID, $academic_calendar_id: ID) {
  payments(
    student_id: $student_id
    status: $status
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentsQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentsQuery({
 *   student_id: // value for 'student_id'
 *   status: // value for 'status'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetPaymentsQuery(variables: Types.GetPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetPaymentsQueryVariables> | ReactiveFunction<Types.GetPaymentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>(GetPaymentsDocument, variables, options);
}
export function useGetPaymentsLazyQuery(variables: Types.GetPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetPaymentsQueryVariables> | ReactiveFunction<Types.GetPaymentsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>(GetPaymentsDocument, variables, options);
}
export type GetPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPaymentsQuery, Types.GetPaymentsQueryVariables>;
export const GetStudentAccountPaymentsDocument = gql`
    query GetStudentAccountPayments($student_id: ID!, $session_id: ID, $academic_calendar_id: ID) {
  payments(
    student_id: $student_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    period_basis: BILLED
  ) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetStudentAccountPaymentsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentAccountPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAccountPaymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentAccountPaymentsQuery({
 *   student_id: // value for 'student_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetStudentAccountPaymentsQuery(variables: Types.GetStudentAccountPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetStudentAccountPaymentsQueryVariables> | ReactiveFunction<Types.GetStudentAccountPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>(GetStudentAccountPaymentsDocument, variables, options);
}
export function useGetStudentAccountPaymentsLazyQuery(variables?: Types.GetStudentAccountPaymentsQueryVariables | VueCompositionApi.Ref<Types.GetStudentAccountPaymentsQueryVariables> | ReactiveFunction<Types.GetStudentAccountPaymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>(GetStudentAccountPaymentsDocument, variables, options);
}
export type GetStudentAccountPaymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentAccountPaymentsQuery, Types.GetStudentAccountPaymentsQueryVariables>;
export const GetPaymentDocument = gql`
    query GetPayment($id: ID!) {
  payment(id: $id) {
    ...PaymentFields
    paymentAllocations {
      id
      amount
      billDetail {
        id
        item_name
        bill {
          id
        }
      }
    }
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useGetPaymentQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetPaymentQuery(variables: Types.GetPaymentQueryVariables | VueCompositionApi.Ref<Types.GetPaymentQueryVariables> | ReactiveFunction<Types.GetPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>(GetPaymentDocument, variables, options);
}
export function useGetPaymentLazyQuery(variables?: Types.GetPaymentQueryVariables | VueCompositionApi.Ref<Types.GetPaymentQueryVariables> | ReactiveFunction<Types.GetPaymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>(GetPaymentDocument, variables, options);
}
export type GetPaymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPaymentQuery, Types.GetPaymentQueryVariables>;
export const GetPaymentReceiptPdfDocument = gql`
    query GetPaymentReceiptPdf($payment_id: ID!) {
  paymentReceiptPdf(payment_id: $payment_id) {
    base64
    filename
  }
}
    `;

/**
 * __useGetPaymentReceiptPdfQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentReceiptPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentReceiptPdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentReceiptPdfQuery({
 *   payment_id: // value for 'payment_id'
 * });
 */
export function useGetPaymentReceiptPdfQuery(variables: Types.GetPaymentReceiptPdfQueryVariables | VueCompositionApi.Ref<Types.GetPaymentReceiptPdfQueryVariables> | ReactiveFunction<Types.GetPaymentReceiptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>(GetPaymentReceiptPdfDocument, variables, options);
}
export function useGetPaymentReceiptPdfLazyQuery(variables?: Types.GetPaymentReceiptPdfQueryVariables | VueCompositionApi.Ref<Types.GetPaymentReceiptPdfQueryVariables> | ReactiveFunction<Types.GetPaymentReceiptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>(GetPaymentReceiptPdfDocument, variables, options);
}
export type GetPaymentReceiptPdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPaymentReceiptPdfQuery, Types.GetPaymentReceiptPdfQueryVariables>;
export const SuggestPaymentAllocationDocument = gql`
    query SuggestPaymentAllocation($student_id: ID!, $amount: Float!) {
  suggestPaymentAllocation(student_id: $student_id, amount: $amount) {
    bill_detail_id
    bill_item_name
    amount_due
    suggested_allocation
    bill_id
    bill_due_date
  }
}
    `;

/**
 * __useSuggestPaymentAllocationQuery__
 *
 * To run a query within a Vue component, call `useSuggestPaymentAllocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestPaymentAllocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSuggestPaymentAllocationQuery({
 *   student_id: // value for 'student_id'
 *   amount: // value for 'amount'
 * });
 */
export function useSuggestPaymentAllocationQuery(variables: Types.SuggestPaymentAllocationQueryVariables | VueCompositionApi.Ref<Types.SuggestPaymentAllocationQueryVariables> | ReactiveFunction<Types.SuggestPaymentAllocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>(SuggestPaymentAllocationDocument, variables, options);
}
export function useSuggestPaymentAllocationLazyQuery(variables?: Types.SuggestPaymentAllocationQueryVariables | VueCompositionApi.Ref<Types.SuggestPaymentAllocationQueryVariables> | ReactiveFunction<Types.SuggestPaymentAllocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>(SuggestPaymentAllocationDocument, variables, options);
}
export type SuggestPaymentAllocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SuggestPaymentAllocationQuery, Types.SuggestPaymentAllocationQueryVariables>;
export const CheckPaymentEnrollmentDocument = gql`
    query CheckPaymentEnrollment($student_id: ID!, $bill_detail_ids: [ID!]!) {
  checkPaymentEnrollment(
    student_id: $student_id
    bill_detail_ids: $bill_detail_ids
  ) {
    enrolled
    warnings
  }
}
    `;

/**
 * __useCheckPaymentEnrollmentQuery__
 *
 * To run a query within a Vue component, call `useCheckPaymentEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPaymentEnrollmentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckPaymentEnrollmentQuery({
 *   student_id: // value for 'student_id'
 *   bill_detail_ids: // value for 'bill_detail_ids'
 * });
 */
export function useCheckPaymentEnrollmentQuery(variables: Types.CheckPaymentEnrollmentQueryVariables | VueCompositionApi.Ref<Types.CheckPaymentEnrollmentQueryVariables> | ReactiveFunction<Types.CheckPaymentEnrollmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>(CheckPaymentEnrollmentDocument, variables, options);
}
export function useCheckPaymentEnrollmentLazyQuery(variables?: Types.CheckPaymentEnrollmentQueryVariables | VueCompositionApi.Ref<Types.CheckPaymentEnrollmentQueryVariables> | ReactiveFunction<Types.CheckPaymentEnrollmentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>(CheckPaymentEnrollmentDocument, variables, options);
}
export type CheckPaymentEnrollmentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CheckPaymentEnrollmentQuery, Types.CheckPaymentEnrollmentQueryVariables>;
export const GetStudentBillsDocument = gql`
    query GetStudentBills($student_id: ID!, $session_id: ID, $academic_calendar_id: ID, $status: BillStatusEnum) {
  studentBills(
    student_id: $student_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    status: $status
  ) {
    ...BillFields
    billDetails {
      ...BillDetailFields
    }
  }
}
    ${BillFieldsFragmentDoc}
${BillDetailFieldsFragmentDoc}`;

/**
 * __useGetStudentBillsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentBillsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentBillsQuery({
 *   student_id: // value for 'student_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   status: // value for 'status'
 * });
 */
export function useGetStudentBillsQuery(variables: Types.GetStudentBillsQueryVariables | VueCompositionApi.Ref<Types.GetStudentBillsQueryVariables> | ReactiveFunction<Types.GetStudentBillsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>(GetStudentBillsDocument, variables, options);
}
export function useGetStudentBillsLazyQuery(variables?: Types.GetStudentBillsQueryVariables | VueCompositionApi.Ref<Types.GetStudentBillsQueryVariables> | ReactiveFunction<Types.GetStudentBillsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>(GetStudentBillsDocument, variables, options);
}
export type GetStudentBillsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentBillsQuery, Types.GetStudentBillsQueryVariables>;
export const GetBillStudentsDocument = gql`
    query GetBillStudents($bill_id: ID!) {
  billStudents(bill_id: $bill_id) {
    id
    first_name
    surname
    other_name
    matric_no
  }
}
    `;

/**
 * __useGetBillStudentsQuery__
 *
 * To run a query within a Vue component, call `useGetBillStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillStudentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillStudentsQuery({
 *   bill_id: // value for 'bill_id'
 * });
 */
export function useGetBillStudentsQuery(variables: Types.GetBillStudentsQueryVariables | VueCompositionApi.Ref<Types.GetBillStudentsQueryVariables> | ReactiveFunction<Types.GetBillStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>(GetBillStudentsDocument, variables, options);
}
export function useGetBillStudentsLazyQuery(variables?: Types.GetBillStudentsQueryVariables | VueCompositionApi.Ref<Types.GetBillStudentsQueryVariables> | ReactiveFunction<Types.GetBillStudentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>(GetBillStudentsDocument, variables, options);
}
export type GetBillStudentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillStudentsQuery, Types.GetBillStudentsQueryVariables>;
export const GetBillStudentsWithStatusDocument = gql`
    query GetBillStudentsWithStatus($bill_id: ID!, $page: Int, $per_page: Int, $search: String, $sort_field: String, $sort_order: String) {
  billStudentsWithStatus(
    bill_id: $bill_id
    page: $page
    per_page: $per_page
    search: $search
    sort_field: $sort_field
    sort_order: $sort_order
  ) {
    students {
      student {
        id
        first_name
        surname
        other_name
        matric_no
        email
        phone
        photo
      }
      base_amount
      exemption_amount
      discount_amount
      adjusted_amount
      amount_paid
      balance
      payment_status
      adjustments {
        bill_detail_id
        source
        label
        amount
      }
      exemptions {
        id
        bill_id
        bill_detail_id
        entity_type
        entity_id
        exemption_type
        amount
        reason
        status
        created_at
        requestedBy {
          id
          name
        }
        approvedBy {
          id
          name
        }
      }
      entity_discounts {
        id
        discount_category_id
        is_active
        effective_from
        effective_until
        notes
        discountCategory {
          id
          name
        }
      }
      enrolled_at
    }
    summary {
      total_students
      total_expected
      total_collected
      total_outstanding
      total_exempted
      total_discounted
      paid_count
      partially_paid_count
      unpaid_count
      exempt_count
      new_students_since_publish
    }
    total
    page
    per_page
  }
}
    `;

/**
 * __useGetBillStudentsWithStatusQuery__
 *
 * To run a query within a Vue component, call `useGetBillStudentsWithStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillStudentsWithStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillStudentsWithStatusQuery({
 *   bill_id: // value for 'bill_id'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 *   search: // value for 'search'
 *   sort_field: // value for 'sort_field'
 *   sort_order: // value for 'sort_order'
 * });
 */
export function useGetBillStudentsWithStatusQuery(variables: Types.GetBillStudentsWithStatusQueryVariables | VueCompositionApi.Ref<Types.GetBillStudentsWithStatusQueryVariables> | ReactiveFunction<Types.GetBillStudentsWithStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>(GetBillStudentsWithStatusDocument, variables, options);
}
export function useGetBillStudentsWithStatusLazyQuery(variables?: Types.GetBillStudentsWithStatusQueryVariables | VueCompositionApi.Ref<Types.GetBillStudentsWithStatusQueryVariables> | ReactiveFunction<Types.GetBillStudentsWithStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>(GetBillStudentsWithStatusDocument, variables, options);
}
export type GetBillStudentsWithStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillStudentsWithStatusQuery, Types.GetBillStudentsWithStatusQueryVariables>;
export const GetDiscountCategoriesDocument = gql`
    query GetDiscountCategories {
  discountCategories {
    id
    name
    description
    is_active
    discountRules {
      id
      apply_to
      target_template_id
      target_category_id
      exclude_template_ids
      discount_type
      discount_value
      max_discount_amount
      priority
      is_active
      deactivated_reason
      targetTemplate {
        id
        name
      }
      targetCategoryEntity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetDiscountCategoriesQuery__
 *
 * To run a query within a Vue component, call `useGetDiscountCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDiscountCategoriesQuery();
 */
export function useGetDiscountCategoriesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>(GetDiscountCategoriesDocument, {}, options);
}
export function useGetDiscountCategoriesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>(GetDiscountCategoriesDocument, {}, options);
}
export type GetDiscountCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetDiscountCategoriesQuery, Types.GetDiscountCategoriesQueryVariables>;
export const GetDiscountCategoryDocument = gql`
    query GetDiscountCategory($id: ID!) {
  discountCategory(id: $id) {
    id
    name
    description
    is_active
    metadata
    created_at
    updated_at
    discountRules {
      id
      apply_to
      target_template_id
      target_category_id
      exclude_template_ids
      discount_type
      discount_value
      max_discount_amount
      priority
      is_active
      deactivated_reason
      targetTemplate {
        id
        name
      }
      targetCategoryEntity {
        id
        name
      }
    }
    entityDiscounts {
      id
      entity_type
      entity_id
      effective_from
      effective_until
      is_active
      notes
      created_at
      assignedBy {
        id
        name
      }
      entity {
        id
        first_name
        surname
        matric_no
      }
    }
  }
}
    `;

/**
 * __useGetDiscountCategoryQuery__
 *
 * To run a query within a Vue component, call `useGetDiscountCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDiscountCategoryQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetDiscountCategoryQuery(variables: Types.GetDiscountCategoryQueryVariables | VueCompositionApi.Ref<Types.GetDiscountCategoryQueryVariables> | ReactiveFunction<Types.GetDiscountCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>(GetDiscountCategoryDocument, variables, options);
}
export function useGetDiscountCategoryLazyQuery(variables?: Types.GetDiscountCategoryQueryVariables | VueCompositionApi.Ref<Types.GetDiscountCategoryQueryVariables> | ReactiveFunction<Types.GetDiscountCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>(GetDiscountCategoryDocument, variables, options);
}
export type GetDiscountCategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetDiscountCategoryQuery, Types.GetDiscountCategoryQueryVariables>;
export const GetEntityDiscountsDocument = gql`
    query GetEntityDiscounts($entity_type: String, $entity_id: ID, $discount_category_id: ID) {
  entityDiscounts(
    entity_type: $entity_type
    entity_id: $entity_id
    discount_category_id: $discount_category_id
  ) {
    id
    discount_category_id
    entity_type
    entity_id
    effective_from
    effective_until
    is_active
    notes
    created_at
    discountCategory {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEntityDiscountsQuery__
 *
 * To run a query within a Vue component, call `useGetEntityDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityDiscountsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEntityDiscountsQuery({
 *   entity_type: // value for 'entity_type'
 *   entity_id: // value for 'entity_id'
 *   discount_category_id: // value for 'discount_category_id'
 * });
 */
export function useGetEntityDiscountsQuery(variables: Types.GetEntityDiscountsQueryVariables | VueCompositionApi.Ref<Types.GetEntityDiscountsQueryVariables> | ReactiveFunction<Types.GetEntityDiscountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>(GetEntityDiscountsDocument, variables, options);
}
export function useGetEntityDiscountsLazyQuery(variables: Types.GetEntityDiscountsQueryVariables | VueCompositionApi.Ref<Types.GetEntityDiscountsQueryVariables> | ReactiveFunction<Types.GetEntityDiscountsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>(GetEntityDiscountsDocument, variables, options);
}
export type GetEntityDiscountsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetEntityDiscountsQuery, Types.GetEntityDiscountsQueryVariables>;
export const GetBillingKpisDocument = gql`
    query GetBillingKpis($session_id: ID, $academic_calendar_id: ID) {
  billingKpis(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    total_billed
    total_paid
    total_outstanding
    total_overdue
    total_discounted
    total_exempted
    discount_breakdown {
      discount_category_id
      name
      amount
      student_count
    }
    collection_rate
    bill_count
    paid_bill_count
  }
}
    `;

/**
 * __useGetBillingKpisQuery__
 *
 * To run a query within a Vue component, call `useGetBillingKpisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingKpisQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetBillingKpisQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetBillingKpisQuery(variables: Types.GetBillingKpisQueryVariables | VueCompositionApi.Ref<Types.GetBillingKpisQueryVariables> | ReactiveFunction<Types.GetBillingKpisQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>(GetBillingKpisDocument, variables, options);
}
export function useGetBillingKpisLazyQuery(variables: Types.GetBillingKpisQueryVariables | VueCompositionApi.Ref<Types.GetBillingKpisQueryVariables> | ReactiveFunction<Types.GetBillingKpisQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>(GetBillingKpisDocument, variables, options);
}
export type GetBillingKpisQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetBillingKpisQuery, Types.GetBillingKpisQueryVariables>;
export const GetRevenueByMonthDocument = gql`
    query GetRevenueByMonth($session_id: ID, $academic_calendar_id: ID) {
  revenueByMonth(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    month
    total
    count
  }
}
    `;

/**
 * __useGetRevenueByMonthQuery__
 *
 * To run a query within a Vue component, call `useGetRevenueByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRevenueByMonthQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRevenueByMonthQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetRevenueByMonthQuery(variables: Types.GetRevenueByMonthQueryVariables | VueCompositionApi.Ref<Types.GetRevenueByMonthQueryVariables> | ReactiveFunction<Types.GetRevenueByMonthQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>(GetRevenueByMonthDocument, variables, options);
}
export function useGetRevenueByMonthLazyQuery(variables: Types.GetRevenueByMonthQueryVariables | VueCompositionApi.Ref<Types.GetRevenueByMonthQueryVariables> | ReactiveFunction<Types.GetRevenueByMonthQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>(GetRevenueByMonthDocument, variables, options);
}
export type GetRevenueByMonthQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetRevenueByMonthQuery, Types.GetRevenueByMonthQueryVariables>;
export const GetPaymentMethodBreakdownDocument = gql`
    query GetPaymentMethodBreakdown($session_id: ID, $academic_calendar_id: ID) {
  paymentMethodBreakdown(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    payment_method
    total
    count
  }
}
    `;

/**
 * __useGetPaymentMethodBreakdownQuery__
 *
 * To run a query within a Vue component, call `useGetPaymentMethodBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodBreakdownQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPaymentMethodBreakdownQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetPaymentMethodBreakdownQuery(variables: Types.GetPaymentMethodBreakdownQueryVariables | VueCompositionApi.Ref<Types.GetPaymentMethodBreakdownQueryVariables> | ReactiveFunction<Types.GetPaymentMethodBreakdownQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>(GetPaymentMethodBreakdownDocument, variables, options);
}
export function useGetPaymentMethodBreakdownLazyQuery(variables: Types.GetPaymentMethodBreakdownQueryVariables | VueCompositionApi.Ref<Types.GetPaymentMethodBreakdownQueryVariables> | ReactiveFunction<Types.GetPaymentMethodBreakdownQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>(GetPaymentMethodBreakdownDocument, variables, options);
}
export type GetPaymentMethodBreakdownQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPaymentMethodBreakdownQuery, Types.GetPaymentMethodBreakdownQueryVariables>;
export const GetDebtorsDocument = gql`
    query GetDebtors($session_id: ID, $academic_calendar_id: ID, $classroom_section_id: ID, $classroom_id: ID, $programme_id: ID, $level: String, $min_outstanding: Float, $search: String, $sort_field: String, $sort_order: String, $page: Int, $per_page: Int) {
  debtors(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    classroom_section_id: $classroom_section_id
    classroom_id: $classroom_id
    programme_id: $programme_id
    level: $level
    min_outstanding: $min_outstanding
    search: $search
    sort_field: $sort_field
    sort_order: $sort_order
    page: $page
    per_page: $per_page
  ) {
    data {
      student {
        id
        first_name
        surname
        other_name
        matric_no
        currentClassroomSection {
          id
          classroom {
            id
            name
          }
          section {
            id
            name
          }
        }
      }
      outstanding_balance
      total_billed
      total_paid
    }
    total
    total_outstanding
    page
    per_page
  }
}
    `;

/**
 * __useGetDebtorsQuery__
 *
 * To run a query within a Vue component, call `useGetDebtorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDebtorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDebtorsQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   classroom_section_id: // value for 'classroom_section_id'
 *   classroom_id: // value for 'classroom_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 *   min_outstanding: // value for 'min_outstanding'
 *   search: // value for 'search'
 *   sort_field: // value for 'sort_field'
 *   sort_order: // value for 'sort_order'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useGetDebtorsQuery(variables: Types.GetDebtorsQueryVariables | VueCompositionApi.Ref<Types.GetDebtorsQueryVariables> | ReactiveFunction<Types.GetDebtorsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>(GetDebtorsDocument, variables, options);
}
export function useGetDebtorsLazyQuery(variables: Types.GetDebtorsQueryVariables | VueCompositionApi.Ref<Types.GetDebtorsQueryVariables> | ReactiveFunction<Types.GetDebtorsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>(GetDebtorsDocument, variables, options);
}
export type GetDebtorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetDebtorsQuery, Types.GetDebtorsQueryVariables>;
export const ExportDebtorsDocument = gql`
    mutation ExportDebtors($report_formats: [String!]!, $granularity: String, $columns: [String!], $session_id: ID, $academic_calendar_id: ID, $classroom_section_id: ID, $classroom_id: ID, $programme_id: ID, $level: String, $min_outstanding: Float, $search: String) {
  exportDebtors(
    report_formats: $report_formats
    granularity: $granularity
    columns: $columns
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    classroom_section_id: $classroom_section_id
    classroom_id: $classroom_id
    programme_id: $programme_id
    level: $level
    min_outstanding: $min_outstanding
    search: $search
  ) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
    created_at
  }
}
    `;

/**
 * __useExportDebtorsMutation__
 *
 * To run a mutation, you first call `useExportDebtorsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportDebtorsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportDebtorsMutation({
 *   variables: {
 *     report_formats: // value for 'report_formats'
 *     granularity: // value for 'granularity'
 *     columns: // value for 'columns'
 *     session_id: // value for 'session_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     classroom_id: // value for 'classroom_id'
 *     programme_id: // value for 'programme_id'
 *     level: // value for 'level'
 *     min_outstanding: // value for 'min_outstanding'
 *     search: // value for 'search'
 *   },
 * });
 */
export function useExportDebtorsMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportDebtorsMutation, Types.ExportDebtorsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportDebtorsMutation, Types.ExportDebtorsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportDebtorsMutation, Types.ExportDebtorsMutationVariables>(ExportDebtorsDocument, options);
}
export type ExportDebtorsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportDebtorsMutation, Types.ExportDebtorsMutationVariables>;
export const GetStudentFinancialsDocument = gql`
    query GetStudentFinancials($session_id: ID, $academic_calendar_id: ID, $search: String, $page: Int, $per_page: Int) {
  studentFinancials(
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    search: $search
    page: $page
    per_page: $per_page
  ) {
    data {
      student {
        id
        first_name
        surname
        other_name
        matric_no
        currentClassroomSection {
          id
          classroom {
            id
            name
          }
          section {
            id
            name
          }
        }
      }
      total_billed
      total_paid
      outstanding_balance
      total_discounted
      total_exempted
      wallet_balance
      last_payment_at
      standing
    }
    total
    page
    per_page
  }
}
    `;

/**
 * __useGetStudentFinancialsQuery__
 *
 * To run a query within a Vue component, call `useGetStudentFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentFinancialsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentFinancialsQuery({
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   search: // value for 'search'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useGetStudentFinancialsQuery(variables: Types.GetStudentFinancialsQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialsQueryVariables> | ReactiveFunction<Types.GetStudentFinancialsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>(GetStudentFinancialsDocument, variables, options);
}
export function useGetStudentFinancialsLazyQuery(variables: Types.GetStudentFinancialsQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialsQueryVariables> | ReactiveFunction<Types.GetStudentFinancialsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>(GetStudentFinancialsDocument, variables, options);
}
export type GetStudentFinancialsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentFinancialsQuery, Types.GetStudentFinancialsQueryVariables>;
export const GetRefundsDocument = gql`
    query GetRefunds($status: RefundStatusEnum, $payment_id: ID) {
  refunds(status: $status, payment_id: $payment_id) {
    id
    payment_id
    amount
    reason
    status
    refund_method
    processor_reference
    requested_by
    approved_by
    processed_at
    notes
    created_at
    updated_at
    payment {
      id
      amount
      payment_method
      student {
        id
        first_name
        surname
      }
    }
    requestedBy {
      id
      name
    }
    approvedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRefundsQuery__
 *
 * To run a query within a Vue component, call `useGetRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRefundsQuery({
 *   status: // value for 'status'
 *   payment_id: // value for 'payment_id'
 * });
 */
export function useGetRefundsQuery(variables: Types.GetRefundsQueryVariables | VueCompositionApi.Ref<Types.GetRefundsQueryVariables> | ReactiveFunction<Types.GetRefundsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>(GetRefundsDocument, variables, options);
}
export function useGetRefundsLazyQuery(variables: Types.GetRefundsQueryVariables | VueCompositionApi.Ref<Types.GetRefundsQueryVariables> | ReactiveFunction<Types.GetRefundsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>(GetRefundsDocument, variables, options);
}
export type GetRefundsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetRefundsQuery, Types.GetRefundsQueryVariables>;
export const GetExemptionsDocument = gql`
    query GetExemptions($status: ExemptionStatusEnum, $bill_id: ID, $entity_type: String, $entity_id: ID) {
  exemptions(
    status: $status
    bill_id: $bill_id
    entity_type: $entity_type
    entity_id: $entity_id
  ) {
    id
    bill_id
    bill_detail_id
    entity_type
    entity_id
    exemption_type
    amount
    reason
    status
    requested_by
    approved_by
    created_at
    updated_at
    entity {
      ... on Student {
        id
        first_name
        surname
        matric_no
      }
    }
    bill {
      id
      invoice_number
      amount
      net_amount
      billable_type
      billable_id
      status
      due_date
      billable {
        ... on Student {
          id
          first_name
          surname
        }
        ... on Classroom {
          id
          name
        }
        ... on ClassroomSection {
          id
          classroom {
            id
            name
          }
          section {
            id
            name
          }
        }
        ... on ProgrammeType {
          id
          program_name
        }
        ... on FormSubmission {
          id
          tracking_code
          applicant_name
        }
        ... on TranscriptRequest {
          id
          request_applicant_name: applicant_name
          request_tracking_code: tracking_code
        }
      }
      billDetails {
        id
        item_name
        amount
        net_amount
      }
    }
    billDetail {
      id
      item_name
      amount
    }
    requestedBy {
      id
      name
    }
    approvedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useGetExemptionsQuery__
 *
 * To run a query within a Vue component, call `useGetExemptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExemptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetExemptionsQuery({
 *   status: // value for 'status'
 *   bill_id: // value for 'bill_id'
 *   entity_type: // value for 'entity_type'
 *   entity_id: // value for 'entity_id'
 * });
 */
export function useGetExemptionsQuery(variables: Types.GetExemptionsQueryVariables | VueCompositionApi.Ref<Types.GetExemptionsQueryVariables> | ReactiveFunction<Types.GetExemptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>(GetExemptionsDocument, variables, options);
}
export function useGetExemptionsLazyQuery(variables: Types.GetExemptionsQueryVariables | VueCompositionApi.Ref<Types.GetExemptionsQueryVariables> | ReactiveFunction<Types.GetExemptionsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>(GetExemptionsDocument, variables, options);
}
export type GetExemptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetExemptionsQuery, Types.GetExemptionsQueryVariables>;
export const GenerateBillingReportDocument = gql`
    query GenerateBillingReport($report_type: String!, $session_id: ID, $academic_calendar_id: ID, $from_date: Date, $to_date: Date, $classroom_section_id: ID, $classroom_id: ID, $programme_id: ID, $level: String, $payment_method: String, $bill_item_category_id: ID, $gateway_settlement_account_id: ID) {
  generateBillingReport(
    report_type: $report_type
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    from_date: $from_date
    to_date: $to_date
    classroom_section_id: $classroom_section_id
    classroom_id: $classroom_id
    programme_id: $programme_id
    level: $level
    payment_method: $payment_method
    bill_item_category_id: $bill_item_category_id
    gateway_settlement_account_id: $gateway_settlement_account_id
  ) {
    ... on RevenueReport {
      type
      summary {
        total_amount
        total_count
        by_method {
          method
          count
          total
        }
      }
      records {
        id
        student_name
        amount
        payment_method
        payment_date
        reference
        status
      }
      record_count
      records_truncated
    }
    ... on OutstandingReport {
      type
      summary {
        total_outstanding
        total_bills
        by_status {
          status
          count
          total
        }
      }
      records {
        id
        billable_type
        billable_name
        billable_type_label
        net_amount
        amount_paid
        balance
        status
        due_date
      }
      record_count
      records_truncated
    }
    ... on PaymentMethodReport {
      type
      summary {
        total_amount
        total_count
      }
      records {
        payment_method
        total
        count
        percentage
      }
      record_count
      records_truncated
    }
    ... on CategoryRevenueReport {
      type
      summary {
        total_amount
        total_count
      }
      records {
        category
        total
        count
        percentage
      }
      record_count
      records_truncated
    }
    ... on ReliefGrantedReport {
      type
      summary {
        total_discounted
        total_exempted
        total_relief
        bill_count
      }
      records {
        id
        billable_type
        billable_name
        billable_type_label
        total_billed
        total_discounted
        total_exempted
        total_relief
        status
      }
      record_count
      records_truncated
    }
    ... on RefundsReport {
      type
      summary {
        total_refunded
        total_count
        pending_count
        by_status {
          status
          count
          total
        }
      }
      records {
        id
        student_name
        amount
        status
        refund_method
        reason
        requested_at
        processed_at
      }
      record_count
      records_truncated
    }
    ... on DailyCollectionsReport {
      type
      summary {
        total_amount
        total_count
        average_per_day
        peak_date
        peak_amount
      }
      records {
        date
        total
        count
      }
      record_count
      records_truncated
    }
  }
}
    `;

/**
 * __useGenerateBillingReportQuery__
 *
 * To run a query within a Vue component, call `useGenerateBillingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateBillingReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenerateBillingReportQuery({
 *   report_type: // value for 'report_type'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   from_date: // value for 'from_date'
 *   to_date: // value for 'to_date'
 *   classroom_section_id: // value for 'classroom_section_id'
 *   classroom_id: // value for 'classroom_id'
 *   programme_id: // value for 'programme_id'
 *   level: // value for 'level'
 *   payment_method: // value for 'payment_method'
 *   bill_item_category_id: // value for 'bill_item_category_id'
 *   gateway_settlement_account_id: // value for 'gateway_settlement_account_id'
 * });
 */
export function useGenerateBillingReportQuery(variables: Types.GenerateBillingReportQueryVariables | VueCompositionApi.Ref<Types.GenerateBillingReportQueryVariables> | ReactiveFunction<Types.GenerateBillingReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>(GenerateBillingReportDocument, variables, options);
}
export function useGenerateBillingReportLazyQuery(variables?: Types.GenerateBillingReportQueryVariables | VueCompositionApi.Ref<Types.GenerateBillingReportQueryVariables> | ReactiveFunction<Types.GenerateBillingReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>(GenerateBillingReportDocument, variables, options);
}
export type GenerateBillingReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GenerateBillingReportQuery, Types.GenerateBillingReportQueryVariables>;
export const ExportBillingReportDocument = gql`
    mutation ExportBillingReport($report_type: String!, $report_formats: [String!]!, $session_id: ID, $academic_calendar_id: ID, $from_date: Date, $to_date: Date, $classroom_section_id: ID, $classroom_id: ID, $programme_id: ID, $level: String, $payment_method: String, $bill_item_category_id: ID, $gateway_settlement_account_id: ID) {
  exportBillingReport(
    report_type: $report_type
    report_formats: $report_formats
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    from_date: $from_date
    to_date: $to_date
    classroom_section_id: $classroom_section_id
    classroom_id: $classroom_id
    programme_id: $programme_id
    level: $level
    payment_method: $payment_method
    bill_item_category_id: $bill_item_category_id
    gateway_settlement_account_id: $gateway_settlement_account_id
  ) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
    created_at
  }
}
    `;

/**
 * __useExportBillingReportMutation__
 *
 * To run a mutation, you first call `useExportBillingReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportBillingReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportBillingReportMutation({
 *   variables: {
 *     report_type: // value for 'report_type'
 *     report_formats: // value for 'report_formats'
 *     session_id: // value for 'session_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     from_date: // value for 'from_date'
 *     to_date: // value for 'to_date'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     classroom_id: // value for 'classroom_id'
 *     programme_id: // value for 'programme_id'
 *     level: // value for 'level'
 *     payment_method: // value for 'payment_method'
 *     bill_item_category_id: // value for 'bill_item_category_id'
 *     gateway_settlement_account_id: // value for 'gateway_settlement_account_id'
 *   },
 * });
 */
export function useExportBillingReportMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportBillingReportMutation, Types.ExportBillingReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportBillingReportMutation, Types.ExportBillingReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportBillingReportMutation, Types.ExportBillingReportMutationVariables>(ExportBillingReportDocument, options);
}
export type ExportBillingReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportBillingReportMutation, Types.ExportBillingReportMutationVariables>;
export const BillInvoicePdfDocument = gql`
    query BillInvoicePdf($bill_id: ID!) {
  billInvoicePdf(bill_id: $bill_id) {
    base64
    filename
  }
}
    `;

/**
 * __useBillInvoicePdfQuery__
 *
 * To run a query within a Vue component, call `useBillInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillInvoicePdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBillInvoicePdfQuery({
 *   bill_id: // value for 'bill_id'
 * });
 */
export function useBillInvoicePdfQuery(variables: Types.BillInvoicePdfQueryVariables | VueCompositionApi.Ref<Types.BillInvoicePdfQueryVariables> | ReactiveFunction<Types.BillInvoicePdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>(BillInvoicePdfDocument, variables, options);
}
export function useBillInvoicePdfLazyQuery(variables?: Types.BillInvoicePdfQueryVariables | VueCompositionApi.Ref<Types.BillInvoicePdfQueryVariables> | ReactiveFunction<Types.BillInvoicePdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>(BillInvoicePdfDocument, variables, options);
}
export type BillInvoicePdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.BillInvoicePdfQuery, Types.BillInvoicePdfQueryVariables>;
export const GetStudentFinancialSummaryDocument = gql`
    query GetStudentFinancialSummary($student_id: ID!, $session_id: ID, $academic_calendar_id: ID) {
  studentFinancialSummary(
    student_id: $student_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
  ) {
    total_billed
    total_paid
    total_outstanding
    total_exempted
    total_discounted
    total_refunded
    wallet_balance
    bill_count
    paid_bill_count
  }
}
    `;

/**
 * __useGetStudentFinancialSummaryQuery__
 *
 * To run a query within a Vue component, call `useGetStudentFinancialSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentFinancialSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentFinancialSummaryQuery({
 *   student_id: // value for 'student_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 * });
 */
export function useGetStudentFinancialSummaryQuery(variables: Types.GetStudentFinancialSummaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialSummaryQueryVariables> | ReactiveFunction<Types.GetStudentFinancialSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>(GetStudentFinancialSummaryDocument, variables, options);
}
export function useGetStudentFinancialSummaryLazyQuery(variables?: Types.GetStudentFinancialSummaryQueryVariables | VueCompositionApi.Ref<Types.GetStudentFinancialSummaryQueryVariables> | ReactiveFunction<Types.GetStudentFinancialSummaryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>(GetStudentFinancialSummaryDocument, variables, options);
}
export type GetStudentFinancialSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentFinancialSummaryQuery, Types.GetStudentFinancialSummaryQueryVariables>;
export const GetStudentWalletDocument = gql`
    query GetStudentWallet($student_id: ID!) {
  studentWallet(student_id: $student_id) {
    id
    student_id
    balance
    currency_code
    transactions {
      id
      type
      amount
      balance_after
      source_type
      source_id
      description
      created_at
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetStudentWalletQuery__
 *
 * To run a query within a Vue component, call `useGetStudentWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentWalletQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentWalletQuery({
 *   student_id: // value for 'student_id'
 * });
 */
export function useGetStudentWalletQuery(variables: Types.GetStudentWalletQueryVariables | VueCompositionApi.Ref<Types.GetStudentWalletQueryVariables> | ReactiveFunction<Types.GetStudentWalletQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>(GetStudentWalletDocument, variables, options);
}
export function useGetStudentWalletLazyQuery(variables?: Types.GetStudentWalletQueryVariables | VueCompositionApi.Ref<Types.GetStudentWalletQueryVariables> | ReactiveFunction<Types.GetStudentWalletQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>(GetStudentWalletDocument, variables, options);
}
export type GetStudentWalletQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentWalletQuery, Types.GetStudentWalletQueryVariables>;
export const GetStudentLedgerDocument = gql`
    query GetStudentLedger($student_id: ID!, $session_id: ID, $academic_calendar_id: ID, $page: Int, $per_page: Int) {
  studentLedger(
    student_id: $student_id
    session_id: $session_id
    academic_calendar_id: $academic_calendar_id
    page: $page
    per_page: $per_page
  ) {
    entries {
      type
      date
      description
      reference
      debit
      credit
      running_balance
      related_id
      related_type
      status
      payment_method
      bill_due_date
      items {
        item_name
        amount
      }
    }
    total
    page
    per_page
  }
}
    `;

/**
 * __useGetStudentLedgerQuery__
 *
 * To run a query within a Vue component, call `useGetStudentLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentLedgerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetStudentLedgerQuery({
 *   student_id: // value for 'student_id'
 *   session_id: // value for 'session_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   page: // value for 'page'
 *   per_page: // value for 'per_page'
 * });
 */
export function useGetStudentLedgerQuery(variables: Types.GetStudentLedgerQueryVariables | VueCompositionApi.Ref<Types.GetStudentLedgerQueryVariables> | ReactiveFunction<Types.GetStudentLedgerQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>(GetStudentLedgerDocument, variables, options);
}
export function useGetStudentLedgerLazyQuery(variables?: Types.GetStudentLedgerQueryVariables | VueCompositionApi.Ref<Types.GetStudentLedgerQueryVariables> | ReactiveFunction<Types.GetStudentLedgerQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>(GetStudentLedgerDocument, variables, options);
}
export type GetStudentLedgerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetStudentLedgerQuery, Types.GetStudentLedgerQueryVariables>;
export const DiscountRuleImpactDocument = gql`
    query DiscountRuleImpact($input: DiscountRuleImpactInput!) {
  discountRuleImpact(input: $input) {
    status
    matched_lines
    matched_bills
    matched_amount
    estimated_discount
    considered_lines
    considered_amount
    samples {
      bill_id
      bill_detail_id
      item_name
      amount
    }
    unmatched_siblings {
      bill_id
      bill_detail_id
      item_name
      amount
    }
  }
}
    `;

/**
 * __useDiscountRuleImpactQuery__
 *
 * To run a query within a Vue component, call `useDiscountRuleImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountRuleImpactQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiscountRuleImpactQuery({
 *   input: // value for 'input'
 * });
 */
export function useDiscountRuleImpactQuery(variables: Types.DiscountRuleImpactQueryVariables | VueCompositionApi.Ref<Types.DiscountRuleImpactQueryVariables> | ReactiveFunction<Types.DiscountRuleImpactQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>(DiscountRuleImpactDocument, variables, options);
}
export function useDiscountRuleImpactLazyQuery(variables?: Types.DiscountRuleImpactQueryVariables | VueCompositionApi.Ref<Types.DiscountRuleImpactQueryVariables> | ReactiveFunction<Types.DiscountRuleImpactQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>(DiscountRuleImpactDocument, variables, options);
}
export type DiscountRuleImpactQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DiscountRuleImpactQuery, Types.DiscountRuleImpactQueryVariables>;
export const DiscountAssignmentPreviewDocument = gql`
    query DiscountAssignmentPreview($input: DiscountAssignmentPreviewInput!) {
  discountAssignmentPreview(input: $input) {
    status
    applies
    matched_lines
    estimated_relief
    considered_bills
    samples {
      item_name
      amount
    }
  }
}
    `;

/**
 * __useDiscountAssignmentPreviewQuery__
 *
 * To run a query within a Vue component, call `useDiscountAssignmentPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountAssignmentPreviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiscountAssignmentPreviewQuery({
 *   input: // value for 'input'
 * });
 */
export function useDiscountAssignmentPreviewQuery(variables: Types.DiscountAssignmentPreviewQueryVariables | VueCompositionApi.Ref<Types.DiscountAssignmentPreviewQueryVariables> | ReactiveFunction<Types.DiscountAssignmentPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>(DiscountAssignmentPreviewDocument, variables, options);
}
export function useDiscountAssignmentPreviewLazyQuery(variables?: Types.DiscountAssignmentPreviewQueryVariables | VueCompositionApi.Ref<Types.DiscountAssignmentPreviewQueryVariables> | ReactiveFunction<Types.DiscountAssignmentPreviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>(DiscountAssignmentPreviewDocument, variables, options);
}
export type DiscountAssignmentPreviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DiscountAssignmentPreviewQuery, Types.DiscountAssignmentPreviewQueryVariables>;
export const CreateCertificateTemplateDocument = gql`
    mutation CreateCertificateTemplate($input: CreateCertificateTemplateInput!) {
  createCertificateTemplate(input: $input) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useCreateCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCertificateTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCertificateTemplateMutation, Types.CreateCertificateTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCertificateTemplateMutation, Types.CreateCertificateTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCertificateTemplateMutation, Types.CreateCertificateTemplateMutationVariables>(CreateCertificateTemplateDocument, options);
}
export type CreateCertificateTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCertificateTemplateMutation, Types.CreateCertificateTemplateMutationVariables>;
export const UpdateCertificateTemplateDocument = gql`
    mutation UpdateCertificateTemplate($input: UpdateCertificateTemplateInput!) {
  updateCertificateTemplate(input: $input) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useUpdateCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCertificateTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCertificateTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCertificateTemplateMutation, Types.UpdateCertificateTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCertificateTemplateMutation, Types.UpdateCertificateTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCertificateTemplateMutation, Types.UpdateCertificateTemplateMutationVariables>(UpdateCertificateTemplateDocument, options);
}
export type UpdateCertificateTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCertificateTemplateMutation, Types.UpdateCertificateTemplateMutationVariables>;
export const DeleteCertificateTemplateDocument = gql`
    mutation DeleteCertificateTemplate($id: ID!) {
  deleteCertificateTemplate(id: $id)
}
    `;

/**
 * __useDeleteCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCertificateTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCertificateTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCertificateTemplateMutation, Types.DeleteCertificateTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCertificateTemplateMutation, Types.DeleteCertificateTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCertificateTemplateMutation, Types.DeleteCertificateTemplateMutationVariables>(DeleteCertificateTemplateDocument, options);
}
export type DeleteCertificateTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCertificateTemplateMutation, Types.DeleteCertificateTemplateMutationVariables>;
export const UploadCertificateBackgroundDocument = gql`
    mutation UploadCertificateBackground($certificate_template_id: ID!, $file: Upload!) {
  uploadCertificateBackground(
    certificate_template_id: $certificate_template_id
    file: $file
  ) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useUploadCertificateBackgroundMutation__
 *
 * To run a mutation, you first call `useUploadCertificateBackgroundMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadCertificateBackgroundMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadCertificateBackgroundMutation({
 *   variables: {
 *     certificate_template_id: // value for 'certificate_template_id'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadCertificateBackgroundMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadCertificateBackgroundMutation, Types.UploadCertificateBackgroundMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadCertificateBackgroundMutation, Types.UploadCertificateBackgroundMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadCertificateBackgroundMutation, Types.UploadCertificateBackgroundMutationVariables>(UploadCertificateBackgroundDocument, options);
}
export type UploadCertificateBackgroundMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadCertificateBackgroundMutation, Types.UploadCertificateBackgroundMutationVariables>;
export const UploadCertificateSignatureDocument = gql`
    mutation UploadCertificateSignature($certificate_template_id: ID!, $signature_id: String!, $file: Upload!) {
  uploadCertificateSignature(
    certificate_template_id: $certificate_template_id
    signature_id: $signature_id
    file: $file
  ) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useUploadCertificateSignatureMutation__
 *
 * To run a mutation, you first call `useUploadCertificateSignatureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadCertificateSignatureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadCertificateSignatureMutation({
 *   variables: {
 *     certificate_template_id: // value for 'certificate_template_id'
 *     signature_id: // value for 'signature_id'
 *     file: // value for 'file'
 *   },
 * });
 */
export function useUploadCertificateSignatureMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadCertificateSignatureMutation, Types.UploadCertificateSignatureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadCertificateSignatureMutation, Types.UploadCertificateSignatureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadCertificateSignatureMutation, Types.UploadCertificateSignatureMutationVariables>(UploadCertificateSignatureDocument, options);
}
export type UploadCertificateSignatureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadCertificateSignatureMutation, Types.UploadCertificateSignatureMutationVariables>;
export const CheckGraduationEligibilityDocument = gql`
    mutation CheckGraduationEligibility($input: CheckGraduationEligibilityInput!) {
  checkGraduationEligibility(input: $input) {
    total_checked
    eligible_count
    not_eligible_count
    records {
      ...GraduationRecordFields
    }
  }
}
    ${GraduationRecordFieldsFragmentDoc}`;

/**
 * __useCheckGraduationEligibilityMutation__
 *
 * To run a mutation, you first call `useCheckGraduationEligibilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckGraduationEligibilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckGraduationEligibilityMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCheckGraduationEligibilityMutation(options: VueApolloComposable.UseMutationOptions<Types.CheckGraduationEligibilityMutation, Types.CheckGraduationEligibilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CheckGraduationEligibilityMutation, Types.CheckGraduationEligibilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CheckGraduationEligibilityMutation, Types.CheckGraduationEligibilityMutationVariables>(CheckGraduationEligibilityDocument, options);
}
export type CheckGraduationEligibilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CheckGraduationEligibilityMutation, Types.CheckGraduationEligibilityMutationVariables>;
export const CheckAllProgrammesEligibilityDocument = gql`
    mutation CheckAllProgrammesEligibility($academic_calendar_id: ID!) {
  checkAllProgrammesEligibility(academic_calendar_id: $academic_calendar_id) {
    id
    type
    status
    progress
    file_name
    error_message
    metadata
  }
}
    `;

/**
 * __useCheckAllProgrammesEligibilityMutation__
 *
 * To run a mutation, you first call `useCheckAllProgrammesEligibilityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCheckAllProgrammesEligibilityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCheckAllProgrammesEligibilityMutation({
 *   variables: {
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useCheckAllProgrammesEligibilityMutation(options: VueApolloComposable.UseMutationOptions<Types.CheckAllProgrammesEligibilityMutation, Types.CheckAllProgrammesEligibilityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CheckAllProgrammesEligibilityMutation, Types.CheckAllProgrammesEligibilityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CheckAllProgrammesEligibilityMutation, Types.CheckAllProgrammesEligibilityMutationVariables>(CheckAllProgrammesEligibilityDocument, options);
}
export type CheckAllProgrammesEligibilityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CheckAllProgrammesEligibilityMutation, Types.CheckAllProgrammesEligibilityMutationVariables>;
export const ApproveGraduationDocument = gql`
    mutation ApproveGraduation($id: ID!) {
  approveGraduation(id: $id) {
    ...GraduationRecordFields
  }
}
    ${GraduationRecordFieldsFragmentDoc}`;

/**
 * __useApproveGraduationMutation__
 *
 * To run a mutation, you first call `useApproveGraduationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveGraduationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveGraduationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveGraduationMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveGraduationMutation, Types.ApproveGraduationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveGraduationMutation, Types.ApproveGraduationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveGraduationMutation, Types.ApproveGraduationMutationVariables>(ApproveGraduationDocument, options);
}
export type ApproveGraduationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveGraduationMutation, Types.ApproveGraduationMutationVariables>;
export const RevokeGraduationDocument = gql`
    mutation RevokeGraduation($id: ID!, $reason: String!) {
  revokeGraduation(id: $id, reason: $reason) {
    ...GraduationRecordFields
  }
}
    ${GraduationRecordFieldsFragmentDoc}`;

/**
 * __useRevokeGraduationMutation__
 *
 * To run a mutation, you first call `useRevokeGraduationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeGraduationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeGraduationMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRevokeGraduationMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeGraduationMutation, Types.RevokeGraduationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeGraduationMutation, Types.RevokeGraduationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeGraduationMutation, Types.RevokeGraduationMutationVariables>(RevokeGraduationDocument, options);
}
export type RevokeGraduationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeGraduationMutation, Types.RevokeGraduationMutationVariables>;
export const BatchApproveGraduationsDocument = gql`
    mutation BatchApproveGraduations($ids: [ID!]!) {
  batchApproveGraduations(ids: $ids) {
    approved_count
    skipped_count
  }
}
    `;

/**
 * __useBatchApproveGraduationsMutation__
 *
 * To run a mutation, you first call `useBatchApproveGraduationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchApproveGraduationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchApproveGraduationsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useBatchApproveGraduationsMutation(options: VueApolloComposable.UseMutationOptions<Types.BatchApproveGraduationsMutation, Types.BatchApproveGraduationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BatchApproveGraduationsMutation, Types.BatchApproveGraduationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BatchApproveGraduationsMutation, Types.BatchApproveGraduationsMutationVariables>(BatchApproveGraduationsDocument, options);
}
export type BatchApproveGraduationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BatchApproveGraduationsMutation, Types.BatchApproveGraduationsMutationVariables>;
export const BatchApproveFilteredGraduationsDocument = gql`
    mutation BatchApproveFilteredGraduations($programme_id: ID, $academic_calendar_id: ID, $graduation_status: GraduationStatusEnum, $search: String, $level: String, $created_from: Date, $created_to: Date) {
  batchApproveFilteredGraduations(
    filter: {programme_id: $programme_id, academic_calendar_id: $academic_calendar_id, graduation_status: $graduation_status, search: $search, level: $level, created_from: $created_from, created_to: $created_to}
  ) {
    approved_count
    skipped_count
  }
}
    `;

/**
 * __useBatchApproveFilteredGraduationsMutation__
 *
 * To run a mutation, you first call `useBatchApproveFilteredGraduationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchApproveFilteredGraduationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchApproveFilteredGraduationsMutation({
 *   variables: {
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     graduation_status: // value for 'graduation_status'
 *     search: // value for 'search'
 *     level: // value for 'level'
 *     created_from: // value for 'created_from'
 *     created_to: // value for 'created_to'
 *   },
 * });
 */
export function useBatchApproveFilteredGraduationsMutation(options: VueApolloComposable.UseMutationOptions<Types.BatchApproveFilteredGraduationsMutation, Types.BatchApproveFilteredGraduationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BatchApproveFilteredGraduationsMutation, Types.BatchApproveFilteredGraduationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BatchApproveFilteredGraduationsMutation, Types.BatchApproveFilteredGraduationsMutationVariables>(BatchApproveFilteredGraduationsDocument, options);
}
export type BatchApproveFilteredGraduationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BatchApproveFilteredGraduationsMutation, Types.BatchApproveFilteredGraduationsMutationVariables>;
export const GenerateCertificateDocument = gql`
    mutation GenerateCertificate($input: GenerateCertificateInput!) {
  generateCertificate(input: $input) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useGenerateCertificateMutation__
 *
 * To run a mutation, you first call `useGenerateCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateCertificateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.GenerateCertificateMutation, Types.GenerateCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GenerateCertificateMutation, Types.GenerateCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GenerateCertificateMutation, Types.GenerateCertificateMutationVariables>(GenerateCertificateDocument, options);
}
export type GenerateCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GenerateCertificateMutation, Types.GenerateCertificateMutationVariables>;
export const BatchGenerateCertificatesDocument = gql`
    mutation BatchGenerateCertificates($input: BatchGenerateCertificatesInput!) {
  batchGenerateCertificates(input: $input) {
    ...CertificateBatchJobFields
  }
}
    ${CertificateBatchJobFieldsFragmentDoc}`;

/**
 * __useBatchGenerateCertificatesMutation__
 *
 * To run a mutation, you first call `useBatchGenerateCertificatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBatchGenerateCertificatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBatchGenerateCertificatesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBatchGenerateCertificatesMutation(options: VueApolloComposable.UseMutationOptions<Types.BatchGenerateCertificatesMutation, Types.BatchGenerateCertificatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BatchGenerateCertificatesMutation, Types.BatchGenerateCertificatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BatchGenerateCertificatesMutation, Types.BatchGenerateCertificatesMutationVariables>(BatchGenerateCertificatesDocument, options);
}
export type BatchGenerateCertificatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BatchGenerateCertificatesMutation, Types.BatchGenerateCertificatesMutationVariables>;
export const SubmitCertificateForReviewDocument = gql`
    mutation SubmitCertificateForReview($id: ID!) {
  submitCertificateForReview(id: $id) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useSubmitCertificateForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitCertificateForReviewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCertificateForReviewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitCertificateForReviewMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSubmitCertificateForReviewMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitCertificateForReviewMutation, Types.SubmitCertificateForReviewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitCertificateForReviewMutation, Types.SubmitCertificateForReviewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitCertificateForReviewMutation, Types.SubmitCertificateForReviewMutationVariables>(SubmitCertificateForReviewDocument, options);
}
export type SubmitCertificateForReviewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitCertificateForReviewMutation, Types.SubmitCertificateForReviewMutationVariables>;
export const ApproveCertificateDocument = gql`
    mutation ApproveCertificate($id: ID!) {
  approveCertificate(id: $id) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useApproveCertificateMutation__
 *
 * To run a mutation, you first call `useApproveCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveCertificateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveCertificateMutation, Types.ApproveCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveCertificateMutation, Types.ApproveCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveCertificateMutation, Types.ApproveCertificateMutationVariables>(ApproveCertificateDocument, options);
}
export type ApproveCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveCertificateMutation, Types.ApproveCertificateMutationVariables>;
export const RejectCertificateDocument = gql`
    mutation RejectCertificate($id: ID!, $reason: String!) {
  rejectCertificate(id: $id, reason: $reason) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useRejectCertificateMutation__
 *
 * To run a mutation, you first call `useRejectCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectCertificateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectCertificateMutation, Types.RejectCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectCertificateMutation, Types.RejectCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectCertificateMutation, Types.RejectCertificateMutationVariables>(RejectCertificateDocument, options);
}
export type RejectCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectCertificateMutation, Types.RejectCertificateMutationVariables>;
export const ReleaseCertificateDocument = gql`
    mutation ReleaseCertificate($id: ID!, $delivery_method: CertificateDeliveryEnum!, $email: String) {
  releaseCertificate(id: $id, delivery_method: $delivery_method, email: $email) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useReleaseCertificateMutation__
 *
 * To run a mutation, you first call `useReleaseCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReleaseCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReleaseCertificateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     delivery_method: // value for 'delivery_method'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useReleaseCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.ReleaseCertificateMutation, Types.ReleaseCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReleaseCertificateMutation, Types.ReleaseCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReleaseCertificateMutation, Types.ReleaseCertificateMutationVariables>(ReleaseCertificateDocument, options);
}
export type ReleaseCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReleaseCertificateMutation, Types.ReleaseCertificateMutationVariables>;
export const ExpressReleaseCertificateDocument = gql`
    mutation ExpressReleaseCertificate($id: ID!, $delivery_method: CertificateDeliveryEnum!, $email: String) {
  expressReleaseCertificate(
    id: $id
    delivery_method: $delivery_method
    email: $email
  ) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useExpressReleaseCertificateMutation__
 *
 * To run a mutation, you first call `useExpressReleaseCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExpressReleaseCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExpressReleaseCertificateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     delivery_method: // value for 'delivery_method'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useExpressReleaseCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.ExpressReleaseCertificateMutation, Types.ExpressReleaseCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExpressReleaseCertificateMutation, Types.ExpressReleaseCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExpressReleaseCertificateMutation, Types.ExpressReleaseCertificateMutationVariables>(ExpressReleaseCertificateDocument, options);
}
export type ExpressReleaseCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExpressReleaseCertificateMutation, Types.ExpressReleaseCertificateMutationVariables>;
export const RevokeCertificateDocument = gql`
    mutation RevokeCertificate($id: ID!, $reason: String!) {
  revokeCertificate(id: $id, reason: $reason) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useRevokeCertificateMutation__
 *
 * To run a mutation, you first call `useRevokeCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeCertificateMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRevokeCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeCertificateMutation, Types.RevokeCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeCertificateMutation, Types.RevokeCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeCertificateMutation, Types.RevokeCertificateMutationVariables>(RevokeCertificateDocument, options);
}
export type RevokeCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeCertificateMutation, Types.RevokeCertificateMutationVariables>;
export const ReissueCertificateDocument = gql`
    mutation ReissueCertificate($input: ReissueCertificateInput!) {
  reissueCertificate(input: $input) {
    ...GeneratedCertificateFields
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useReissueCertificateMutation__
 *
 * To run a mutation, you first call `useReissueCertificateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReissueCertificateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReissueCertificateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReissueCertificateMutation(options: VueApolloComposable.UseMutationOptions<Types.ReissueCertificateMutation, Types.ReissueCertificateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReissueCertificateMutation, Types.ReissueCertificateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReissueCertificateMutation, Types.ReissueCertificateMutationVariables>(ReissueCertificateDocument, options);
}
export type ReissueCertificateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReissueCertificateMutation, Types.ReissueCertificateMutationVariables>;
export const RetryFailedBatchCertificatesDocument = gql`
    mutation RetryFailedBatchCertificates($batch_job_id: ID!) {
  retryFailedBatchCertificates(batch_job_id: $batch_job_id) {
    ...CertificateBatchJobFields
  }
}
    ${CertificateBatchJobFieldsFragmentDoc}`;

/**
 * __useRetryFailedBatchCertificatesMutation__
 *
 * To run a mutation, you first call `useRetryFailedBatchCertificatesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedBatchCertificatesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetryFailedBatchCertificatesMutation({
 *   variables: {
 *     batch_job_id: // value for 'batch_job_id'
 *   },
 * });
 */
export function useRetryFailedBatchCertificatesMutation(options: VueApolloComposable.UseMutationOptions<Types.RetryFailedBatchCertificatesMutation, Types.RetryFailedBatchCertificatesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RetryFailedBatchCertificatesMutation, Types.RetryFailedBatchCertificatesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RetryFailedBatchCertificatesMutation, Types.RetryFailedBatchCertificatesMutationVariables>(RetryFailedBatchCertificatesDocument, options);
}
export type RetryFailedBatchCertificatesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RetryFailedBatchCertificatesMutation, Types.RetryFailedBatchCertificatesMutationVariables>;
export const GetCertificateTemplatesDocument = gql`
    query GetCertificateTemplates {
  certificateTemplates {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useGetCertificateTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateTemplatesQuery();
 */
export function useGetCertificateTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>(GetCertificateTemplatesDocument, {}, options);
}
export function useGetCertificateTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>(GetCertificateTemplatesDocument, {}, options);
}
export type GetCertificateTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateTemplatesQuery, Types.GetCertificateTemplatesQueryVariables>;
export const GetCertificateTemplateDocument = gql`
    query GetCertificateTemplate($id: ID!) {
  certificateTemplate(id: $id) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useGetCertificateTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCertificateTemplateQuery(variables: Types.GetCertificateTemplateQueryVariables | VueCompositionApi.Ref<Types.GetCertificateTemplateQueryVariables> | ReactiveFunction<Types.GetCertificateTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>(GetCertificateTemplateDocument, variables, options);
}
export function useGetCertificateTemplateLazyQuery(variables?: Types.GetCertificateTemplateQueryVariables | VueCompositionApi.Ref<Types.GetCertificateTemplateQueryVariables> | ReactiveFunction<Types.GetCertificateTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>(GetCertificateTemplateDocument, variables, options);
}
export type GetCertificateTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateTemplateQuery, Types.GetCertificateTemplateQueryVariables>;
export const GetGraduationRecordsDocument = gql`
    query GetGraduationRecords($programme_id: ID, $academic_calendar_id: ID, $graduation_status: GraduationStatusEnum, $search: String, $level: String, $created_from: Date, $created_to: Date, $first: Int = 15, $page: Int = 1) {
  graduationRecords(
    filter: {programme_id: $programme_id, academic_calendar_id: $academic_calendar_id, graduation_status: $graduation_status, search: $search, level: $level, created_from: $created_from, created_to: $created_to}
    first: $first
    page: $page
  ) {
    data {
      ...GraduationRecordFields
    }
    paginatorInfo {
      currentPage
      perPage
      total
      lastPage
      hasMorePages
    }
  }
}
    ${GraduationRecordFieldsFragmentDoc}`;

/**
 * __useGetGraduationRecordsQuery__
 *
 * To run a query within a Vue component, call `useGetGraduationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationRecordsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGraduationRecordsQuery({
 *   programme_id: // value for 'programme_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   graduation_status: // value for 'graduation_status'
 *   search: // value for 'search'
 *   level: // value for 'level'
 *   created_from: // value for 'created_from'
 *   created_to: // value for 'created_to'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetGraduationRecordsQuery(variables: Types.GetGraduationRecordsQueryVariables | VueCompositionApi.Ref<Types.GetGraduationRecordsQueryVariables> | ReactiveFunction<Types.GetGraduationRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>(GetGraduationRecordsDocument, variables, options);
}
export function useGetGraduationRecordsLazyQuery(variables: Types.GetGraduationRecordsQueryVariables | VueCompositionApi.Ref<Types.GetGraduationRecordsQueryVariables> | ReactiveFunction<Types.GetGraduationRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>(GetGraduationRecordsDocument, variables, options);
}
export type GetGraduationRecordsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGraduationRecordsQuery, Types.GetGraduationRecordsQueryVariables>;
export const GetGraduationRecordDocument = gql`
    query GetGraduationRecord($id: ID!) {
  graduationRecord(id: $id) {
    ...GraduationRecordFields
  }
}
    ${GraduationRecordFieldsFragmentDoc}`;

/**
 * __useGetGraduationRecordQuery__
 *
 * To run a query within a Vue component, call `useGetGraduationRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationRecordQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGraduationRecordQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGraduationRecordQuery(variables: Types.GetGraduationRecordQueryVariables | VueCompositionApi.Ref<Types.GetGraduationRecordQueryVariables> | ReactiveFunction<Types.GetGraduationRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>(GetGraduationRecordDocument, variables, options);
}
export function useGetGraduationRecordLazyQuery(variables?: Types.GetGraduationRecordQueryVariables | VueCompositionApi.Ref<Types.GetGraduationRecordQueryVariables> | ReactiveFunction<Types.GetGraduationRecordQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>(GetGraduationRecordDocument, variables, options);
}
export type GetGraduationRecordQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGraduationRecordQuery, Types.GetGraduationRecordQueryVariables>;
export const GetGeneratedCertificatesDocument = gql`
    query GetGeneratedCertificates($status: CertificateStatusEnum, $programme_id: ID, $search: String, $first: Int = 15, $page: Int = 1) {
  generatedCertificates(
    filter: {status: $status, programme_id: $programme_id, search: $search}
    first: $first
    page: $page
  ) {
    data {
      ...GeneratedCertificateFields
    }
    paginatorInfo {
      currentPage
      perPage
      total
      lastPage
      hasMorePages
    }
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}`;

/**
 * __useGetGeneratedCertificatesQuery__
 *
 * To run a query within a Vue component, call `useGetGeneratedCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedCertificatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGeneratedCertificatesQuery({
 *   status: // value for 'status'
 *   programme_id: // value for 'programme_id'
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetGeneratedCertificatesQuery(variables: Types.GetGeneratedCertificatesQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedCertificatesQueryVariables> | ReactiveFunction<Types.GetGeneratedCertificatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>(GetGeneratedCertificatesDocument, variables, options);
}
export function useGetGeneratedCertificatesLazyQuery(variables: Types.GetGeneratedCertificatesQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedCertificatesQueryVariables> | ReactiveFunction<Types.GetGeneratedCertificatesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>(GetGeneratedCertificatesDocument, variables, options);
}
export type GetGeneratedCertificatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGeneratedCertificatesQuery, Types.GetGeneratedCertificatesQueryVariables>;
export const GetGeneratedCertificateDocument = gql`
    query GetGeneratedCertificate($id: ID!) {
  generatedCertificate(id: $id) {
    ...GeneratedCertificateFields
    auditLogs {
      ...CertificateAuditLogFields
    }
  }
}
    ${GeneratedCertificateFieldsFragmentDoc}
${CertificateAuditLogFieldsFragmentDoc}`;

/**
 * __useGetGeneratedCertificateQuery__
 *
 * To run a query within a Vue component, call `useGetGeneratedCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedCertificateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGeneratedCertificateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGeneratedCertificateQuery(variables: Types.GetGeneratedCertificateQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedCertificateQueryVariables> | ReactiveFunction<Types.GetGeneratedCertificateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>(GetGeneratedCertificateDocument, variables, options);
}
export function useGetGeneratedCertificateLazyQuery(variables?: Types.GetGeneratedCertificateQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedCertificateQueryVariables> | ReactiveFunction<Types.GetGeneratedCertificateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>(GetGeneratedCertificateDocument, variables, options);
}
export type GetGeneratedCertificateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGeneratedCertificateQuery, Types.GetGeneratedCertificateQueryVariables>;
export const GetCertificateBatchJobsDocument = gql`
    query GetCertificateBatchJobs($first: Int = 15, $page: Int = 1) {
  certificateBatchJobs(first: $first, page: $page) {
    data {
      ...CertificateBatchJobFields
    }
    paginatorInfo {
      currentPage
      perPage
      total
      lastPage
      hasMorePages
    }
  }
}
    ${CertificateBatchJobFieldsFragmentDoc}`;

/**
 * __useGetCertificateBatchJobsQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateBatchJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateBatchJobsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateBatchJobsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetCertificateBatchJobsQuery(variables: Types.GetCertificateBatchJobsQueryVariables | VueCompositionApi.Ref<Types.GetCertificateBatchJobsQueryVariables> | ReactiveFunction<Types.GetCertificateBatchJobsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>(GetCertificateBatchJobsDocument, variables, options);
}
export function useGetCertificateBatchJobsLazyQuery(variables: Types.GetCertificateBatchJobsQueryVariables | VueCompositionApi.Ref<Types.GetCertificateBatchJobsQueryVariables> | ReactiveFunction<Types.GetCertificateBatchJobsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>(GetCertificateBatchJobsDocument, variables, options);
}
export type GetCertificateBatchJobsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateBatchJobsQuery, Types.GetCertificateBatchJobsQueryVariables>;
export const GetCertificateBatchJobDocument = gql`
    query GetCertificateBatchJob($id: ID!) {
  certificateBatchJob(id: $id) {
    ...CertificateBatchJobFields
  }
}
    ${CertificateBatchJobFieldsFragmentDoc}`;

/**
 * __useGetCertificateBatchJobQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateBatchJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateBatchJobQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateBatchJobQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetCertificateBatchJobQuery(variables: Types.GetCertificateBatchJobQueryVariables | VueCompositionApi.Ref<Types.GetCertificateBatchJobQueryVariables> | ReactiveFunction<Types.GetCertificateBatchJobQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>(GetCertificateBatchJobDocument, variables, options);
}
export function useGetCertificateBatchJobLazyQuery(variables?: Types.GetCertificateBatchJobQueryVariables | VueCompositionApi.Ref<Types.GetCertificateBatchJobQueryVariables> | ReactiveFunction<Types.GetCertificateBatchJobQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>(GetCertificateBatchJobDocument, variables, options);
}
export type GetCertificateBatchJobQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateBatchJobQuery, Types.GetCertificateBatchJobQueryVariables>;
export const GetCertificateFieldTypesDocument = gql`
    query GetCertificateFieldTypes {
  certificateFieldTypes {
    value
    label
    description
    is_dynamic
  }
}
    `;

/**
 * __useGetCertificateFieldTypesQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateFieldTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateFieldTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateFieldTypesQuery();
 */
export function useGetCertificateFieldTypesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>(GetCertificateFieldTypesDocument, {}, options);
}
export function useGetCertificateFieldTypesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>(GetCertificateFieldTypesDocument, {}, options);
}
export type GetCertificateFieldTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateFieldTypesQuery, Types.GetCertificateFieldTypesQueryVariables>;
export const GetCertificateAuditLogsDocument = gql`
    query GetCertificateAuditLogs($certificate_id: ID!) {
  certificateAuditLogs(filter: {certificate_id: $certificate_id}) {
    ...CertificateAuditLogFields
  }
}
    ${CertificateAuditLogFieldsFragmentDoc}`;

/**
 * __useGetCertificateAuditLogsQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateAuditLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateAuditLogsQuery({
 *   certificate_id: // value for 'certificate_id'
 * });
 */
export function useGetCertificateAuditLogsQuery(variables: Types.GetCertificateAuditLogsQueryVariables | VueCompositionApi.Ref<Types.GetCertificateAuditLogsQueryVariables> | ReactiveFunction<Types.GetCertificateAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>(GetCertificateAuditLogsDocument, variables, options);
}
export function useGetCertificateAuditLogsLazyQuery(variables?: Types.GetCertificateAuditLogsQueryVariables | VueCompositionApi.Ref<Types.GetCertificateAuditLogsQueryVariables> | ReactiveFunction<Types.GetCertificateAuditLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>(GetCertificateAuditLogsDocument, variables, options);
}
export type GetCertificateAuditLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateAuditLogsQuery, Types.GetCertificateAuditLogsQueryVariables>;
export const GetCertificateDesignsDocument = gql`
    query GetCertificateDesigns {
  certificateDesigns {
    value
    label
    description
  }
}
    `;

/**
 * __useGetCertificateDesignsQuery__
 *
 * To run a query within a Vue component, call `useGetCertificateDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateDesignsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCertificateDesignsQuery();
 */
export function useGetCertificateDesignsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>(GetCertificateDesignsDocument, {}, options);
}
export function useGetCertificateDesignsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>(GetCertificateDesignsDocument, {}, options);
}
export type GetCertificateDesignsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetCertificateDesignsQuery, Types.GetCertificateDesignsQueryVariables>;
export const GetGraduationCriteriaPresetsDocument = gql`
    query GetGraduationCriteriaPresets {
  graduationCriteriaPresets {
    key
    label
    description
    criteria
  }
}
    `;

/**
 * __useGetGraduationCriteriaPresetsQuery__
 *
 * To run a query within a Vue component, call `useGetGraduationCriteriaPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraduationCriteriaPresetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGraduationCriteriaPresetsQuery();
 */
export function useGetGraduationCriteriaPresetsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>(GetGraduationCriteriaPresetsDocument, {}, options);
}
export function useGetGraduationCriteriaPresetsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>(GetGraduationCriteriaPresetsDocument, {}, options);
}
export type GetGraduationCriteriaPresetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGraduationCriteriaPresetsQuery, Types.GetGraduationCriteriaPresetsQueryVariables>;
export const ExportGraduationRecordsDocument = gql`
    query ExportGraduationRecords($graduation_status: GraduationStatusEnum, $programme_id: ID, $academic_calendar_id: ID, $search: String, $level: String, $created_from: Date, $created_to: Date) {
  exportGraduationRecords(
    graduation_status: $graduation_status
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
    search: $search
    level: $level
    created_from: $created_from
    created_to: $created_to
  ) {
    id
    type
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useExportGraduationRecordsQuery__
 *
 * To run a query within a Vue component, call `useExportGraduationRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportGraduationRecordsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportGraduationRecordsQuery({
 *   graduation_status: // value for 'graduation_status'
 *   programme_id: // value for 'programme_id'
 *   academic_calendar_id: // value for 'academic_calendar_id'
 *   search: // value for 'search'
 *   level: // value for 'level'
 *   created_from: // value for 'created_from'
 *   created_to: // value for 'created_to'
 * });
 */
export function useExportGraduationRecordsQuery(variables: Types.ExportGraduationRecordsQueryVariables | VueCompositionApi.Ref<Types.ExportGraduationRecordsQueryVariables> | ReactiveFunction<Types.ExportGraduationRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>(ExportGraduationRecordsDocument, variables, options);
}
export function useExportGraduationRecordsLazyQuery(variables: Types.ExportGraduationRecordsQueryVariables | VueCompositionApi.Ref<Types.ExportGraduationRecordsQueryVariables> | ReactiveFunction<Types.ExportGraduationRecordsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>(ExportGraduationRecordsDocument, variables, options);
}
export type ExportGraduationRecordsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ExportGraduationRecordsQuery, Types.ExportGraduationRecordsQueryVariables>;
export const VerifyCertificateDocument = gql`
    query VerifyCertificate($verification_code: String!) {
  verifyCertificate(verification_code: $verification_code) {
    is_valid
    certificate_number
    student_name
    programme_name
    degree_classification
    graduation_date
    school_name
    status
    message
  }
}
    `;

/**
 * __useVerifyCertificateQuery__
 *
 * To run a query within a Vue component, call `useVerifyCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyCertificateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVerifyCertificateQuery({
 *   verification_code: // value for 'verification_code'
 * });
 */
export function useVerifyCertificateQuery(variables: Types.VerifyCertificateQueryVariables | VueCompositionApi.Ref<Types.VerifyCertificateQueryVariables> | ReactiveFunction<Types.VerifyCertificateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>(VerifyCertificateDocument, variables, options);
}
export function useVerifyCertificateLazyQuery(variables?: Types.VerifyCertificateQueryVariables | VueCompositionApi.Ref<Types.VerifyCertificateQueryVariables> | ReactiveFunction<Types.VerifyCertificateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>(VerifyCertificateDocument, variables, options);
}
export type VerifyCertificateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.VerifyCertificateQuery, Types.VerifyCertificateQueryVariables>;
export const CustomFieldDefinitionsDocument = gql`
    query CustomFieldDefinitions($entity: CustomFieldEntity!, $include_inactive: Boolean) {
  customFields(entity: $entity, include_inactive: $include_inactive) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useCustomFieldDefinitionsQuery__
 *
 * To run a query within a Vue component, call `useCustomFieldDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldDefinitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCustomFieldDefinitionsQuery({
 *   entity: // value for 'entity'
 *   include_inactive: // value for 'include_inactive'
 * });
 */
export function useCustomFieldDefinitionsQuery(variables: Types.CustomFieldDefinitionsQueryVariables | VueCompositionApi.Ref<Types.CustomFieldDefinitionsQueryVariables> | ReactiveFunction<Types.CustomFieldDefinitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>(CustomFieldDefinitionsDocument, variables, options);
}
export function useCustomFieldDefinitionsLazyQuery(variables?: Types.CustomFieldDefinitionsQueryVariables | VueCompositionApi.Ref<Types.CustomFieldDefinitionsQueryVariables> | ReactiveFunction<Types.CustomFieldDefinitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>(CustomFieldDefinitionsDocument, variables, options);
}
export type CustomFieldDefinitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CustomFieldDefinitionsQuery, Types.CustomFieldDefinitionsQueryVariables>;
export const CreateCustomFieldDocument = gql`
    mutation CreateCustomField($input: CreateCustomFieldInput!) {
  createCustomField(input: $input) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useCreateCustomFieldMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCustomFieldMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomFieldMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCustomFieldMutation, Types.CreateCustomFieldMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCustomFieldMutation, Types.CreateCustomFieldMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCustomFieldMutation, Types.CreateCustomFieldMutationVariables>(CreateCustomFieldDocument, options);
}
export type CreateCustomFieldMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCustomFieldMutation, Types.CreateCustomFieldMutationVariables>;
export const UpdateCustomFieldDocument = gql`
    mutation UpdateCustomField($id: ID!, $input: UpdateCustomFieldInput!) {
  updateCustomField(id: $id, input: $input) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useUpdateCustomFieldMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCustomFieldMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFieldMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCustomFieldMutation, Types.UpdateCustomFieldMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCustomFieldMutation, Types.UpdateCustomFieldMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCustomFieldMutation, Types.UpdateCustomFieldMutationVariables>(UpdateCustomFieldDocument, options);
}
export type UpdateCustomFieldMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCustomFieldMutation, Types.UpdateCustomFieldMutationVariables>;
export const DeleteCustomFieldDocument = gql`
    mutation DeleteCustomField($id: ID!) {
  deleteCustomField(id: $id)
}
    `;

/**
 * __useDeleteCustomFieldMutation__
 *
 * To run a mutation, you first call `useDeleteCustomFieldMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomFieldMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCustomFieldMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomFieldMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCustomFieldMutation, Types.DeleteCustomFieldMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCustomFieldMutation, Types.DeleteCustomFieldMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCustomFieldMutation, Types.DeleteCustomFieldMutationVariables>(DeleteCustomFieldDocument, options);
}
export type DeleteCustomFieldMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCustomFieldMutation, Types.DeleteCustomFieldMutationVariables>;
export const ReorderCustomFieldsDocument = gql`
    mutation ReorderCustomFields($entity: CustomFieldEntity!, $ids: [ID!]!) {
  reorderCustomFields(entity: $entity, ids: $ids) {
    id
    sequence
  }
}
    `;

/**
 * __useReorderCustomFieldsMutation__
 *
 * To run a mutation, you first call `useReorderCustomFieldsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderCustomFieldsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderCustomFieldsMutation({
 *   variables: {
 *     entity: // value for 'entity'
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useReorderCustomFieldsMutation(options: VueApolloComposable.UseMutationOptions<Types.ReorderCustomFieldsMutation, Types.ReorderCustomFieldsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReorderCustomFieldsMutation, Types.ReorderCustomFieldsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReorderCustomFieldsMutation, Types.ReorderCustomFieldsMutationVariables>(ReorderCustomFieldsDocument, options);
}
export type ReorderCustomFieldsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReorderCustomFieldsMutation, Types.ReorderCustomFieldsMutationVariables>;
export const CustomFieldTemplateListDocument = gql`
    query CustomFieldTemplateList($entity: CustomFieldEntity!) {
  customFieldTemplates(entity: $entity) {
    key
    name
    description
    entity
    applied
    fields {
      key
      label
      type
      options_source
      depends_on
      description
      exists
    }
  }
}
    `;

/**
 * __useCustomFieldTemplateListQuery__
 *
 * To run a query within a Vue component, call `useCustomFieldTemplateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldTemplateListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCustomFieldTemplateListQuery({
 *   entity: // value for 'entity'
 * });
 */
export function useCustomFieldTemplateListQuery(variables: Types.CustomFieldTemplateListQueryVariables | VueCompositionApi.Ref<Types.CustomFieldTemplateListQueryVariables> | ReactiveFunction<Types.CustomFieldTemplateListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>(CustomFieldTemplateListDocument, variables, options);
}
export function useCustomFieldTemplateListLazyQuery(variables?: Types.CustomFieldTemplateListQueryVariables | VueCompositionApi.Ref<Types.CustomFieldTemplateListQueryVariables> | ReactiveFunction<Types.CustomFieldTemplateListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>(CustomFieldTemplateListDocument, variables, options);
}
export type CustomFieldTemplateListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CustomFieldTemplateListQuery, Types.CustomFieldTemplateListQueryVariables>;
export const ApplyCustomFieldTemplateDocument = gql`
    mutation ApplyCustomFieldTemplate($entity: CustomFieldEntity!, $template: String!) {
  applyCustomFieldTemplate(entity: $entity, template: $template) {
    ...CustomFieldFields
  }
}
    ${CustomFieldFieldsFragmentDoc}`;

/**
 * __useApplyCustomFieldTemplateMutation__
 *
 * To run a mutation, you first call `useApplyCustomFieldTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApplyCustomFieldTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApplyCustomFieldTemplateMutation({
 *   variables: {
 *     entity: // value for 'entity'
 *     template: // value for 'template'
 *   },
 * });
 */
export function useApplyCustomFieldTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.ApplyCustomFieldTemplateMutation, Types.ApplyCustomFieldTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApplyCustomFieldTemplateMutation, Types.ApplyCustomFieldTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApplyCustomFieldTemplateMutation, Types.ApplyCustomFieldTemplateMutationVariables>(ApplyCustomFieldTemplateDocument, options);
}
export type ApplyCustomFieldTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApplyCustomFieldTemplateMutation, Types.ApplyCustomFieldTemplateMutationVariables>;
export const StudentCustomFieldValuesDocument = gql`
    query StudentCustomFieldValues($id: ID!) {
  student(id: $id) {
    id
    customFieldValues {
      ...CustomFieldValueFields
    }
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useStudentCustomFieldValuesQuery__
 *
 * To run a query within a Vue component, call `useStudentCustomFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentCustomFieldValuesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentCustomFieldValuesQuery({
 *   id: // value for 'id'
 * });
 */
export function useStudentCustomFieldValuesQuery(variables: Types.StudentCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.StudentCustomFieldValuesQueryVariables> | ReactiveFunction<Types.StudentCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>(StudentCustomFieldValuesDocument, variables, options);
}
export function useStudentCustomFieldValuesLazyQuery(variables?: Types.StudentCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.StudentCustomFieldValuesQueryVariables> | ReactiveFunction<Types.StudentCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>(StudentCustomFieldValuesDocument, variables, options);
}
export type StudentCustomFieldValuesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentCustomFieldValuesQuery, Types.StudentCustomFieldValuesQueryVariables>;
export const UpdateStudentCustomFieldValuesDocument = gql`
    mutation UpdateStudentCustomFieldValues($student_id: ID!, $values: [CustomFieldValueInput!]!) {
  updateStudentCustomFieldValues(student_id: $student_id, values: $values) {
    ...CustomFieldValueFields
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useUpdateStudentCustomFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCustomFieldValuesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCustomFieldValuesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentCustomFieldValuesMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateStudentCustomFieldValuesMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentCustomFieldValuesMutation, Types.UpdateStudentCustomFieldValuesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentCustomFieldValuesMutation, Types.UpdateStudentCustomFieldValuesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentCustomFieldValuesMutation, Types.UpdateStudentCustomFieldValuesMutationVariables>(UpdateStudentCustomFieldValuesDocument, options);
}
export type UpdateStudentCustomFieldValuesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentCustomFieldValuesMutation, Types.UpdateStudentCustomFieldValuesMutationVariables>;
export const StaffCustomFieldValuesDocument = gql`
    query StaffCustomFieldValues($id: ID!) {
  staff(id: $id) {
    id
    customFieldValues {
      ...CustomFieldValueFields
    }
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useStaffCustomFieldValuesQuery__
 *
 * To run a query within a Vue component, call `useStaffCustomFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffCustomFieldValuesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStaffCustomFieldValuesQuery({
 *   id: // value for 'id'
 * });
 */
export function useStaffCustomFieldValuesQuery(variables: Types.StaffCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.StaffCustomFieldValuesQueryVariables> | ReactiveFunction<Types.StaffCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>(StaffCustomFieldValuesDocument, variables, options);
}
export function useStaffCustomFieldValuesLazyQuery(variables?: Types.StaffCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.StaffCustomFieldValuesQueryVariables> | ReactiveFunction<Types.StaffCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>(StaffCustomFieldValuesDocument, variables, options);
}
export type StaffCustomFieldValuesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StaffCustomFieldValuesQuery, Types.StaffCustomFieldValuesQueryVariables>;
export const GuardianCustomFieldValuesDocument = gql`
    query GuardianCustomFieldValues($id: ID!) {
  guardian(id: $id) {
    id
    customFieldValues {
      ...CustomFieldValueFields
    }
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useGuardianCustomFieldValuesQuery__
 *
 * To run a query within a Vue component, call `useGuardianCustomFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianCustomFieldValuesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianCustomFieldValuesQuery({
 *   id: // value for 'id'
 * });
 */
export function useGuardianCustomFieldValuesQuery(variables: Types.GuardianCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.GuardianCustomFieldValuesQueryVariables> | ReactiveFunction<Types.GuardianCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>(GuardianCustomFieldValuesDocument, variables, options);
}
export function useGuardianCustomFieldValuesLazyQuery(variables?: Types.GuardianCustomFieldValuesQueryVariables | VueCompositionApi.Ref<Types.GuardianCustomFieldValuesQueryVariables> | ReactiveFunction<Types.GuardianCustomFieldValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>(GuardianCustomFieldValuesDocument, variables, options);
}
export type GuardianCustomFieldValuesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianCustomFieldValuesQuery, Types.GuardianCustomFieldValuesQueryVariables>;
export const UpdateStaffCustomFieldValuesDocument = gql`
    mutation UpdateStaffCustomFieldValues($staff_id: ID!, $values: [CustomFieldValueInput!]!) {
  updateStaffCustomFieldValues(staff_id: $staff_id, values: $values) {
    ...CustomFieldValueFields
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useUpdateStaffCustomFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateStaffCustomFieldValuesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffCustomFieldValuesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStaffCustomFieldValuesMutation({
 *   variables: {
 *     staff_id: // value for 'staff_id'
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateStaffCustomFieldValuesMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStaffCustomFieldValuesMutation, Types.UpdateStaffCustomFieldValuesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStaffCustomFieldValuesMutation, Types.UpdateStaffCustomFieldValuesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStaffCustomFieldValuesMutation, Types.UpdateStaffCustomFieldValuesMutationVariables>(UpdateStaffCustomFieldValuesDocument, options);
}
export type UpdateStaffCustomFieldValuesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStaffCustomFieldValuesMutation, Types.UpdateStaffCustomFieldValuesMutationVariables>;
export const UpdateGuardianCustomFieldValuesDocument = gql`
    mutation UpdateGuardianCustomFieldValues($guardian_id: ID!, $values: [CustomFieldValueInput!]!) {
  updateGuardianCustomFieldValues(guardian_id: $guardian_id, values: $values) {
    ...CustomFieldValueFields
  }
}
    ${CustomFieldValueFieldsFragmentDoc}`;

/**
 * __useUpdateGuardianCustomFieldValuesMutation__
 *
 * To run a mutation, you first call `useUpdateGuardianCustomFieldValuesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuardianCustomFieldValuesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGuardianCustomFieldValuesMutation({
 *   variables: {
 *     guardian_id: // value for 'guardian_id'
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateGuardianCustomFieldValuesMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateGuardianCustomFieldValuesMutation, Types.UpdateGuardianCustomFieldValuesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateGuardianCustomFieldValuesMutation, Types.UpdateGuardianCustomFieldValuesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateGuardianCustomFieldValuesMutation, Types.UpdateGuardianCustomFieldValuesMutationVariables>(UpdateGuardianCustomFieldValuesDocument, options);
}
export type UpdateGuardianCustomFieldValuesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateGuardianCustomFieldValuesMutation, Types.UpdateGuardianCustomFieldValuesMutationVariables>;
export const AcceptGuardianInvitationDocument = gql`
    mutation AcceptGuardianInvitation($token: String!, $password: String!, $name: String) {
  acceptGuardianInvitation(token: $token, password: $password, name: $name) {
    token
    status
    message
    user {
      ... on User {
        id
        name
        email
      }
    }
    schools {
      id
      name
      school_type
      logo
    }
    school_count
    loginSchools {
      school {
        id
        name
        school_type
        logo
      }
      portals
    }
  }
}
    `;

/**
 * __useAcceptGuardianInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptGuardianInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptGuardianInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptGuardianInvitationMutation({
 *   variables: {
 *     token: // value for 'token'
 *     password: // value for 'password'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useAcceptGuardianInvitationMutation(options: VueApolloComposable.UseMutationOptions<Types.AcceptGuardianInvitationMutation, Types.AcceptGuardianInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AcceptGuardianInvitationMutation, Types.AcceptGuardianInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AcceptGuardianInvitationMutation, Types.AcceptGuardianInvitationMutationVariables>(AcceptGuardianInvitationDocument, options);
}
export type AcceptGuardianInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AcceptGuardianInvitationMutation, Types.AcceptGuardianInvitationMutationVariables>;
export const RegisterAsGuardianDocument = gql`
    mutation RegisterAsGuardian($input: RegisterGuardianInput!) {
  registerAsGuardian(input: $input) {
    token
    status
    message
    user {
      ... on User {
        id
        name
        email
      }
    }
    schools {
      id
      name
      school_type
      logo
    }
    school_count
    loginSchools {
      school {
        id
        name
        school_type
        logo
      }
      portals
    }
  }
}
    `;

/**
 * __useRegisterAsGuardianMutation__
 *
 * To run a mutation, you first call `useRegisterAsGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterAsGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterAsGuardianMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRegisterAsGuardianMutation(options: VueApolloComposable.UseMutationOptions<Types.RegisterAsGuardianMutation, Types.RegisterAsGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RegisterAsGuardianMutation, Types.RegisterAsGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RegisterAsGuardianMutation, Types.RegisterAsGuardianMutationVariables>(RegisterAsGuardianDocument, options);
}
export type RegisterAsGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RegisterAsGuardianMutation, Types.RegisterAsGuardianMutationVariables>;
export const AddChildByLinkingCodeDocument = gql`
    mutation AddChildByLinkingCode($linkingCode: String!, $relationshipType: GuardianRelationshipType!) {
  addChildByLinkingCode(
    linkingCode: $linkingCode
    relationshipType: $relationshipType
  ) {
    id
    student {
      id
      first_name
      surname
    }
    relationshipType
  }
}
    `;

/**
 * __useAddChildByLinkingCodeMutation__
 *
 * To run a mutation, you first call `useAddChildByLinkingCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddChildByLinkingCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddChildByLinkingCodeMutation({
 *   variables: {
 *     linkingCode: // value for 'linkingCode'
 *     relationshipType: // value for 'relationshipType'
 *   },
 * });
 */
export function useAddChildByLinkingCodeMutation(options: VueApolloComposable.UseMutationOptions<Types.AddChildByLinkingCodeMutation, Types.AddChildByLinkingCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddChildByLinkingCodeMutation, Types.AddChildByLinkingCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddChildByLinkingCodeMutation, Types.AddChildByLinkingCodeMutationVariables>(AddChildByLinkingCodeDocument, options);
}
export type AddChildByLinkingCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddChildByLinkingCodeMutation, Types.AddChildByLinkingCodeMutationVariables>;
export const UpdateGuardianNotificationPreferencesDocument = gql`
    mutation UpdateGuardianNotificationPreferences($guardianStudentId: ID!, $receivesFeeNotifications: Boolean, $receivesAttendanceNotifications: Boolean, $receivesResultNotifications: Boolean) {
  updateGuardianNotificationPreferences(
    guardianStudentId: $guardianStudentId
    receivesFeeNotifications: $receivesFeeNotifications
    receivesAttendanceNotifications: $receivesAttendanceNotifications
    receivesResultNotifications: $receivesResultNotifications
  ) {
    id
    receivesFeeNotifications
    receivesAttendanceNotifications
    receivesResultNotifications
  }
}
    `;

/**
 * __useUpdateGuardianNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateGuardianNotificationPreferencesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuardianNotificationPreferencesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGuardianNotificationPreferencesMutation({
 *   variables: {
 *     guardianStudentId: // value for 'guardianStudentId'
 *     receivesFeeNotifications: // value for 'receivesFeeNotifications'
 *     receivesAttendanceNotifications: // value for 'receivesAttendanceNotifications'
 *     receivesResultNotifications: // value for 'receivesResultNotifications'
 *   },
 * });
 */
export function useUpdateGuardianNotificationPreferencesMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateGuardianNotificationPreferencesMutation, Types.UpdateGuardianNotificationPreferencesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateGuardianNotificationPreferencesMutation, Types.UpdateGuardianNotificationPreferencesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateGuardianNotificationPreferencesMutation, Types.UpdateGuardianNotificationPreferencesMutationVariables>(UpdateGuardianNotificationPreferencesDocument, options);
}
export type UpdateGuardianNotificationPreferencesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateGuardianNotificationPreferencesMutation, Types.UpdateGuardianNotificationPreferencesMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    id
    name
    email
  }
}
    `;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserProfileMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateUserProfileMutation, Types.UpdateUserProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateUserProfileMutation, Types.UpdateUserProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateUserProfileMutation, Types.UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
}
export type UpdateUserProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateUserProfileMutation, Types.UpdateUserProfileMutationVariables>;
export const GuardianChildrenDocument = gql`
    query GuardianChildren {
  guardianChildren {
    student {
      id
      first_name
      surname
      matric_no
      photo
    }
    link {
      id
      receivesFeeNotifications
      receivesAttendanceNotifications
      receivesResultNotifications
    }
    relationshipType
    school {
      id
      name
      school_type
      logo
    }
    currentClassroom
    currentProgramme
    currentLevel
    attendancePercentage
    outstandingBalance
  }
}
    `;

/**
 * __useGuardianChildrenQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildrenQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildrenQuery();
 */
export function useGuardianChildrenQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>(GuardianChildrenDocument, {}, options);
}
export function useGuardianChildrenLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>(GuardianChildrenDocument, {}, options);
}
export type GuardianChildrenQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildrenQuery, Types.GuardianChildrenQueryVariables>;
export const GuardianChildResultsDocument = gql`
    query GuardianChildResults($studentId: ID!, $academicCalendarId: ID!) {
  guardianChildResults(
    studentId: $studentId
    academicCalendarId: $academicCalendarId
  ) {
    student {
      id
      first_name
      surname
      matric_no
      photo
    }
    classroom {
      id
      name
    }
    academic_calendar {
      id
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
    template {
      id
      name
    }
    headers {
      key
      label
      type
    }
    data
    summary
    status
    result_mode
    result_feedbacks {
      id
      comment
      author {
        id
        name
      }
    }
    programme {
      id
      program_name
    }
  }
}
    `;

/**
 * __useGuardianChildResultsQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildResultsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildResultsQuery({
 *   studentId: // value for 'studentId'
 *   academicCalendarId: // value for 'academicCalendarId'
 * });
 */
export function useGuardianChildResultsQuery(variables: Types.GuardianChildResultsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildResultsQueryVariables> | ReactiveFunction<Types.GuardianChildResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>(GuardianChildResultsDocument, variables, options);
}
export function useGuardianChildResultsLazyQuery(variables?: Types.GuardianChildResultsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildResultsQueryVariables> | ReactiveFunction<Types.GuardianChildResultsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>(GuardianChildResultsDocument, variables, options);
}
export type GuardianChildResultsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildResultsQuery, Types.GuardianChildResultsQueryVariables>;
export const GuardianChildCalendarsDocument = gql`
    query GuardianChildCalendars($studentId: ID!) {
  guardianChildCalendars(studentId: $studentId) {
    id
    name
    is_active
    session {
      id
      name
    }
  }
}
    `;

/**
 * __useGuardianChildCalendarsQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildCalendarsQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardianChildCalendarsQuery(variables: Types.GuardianChildCalendarsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildCalendarsQueryVariables> | ReactiveFunction<Types.GuardianChildCalendarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>(GuardianChildCalendarsDocument, variables, options);
}
export function useGuardianChildCalendarsLazyQuery(variables?: Types.GuardianChildCalendarsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildCalendarsQueryVariables> | ReactiveFunction<Types.GuardianChildCalendarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>(GuardianChildCalendarsDocument, variables, options);
}
export type GuardianChildCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildCalendarsQuery, Types.GuardianChildCalendarsQueryVariables>;
export const GuardianChildAttendanceDocument = gql`
    query GuardianChildAttendance($studentId: ID!, $academicCalendarId: ID) {
  guardianChildAttendance(
    studentId: $studentId
    academicCalendarId: $academicCalendarId
  ) {
    summary {
      present
      absent
      late
      excused
      total
      percentage
    }
    records {
      id
      date
      status
      remark
    }
  }
}
    `;

/**
 * __useGuardianChildAttendanceQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildAttendanceQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildAttendanceQuery({
 *   studentId: // value for 'studentId'
 *   academicCalendarId: // value for 'academicCalendarId'
 * });
 */
export function useGuardianChildAttendanceQuery(variables: Types.GuardianChildAttendanceQueryVariables | VueCompositionApi.Ref<Types.GuardianChildAttendanceQueryVariables> | ReactiveFunction<Types.GuardianChildAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>(GuardianChildAttendanceDocument, variables, options);
}
export function useGuardianChildAttendanceLazyQuery(variables?: Types.GuardianChildAttendanceQueryVariables | VueCompositionApi.Ref<Types.GuardianChildAttendanceQueryVariables> | ReactiveFunction<Types.GuardianChildAttendanceQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>(GuardianChildAttendanceDocument, variables, options);
}
export type GuardianChildAttendanceQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildAttendanceQuery, Types.GuardianChildAttendanceQueryVariables>;
export const GuardianChildTimetableDocument = gql`
    query GuardianChildTimetable($studentId: ID!) {
  guardianChildTimetable(studentId: $studentId) {
    id
    title
    is_active
    template {
      id
      name
      timeSlots {
        id
        name
        start_time
        end_time
        type
      }
    }
    entries {
      id
      day_of_week
      custom_title
      room_name
      teachable {
        ... on Subject {
          id
          name
        }
        ... on Course {
          id
          course_title
          course_code
        }
      }
      staff {
        id
        user {
          name
        }
      }
      timeSlot {
        id
        name
        start_time
        end_time
      }
    }
  }
}
    `;

/**
 * __useGuardianChildTimetableQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildTimetableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildTimetableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildTimetableQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardianChildTimetableQuery(variables: Types.GuardianChildTimetableQueryVariables | VueCompositionApi.Ref<Types.GuardianChildTimetableQueryVariables> | ReactiveFunction<Types.GuardianChildTimetableQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>(GuardianChildTimetableDocument, variables, options);
}
export function useGuardianChildTimetableLazyQuery(variables?: Types.GuardianChildTimetableQueryVariables | VueCompositionApi.Ref<Types.GuardianChildTimetableQueryVariables> | ReactiveFunction<Types.GuardianChildTimetableQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>(GuardianChildTimetableDocument, variables, options);
}
export type GuardianChildTimetableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildTimetableQuery, Types.GuardianChildTimetableQueryVariables>;
export const GuardianChildBillsDocument = gql`
    query GuardianChildBills($studentId: ID!, $sessionId: ID, $academicCalendarId: ID) {
  guardianChildBills(
    studentId: $studentId
    sessionId: $sessionId
    academicCalendarId: $academicCalendarId
  ) {
    id
    net_amount
    amount_paid
    balance
    status
    due_date
    created_at
    session {
      id
      name
    }
    academicCalendar {
      id
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
    billDetails {
      id
      item_name
      amount
      balance
    }
  }
}
    `;

/**
 * __useGuardianChildBillsQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildBillsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildBillsQuery({
 *   studentId: // value for 'studentId'
 *   sessionId: // value for 'sessionId'
 *   academicCalendarId: // value for 'academicCalendarId'
 * });
 */
export function useGuardianChildBillsQuery(variables: Types.GuardianChildBillsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildBillsQueryVariables> | ReactiveFunction<Types.GuardianChildBillsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>(GuardianChildBillsDocument, variables, options);
}
export function useGuardianChildBillsLazyQuery(variables?: Types.GuardianChildBillsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildBillsQueryVariables> | ReactiveFunction<Types.GuardianChildBillsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>(GuardianChildBillsDocument, variables, options);
}
export type GuardianChildBillsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildBillsQuery, Types.GuardianChildBillsQueryVariables>;
export const GuardianChildBillDocument = gql`
    query GuardianChildBill($studentId: ID!, $billId: ID!) {
  guardianChildBill(studentId: $studentId, billId: $billId) {
    id
    status
    due_date
    net_amount
    amount_paid
    balance
    session {
      id
      name
    }
    academicCalendar {
      id
      session {
        id
        name
      }
      termStructure {
        id
        name
      }
    }
    billDetails {
      id
      item_name
      item_description
      amount
      amount_paid
      balance
    }
    billDiscounts {
      id
      description
      calculated_amount
      voided_at
    }
    derivedAdjustments {
      label
      amount
    }
  }
}
    `;

/**
 * __useGuardianChildBillQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildBillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildBillQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildBillQuery({
 *   studentId: // value for 'studentId'
 *   billId: // value for 'billId'
 * });
 */
export function useGuardianChildBillQuery(variables: Types.GuardianChildBillQueryVariables | VueCompositionApi.Ref<Types.GuardianChildBillQueryVariables> | ReactiveFunction<Types.GuardianChildBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>(GuardianChildBillDocument, variables, options);
}
export function useGuardianChildBillLazyQuery(variables?: Types.GuardianChildBillQueryVariables | VueCompositionApi.Ref<Types.GuardianChildBillQueryVariables> | ReactiveFunction<Types.GuardianChildBillQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>(GuardianChildBillDocument, variables, options);
}
export type GuardianChildBillQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildBillQuery, Types.GuardianChildBillQueryVariables>;
export const GuardianChildAnnouncementsDocument = gql`
    query GuardianChildAnnouncements($studentId: ID!) {
  guardianChildAnnouncements(studentId: $studentId) {
    id
    title
    body
    severity
    published_at
    expires_at
  }
}
    `;

/**
 * __useGuardianChildAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildAnnouncementsQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardianChildAnnouncementsQuery(variables: Types.GuardianChildAnnouncementsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildAnnouncementsQueryVariables> | ReactiveFunction<Types.GuardianChildAnnouncementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>(GuardianChildAnnouncementsDocument, variables, options);
}
export function useGuardianChildAnnouncementsLazyQuery(variables?: Types.GuardianChildAnnouncementsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildAnnouncementsQueryVariables> | ReactiveFunction<Types.GuardianChildAnnouncementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>(GuardianChildAnnouncementsDocument, variables, options);
}
export type GuardianChildAnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildAnnouncementsQuery, Types.GuardianChildAnnouncementsQueryVariables>;
export const GuardianDashboardSummaryDocument = gql`
    query GuardianDashboardSummary {
  guardianDashboardSummary {
    totalChildren
    totalOutstanding
    recentActivity {
      type
      title
      description
      studentName
      timestamp
    }
  }
}
    `;

/**
 * __useGuardianDashboardSummaryQuery__
 *
 * To run a query within a Vue component, call `useGuardianDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianDashboardSummaryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianDashboardSummaryQuery();
 */
export function useGuardianDashboardSummaryQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>(GuardianDashboardSummaryDocument, {}, options);
}
export function useGuardianDashboardSummaryLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>(GuardianDashboardSummaryDocument, {}, options);
}
export type GuardianDashboardSummaryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianDashboardSummaryQuery, Types.GuardianDashboardSummaryQueryVariables>;
export const GuardianChildCourseRegistrationDocument = gql`
    query GuardianChildCourseRegistration($studentId: ID!) {
  guardianChildCourseRegistration(studentId: $studentId) {
    id
    academic_session
    semester
    registration_level
    authorization_status
    approval_status
    senate_approval_status
    rejection_reason
    academic_calendar_id
    programme {
      id
      program_name
    }
    coursesRegistered {
      id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGuardianChildCourseRegistrationQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildCourseRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildCourseRegistrationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildCourseRegistrationQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardianChildCourseRegistrationQuery(variables: Types.GuardianChildCourseRegistrationQueryVariables | VueCompositionApi.Ref<Types.GuardianChildCourseRegistrationQueryVariables> | ReactiveFunction<Types.GuardianChildCourseRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>(GuardianChildCourseRegistrationDocument, variables, options);
}
export function useGuardianChildCourseRegistrationLazyQuery(variables?: Types.GuardianChildCourseRegistrationQueryVariables | VueCompositionApi.Ref<Types.GuardianChildCourseRegistrationQueryVariables> | ReactiveFunction<Types.GuardianChildCourseRegistrationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>(GuardianChildCourseRegistrationDocument, variables, options);
}
export type GuardianChildCourseRegistrationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildCourseRegistrationQuery, Types.GuardianChildCourseRegistrationQueryVariables>;
export const GuardianChildTranscriptRequestsDocument = gql`
    query GuardianChildTranscriptRequests($studentId: ID!) {
  guardianChildTranscriptRequests(studentId: $studentId) {
    id
    tracking_code
    status
    applicant_name
    number_of_copies
    destination_institution
    rejection_reason
    submitted_at
    approved_at
    collected_at
    created_at
    transcriptType {
      id
      name
      category
    }
    bill {
      id
      status
      net_amount
      amount_paid
      balance
    }
  }
}
    `;

/**
 * __useGuardianChildTranscriptRequestsQuery__
 *
 * To run a query within a Vue component, call `useGuardianChildTranscriptRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardianChildTranscriptRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGuardianChildTranscriptRequestsQuery({
 *   studentId: // value for 'studentId'
 * });
 */
export function useGuardianChildTranscriptRequestsQuery(variables: Types.GuardianChildTranscriptRequestsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildTranscriptRequestsQueryVariables> | ReactiveFunction<Types.GuardianChildTranscriptRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>(GuardianChildTranscriptRequestsDocument, variables, options);
}
export function useGuardianChildTranscriptRequestsLazyQuery(variables?: Types.GuardianChildTranscriptRequestsQueryVariables | VueCompositionApi.Ref<Types.GuardianChildTranscriptRequestsQueryVariables> | ReactiveFunction<Types.GuardianChildTranscriptRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>(GuardianChildTranscriptRequestsDocument, variables, options);
}
export type GuardianChildTranscriptRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GuardianChildTranscriptRequestsQuery, Types.GuardianChildTranscriptRequestsQueryVariables>;
export const VisitorCountryDocument = gql`
    query VisitorCountry {
  visitorCountry {
    country_code
  }
}
    `;

/**
 * __useVisitorCountryQuery__
 *
 * To run a query within a Vue component, call `useVisitorCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorCountryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useVisitorCountryQuery();
 */
export function useVisitorCountryQuery(options: VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>(VisitorCountryDocument, {}, options);
}
export function useVisitorCountryLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>(VisitorCountryDocument, {}, options);
}
export type VisitorCountryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.VisitorCountryQuery, Types.VisitorCountryQueryVariables>;
export const RequestDemoDocument = gql`
    mutation RequestDemo($input: RequestDemoInput!) {
  requestDemo(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useRequestDemoMutation__
 *
 * To run a mutation, you first call `useRequestDemoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestDemoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestDemoMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestDemoMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestDemoMutation, Types.RequestDemoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>(RequestDemoDocument, options);
}
export type RequestDemoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestDemoMutation, Types.RequestDemoMutationVariables>;
export const CreateQuestionsDocument = gql`
    mutation CreateQuestions($input: CreateQuestionsInput!) {
  createQuestions(input: $input) {
    id
    question
    marks
    question_type
  }
}
    `;

/**
 * __useCreateQuestionsMutation__
 *
 * To run a mutation, you first call `useCreateQuestionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionsMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateQuestionsMutation, Types.CreateQuestionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateQuestionsMutation, Types.CreateQuestionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateQuestionsMutation, Types.CreateQuestionsMutationVariables>(CreateQuestionsDocument, options);
}
export type CreateQuestionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateQuestionsMutation, Types.CreateQuestionsMutationVariables>;
export const SubjectsDocument = gql`
    query subjects {
  subjects {
    id
    name
    teachers {
      id
      user {
        id
        name
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSubjectsQuery__
 *
 * To run a query within a Vue component, call `useSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubjectsQuery();
 */
export function useSubjectsQuery(options: VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SubjectsQuery, Types.SubjectsQueryVariables>(SubjectsDocument, {}, options);
}
export function useSubjectsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectsQuery, Types.SubjectsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SubjectsQuery, Types.SubjectsQueryVariables>(SubjectsDocument, {}, options);
}
export type SubjectsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SubjectsQuery, Types.SubjectsQueryVariables>;
export const SubjectDocument = gql`
    query subject($id: ID!) {
  subject(id: $id) {
    id
    name
    teachers {
      id
      user {
        id
        name
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSubjectQuery__
 *
 * To run a query within a Vue component, call `useSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubjectQuery({
 *   id: // value for 'id'
 * });
 */
export function useSubjectQuery(variables: Types.SubjectQueryVariables | VueCompositionApi.Ref<Types.SubjectQueryVariables> | ReactiveFunction<Types.SubjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SubjectQuery, Types.SubjectQueryVariables>(SubjectDocument, variables, options);
}
export function useSubjectLazyQuery(variables?: Types.SubjectQueryVariables | VueCompositionApi.Ref<Types.SubjectQueryVariables> | ReactiveFunction<Types.SubjectQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectQuery, Types.SubjectQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SubjectQuery, Types.SubjectQueryVariables>(SubjectDocument, variables, options);
}
export type SubjectQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SubjectQuery, Types.SubjectQueryVariables>;
export const SubjectTeachersDocument = gql`
    query subjectTeachers($subjectId: ID!) {
  subjectTeachers(subjectId: $subjectId) {
    id
    email
    status
    subjects {
      subject {
        id
        name
      }
      classroomSections {
        id
        name
        classroom {
          id
          name
        }
      }
    }
    user {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useSubjectTeachersQuery__
 *
 * To run a query within a Vue component, call `useSubjectTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectTeachersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSubjectTeachersQuery({
 *   subjectId: // value for 'subjectId'
 * });
 */
export function useSubjectTeachersQuery(variables: Types.SubjectTeachersQueryVariables | VueCompositionApi.Ref<Types.SubjectTeachersQueryVariables> | ReactiveFunction<Types.SubjectTeachersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>(SubjectTeachersDocument, variables, options);
}
export function useSubjectTeachersLazyQuery(variables?: Types.SubjectTeachersQueryVariables | VueCompositionApi.Ref<Types.SubjectTeachersQueryVariables> | ReactiveFunction<Types.SubjectTeachersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>(SubjectTeachersDocument, variables, options);
}
export type SubjectTeachersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SubjectTeachersQuery, Types.SubjectTeachersQueryVariables>;
export const CreateSubjectDocument = gql`
    mutation createSubject($name: String!) {
  createSubject(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useCreateSubjectMutation__
 *
 * To run a mutation, you first call `useCreateSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSubjectMutation({
 *   variables: {
 *     name: // value for 'name'
 *   },
 * });
 */
export function useCreateSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSubjectMutation, Types.CreateSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSubjectMutation, Types.CreateSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSubjectMutation, Types.CreateSubjectMutationVariables>(CreateSubjectDocument, options);
}
export type CreateSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSubjectMutation, Types.CreateSubjectMutationVariables>;
export const UpdateSubjectDocument = gql`
    mutation updateSubject($id: ID!, $name: String!) {
  updateSubject(id: $id, name: $name) {
    id
    name
  }
}
    `;

/**
 * __useUpdateSubjectMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSubjectMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSubjectMutation, Types.UpdateSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSubjectMutation, Types.UpdateSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSubjectMutation, Types.UpdateSubjectMutationVariables>(UpdateSubjectDocument, options);
}
export type UpdateSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSubjectMutation, Types.UpdateSubjectMutationVariables>;
export const DeleteSubjectDocument = gql`
    mutation deleteSubject($id: ID!) {
  deleteSubject(id: $id)
}
    `;

/**
 * __useDeleteSubjectMutation__
 *
 * To run a mutation, you first call `useDeleteSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSubjectMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSubjectMutation, Types.DeleteSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSubjectMutation, Types.DeleteSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSubjectMutation, Types.DeleteSubjectMutationVariables>(DeleteSubjectDocument, options);
}
export type DeleteSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSubjectMutation, Types.DeleteSubjectMutationVariables>;
export const AssignTeacherToSubjectDocument = gql`
    mutation assignTeacherToSubject($subjectId: ID!, $teacherId: ID!, $classroomSectionIds: [ID!]) {
  assignTeacherToSubject(
    subjectId: $subjectId
    teacherId: $teacherId
    classroomSectionIds: $classroomSectionIds
  ) {
    id
    subject {
      id
      name
    }
    staff {
      id
      user {
        id
        name
      }
    }
    classroomSection {
      id
      name
    }
  }
}
    `;

/**
 * __useAssignTeacherToSubjectMutation__
 *
 * To run a mutation, you first call `useAssignTeacherToSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeacherToSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignTeacherToSubjectMutation({
 *   variables: {
 *     subjectId: // value for 'subjectId'
 *     teacherId: // value for 'teacherId'
 *     classroomSectionIds: // value for 'classroomSectionIds'
 *   },
 * });
 */
export function useAssignTeacherToSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignTeacherToSubjectMutation, Types.AssignTeacherToSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignTeacherToSubjectMutation, Types.AssignTeacherToSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignTeacherToSubjectMutation, Types.AssignTeacherToSubjectMutationVariables>(AssignTeacherToSubjectDocument, options);
}
export type AssignTeacherToSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignTeacherToSubjectMutation, Types.AssignTeacherToSubjectMutationVariables>;
export const RemoveTeacherFromSubjectDocument = gql`
    mutation removeTeacherFromSubject($subjectId: ID!, $teacherId: ID!, $classroomSectionId: ID) {
  removeTeacherFromSubject(
    subjectId: $subjectId
    teacherId: $teacherId
    classroomSectionId: $classroomSectionId
  ) {
    success
    message
    code
  }
}
    `;

/**
 * __useRemoveTeacherFromSubjectMutation__
 *
 * To run a mutation, you first call `useRemoveTeacherFromSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeacherFromSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveTeacherFromSubjectMutation({
 *   variables: {
 *     subjectId: // value for 'subjectId'
 *     teacherId: // value for 'teacherId'
 *     classroomSectionId: // value for 'classroomSectionId'
 *   },
 * });
 */
export function useRemoveTeacherFromSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveTeacherFromSubjectMutation, Types.RemoveTeacherFromSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveTeacherFromSubjectMutation, Types.RemoveTeacherFromSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveTeacherFromSubjectMutation, Types.RemoveTeacherFromSubjectMutationVariables>(RemoveTeacherFromSubjectDocument, options);
}
export type RemoveTeacherFromSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveTeacherFromSubjectMutation, Types.RemoveTeacherFromSubjectMutationVariables>;
export const EnrollStudentSubjectDocument = gql`
    mutation EnrollStudentSubject($model: EnrollmentModel!, $ids: [ID!]!, $subjectIds: [ID!]!, $academicCalendarId: ID) {
  enrollStudentSubject(
    model: $model
    ids: $ids
    subjectIds: $subjectIds
    academicCalendarId: $academicCalendarId
  ) {
    message
    success
    enrolledCount
  }
}
    `;

/**
 * __useEnrollStudentSubjectMutation__
 *
 * To run a mutation, you first call `useEnrollStudentSubjectMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollStudentSubjectMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollStudentSubjectMutation({
 *   variables: {
 *     model: // value for 'model'
 *     ids: // value for 'ids'
 *     subjectIds: // value for 'subjectIds'
 *     academicCalendarId: // value for 'academicCalendarId'
 *   },
 * });
 */
export function useEnrollStudentSubjectMutation(options: VueApolloComposable.UseMutationOptions<Types.EnrollStudentSubjectMutation, Types.EnrollStudentSubjectMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EnrollStudentSubjectMutation, Types.EnrollStudentSubjectMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EnrollStudentSubjectMutation, Types.EnrollStudentSubjectMutationVariables>(EnrollStudentSubjectDocument, options);
}
export type EnrollStudentSubjectMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EnrollStudentSubjectMutation, Types.EnrollStudentSubjectMutationVariables>;
export const DeleteSubjectEnrollmentDocument = gql`
    mutation DeleteSubjectEnrollment($modelIds: [ID!]!, $modelType: DeletableModelType!, $subject_id: ID!, $academic_calendar_id: ID!) {
  deleteSubjectEnrollment(
    modelIds: $modelIds
    modelType: $modelType
    subject_id: $subject_id
    academic_calendar_id: $academic_calendar_id
  ) {
    message
    success
  }
}
    `;

/**
 * __useDeleteSubjectEnrollmentMutation__
 *
 * To run a mutation, you first call `useDeleteSubjectEnrollmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubjectEnrollmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSubjectEnrollmentMutation({
 *   variables: {
 *     modelIds: // value for 'modelIds'
 *     modelType: // value for 'modelType'
 *     subject_id: // value for 'subject_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useDeleteSubjectEnrollmentMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSubjectEnrollmentMutation, Types.DeleteSubjectEnrollmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSubjectEnrollmentMutation, Types.DeleteSubjectEnrollmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSubjectEnrollmentMutation, Types.DeleteSubjectEnrollmentMutationVariables>(DeleteSubjectEnrollmentDocument, options);
}
export type DeleteSubjectEnrollmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSubjectEnrollmentMutation, Types.DeleteSubjectEnrollmentMutationVariables>;
export const CreateTimetableTemplateDocument = gql`
    mutation CreateTimetableTemplate($input: CreateTimetableTemplateInput!) {
  createTimetableTemplate(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useCreateTimetableTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTimetableTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimetableTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTimetableTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimetableTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTimetableTemplateMutation, Types.CreateTimetableTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTimetableTemplateMutation, Types.CreateTimetableTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTimetableTemplateMutation, Types.CreateTimetableTemplateMutationVariables>(CreateTimetableTemplateDocument, options);
}
export type CreateTimetableTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTimetableTemplateMutation, Types.CreateTimetableTemplateMutationVariables>;
export const CreateTimetableTimeSlotDocument = gql`
    mutation CreateTimetableTimeSlot($input: CreateTimetableTimeSlotInput!) {
  createTimetableTimeSlot(input: $input) {
    id
    name
    start_time
    end_time
    type
    color
  }
}
    `;

/**
 * __useCreateTimetableTimeSlotMutation__
 *
 * To run a mutation, you first call `useCreateTimetableTimeSlotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimetableTimeSlotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTimetableTimeSlotMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimetableTimeSlotMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTimetableTimeSlotMutation, Types.CreateTimetableTimeSlotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTimetableTimeSlotMutation, Types.CreateTimetableTimeSlotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTimetableTimeSlotMutation, Types.CreateTimetableTimeSlotMutationVariables>(CreateTimetableTimeSlotDocument, options);
}
export type CreateTimetableTimeSlotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTimetableTimeSlotMutation, Types.CreateTimetableTimeSlotMutationVariables>;
export const CreateTimetableDocument = gql`
    mutation CreateTimetable($input: CreateTimetableInput!) {
  createTimetable(input: $input) {
    id
    title
  }
}
    `;

/**
 * __useCreateTimetableMutation__
 *
 * To run a mutation, you first call `useCreateTimetableMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimetableMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTimetableMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimetableMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTimetableMutation, Types.CreateTimetableMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTimetableMutation, Types.CreateTimetableMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTimetableMutation, Types.CreateTimetableMutationVariables>(CreateTimetableDocument, options);
}
export type CreateTimetableMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTimetableMutation, Types.CreateTimetableMutationVariables>;
export const UpsertTimetableEntryDocument = gql`
    mutation UpsertTimetableEntry($input: UpsertTimetableEntryInput!) {
  upsertTimetableEntry(input: $input) {
    id
    day_of_week
    teachable {
      __typename
      ... on Subject {
        id
        name
      }
      ... on Course {
        id
        course_code
        course_title
      }
    }
    staff {
      id
      user {
        name
      }
    }
  }
}
    `;

/**
 * __useUpsertTimetableEntryMutation__
 *
 * To run a mutation, you first call `useUpsertTimetableEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTimetableEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertTimetableEntryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertTimetableEntryMutation(options: VueApolloComposable.UseMutationOptions<Types.UpsertTimetableEntryMutation, Types.UpsertTimetableEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpsertTimetableEntryMutation, Types.UpsertTimetableEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpsertTimetableEntryMutation, Types.UpsertTimetableEntryMutationVariables>(UpsertTimetableEntryDocument, options);
}
export type UpsertTimetableEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpsertTimetableEntryMutation, Types.UpsertTimetableEntryMutationVariables>;
export const UpdateTimetableTemplateDocument = gql`
    mutation UpdateTimetableTemplate($input: UpdateTimetableTemplateInput!) {
  updateTimetableTemplate(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useUpdateTimetableTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTimetableTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimetableTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTimetableTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimetableTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTimetableTemplateMutation, Types.UpdateTimetableTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTimetableTemplateMutation, Types.UpdateTimetableTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTimetableTemplateMutation, Types.UpdateTimetableTemplateMutationVariables>(UpdateTimetableTemplateDocument, options);
}
export type UpdateTimetableTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTimetableTemplateMutation, Types.UpdateTimetableTemplateMutationVariables>;
export const DeleteTimetableTemplateDocument = gql`
    mutation DeleteTimetableTemplate($id: ID!) {
  deleteTimetableTemplate(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteTimetableTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTimetableTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimetableTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTimetableTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimetableTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteTimetableTemplateMutation, Types.DeleteTimetableTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteTimetableTemplateMutation, Types.DeleteTimetableTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteTimetableTemplateMutation, Types.DeleteTimetableTemplateMutationVariables>(DeleteTimetableTemplateDocument, options);
}
export type DeleteTimetableTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteTimetableTemplateMutation, Types.DeleteTimetableTemplateMutationVariables>;
export const DeleteTimetableEntryDocument = gql`
    mutation DeleteTimetableEntry($id: ID!) {
  deleteTimetableEntry(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteTimetableEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimetableEntryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimetableEntryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTimetableEntryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimetableEntryMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteTimetableEntryMutation, Types.DeleteTimetableEntryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteTimetableEntryMutation, Types.DeleteTimetableEntryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteTimetableEntryMutation, Types.DeleteTimetableEntryMutationVariables>(DeleteTimetableEntryDocument, options);
}
export type DeleteTimetableEntryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteTimetableEntryMutation, Types.DeleteTimetableEntryMutationVariables>;
export const DeleteTimetableTimeSlotDocument = gql`
    mutation DeleteTimetableTimeSlot($id: ID!) {
  deleteTimetableTimeSlot(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteTimetableTimeSlotMutation__
 *
 * To run a mutation, you first call `useDeleteTimetableTimeSlotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimetableTimeSlotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTimetableTimeSlotMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimetableTimeSlotMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteTimetableTimeSlotMutation, Types.DeleteTimetableTimeSlotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteTimetableTimeSlotMutation, Types.DeleteTimetableTimeSlotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteTimetableTimeSlotMutation, Types.DeleteTimetableTimeSlotMutationVariables>(DeleteTimetableTimeSlotDocument, options);
}
export type DeleteTimetableTimeSlotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteTimetableTimeSlotMutation, Types.DeleteTimetableTimeSlotMutationVariables>;
export const UpdateTimetableTimeSlotDocument = gql`
    mutation UpdateTimetableTimeSlot($id: ID!, $input: UpdateTimetableTimeSlotInput!) {
  updateTimetableTimeSlot(id: $id, input: $input) {
    id
    name
    start_time
    end_time
    type
    color
  }
}
    `;

/**
 * __useUpdateTimetableTimeSlotMutation__
 *
 * To run a mutation, you first call `useUpdateTimetableTimeSlotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimetableTimeSlotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTimetableTimeSlotMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimetableTimeSlotMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTimetableTimeSlotMutation, Types.UpdateTimetableTimeSlotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTimetableTimeSlotMutation, Types.UpdateTimetableTimeSlotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTimetableTimeSlotMutation, Types.UpdateTimetableTimeSlotMutationVariables>(UpdateTimetableTimeSlotDocument, options);
}
export type UpdateTimetableTimeSlotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTimetableTimeSlotMutation, Types.UpdateTimetableTimeSlotMutationVariables>;
export const CreateAssessmentTypeDocument = gql`
    mutation CreateAssessmentType($input: CreateAssessmentTypeInput!) {
  createAssessmentType(input: $input) {
    id
    name
    description
    max_score
    is_ca
    is_exam
    sequence
    subject_id
    academic_calendar_id
  }
}
    `;

/**
 * __useCreateAssessmentTypeMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAssessmentTypeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateAssessmentTypeMutation, Types.CreateAssessmentTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateAssessmentTypeMutation, Types.CreateAssessmentTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateAssessmentTypeMutation, Types.CreateAssessmentTypeMutationVariables>(CreateAssessmentTypeDocument, options);
}
export type CreateAssessmentTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateAssessmentTypeMutation, Types.CreateAssessmentTypeMutationVariables>;
export const UpdateAssessmentTypeDocument = gql`
    mutation UpdateAssessmentType($input: UpdateAssessmentTypeInput!) {
  updateAssessmentType(input: $input) {
    id
    name
    description
    max_score
    is_ca
    is_exam
    sequence
    subject_id
    academic_calendar_id
  }
}
    `;

/**
 * __useUpdateAssessmentTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAssessmentTypeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateAssessmentTypeMutation, Types.UpdateAssessmentTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateAssessmentTypeMutation, Types.UpdateAssessmentTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateAssessmentTypeMutation, Types.UpdateAssessmentTypeMutationVariables>(UpdateAssessmentTypeDocument, options);
}
export type UpdateAssessmentTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateAssessmentTypeMutation, Types.UpdateAssessmentTypeMutationVariables>;
export const DeleteAssessmentTypeDocument = gql`
    mutation DeleteAssessmentType($id: ID!) {
  deleteAssessmentType(id: $id) {
    success
    message
    deleted_count
  }
}
    `;

/**
 * __useDeleteAssessmentTypeMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAssessmentTypeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssessmentTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteAssessmentTypeMutation, Types.DeleteAssessmentTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteAssessmentTypeMutation, Types.DeleteAssessmentTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteAssessmentTypeMutation, Types.DeleteAssessmentTypeMutationVariables>(DeleteAssessmentTypeDocument, options);
}
export type DeleteAssessmentTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteAssessmentTypeMutation, Types.DeleteAssessmentTypeMutationVariables>;
export const ReorderAssessmentTypesDocument = gql`
    mutation ReorderAssessmentTypes($order_data: [AssessmentTypeOrderInput!]!) {
  reorderAssessmentTypes(order_data: $order_data) {
    success
    message
  }
}
    `;

/**
 * __useReorderAssessmentTypesMutation__
 *
 * To run a mutation, you first call `useReorderAssessmentTypesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderAssessmentTypesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderAssessmentTypesMutation({
 *   variables: {
 *     order_data: // value for 'order_data'
 *   },
 * });
 */
export function useReorderAssessmentTypesMutation(options: VueApolloComposable.UseMutationOptions<Types.ReorderAssessmentTypesMutation, Types.ReorderAssessmentTypesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReorderAssessmentTypesMutation, Types.ReorderAssessmentTypesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReorderAssessmentTypesMutation, Types.ReorderAssessmentTypesMutationVariables>(ReorderAssessmentTypesDocument, options);
}
export type ReorderAssessmentTypesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReorderAssessmentTypesMutation, Types.ReorderAssessmentTypesMutationVariables>;
export const CopyCbtScoresToAssessmentDocument = gql`
    mutation CopyCbtScoresToAssessment($input: CopyCbtScoresToAssessmentInput!) {
  copyCbtScoresToAssessment(input: $input) {
    success
    message
    copied_count
    updated_count
    skipped_count
    errors
  }
}
    `;

/**
 * __useCopyCbtScoresToAssessmentMutation__
 *
 * To run a mutation, you first call `useCopyCbtScoresToAssessmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyCbtScoresToAssessmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyCbtScoresToAssessmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCopyCbtScoresToAssessmentMutation(options: VueApolloComposable.UseMutationOptions<Types.CopyCbtScoresToAssessmentMutation, Types.CopyCbtScoresToAssessmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CopyCbtScoresToAssessmentMutation, Types.CopyCbtScoresToAssessmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CopyCbtScoresToAssessmentMutation, Types.CopyCbtScoresToAssessmentMutationVariables>(CopyCbtScoresToAssessmentDocument, options);
}
export type CopyCbtScoresToAssessmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CopyCbtScoresToAssessmentMutation, Types.CopyCbtScoresToAssessmentMutationVariables>;
export const CreateBroadsheetTemplateDocument = gql`
    mutation CreateBroadsheetTemplate($input: CreateBroadsheetTemplateInput!) {
  createBroadsheetTemplate(input: $input) {
    id
    name
    description
    columns {
      id
      label
      key
      type
      sequence
      is_visible
    }
  }
}
    `;

/**
 * __useCreateBroadsheetTemplateMutation__
 *
 * To run a mutation, you first call `useCreateBroadsheetTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBroadsheetTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBroadsheetTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBroadsheetTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateBroadsheetTemplateMutation, Types.CreateBroadsheetTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateBroadsheetTemplateMutation, Types.CreateBroadsheetTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateBroadsheetTemplateMutation, Types.CreateBroadsheetTemplateMutationVariables>(CreateBroadsheetTemplateDocument, options);
}
export type CreateBroadsheetTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateBroadsheetTemplateMutation, Types.CreateBroadsheetTemplateMutationVariables>;
export const UpdateBroadsheetTemplateDocument = gql`
    mutation UpdateBroadsheetTemplate($input: UpdateBroadsheetTemplateInput!) {
  updateBroadsheetTemplate(input: $input) {
    id
    name
    description
    columns {
      id
      label
      key
      type
      sequence
      is_visible
      calculation_function
      calculation_arguments
    }
  }
}
    `;

/**
 * __useUpdateBroadsheetTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateBroadsheetTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBroadsheetTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBroadsheetTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBroadsheetTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateBroadsheetTemplateMutation, Types.UpdateBroadsheetTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateBroadsheetTemplateMutation, Types.UpdateBroadsheetTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateBroadsheetTemplateMutation, Types.UpdateBroadsheetTemplateMutationVariables>(UpdateBroadsheetTemplateDocument, options);
}
export type UpdateBroadsheetTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateBroadsheetTemplateMutation, Types.UpdateBroadsheetTemplateMutationVariables>;
export const DeleteBroadsheetTemplateDocument = gql`
    mutation DeleteBroadsheetTemplate($id: ID!) {
  deleteBroadsheetTemplate(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteBroadsheetTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteBroadsheetTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBroadsheetTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteBroadsheetTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBroadsheetTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteBroadsheetTemplateMutation, Types.DeleteBroadsheetTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteBroadsheetTemplateMutation, Types.DeleteBroadsheetTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteBroadsheetTemplateMutation, Types.DeleteBroadsheetTemplateMutationVariables>(DeleteBroadsheetTemplateDocument, options);
}
export type DeleteBroadsheetTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteBroadsheetTemplateMutation, Types.DeleteBroadsheetTemplateMutationVariables>;
export const CreateQueryBankDocument = gql`
    mutation CreateQueryBank($input: CreateQuestionBankInput!) {
  createQueryBank(input: $input) {
    id
    name
    school {
      id
      name
      school_type
    }
  }
}
    `;

/**
 * __useCreateQueryBank__
 *
 * To run a mutation, you first call `useCreateQueryBank` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQueryBank` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQueryBank({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateQueryBank(options: VueApolloComposable.UseMutationOptions<Types.CreateQueryBankMutation, Types.CreateQueryBankMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateQueryBankMutation, Types.CreateQueryBankMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateQueryBankMutation, Types.CreateQueryBankMutationVariables>(CreateQueryBankDocument, options);
}
export type CreateQueryBankCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateQueryBankMutation, Types.CreateQueryBankMutationVariables>;
export const UpdateQueryBankDocument = gql`
    mutation UpdateQueryBank($id: ID!, $input: UpdateQuestionBankInput!) {
  updateQueryBank(id: $id, input: $input) {
    id
    name
  }
}
    `;

/**
 * __useUpdateQueryBank__
 *
 * To run a mutation, you first call `useUpdateQueryBank` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQueryBank` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQueryBank({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQueryBank(options: VueApolloComposable.UseMutationOptions<Types.UpdateQueryBankMutation, Types.UpdateQueryBankMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateQueryBankMutation, Types.UpdateQueryBankMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateQueryBankMutation, Types.UpdateQueryBankMutationVariables>(UpdateQueryBankDocument, options);
}
export type UpdateQueryBankCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateQueryBankMutation, Types.UpdateQueryBankMutationVariables>;
export const DeleteQueryBankDocument = gql`
    mutation DeleteQueryBank($id: ID!) {
  deleteQueryBank(id: $id) {
    success
    message
    code
  }
}
    `;

/**
 * __useDeleteQueryBank__
 *
 * To run a mutation, you first call `useDeleteQueryBank` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQueryBank` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteQueryBank({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQueryBank(options: VueApolloComposable.UseMutationOptions<Types.DeleteQueryBankMutation, Types.DeleteQueryBankMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteQueryBankMutation, Types.DeleteQueryBankMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteQueryBankMutation, Types.DeleteQueryBankMutationVariables>(DeleteQueryBankDocument, options);
}
export type DeleteQueryBankCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteQueryBankMutation, Types.DeleteQueryBankMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($input: CreateQuestionInput!) {
  createQuestion(input: $input) {
    id
    question
    question_type
    marks
    correct_answer_guidelines
    correct_answer_prose
    images {
      url
    }
    options {
      id
      option
      is_correct
      images {
        url
      }
    }
  }
}
    `;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateQuestionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateQuestionMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateQuestionMutation, Types.CreateQuestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateQuestionMutation, Types.CreateQuestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateQuestionMutation, Types.CreateQuestionMutationVariables>(CreateQuestionDocument, options);
}
export type CreateQuestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateQuestionMutation, Types.CreateQuestionMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($id: ID!, $input: UpdateQuestionInput!) {
  updateQuestion(id: $id, input: $input) {
    id
    question
    question_type
    marks
    correct_answer_guidelines
    correct_answer_prose
    images {
      url
    }
    options {
      id
      option
      is_correct
      images {
        url
      }
    }
  }
}
    `;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateQuestionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuestionMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
}
export type UpdateQuestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateQuestionMutation, Types.UpdateQuestionMutationVariables>;
export const DeleteQuestionDocument = gql`
    mutation DeleteQuestion($id: ID!) {
  deleteQuestion(id: $id) {
    success
    message
    code
  }
}
    `;

/**
 * __useDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteQuestionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQuestionMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>(DeleteQuestionDocument, options);
}
export type DeleteQuestionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteQuestionMutation, Types.DeleteQuestionMutationVariables>;
export const CreateCbtTestDocument = gql`
    mutation CreateCBTTest($input: CreateCBTTestInput!) {
  createCBTTest(input: $input) {
    id
    title
    description
    duration
    start_time
    end_time
    question_count
    school {
      id
      name
    }
    questionBanks {
      id
      name
    }
    questions {
      id
      question
    }
    linkedAssessmentType {
      id
      name
      max_score
      is_ca
      is_exam
    }
  }
}
    `;

/**
 * __useCreateCbtTestMutation__
 *
 * To run a mutation, you first call `useCreateCbtTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCbtTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCbtTestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCbtTestMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCbtTestMutation, Types.CreateCbtTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCbtTestMutation, Types.CreateCbtTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCbtTestMutation, Types.CreateCbtTestMutationVariables>(CreateCbtTestDocument, options);
}
export type CreateCbtTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCbtTestMutation, Types.CreateCbtTestMutationVariables>;
export const UpdateCbtTestDocument = gql`
    mutation UpdateCBTTest($id: ID!, $input: UpdateCBTTestInput!) {
  updateCBTTest(id: $id, input: $input) {
    id
    title
    description
    duration
    start_time
    end_time
    question_count
    linkedAssessmentType {
      id
      name
      max_score
      is_ca
      is_exam
    }
  }
}
    `;

/**
 * __useUpdateCbtTestMutation__
 *
 * To run a mutation, you first call `useUpdateCbtTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCbtTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCbtTestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCbtTestMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCbtTestMutation, Types.UpdateCbtTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCbtTestMutation, Types.UpdateCbtTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCbtTestMutation, Types.UpdateCbtTestMutationVariables>(UpdateCbtTestDocument, options);
}
export type UpdateCbtTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCbtTestMutation, Types.UpdateCbtTestMutationVariables>;
export const DeleteCbtTestDocument = gql`
    mutation DeleteCBTTest($id: ID!) {
  deleteCBTTest(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteCbtTestMutation__
 *
 * To run a mutation, you first call `useDeleteCbtTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCbtTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCbtTestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCbtTestMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCbtTestMutation, Types.DeleteCbtTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCbtTestMutation, Types.DeleteCbtTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCbtTestMutation, Types.DeleteCbtTestMutationVariables>(DeleteCbtTestDocument, options);
}
export type DeleteCbtTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCbtTestMutation, Types.DeleteCbtTestMutationVariables>;
export const DeleteCbtTestSessionDocument = gql`
    mutation DeleteCBTTestSession($id: ID!) {
  deleteCBTTestSession(id: $id) {
    success
    message
    code
  }
}
    `;

/**
 * __useDeleteCbtTestSessionMutation__
 *
 * To run a mutation, you first call `useDeleteCbtTestSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCbtTestSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCbtTestSessionMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCbtTestSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCbtTestSessionMutation, Types.DeleteCbtTestSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCbtTestSessionMutation, Types.DeleteCbtTestSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCbtTestSessionMutation, Types.DeleteCbtTestSessionMutationVariables>(DeleteCbtTestSessionDocument, options);
}
export type DeleteCbtTestSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCbtTestSessionMutation, Types.DeleteCbtTestSessionMutationVariables>;
export const StartCbtTestDocument = gql`
    mutation StartCBTTest($testId: ID!) {
  startCBTTest(testId: $testId) {
    id
    status
    start_time
    end_time
    selected_question_ids
    cbtTest {
      id
      title
      duration
      questionBanks {
        id
        name
      }
      questions {
        id
        question
        question_type
        images {
          url
        }
        questionBank {
          id
          name
        }
        marks
        options {
          id
          option
          images {
            url
          }
          question {
            id
            question
          }
        }
      }
      track_progress
    }
    progress {
      id
      question {
        id
        question
        question_type
        questionBank {
          id
          name
        }
        marks
        options {
          id
          option
          question {
            id
            question
          }
        }
      }
      selectedOption {
        id
        option
      }
    }
    theoryQuestionAnswers {
      question {
        id
      }
      student_answer
    }
  }
}
    `;

/**
 * __useStartCbtTestMutation__
 *
 * To run a mutation, you first call `useStartCbtTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStartCbtTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStartCbtTestMutation({
 *   variables: {
 *     testId: // value for 'testId'
 *   },
 * });
 */
export function useStartCbtTestMutation(options: VueApolloComposable.UseMutationOptions<Types.StartCbtTestMutation, Types.StartCbtTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StartCbtTestMutation, Types.StartCbtTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StartCbtTestMutation, Types.StartCbtTestMutationVariables>(StartCbtTestDocument, options);
}
export type StartCbtTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StartCbtTestMutation, Types.StartCbtTestMutationVariables>;
export const SubmitAnswersDocument = gql`
    mutation SubmitAnswers($sessionId: ID!, $answers: [StudentAnswerInput!]!) {
  submitAnswers(sessionId: $sessionId, answers: $answers)
}
    `;

/**
 * __useSubmitAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitAnswersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAnswersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitAnswersMutation({
 *   variables: {
 *     sessionId: // value for 'sessionId'
 *     answers: // value for 'answers'
 *   },
 * });
 */
export function useSubmitAnswersMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitAnswersMutation, Types.SubmitAnswersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitAnswersMutation, Types.SubmitAnswersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitAnswersMutation, Types.SubmitAnswersMutationVariables>(SubmitAnswersDocument, options);
}
export type SubmitAnswersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitAnswersMutation, Types.SubmitAnswersMutationVariables>;
export const SubmitCbtTestDocument = gql`
    mutation SubmitCBTTest($input: SubmitCBTTestInput!) {
  submitCBTTest(input: $input) {
    id
    score
    status
    end_time
    cbtTest {
      id
      title
    }
  }
}
    `;

/**
 * __useSubmitCbtTestMutation__
 *
 * To run a mutation, you first call `useSubmitCbtTestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCbtTestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitCbtTestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCbtTestMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitCbtTestMutation, Types.SubmitCbtTestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitCbtTestMutation, Types.SubmitCbtTestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitCbtTestMutation, Types.SubmitCbtTestMutationVariables>(SubmitCbtTestDocument, options);
}
export type SubmitCbtTestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitCbtTestMutation, Types.SubmitCbtTestMutationVariables>;
export const PreviewQuestionsFromFileDocument = gql`
    mutation PreviewQuestionsFromFile($question_type: String!, $question_file: Upload!, $cbt_question_bank_id: Int!) {
  previewQuestionsFromFile(
    question_type: $question_type
    question_file: $question_file
    cbt_question_bank_id: $cbt_question_bank_id
  ) {
    status
    created_questions {
      id
      question
      images {
        url
      }
      options {
        option
        images {
          url
        }
      }
    }
  }
}
    `;

/**
 * __usePreviewQuestionsFromFileMutation__
 *
 * To run a mutation, you first call `usePreviewQuestionsFromFileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewQuestionsFromFileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewQuestionsFromFileMutation({
 *   variables: {
 *     question_type: // value for 'question_type'
 *     question_file: // value for 'question_file'
 *     cbt_question_bank_id: // value for 'cbt_question_bank_id'
 *   },
 * });
 */
export function usePreviewQuestionsFromFileMutation(options: VueApolloComposable.UseMutationOptions<Types.PreviewQuestionsFromFileMutation, Types.PreviewQuestionsFromFileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PreviewQuestionsFromFileMutation, Types.PreviewQuestionsFromFileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PreviewQuestionsFromFileMutation, Types.PreviewQuestionsFromFileMutationVariables>(PreviewQuestionsFromFileDocument, options);
}
export type PreviewQuestionsFromFileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PreviewQuestionsFromFileMutation, Types.PreviewQuestionsFromFileMutationVariables>;
export const SubmitTheoryAnswersDocument = gql`
    mutation SubmitTheoryAnswers($input: [StudentTheoryAnswerInput!]!) {
  submitTheoryAnswers(input: $input)
}
    `;

/**
 * __useSubmitTheoryAnswersMutation__
 *
 * To run a mutation, you first call `useSubmitTheoryAnswersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTheoryAnswersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitTheoryAnswersMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTheoryAnswersMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitTheoryAnswersMutation, Types.SubmitTheoryAnswersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitTheoryAnswersMutation, Types.SubmitTheoryAnswersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitTheoryAnswersMutation, Types.SubmitTheoryAnswersMutationVariables>(SubmitTheoryAnswersDocument, options);
}
export type SubmitTheoryAnswersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitTheoryAnswersMutation, Types.SubmitTheoryAnswersMutationVariables>;
export const TriggerAiGradingDocument = gql`
    mutation TriggerAiGrading($cbt_test_session_id: ID!) {
  triggerAiGrading(cbt_test_session_id: $cbt_test_session_id)
}
    `;

/**
 * __useTriggerAiGradingMutation__
 *
 * To run a mutation, you first call `useTriggerAiGradingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAiGradingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTriggerAiGradingMutation({
 *   variables: {
 *     cbt_test_session_id: // value for 'cbt_test_session_id'
 *   },
 * });
 */
export function useTriggerAiGradingMutation(options: VueApolloComposable.UseMutationOptions<Types.TriggerAiGradingMutation, Types.TriggerAiGradingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.TriggerAiGradingMutation, Types.TriggerAiGradingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.TriggerAiGradingMutation, Types.TriggerAiGradingMutationVariables>(TriggerAiGradingDocument, options);
}
export type TriggerAiGradingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.TriggerAiGradingMutation, Types.TriggerAiGradingMutationVariables>;
export const GradeTheoryAnswerDocument = gql`
    mutation GradeTheoryAnswer($id: ID!, $grade: Int!, $feedback: String, $attestation: Boolean!) {
  gradeTheoryAnswer(
    id: $id
    grade: $grade
    feedback: $feedback
    attestation: $attestation
  ) {
    id
    instructor_grade
    feedback
    instructor_attestation
  }
}
    `;

/**
 * __useGradeTheoryAnswerMutation__
 *
 * To run a mutation, you first call `useGradeTheoryAnswerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGradeTheoryAnswerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGradeTheoryAnswerMutation({
 *   variables: {
 *     id: // value for 'id'
 *     grade: // value for 'grade'
 *     feedback: // value for 'feedback'
 *     attestation: // value for 'attestation'
 *   },
 * });
 */
export function useGradeTheoryAnswerMutation(options: VueApolloComposable.UseMutationOptions<Types.GradeTheoryAnswerMutation, Types.GradeTheoryAnswerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GradeTheoryAnswerMutation, Types.GradeTheoryAnswerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GradeTheoryAnswerMutation, Types.GradeTheoryAnswerMutationVariables>(GradeTheoryAnswerDocument, options);
}
export type GradeTheoryAnswerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GradeTheoryAnswerMutation, Types.GradeTheoryAnswerMutationVariables>;
export const BulkUpdateCbtTestsDocument = gql`
    mutation BulkUpdateCbtTests($input: BulkUpdateCbtTestsInput!) {
  bulkUpdateCbtTests(input: $input) {
    success
    message
    affected_count
  }
}
    `;

/**
 * __useBulkUpdateCbtTestsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCbtTestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCbtTestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateCbtTestsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateCbtTestsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkUpdateCbtTestsMutation, Types.BulkUpdateCbtTestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkUpdateCbtTestsMutation, Types.BulkUpdateCbtTestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkUpdateCbtTestsMutation, Types.BulkUpdateCbtTestsMutationVariables>(BulkUpdateCbtTestsDocument, options);
}
export type BulkUpdateCbtTestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkUpdateCbtTestsMutation, Types.BulkUpdateCbtTestsMutationVariables>;
export const BulkDeleteCbtTestsDocument = gql`
    mutation BulkDeleteCbtTests($ids: [ID!]!) {
  bulkDeleteCbtTests(ids: $ids) {
    success
    message
    affected_count
  }
}
    `;

/**
 * __useBulkDeleteCbtTestsMutation__
 *
 * To run a mutation, you first call `useBulkDeleteCbtTestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteCbtTestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkDeleteCbtTestsMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteCbtTestsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkDeleteCbtTestsMutation, Types.BulkDeleteCbtTestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkDeleteCbtTestsMutation, Types.BulkDeleteCbtTestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkDeleteCbtTestsMutation, Types.BulkDeleteCbtTestsMutationVariables>(BulkDeleteCbtTestsDocument, options);
}
export type BulkDeleteCbtTestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkDeleteCbtTestsMutation, Types.BulkDeleteCbtTestsMutationVariables>;
export const AddStudentCourseToExemptDocument = gql`
    mutation AddStudentCourseToExempt($input: AddStudentCourseToExemptInput!) {
  addStudentCourseToExempt(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useAddStudentCourseToExemptMutation__
 *
 * To run a mutation, you first call `useAddStudentCourseToExemptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentCourseToExemptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddStudentCourseToExemptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddStudentCourseToExemptMutation(options: VueApolloComposable.UseMutationOptions<Types.AddStudentCourseToExemptMutation, Types.AddStudentCourseToExemptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddStudentCourseToExemptMutation, Types.AddStudentCourseToExemptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddStudentCourseToExemptMutation, Types.AddStudentCourseToExemptMutationVariables>(AddStudentCourseToExemptDocument, options);
}
export type AddStudentCourseToExemptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddStudentCourseToExemptMutation, Types.AddStudentCourseToExemptMutationVariables>;
export const UpdateStudentCourseExemptionDocument = gql`
    mutation UpdateStudentCourseExemption($id: ID!, $fields: UpdateStudentCourseExemptionInput!) {
  updateStudentCourseExemption(id: $id, fields: $fields) {
    success
    message
  }
}
    `;

/**
 * __useUpdateStudentCourseExemptionMutation__
 *
 * To run a mutation, you first call `useUpdateStudentCourseExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentCourseExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentCourseExemptionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateStudentCourseExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentCourseExemptionMutation, Types.UpdateStudentCourseExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentCourseExemptionMutation, Types.UpdateStudentCourseExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentCourseExemptionMutation, Types.UpdateStudentCourseExemptionMutationVariables>(UpdateStudentCourseExemptionDocument, options);
}
export type UpdateStudentCourseExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentCourseExemptionMutation, Types.UpdateStudentCourseExemptionMutationVariables>;
export const BulkUpdateStudentCourseExemptionDocument = gql`
    mutation BulkUpdateStudentCourseExemption($input: [BulkUpdateStudentCourseExemptionInput!]!) {
  bulkUpdateStudentCourseExemption(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useBulkUpdateStudentCourseExemptionMutation__
 *
 * To run a mutation, you first call `useBulkUpdateStudentCourseExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateStudentCourseExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateStudentCourseExemptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateStudentCourseExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkUpdateStudentCourseExemptionMutation, Types.BulkUpdateStudentCourseExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkUpdateStudentCourseExemptionMutation, Types.BulkUpdateStudentCourseExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkUpdateStudentCourseExemptionMutation, Types.BulkUpdateStudentCourseExemptionMutationVariables>(BulkUpdateStudentCourseExemptionDocument, options);
}
export type BulkUpdateStudentCourseExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkUpdateStudentCourseExemptionMutation, Types.BulkUpdateStudentCourseExemptionMutationVariables>;
export const BulkDeleteStudentCourseExemptionDocument = gql`
    mutation BulkDeleteStudentCourseExemption($ids: [ID!]!) {
  bulkDeleteStudentCourseExemption(ids: $ids) {
    success
    message
  }
}
    `;

/**
 * __useBulkDeleteStudentCourseExemptionMutation__
 *
 * To run a mutation, you first call `useBulkDeleteStudentCourseExemptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteStudentCourseExemptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkDeleteStudentCourseExemptionMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteStudentCourseExemptionMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkDeleteStudentCourseExemptionMutation, Types.BulkDeleteStudentCourseExemptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkDeleteStudentCourseExemptionMutation, Types.BulkDeleteStudentCourseExemptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkDeleteStudentCourseExemptionMutation, Types.BulkDeleteStudentCourseExemptionMutationVariables>(BulkDeleteStudentCourseExemptionDocument, options);
}
export type BulkDeleteStudentCourseExemptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkDeleteStudentCourseExemptionMutation, Types.BulkDeleteStudentCourseExemptionMutationVariables>;
export const BulkExemptByStudentsDocument = gql`
    mutation BulkExemptByStudents($input: BulkExemptByStudentsInput!) {
  bulkExemptByStudents(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useBulkExemptByStudentsMutation__
 *
 * To run a mutation, you first call `useBulkExemptByStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkExemptByStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkExemptByStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkExemptByStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkExemptByStudentsMutation, Types.BulkExemptByStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkExemptByStudentsMutation, Types.BulkExemptByStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkExemptByStudentsMutation, Types.BulkExemptByStudentsMutationVariables>(BulkExemptByStudentsDocument, options);
}
export type BulkExemptByStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkExemptByStudentsMutation, Types.BulkExemptByStudentsMutationVariables>;
export const BulkExemptDocument = gql`
    mutation BulkExempt($input: BulkExemptInput!) {
  bulkExempt(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useBulkExemptMutation__
 *
 * To run a mutation, you first call `useBulkExemptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkExemptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkExemptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkExemptMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkExemptMutation, Types.BulkExemptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkExemptMutation, Types.BulkExemptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkExemptMutation, Types.BulkExemptMutationVariables>(BulkExemptDocument, options);
}
export type BulkExemptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkExemptMutation, Types.BulkExemptMutationVariables>;
export const BulkExemptFromExcelDocument = gql`
    mutation BulkExemptFromExcel($matric_list: Upload!, $course_ids: [ID!]!) {
  bulkExemptFromExcel(matric_list: $matric_list, course_ids: $course_ids) {
    success
    message
  }
}
    `;

/**
 * __useBulkExemptFromExcelMutation__
 *
 * To run a mutation, you first call `useBulkExemptFromExcelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkExemptFromExcelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkExemptFromExcelMutation({
 *   variables: {
 *     matric_list: // value for 'matric_list'
 *     course_ids: // value for 'course_ids'
 *   },
 * });
 */
export function useBulkExemptFromExcelMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkExemptFromExcelMutation, Types.BulkExemptFromExcelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkExemptFromExcelMutation, Types.BulkExemptFromExcelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkExemptFromExcelMutation, Types.BulkExemptFromExcelMutationVariables>(BulkExemptFromExcelDocument, options);
}
export type BulkExemptFromExcelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkExemptFromExcelMutation, Types.BulkExemptFromExcelMutationVariables>;
export const SubmitCourseRegistrationDocument = gql`
    mutation SubmitCourseRegistration($input: courseRegistrationInput!) {
  submitCourseRegistration(input: $input) {
    id
    academic_session
    semester
    registration_level
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useSubmitCourseRegistrationMutation__
 *
 * To run a mutation, you first call `useSubmitCourseRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCourseRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitCourseRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCourseRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitCourseRegistrationMutation, Types.SubmitCourseRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitCourseRegistrationMutation, Types.SubmitCourseRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitCourseRegistrationMutation, Types.SubmitCourseRegistrationMutationVariables>(SubmitCourseRegistrationDocument, options);
}
export type SubmitCourseRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitCourseRegistrationMutation, Types.SubmitCourseRegistrationMutationVariables>;
export const ResubmitCourseRegistrationDocument = gql`
    mutation ResubmitCourseRegistration($input: courseRegistrationInput!) {
  resubmitCourseRegistration(input: $input) {
    id
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useResubmitCourseRegistrationMutation__
 *
 * To run a mutation, you first call `useResubmitCourseRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResubmitCourseRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResubmitCourseRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResubmitCourseRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.ResubmitCourseRegistrationMutation, Types.ResubmitCourseRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResubmitCourseRegistrationMutation, Types.ResubmitCourseRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResubmitCourseRegistrationMutation, Types.ResubmitCourseRegistrationMutationVariables>(ResubmitCourseRegistrationDocument, options);
}
export type ResubmitCourseRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResubmitCourseRegistrationMutation, Types.ResubmitCourseRegistrationMutationVariables>;
export const AttachResourceToLessonNoteDocument = gql`
    mutation attachResourceToLessonNote($input: AttachResourceToLessonNoteInput!) {
  attachResourceToLessonNote(input: $input) {
    id
    title
    description
    resourceType
    accessLevel
    externalUrl
    sortOrder
    createdAt
    updatedAt
    file {
      id
      url
      original_name
      mime_type
      extension
      size
    }
    createdBy {
      id
      name
    }
  }
}
    `;

/**
 * __useAttachResourceToLessonNoteMutation__
 *
 * To run a mutation, you first call `useAttachResourceToLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachResourceToLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachResourceToLessonNoteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAttachResourceToLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.AttachResourceToLessonNoteMutation, Types.AttachResourceToLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AttachResourceToLessonNoteMutation, Types.AttachResourceToLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AttachResourceToLessonNoteMutation, Types.AttachResourceToLessonNoteMutationVariables>(AttachResourceToLessonNoteDocument, options);
}
export type AttachResourceToLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AttachResourceToLessonNoteMutation, Types.AttachResourceToLessonNoteMutationVariables>;
export const AttachLinkResourceToLessonNoteDocument = gql`
    mutation attachLinkResourceToLessonNote($input: AttachLinkResourceToLessonNoteInput!) {
  attachLinkResourceToLessonNote(input: $input) {
    id
    title
    description
    resourceType
    accessLevel
    externalUrl
    sortOrder
    createdAt
    updatedAt
    file {
      id
      url
      original_name
      mime_type
      extension
      size
    }
    createdBy {
      id
      name
    }
  }
}
    `;

/**
 * __useAttachLinkResourceToLessonNoteMutation__
 *
 * To run a mutation, you first call `useAttachLinkResourceToLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAttachLinkResourceToLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAttachLinkResourceToLessonNoteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAttachLinkResourceToLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.AttachLinkResourceToLessonNoteMutation, Types.AttachLinkResourceToLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AttachLinkResourceToLessonNoteMutation, Types.AttachLinkResourceToLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AttachLinkResourceToLessonNoteMutation, Types.AttachLinkResourceToLessonNoteMutationVariables>(AttachLinkResourceToLessonNoteDocument, options);
}
export type AttachLinkResourceToLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AttachLinkResourceToLessonNoteMutation, Types.AttachLinkResourceToLessonNoteMutationVariables>;
export const UpdateEducationalResourceDocument = gql`
    mutation updateEducationalResource($id: ID!, $input: UpdateEducationalResourceInput!) {
  updateEducationalResource(id: $id, input: $input) {
    id
    title
    description
    resourceType
    accessLevel
    externalUrl
    sortOrder
    createdAt
    updatedAt
    file {
      id
      url
      original_name
      mime_type
      extension
      size
    }
    createdBy {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateEducationalResourceMutation__
 *
 * To run a mutation, you first call `useUpdateEducationalResourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEducationalResourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEducationalResourceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEducationalResourceMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateEducationalResourceMutation, Types.UpdateEducationalResourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateEducationalResourceMutation, Types.UpdateEducationalResourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateEducationalResourceMutation, Types.UpdateEducationalResourceMutationVariables>(UpdateEducationalResourceDocument, options);
}
export type UpdateEducationalResourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateEducationalResourceMutation, Types.UpdateEducationalResourceMutationVariables>;
export const DetachEducationalResourceDocument = gql`
    mutation detachEducationalResource($id: ID!, $deleteUnderlyingFile: Boolean) {
  detachEducationalResource(id: $id, deleteUnderlyingFile: $deleteUnderlyingFile)
}
    `;

/**
 * __useDetachEducationalResourceMutation__
 *
 * To run a mutation, you first call `useDetachEducationalResourceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDetachEducationalResourceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDetachEducationalResourceMutation({
 *   variables: {
 *     id: // value for 'id'
 *     deleteUnderlyingFile: // value for 'deleteUnderlyingFile'
 *   },
 * });
 */
export function useDetachEducationalResourceMutation(options: VueApolloComposable.UseMutationOptions<Types.DetachEducationalResourceMutation, Types.DetachEducationalResourceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DetachEducationalResourceMutation, Types.DetachEducationalResourceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DetachEducationalResourceMutation, Types.DetachEducationalResourceMutationVariables>(DetachEducationalResourceDocument, options);
}
export type DetachEducationalResourceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DetachEducationalResourceMutation, Types.DetachEducationalResourceMutationVariables>;
export const ReorderLessonNoteResourcesDocument = gql`
    mutation reorderLessonNoteResources($lessonNoteId: ID!, $resourceIds: [ID!]!) {
  reorderLessonNoteResources(
    lessonNoteId: $lessonNoteId
    resourceIds: $resourceIds
  ) {
    id
    resources {
      id
      title
      description
      resourceType
      accessLevel
      externalUrl
      sortOrder
      createdAt
      updatedAt
      file {
        id
        url
        original_name
        mime_type
        extension
        size
      }
      createdBy {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useReorderLessonNoteResourcesMutation__
 *
 * To run a mutation, you first call `useReorderLessonNoteResourcesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReorderLessonNoteResourcesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReorderLessonNoteResourcesMutation({
 *   variables: {
 *     lessonNoteId: // value for 'lessonNoteId'
 *     resourceIds: // value for 'resourceIds'
 *   },
 * });
 */
export function useReorderLessonNoteResourcesMutation(options: VueApolloComposable.UseMutationOptions<Types.ReorderLessonNoteResourcesMutation, Types.ReorderLessonNoteResourcesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReorderLessonNoteResourcesMutation, Types.ReorderLessonNoteResourcesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReorderLessonNoteResourcesMutation, Types.ReorderLessonNoteResourcesMutationVariables>(ReorderLessonNoteResourcesDocument, options);
}
export type ReorderLessonNoteResourcesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReorderLessonNoteResourcesMutation, Types.ReorderLessonNoteResourcesMutationVariables>;
export const CreateSchoolGradeDocument = gql`
    mutation createSchoolGrade($createGradeInput: SchoolGradeInput!) {
  createSchoolGrade(createGradeInput: $createGradeInput) {
    id
    name
    grade
    minimum
    maximum
    point
    group
  }
}
    `;

/**
 * __useCreateSchoolGradeMutation__
 *
 * To run a mutation, you first call `useCreateSchoolGradeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolGradeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSchoolGradeMutation({
 *   variables: {
 *     createGradeInput: // value for 'createGradeInput'
 *   },
 * });
 */
export function useCreateSchoolGradeMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSchoolGradeMutation, Types.CreateSchoolGradeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSchoolGradeMutation, Types.CreateSchoolGradeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSchoolGradeMutation, Types.CreateSchoolGradeMutationVariables>(CreateSchoolGradeDocument, options);
}
export type CreateSchoolGradeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSchoolGradeMutation, Types.CreateSchoolGradeMutationVariables>;
export const UpdateSchoolGradeDocument = gql`
    mutation updateSchoolGrade($id: ID!, $updateGradeInput: SchoolGradeInput) {
  updateSchoolGrade(id: $id, updateGradeInput: $updateGradeInput) {
    id
    name
    grade
    minimum
    maximum
    point
    group
  }
}
    `;

/**
 * __useUpdateSchoolGradeMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolGradeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolGradeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolGradeMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateGradeInput: // value for 'updateGradeInput'
 *   },
 * });
 */
export function useUpdateSchoolGradeMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolGradeMutation, Types.UpdateSchoolGradeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolGradeMutation, Types.UpdateSchoolGradeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolGradeMutation, Types.UpdateSchoolGradeMutationVariables>(UpdateSchoolGradeDocument, options);
}
export type UpdateSchoolGradeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolGradeMutation, Types.UpdateSchoolGradeMutationVariables>;
export const DeleteSchoolGradeDocument = gql`
    mutation deleteSchoolGrade($id: ID!) {
  deleteSchoolGrade(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteSchoolGradeMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolGradeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolGradeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSchoolGradeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchoolGradeMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSchoolGradeMutation, Types.DeleteSchoolGradeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSchoolGradeMutation, Types.DeleteSchoolGradeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSchoolGradeMutation, Types.DeleteSchoolGradeMutationVariables>(DeleteSchoolGradeDocument, options);
}
export type DeleteSchoolGradeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSchoolGradeMutation, Types.DeleteSchoolGradeMutationVariables>;
export const UpdateSchoolGradeGroupDocument = gql`
    mutation updateSchoolGradeGroup($id: ID!, $name: String!) {
  updateSchoolGradeGroup(id: $id, name: $name) {
    id
    name
    description
  }
}
    `;

/**
 * __useUpdateSchoolGradeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolGradeGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolGradeGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolGradeGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *   },
 * });
 */
export function useUpdateSchoolGradeGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolGradeGroupMutation, Types.UpdateSchoolGradeGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolGradeGroupMutation, Types.UpdateSchoolGradeGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolGradeGroupMutation, Types.UpdateSchoolGradeGroupMutationVariables>(UpdateSchoolGradeGroupDocument, options);
}
export type UpdateSchoolGradeGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolGradeGroupMutation, Types.UpdateSchoolGradeGroupMutationVariables>;
export const DeleteSchoolGradeGroupDocument = gql`
    mutation deleteSchoolGradeGroup($id: ID!) {
  deleteSchoolGradeGroup(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteSchoolGradeGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolGradeGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolGradeGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSchoolGradeGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchoolGradeGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSchoolGradeGroupMutation, Types.DeleteSchoolGradeGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSchoolGradeGroupMutation, Types.DeleteSchoolGradeGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSchoolGradeGroupMutation, Types.DeleteSchoolGradeGroupMutationVariables>(DeleteSchoolGradeGroupDocument, options);
}
export type DeleteSchoolGradeGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSchoolGradeGroupMutation, Types.DeleteSchoolGradeGroupMutationVariables>;
export const CreateSchoolGradeBulkDocument = gql`
    mutation createSchoolGradeBulk($inputs: [CreateSchoolGradeBulkInput!]!) {
  createSchoolGradeBulk(inputs: $inputs) {
    id
    name
    grade
    minimum
    maximum
    point
    group
  }
}
    `;

/**
 * __useCreateSchoolGradeBulkMutation__
 *
 * To run a mutation, you first call `useCreateSchoolGradeBulkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolGradeBulkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSchoolGradeBulkMutation({
 *   variables: {
 *     inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateSchoolGradeBulkMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSchoolGradeBulkMutation, Types.CreateSchoolGradeBulkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSchoolGradeBulkMutation, Types.CreateSchoolGradeBulkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSchoolGradeBulkMutation, Types.CreateSchoolGradeBulkMutationVariables>(CreateSchoolGradeBulkDocument, options);
}
export type CreateSchoolGradeBulkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSchoolGradeBulkMutation, Types.CreateSchoolGradeBulkMutationVariables>;
export const CreateGuardianDocument = gql`
    mutation createGuardian($input: CreateGuardianInput!) {
  createGuardian(input: $input) {
    ...GuardianResult
  }
}
    ${GuardianResultFragmentDoc}`;

/**
 * __useCreateGuardianMutation__
 *
 * To run a mutation, you first call `useCreateGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGuardianMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGuardianMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateGuardianMutation, Types.CreateGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateGuardianMutation, Types.CreateGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateGuardianMutation, Types.CreateGuardianMutationVariables>(CreateGuardianDocument, options);
}
export type CreateGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateGuardianMutation, Types.CreateGuardianMutationVariables>;
export const UpdateGuardianDocument = gql`
    mutation updateGuardian($id: ID!, $input: UpdateGuardianInput!) {
  updateGuardian(id: $id, input: $input) {
    ...GuardianResult
  }
}
    ${GuardianResultFragmentDoc}`;

/**
 * __useUpdateGuardianMutation__
 *
 * To run a mutation, you first call `useUpdateGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGuardianMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGuardianMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateGuardianMutation, Types.UpdateGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateGuardianMutation, Types.UpdateGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateGuardianMutation, Types.UpdateGuardianMutationVariables>(UpdateGuardianDocument, options);
}
export type UpdateGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateGuardianMutation, Types.UpdateGuardianMutationVariables>;
export const DeleteGuardianDocument = gql`
    mutation deleteGuardian($id: ID!) {
  deleteGuardian(id: $id)
}
    `;

/**
 * __useDeleteGuardianMutation__
 *
 * To run a mutation, you first call `useDeleteGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGuardianMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGuardianMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteGuardianMutation, Types.DeleteGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteGuardianMutation, Types.DeleteGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteGuardianMutation, Types.DeleteGuardianMutationVariables>(DeleteGuardianDocument, options);
}
export type DeleteGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteGuardianMutation, Types.DeleteGuardianMutationVariables>;
export const LinkGuardianToStudentDocument = gql`
    mutation linkGuardianToStudent($guardianId: ID!, $input: GuardianStudentLinkInput!) {
  linkGuardianToStudent(guardianId: $guardianId, input: $input) {
    ...GuardianStudentLinkResult
  }
}
    ${GuardianStudentLinkResultFragmentDoc}`;

/**
 * __useLinkGuardianToStudentMutation__
 *
 * To run a mutation, you first call `useLinkGuardianToStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLinkGuardianToStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLinkGuardianToStudentMutation({
 *   variables: {
 *     guardianId: // value for 'guardianId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useLinkGuardianToStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.LinkGuardianToStudentMutation, Types.LinkGuardianToStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LinkGuardianToStudentMutation, Types.LinkGuardianToStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LinkGuardianToStudentMutation, Types.LinkGuardianToStudentMutationVariables>(LinkGuardianToStudentDocument, options);
}
export type LinkGuardianToStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LinkGuardianToStudentMutation, Types.LinkGuardianToStudentMutationVariables>;
export const UnlinkGuardianFromStudentDocument = gql`
    mutation unlinkGuardianFromStudent($guardianId: ID!, $studentId: ID!) {
  unlinkGuardianFromStudent(guardianId: $guardianId, studentId: $studentId)
}
    `;

/**
 * __useUnlinkGuardianFromStudentMutation__
 *
 * To run a mutation, you first call `useUnlinkGuardianFromStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkGuardianFromStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnlinkGuardianFromStudentMutation({
 *   variables: {
 *     guardianId: // value for 'guardianId'
 *     studentId: // value for 'studentId'
 *   },
 * });
 */
export function useUnlinkGuardianFromStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.UnlinkGuardianFromStudentMutation, Types.UnlinkGuardianFromStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UnlinkGuardianFromStudentMutation, Types.UnlinkGuardianFromStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UnlinkGuardianFromStudentMutation, Types.UnlinkGuardianFromStudentMutationVariables>(UnlinkGuardianFromStudentDocument, options);
}
export type UnlinkGuardianFromStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UnlinkGuardianFromStudentMutation, Types.UnlinkGuardianFromStudentMutationVariables>;
export const UpdateGuardianStudentLinkDocument = gql`
    mutation updateGuardianStudentLink($id: ID!, $input: GuardianStudentLinkInput!) {
  updateGuardianStudentLink(id: $id, input: $input) {
    ...GuardianStudentLinkResult
  }
}
    ${GuardianStudentLinkResultFragmentDoc}`;

/**
 * __useUpdateGuardianStudentLinkMutation__
 *
 * To run a mutation, you first call `useUpdateGuardianStudentLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuardianStudentLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGuardianStudentLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGuardianStudentLinkMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateGuardianStudentLinkMutation, Types.UpdateGuardianStudentLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateGuardianStudentLinkMutation, Types.UpdateGuardianStudentLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateGuardianStudentLinkMutation, Types.UpdateGuardianStudentLinkMutationVariables>(UpdateGuardianStudentLinkDocument, options);
}
export type UpdateGuardianStudentLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateGuardianStudentLinkMutation, Types.UpdateGuardianStudentLinkMutationVariables>;
export const InviteGuardianDocument = gql`
    mutation inviteGuardian($guardianId: ID!, $email: String!) {
  inviteGuardian(guardianId: $guardianId, email: $email) {
    id
    email
    status
    expiresAt
  }
}
    `;

/**
 * __useInviteGuardianMutation__
 *
 * To run a mutation, you first call `useInviteGuardianMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteGuardianMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteGuardianMutation({
 *   variables: {
 *     guardianId: // value for 'guardianId'
 *     email: // value for 'email'
 *   },
 * });
 */
export function useInviteGuardianMutation(options: VueApolloComposable.UseMutationOptions<Types.InviteGuardianMutation, Types.InviteGuardianMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.InviteGuardianMutation, Types.InviteGuardianMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.InviteGuardianMutation, Types.InviteGuardianMutationVariables>(InviteGuardianDocument, options);
}
export type InviteGuardianMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.InviteGuardianMutation, Types.InviteGuardianMutationVariables>;
export const BroadcastToGuardiansDocument = gql`
    mutation broadcastToGuardians($guardianIds: [ID!]!, $channels: [GuardianBroadcastChannel!]!, $subject: String, $message: String!) {
  broadcastToGuardians(
    guardianIds: $guardianIds
    channels: $channels
    subject: $subject
    message: $message
  ) {
    emailsSent
    whatsappSent
    skipped
  }
}
    `;

/**
 * __useBroadcastToGuardiansMutation__
 *
 * To run a mutation, you first call `useBroadcastToGuardiansMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBroadcastToGuardiansMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBroadcastToGuardiansMutation({
 *   variables: {
 *     guardianIds: // value for 'guardianIds'
 *     channels: // value for 'channels'
 *     subject: // value for 'subject'
 *     message: // value for 'message'
 *   },
 * });
 */
export function useBroadcastToGuardiansMutation(options: VueApolloComposable.UseMutationOptions<Types.BroadcastToGuardiansMutation, Types.BroadcastToGuardiansMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BroadcastToGuardiansMutation, Types.BroadcastToGuardiansMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BroadcastToGuardiansMutation, Types.BroadcastToGuardiansMutationVariables>(BroadcastToGuardiansDocument, options);
}
export type BroadcastToGuardiansMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BroadcastToGuardiansMutation, Types.BroadcastToGuardiansMutationVariables>;
export const SearchStudentsLinkingCodesDocument = gql`
    query searchStudentsLinkingCodes($filter: StudentFilter, $first: Int = 10, $page: Int = 1) {
  students(filter: $filter, first: $first, page: $page) {
    data {
      id
      first_name
      surname
      matric_no
      linking_code
      photo
    }
  }
}
    `;

/**
 * __useSearchStudentsLinkingCodesQuery__
 *
 * To run a query within a Vue component, call `useSearchStudentsLinkingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStudentsLinkingCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSearchStudentsLinkingCodesQuery({
 *   filter: // value for 'filter'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useSearchStudentsLinkingCodesQuery(variables: Types.SearchStudentsLinkingCodesQueryVariables | VueCompositionApi.Ref<Types.SearchStudentsLinkingCodesQueryVariables> | ReactiveFunction<Types.SearchStudentsLinkingCodesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>(SearchStudentsLinkingCodesDocument, variables, options);
}
export function useSearchStudentsLinkingCodesLazyQuery(variables: Types.SearchStudentsLinkingCodesQueryVariables | VueCompositionApi.Ref<Types.SearchStudentsLinkingCodesQueryVariables> | ReactiveFunction<Types.SearchStudentsLinkingCodesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>(SearchStudentsLinkingCodesDocument, variables, options);
}
export type SearchStudentsLinkingCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SearchStudentsLinkingCodesQuery, Types.SearchStudentsLinkingCodesQueryVariables>;
export const GenerateStudentLinkingCodeDocument = gql`
    mutation generateStudentLinkingCode($studentId: ID!) {
  generateStudentLinkingCode(studentId: $studentId) {
    id
    linking_code
  }
}
    `;

/**
 * __useGenerateStudentLinkingCodeMutation__
 *
 * To run a mutation, you first call `useGenerateStudentLinkingCodeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStudentLinkingCodeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateStudentLinkingCodeMutation({
 *   variables: {
 *     studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGenerateStudentLinkingCodeMutation(options: VueApolloComposable.UseMutationOptions<Types.GenerateStudentLinkingCodeMutation, Types.GenerateStudentLinkingCodeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GenerateStudentLinkingCodeMutation, Types.GenerateStudentLinkingCodeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GenerateStudentLinkingCodeMutation, Types.GenerateStudentLinkingCodeMutationVariables>(GenerateStudentLinkingCodeDocument, options);
}
export type GenerateStudentLinkingCodeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GenerateStudentLinkingCodeMutation, Types.GenerateStudentLinkingCodeMutationVariables>;
export const BulkGenerateStudentLinkingCodesDocument = gql`
    mutation bulkGenerateStudentLinkingCodes($force: Boolean) {
  bulkGenerateStudentLinkingCodes(force: $force) {
    generated
    skipped
    total
  }
}
    `;

/**
 * __useBulkGenerateStudentLinkingCodesMutation__
 *
 * To run a mutation, you first call `useBulkGenerateStudentLinkingCodesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkGenerateStudentLinkingCodesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkGenerateStudentLinkingCodesMutation({
 *   variables: {
 *     force: // value for 'force'
 *   },
 * });
 */
export function useBulkGenerateStudentLinkingCodesMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkGenerateStudentLinkingCodesMutation, Types.BulkGenerateStudentLinkingCodesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkGenerateStudentLinkingCodesMutation, Types.BulkGenerateStudentLinkingCodesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkGenerateStudentLinkingCodesMutation, Types.BulkGenerateStudentLinkingCodesMutationVariables>(BulkGenerateStudentLinkingCodesDocument, options);
}
export type BulkGenerateStudentLinkingCodesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkGenerateStudentLinkingCodesMutation, Types.BulkGenerateStudentLinkingCodesMutationVariables>;
export const ExportStudentLinkingCodesDocument = gql`
    query exportStudentLinkingCodes {
  exportStudentLinkingCodes {
    studentName
    matricNo
    className
    programmeName
    linkingCode
  }
}
    `;

/**
 * __useExportStudentLinkingCodesQuery__
 *
 * To run a query within a Vue component, call `useExportStudentLinkingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStudentLinkingCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useExportStudentLinkingCodesQuery();
 */
export function useExportStudentLinkingCodesQuery(options: VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>(ExportStudentLinkingCodesDocument, {}, options);
}
export function useExportStudentLinkingCodesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>(ExportStudentLinkingCodesDocument, {}, options);
}
export type ExportStudentLinkingCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ExportStudentLinkingCodesQuery, Types.ExportStudentLinkingCodesQueryVariables>;
export const UserLoginDocument = gql`
    mutation userLogin($email: String!, $password: String!) {
  userLogin(email: $email, password: $password) {
    token
    message
    status
    user {
      __typename
      ... on User {
        id
        name
        email
      }
    }
  }
}
    `;

/**
 * __useUserLoginMutation__
 *
 * To run a mutation, you first call `useUserLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUserLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUserLoginMutation({
 *   variables: {
 *     email: // value for 'email'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useUserLoginMutation(options: VueApolloComposable.UseMutationOptions<Types.UserLoginMutation, Types.UserLoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UserLoginMutation, Types.UserLoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UserLoginMutation, Types.UserLoginMutationVariables>(UserLoginDocument, options);
}
export type UserLoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UserLoginMutation, Types.UserLoginMutationVariables>;
export const LoginDocument = gql`
    mutation login($identifier: String!, $password: String!) {
  login(identifier: $identifier, password: $password) {
    token
    message
    status
    school_count
    schools {
      id
      name
      logo
      school_type
      student_portal_mode
    }
    loginSchools {
      school {
        id
        name
        logo
        school_type
        student_portal_mode
      }
      portals
    }
    user {
      __typename
      ... on User {
        id
        name
        email
      }
      ... on Student {
        id
        matric_no
        first_name
        surname
        email
        school {
          school_type
          student_portal_mode
        }
      }
    }
  }
}
    `;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLoginMutation({
 *   variables: {
 *     identifier: // value for 'identifier'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(options: VueApolloComposable.UseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LoginMutation, Types.LoginMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LoginMutation, Types.LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LoginMutation, Types.LoginMutationVariables>;
export const StudentResetPasswordDocument = gql`
    mutation studentResetPassword($matricNumber: String!, $password: String!) {
  studentResetPassword(matricNumber: $matricNumber, password: $password) {
    success
    message
    code
  }
}
    `;

/**
 * __useStudentResetPasswordMutation__
 *
 * To run a mutation, you first call `useStudentResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStudentResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStudentResetPasswordMutation({
 *   variables: {
 *     matricNumber: // value for 'matricNumber'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useStudentResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.StudentResetPasswordMutation, Types.StudentResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StudentResetPasswordMutation, Types.StudentResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StudentResetPasswordMutation, Types.StudentResetPasswordMutationVariables>(StudentResetPasswordDocument, options);
}
export type StudentResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StudentResetPasswordMutation, Types.StudentResetPasswordMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useForgotPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ForgotPasswordMutation, Types.ForgotPasswordMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>(ResetPasswordDocument, options);
}
export type ResetPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResetPasswordMutation, Types.ResetPasswordMutationVariables>;
export const StudentSetPasswordWithTokenDocument = gql`
    mutation StudentSetPasswordWithToken($email: String!, $token: String!, $password: String!) {
  studentSetPasswordWithToken(email: $email, token: $token, password: $password) {
    success
    message
  }
}
    `;

/**
 * __useStudentSetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useStudentSetPasswordWithTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useStudentSetPasswordWithTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useStudentSetPasswordWithTokenMutation({
 *   variables: {
 *     email: // value for 'email'
 *     token: // value for 'token'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useStudentSetPasswordWithTokenMutation(options: VueApolloComposable.UseMutationOptions<Types.StudentSetPasswordWithTokenMutation, Types.StudentSetPasswordWithTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.StudentSetPasswordWithTokenMutation, Types.StudentSetPasswordWithTokenMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.StudentSetPasswordWithTokenMutation, Types.StudentSetPasswordWithTokenMutationVariables>(StudentSetPasswordWithTokenDocument, options);
}
export type StudentSetPasswordWithTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.StudentSetPasswordWithTokenMutation, Types.StudentSetPasswordWithTokenMutationVariables>;
export const AdminResetStudentPasswordDocument = gql`
    mutation AdminResetStudentPassword($input: AdminResetStudentPasswordInput!) {
  adminResetStudentPassword(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useAdminResetStudentPasswordMutation__
 *
 * To run a mutation, you first call `useAdminResetStudentPasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAdminResetStudentPasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAdminResetStudentPasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAdminResetStudentPasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.AdminResetStudentPasswordMutation, Types.AdminResetStudentPasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AdminResetStudentPasswordMutation, Types.AdminResetStudentPasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AdminResetStudentPasswordMutation, Types.AdminResetStudentPasswordMutationVariables>(AdminResetStudentPasswordDocument, options);
}
export type AdminResetStudentPasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AdminResetStudentPasswordMutation, Types.AdminResetStudentPasswordMutationVariables>;
export const UpdateSchoolDocument = gql`
    mutation UpdateSchool($id: ID!, $updateSchoolInput: UpdateSchoolInput!) {
  updateSchool(id: $id, updateSchoolInput: $updateSchoolInput) {
    id
    name
    email
    mobile
    website
    address
    ticket_auto_response
    attendance_type
    logo
    affiliate_logo
    affiliate_name
  }
}
    `;

/**
 * __useUpdateSchoolMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolMutation({
 *   variables: {
 *     id: // value for 'id'
 *     updateSchoolInput: // value for 'updateSchoolInput'
 *   },
 * });
 */
export function useUpdateSchoolMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolMutation, Types.UpdateSchoolMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolMutation, Types.UpdateSchoolMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolMutation, Types.UpdateSchoolMutationVariables>(UpdateSchoolDocument, options);
}
export type UpdateSchoolMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolMutation, Types.UpdateSchoolMutationVariables>;
export const UploadSchoolLogoDocument = gql`
    mutation UploadSchoolLogo($logo: Upload!) {
  uploadSchoolLogo(logo: $logo) {
    id
    name
    logo
  }
}
    `;

/**
 * __useUploadSchoolLogoMutation__
 *
 * To run a mutation, you first call `useUploadSchoolLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadSchoolLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadSchoolLogoMutation({
 *   variables: {
 *     logo: // value for 'logo'
 *   },
 * });
 */
export function useUploadSchoolLogoMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadSchoolLogoMutation, Types.UploadSchoolLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadSchoolLogoMutation, Types.UploadSchoolLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadSchoolLogoMutation, Types.UploadSchoolLogoMutationVariables>(UploadSchoolLogoDocument, options);
}
export type UploadSchoolLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadSchoolLogoMutation, Types.UploadSchoolLogoMutationVariables>;
export const UploadSchoolAffiliateLogoDocument = gql`
    mutation UploadSchoolAffiliateLogo($logo: Upload!) {
  uploadSchoolAffiliateLogo(logo: $logo) {
    id
    affiliate_logo
    affiliate_name
  }
}
    `;

/**
 * __useUploadSchoolAffiliateLogoMutation__
 *
 * To run a mutation, you first call `useUploadSchoolAffiliateLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadSchoolAffiliateLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadSchoolAffiliateLogoMutation({
 *   variables: {
 *     logo: // value for 'logo'
 *   },
 * });
 */
export function useUploadSchoolAffiliateLogoMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadSchoolAffiliateLogoMutation, Types.UploadSchoolAffiliateLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadSchoolAffiliateLogoMutation, Types.UploadSchoolAffiliateLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadSchoolAffiliateLogoMutation, Types.UploadSchoolAffiliateLogoMutationVariables>(UploadSchoolAffiliateLogoDocument, options);
}
export type UploadSchoolAffiliateLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadSchoolAffiliateLogoMutation, Types.UploadSchoolAffiliateLogoMutationVariables>;
export const RemoveSchoolAffiliateLogoDocument = gql`
    mutation RemoveSchoolAffiliateLogo {
  removeSchoolAffiliateLogo {
    id
    affiliate_logo
    affiliate_name
  }
}
    `;

/**
 * __useRemoveSchoolAffiliateLogoMutation__
 *
 * To run a mutation, you first call `useRemoveSchoolAffiliateLogoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSchoolAffiliateLogoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveSchoolAffiliateLogoMutation();
 */
export function useRemoveSchoolAffiliateLogoMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveSchoolAffiliateLogoMutation, Types.RemoveSchoolAffiliateLogoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveSchoolAffiliateLogoMutation, Types.RemoveSchoolAffiliateLogoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveSchoolAffiliateLogoMutation, Types.RemoveSchoolAffiliateLogoMutationVariables>(RemoveSchoolAffiliateLogoDocument, options);
}
export type RemoveSchoolAffiliateLogoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveSchoolAffiliateLogoMutation, Types.RemoveSchoolAffiliateLogoMutationVariables>;
export const UploadStudentPhotoDocument = gql`
    mutation UploadStudentPhoto($student_id: ID!, $photo: Upload!) {
  uploadStudentPhoto(student_id: $student_id, photo: $photo) {
    id
    photo
  }
}
    `;

/**
 * __useUploadStudentPhotoMutation__
 *
 * To run a mutation, you first call `useUploadStudentPhotoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadStudentPhotoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadStudentPhotoMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *     photo: // value for 'photo'
 *   },
 * });
 */
export function useUploadStudentPhotoMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadStudentPhotoMutation, Types.UploadStudentPhotoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadStudentPhotoMutation, Types.UploadStudentPhotoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadStudentPhotoMutation, Types.UploadStudentPhotoMutationVariables>(UploadStudentPhotoDocument, options);
}
export type UploadStudentPhotoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadStudentPhotoMutation, Types.UploadStudentPhotoMutationVariables>;
export const UploadMyPhotoDocument = gql`
    mutation UploadMyPhoto($photo: Upload!) {
  uploadMyPhoto(photo: $photo) {
    id
    photo
  }
}
    `;

/**
 * __useUploadMyPhotoMutation__
 *
 * To run a mutation, you first call `useUploadMyPhotoMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUploadMyPhotoMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUploadMyPhotoMutation({
 *   variables: {
 *     photo: // value for 'photo'
 *   },
 * });
 */
export function useUploadMyPhotoMutation(options: VueApolloComposable.UseMutationOptions<Types.UploadMyPhotoMutation, Types.UploadMyPhotoMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UploadMyPhotoMutation, Types.UploadMyPhotoMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UploadMyPhotoMutation, Types.UploadMyPhotoMutationVariables>(UploadMyPhotoDocument, options);
}
export type UploadMyPhotoMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UploadMyPhotoMutation, Types.UploadMyPhotoMutationVariables>;
export const UpdateMyProfileDocument = gql`
    mutation UpdateMyProfile($email: String, $phone: String) {
  updateMyProfile(email: $email, phone: $phone) {
    id
    email
    phone
  }
}
    `;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMyProfileMutation({
 *   variables: {
 *     email: // value for 'email'
 *     phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateMyProfileMutation, Types.UpdateMyProfileMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateMyProfileMutation, Types.UpdateMyProfileMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateMyProfileMutation, Types.UpdateMyProfileMutationVariables>(UpdateMyProfileDocument, options);
}
export type UpdateMyProfileMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateMyProfileMutation, Types.UpdateMyProfileMutationVariables>;
export const UpdateSchoolSettingsDocument = gql`
    mutation UpdateSchoolSettings($settings: JSON!) {
  updateSchoolSettings(settings: $settings) {
    id
    settings
  }
}
    `;

/**
 * __useUpdateSchoolSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolSettingsMutation({
 *   variables: {
 *     settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateSchoolSettingsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolSettingsMutation, Types.UpdateSchoolSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolSettingsMutation, Types.UpdateSchoolSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolSettingsMutation, Types.UpdateSchoolSettingsMutationVariables>(UpdateSchoolSettingsDocument, options);
}
export type UpdateSchoolSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolSettingsMutation, Types.UpdateSchoolSettingsMutationVariables>;
export const DeleteStaffDocument = gql`
    mutation DeleteStaff($staffId: ID!) {
  deleteStaff(staffId: $staffId)
}
    `;

/**
 * __useDeleteStaffMutation__
 *
 * To run a mutation, you first call `useDeleteStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStaffMutation({
 *   variables: {
 *     staffId: // value for 'staffId'
 *   },
 * });
 */
export function useDeleteStaffMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteStaffMutation, Types.DeleteStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteStaffMutation, Types.DeleteStaffMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteStaffMutation, Types.DeleteStaffMutationVariables>(DeleteStaffDocument, options);
}
export type DeleteStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteStaffMutation, Types.DeleteStaffMutationVariables>;
export const UpdateStaffStatusDocument = gql`
    mutation UpdateStaffStatus($staffId: ID!, $status: StaffStatus!, $reason: String) {
  updateStaffStatus(staffId: $staffId, status: $status, reason: $reason) {
    id
    status
  }
}
    `;

/**
 * __useUpdateStaffStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStaffStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStaffStatusMutation({
 *   variables: {
 *     staffId: // value for 'staffId'
 *     status: // value for 'status'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateStaffStatusMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStaffStatusMutation, Types.UpdateStaffStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStaffStatusMutation, Types.UpdateStaffStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStaffStatusMutation, Types.UpdateStaffStatusMutationVariables>(UpdateStaffStatusDocument, options);
}
export type UpdateStaffStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStaffStatusMutation, Types.UpdateStaffStatusMutationVariables>;
export const DismissTourIntroDocument = gql`
    mutation DismissTourIntro {
  dismissTourIntro
}
    `;

/**
 * __useDismissTourIntroMutation__
 *
 * To run a mutation, you first call `useDismissTourIntroMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissTourIntroMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissTourIntroMutation();
 */
export function useDismissTourIntroMutation(options: VueApolloComposable.UseMutationOptions<Types.DismissTourIntroMutation, Types.DismissTourIntroMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DismissTourIntroMutation, Types.DismissTourIntroMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DismissTourIntroMutation, Types.DismissTourIntroMutationVariables>(DismissTourIntroDocument, options);
}
export type DismissTourIntroMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DismissTourIntroMutation, Types.DismissTourIntroMutationVariables>;
export const DismissNoticeDocument = gql`
    mutation DismissNotice($notice: DismissibleNotice!) {
  dismissNotice(notice: $notice)
}
    `;

/**
 * __useDismissNoticeMutation__
 *
 * To run a mutation, you first call `useDismissNoticeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissNoticeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissNoticeMutation({
 *   variables: {
 *     notice: // value for 'notice'
 *   },
 * });
 */
export function useDismissNoticeMutation(options: VueApolloComposable.UseMutationOptions<Types.DismissNoticeMutation, Types.DismissNoticeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DismissNoticeMutation, Types.DismissNoticeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DismissNoticeMutation, Types.DismissNoticeMutationVariables>(DismissNoticeDocument, options);
}
export type DismissNoticeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DismissNoticeMutation, Types.DismissNoticeMutationVariables>;
export const AssignStaffDepartmentDocument = gql`
    mutation AssignStaffDepartment($staff_id: ID!, $department_id: ID) {
  assignStaffDepartment(staff_id: $staff_id, department_id: $department_id) {
    id
    name
    department_id
    department {
      id
      department_name
      faculty_id
      faculty {
        id
        faculty_name
      }
    }
  }
}
    `;

/**
 * __useAssignStaffDepartmentMutation__
 *
 * To run a mutation, you first call `useAssignStaffDepartmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignStaffDepartmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignStaffDepartmentMutation({
 *   variables: {
 *     staff_id: // value for 'staff_id'
 *     department_id: // value for 'department_id'
 *   },
 * });
 */
export function useAssignStaffDepartmentMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignStaffDepartmentMutation, Types.AssignStaffDepartmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignStaffDepartmentMutation, Types.AssignStaffDepartmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignStaffDepartmentMutation, Types.AssignStaffDepartmentMutationVariables>(AssignStaffDepartmentDocument, options);
}
export type AssignStaffDepartmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignStaffDepartmentMutation, Types.AssignStaffDepartmentMutationVariables>;
export const CreateSchoolDocument = gql`
    mutation CreateSchool($createSchoolInput: CreateSchoolInput!, $userRegisterInput: UserRegisterInput!) {
  createSchool(
    createSchoolInput: $createSchoolInput
    userRegisterInput: $userRegisterInput
  ) {
    id
    name
    address
    mobile
    website
    email
    logo
  }
}
    `;

/**
 * __useCreateSchoolMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSchoolMutation({
 *   variables: {
 *     createSchoolInput: // value for 'createSchoolInput'
 *     userRegisterInput: // value for 'userRegisterInput'
 *   },
 * });
 */
export function useCreateSchoolMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSchoolMutation, Types.CreateSchoolMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSchoolMutation, Types.CreateSchoolMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSchoolMutation, Types.CreateSchoolMutationVariables>(CreateSchoolDocument, options);
}
export type CreateSchoolMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSchoolMutation, Types.CreateSchoolMutationVariables>;
export const CreateBillsForGroupDocument = gql`
    mutation CreateBillsForGroup($input: CreateBillsInput!) {
  createBills(input: $input) {
    id
    amount
    due_date
    status
    billable_type
    billable_id
    academic_calendar_id
    session_id
    school_id
    billDetails {
      id
      amount
      bill_item_template_id
      billItemTemplate {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCreateBillsForGroupMutation__
 *
 * To run a mutation, you first call `useCreateBillsForGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillsForGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBillsForGroupMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBillsForGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateBillsForGroupMutation, Types.CreateBillsForGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateBillsForGroupMutation, Types.CreateBillsForGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateBillsForGroupMutation, Types.CreateBillsForGroupMutationVariables>(CreateBillsForGroupDocument, options);
}
export type CreateBillsForGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateBillsForGroupMutation, Types.CreateBillsForGroupMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(options: VueApolloComposable.UseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ChangePasswordMutation, Types.ChangePasswordMutationVariables>;
export const UpdatePdfResultConfigDocument = gql`
    mutation UpdatePdfResultConfig($input: PdfResultConfigInput!) {
  updatePdfResultConfig(input: $input) {
    preset
    logo_position
    logo_height
    show_school_name
    show_school_address
    show_report_title
    report_title
    subject_column_width
    font_size
    header_font_size
    row_padding
    show_borders
    striped_rows
    alternate_row_color
    show_student_info
    student_info_fields
    show_summary
    show_grading_key
    show_attendance
    show_remarks
    show_footer
    footer_text
    page_size
    page_orientation
    page_margin
    show_signature_lines
    signature_labels
    show_watermark
    watermark_text
    show_next_term_date
  }
}
    `;

/**
 * __useUpdatePdfResultConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePdfResultConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePdfResultConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePdfResultConfigMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePdfResultConfigMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdatePdfResultConfigMutation, Types.UpdatePdfResultConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdatePdfResultConfigMutation, Types.UpdatePdfResultConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdatePdfResultConfigMutation, Types.UpdatePdfResultConfigMutationVariables>(UpdatePdfResultConfigDocument, options);
}
export type UpdatePdfResultConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdatePdfResultConfigMutation, Types.UpdatePdfResultConfigMutationVariables>;
export const CreateLessonNoteDocument = gql`
    mutation createLessonNote($input: CreateLessonNoteInput!) {
  createLessonNote(input: $input) {
    id
    title
    body
    status
    aiGenerated
    aiModel
    aiGeneratedAt
    createdAt
    updatedAt
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    schemeWeek {
      id
      weekNumber
      topic
      schemeOfWork {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useCreateLessonNoteMutation__
 *
 * To run a mutation, you first call `useCreateLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateLessonNoteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateLessonNoteMutation, Types.CreateLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateLessonNoteMutation, Types.CreateLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateLessonNoteMutation, Types.CreateLessonNoteMutationVariables>(CreateLessonNoteDocument, options);
}
export type CreateLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateLessonNoteMutation, Types.CreateLessonNoteMutationVariables>;
export const GenerateLessonNoteWithAiDocument = gql`
    mutation generateLessonNoteWithAi($input: GenerateLessonNoteWithAiInput!) {
  generateLessonNoteWithAi(input: $input) {
    id
    title
    body
    status
    aiGenerated
    aiModel
    aiGeneratedAt
    createdAt
    updatedAt
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    schemeWeek {
      id
      weekNumber
      topic
      schemeOfWork {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useGenerateLessonNoteWithAiMutation__
 *
 * To run a mutation, you first call `useGenerateLessonNoteWithAiMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLessonNoteWithAiMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateLessonNoteWithAiMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLessonNoteWithAiMutation(options: VueApolloComposable.UseMutationOptions<Types.GenerateLessonNoteWithAiMutation, Types.GenerateLessonNoteWithAiMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GenerateLessonNoteWithAiMutation, Types.GenerateLessonNoteWithAiMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GenerateLessonNoteWithAiMutation, Types.GenerateLessonNoteWithAiMutationVariables>(GenerateLessonNoteWithAiDocument, options);
}
export type GenerateLessonNoteWithAiMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GenerateLessonNoteWithAiMutation, Types.GenerateLessonNoteWithAiMutationVariables>;
export const UpdateLessonNoteDocument = gql`
    mutation updateLessonNote($id: ID!, $input: UpdateLessonNoteInput!) {
  updateLessonNote(id: $id, input: $input) {
    id
    title
    body
    status
    aiGenerated
    aiModel
    aiGeneratedAt
    createdAt
    updatedAt
    schemeWeek {
      id
      weekNumber
      topic
      schemeOfWork {
        id
        title
      }
    }
  }
}
    `;

/**
 * __useUpdateLessonNoteMutation__
 *
 * To run a mutation, you first call `useUpdateLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLessonNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateLessonNoteMutation, Types.UpdateLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateLessonNoteMutation, Types.UpdateLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateLessonNoteMutation, Types.UpdateLessonNoteMutationVariables>(UpdateLessonNoteDocument, options);
}
export type UpdateLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateLessonNoteMutation, Types.UpdateLessonNoteMutationVariables>;
export const DeleteLessonNoteDocument = gql`
    mutation deleteLessonNote($id: ID!) {
  deleteLessonNote(id: $id)
}
    `;

/**
 * __useDeleteLessonNoteMutation__
 *
 * To run a mutation, you first call `useDeleteLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLessonNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteLessonNoteMutation, Types.DeleteLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteLessonNoteMutation, Types.DeleteLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteLessonNoteMutation, Types.DeleteLessonNoteMutationVariables>(DeleteLessonNoteDocument, options);
}
export type DeleteLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteLessonNoteMutation, Types.DeleteLessonNoteMutationVariables>;
export const SubmitLessonNoteForReviewDocument = gql`
    mutation submitLessonNoteForReview($id: ID!) {
  submitLessonNoteForReview(id: $id) {
    id
    status
    submittedAt
    submittedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useSubmitLessonNoteForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitLessonNoteForReviewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLessonNoteForReviewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitLessonNoteForReviewMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSubmitLessonNoteForReviewMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitLessonNoteForReviewMutation, Types.SubmitLessonNoteForReviewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitLessonNoteForReviewMutation, Types.SubmitLessonNoteForReviewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitLessonNoteForReviewMutation, Types.SubmitLessonNoteForReviewMutationVariables>(SubmitLessonNoteForReviewDocument, options);
}
export type SubmitLessonNoteForReviewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitLessonNoteForReviewMutation, Types.SubmitLessonNoteForReviewMutationVariables>;
export const ApproveLessonNoteDocument = gql`
    mutation approveLessonNote($id: ID!, $notes: String) {
  approveLessonNote(id: $id, notes: $notes) {
    id
    status
    reviewedAt
    reviewNotes
    reviewedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useApproveLessonNoteMutation__
 *
 * To run a mutation, you first call `useApproveLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveLessonNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     notes: // value for 'notes'
 *   },
 * });
 */
export function useApproveLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveLessonNoteMutation, Types.ApproveLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveLessonNoteMutation, Types.ApproveLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveLessonNoteMutation, Types.ApproveLessonNoteMutationVariables>(ApproveLessonNoteDocument, options);
}
export type ApproveLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveLessonNoteMutation, Types.ApproveLessonNoteMutationVariables>;
export const RejectLessonNoteDocument = gql`
    mutation rejectLessonNote($id: ID!, $notes: String!) {
  rejectLessonNote(id: $id, notes: $notes) {
    id
    status
    reviewedAt
    reviewNotes
    reviewedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useRejectLessonNoteMutation__
 *
 * To run a mutation, you first call `useRejectLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectLessonNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *     notes: // value for 'notes'
 *   },
 * });
 */
export function useRejectLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectLessonNoteMutation, Types.RejectLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectLessonNoteMutation, Types.RejectLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectLessonNoteMutation, Types.RejectLessonNoteMutationVariables>(RejectLessonNoteDocument, options);
}
export type RejectLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectLessonNoteMutation, Types.RejectLessonNoteMutationVariables>;
export const PublishLessonNoteDocument = gql`
    mutation publishLessonNote($id: ID!) {
  publishLessonNote(id: $id) {
    id
    status
  }
}
    `;

/**
 * __usePublishLessonNoteMutation__
 *
 * To run a mutation, you first call `usePublishLessonNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishLessonNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishLessonNoteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function usePublishLessonNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.PublishLessonNoteMutation, Types.PublishLessonNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PublishLessonNoteMutation, Types.PublishLessonNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PublishLessonNoteMutation, Types.PublishLessonNoteMutationVariables>(PublishLessonNoteDocument, options);
}
export type PublishLessonNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PublishLessonNoteMutation, Types.PublishLessonNoteMutationVariables>;
export const BulkUpdateCurriculumDocument = gql`
    mutation BulkUpdateCurriculum($ids: [ID!]!, $status: String, $course_registration_level: String, $semester: Int, $programme_id: ID, $programme_module_id: ID, $remove_from_module: Boolean) {
  bulkUpdateCurriculum(
    ids: $ids
    status: $status
    course_registration_level: $course_registration_level
    semester: $semester
    programme_id: $programme_id
    programme_module_id: $programme_module_id
    remove_from_module: $remove_from_module
  ) {
    success
    message
  }
}
    `;

/**
 * __useBulkUpdateCurriculumMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCurriculumMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCurriculumMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateCurriculumMutation({
 *   variables: {
 *     ids: // value for 'ids'
 *     status: // value for 'status'
 *     course_registration_level: // value for 'course_registration_level'
 *     semester: // value for 'semester'
 *     programme_id: // value for 'programme_id'
 *     programme_module_id: // value for 'programme_module_id'
 *     remove_from_module: // value for 'remove_from_module'
 *   },
 * });
 */
export function useBulkUpdateCurriculumMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkUpdateCurriculumMutation, Types.BulkUpdateCurriculumMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkUpdateCurriculumMutation, Types.BulkUpdateCurriculumMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkUpdateCurriculumMutation, Types.BulkUpdateCurriculumMutationVariables>(BulkUpdateCurriculumDocument, options);
}
export type BulkUpdateCurriculumMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkUpdateCurriculumMutation, Types.BulkUpdateCurriculumMutationVariables>;
export const CloneModulesWithCoursesDocument = gql`
    mutation CloneModulesWithCourses($input: cloneProgrammeModulesInput!) {
  cloneProgrammeModules(input: $input) {
    created
    skipped
    modules {
      id
      name
    }
  }
}
    `;

/**
 * __useCloneModulesWithCoursesMutation__
 *
 * To run a mutation, you first call `useCloneModulesWithCoursesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloneModulesWithCoursesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloneModulesWithCoursesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCloneModulesWithCoursesMutation(options: VueApolloComposable.UseMutationOptions<Types.CloneModulesWithCoursesMutation, Types.CloneModulesWithCoursesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CloneModulesWithCoursesMutation, Types.CloneModulesWithCoursesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CloneModulesWithCoursesMutation, Types.CloneModulesWithCoursesMutationVariables>(CloneModulesWithCoursesDocument, options);
}
export type CloneModulesWithCoursesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CloneModulesWithCoursesMutation, Types.CloneModulesWithCoursesMutationVariables>;
export const AddModuleElectivesDocument = gql`
    mutation AddModuleElectives($moduleId: ID!, $calendarId: ID!, $courseIds: [ID!]!) {
  addModuleElectiveOfferings(
    module_id: $moduleId
    academic_calendar_id: $calendarId
    course_ids: $courseIds
  ) {
    success
    message
  }
}
    `;

/**
 * __useAddModuleElectivesMutation__
 *
 * To run a mutation, you first call `useAddModuleElectivesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddModuleElectivesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddModuleElectivesMutation({
 *   variables: {
 *     moduleId: // value for 'moduleId'
 *     calendarId: // value for 'calendarId'
 *     courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useAddModuleElectivesMutation(options: VueApolloComposable.UseMutationOptions<Types.AddModuleElectivesMutation, Types.AddModuleElectivesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddModuleElectivesMutation, Types.AddModuleElectivesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddModuleElectivesMutation, Types.AddModuleElectivesMutationVariables>(AddModuleElectivesDocument, options);
}
export type AddModuleElectivesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddModuleElectivesMutation, Types.AddModuleElectivesMutationVariables>;
export const RemoveModuleElectiveDocument = gql`
    mutation RemoveModuleElective($moduleId: ID!, $offeringId: ID!) {
  removeModuleElectiveOffering(module_id: $moduleId, offering_id: $offeringId) {
    success
    message
  }
}
    `;

/**
 * __useRemoveModuleElectiveMutation__
 *
 * To run a mutation, you first call `useRemoveModuleElectiveMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModuleElectiveMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveModuleElectiveMutation({
 *   variables: {
 *     moduleId: // value for 'moduleId'
 *     offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useRemoveModuleElectiveMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveModuleElectiveMutation, Types.RemoveModuleElectiveMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveModuleElectiveMutation, Types.RemoveModuleElectiveMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveModuleElectiveMutation, Types.RemoveModuleElectiveMutationVariables>(RemoveModuleElectiveDocument, options);
}
export type RemoveModuleElectiveMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveModuleElectiveMutation, Types.RemoveModuleElectiveMutationVariables>;
export const PrepareModuleRegistrationPaymentsDocument = gql`
    mutation PrepareModuleRegistrationPayments($module_ids: [ID!]!, $initiate_retake: Boolean) {
  prepareModuleRegistrationPayments(
    module_ids: $module_ids
    initiate_retake: $initiate_retake
  ) {
    amount
    paid
    outstanding
    cleared
    modules {
      module_id
      module_name
      bill_id
      amount
      paid
      outstanding
      cleared
      attempt_number
    }
  }
}
    `;

/**
 * __usePrepareModuleRegistrationPaymentsMutation__
 *
 * To run a mutation, you first call `usePrepareModuleRegistrationPaymentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePrepareModuleRegistrationPaymentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePrepareModuleRegistrationPaymentsMutation({
 *   variables: {
 *     module_ids: // value for 'module_ids'
 *     initiate_retake: // value for 'initiate_retake'
 *   },
 * });
 */
export function usePrepareModuleRegistrationPaymentsMutation(options: VueApolloComposable.UseMutationOptions<Types.PrepareModuleRegistrationPaymentsMutation, Types.PrepareModuleRegistrationPaymentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PrepareModuleRegistrationPaymentsMutation, Types.PrepareModuleRegistrationPaymentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PrepareModuleRegistrationPaymentsMutation, Types.PrepareModuleRegistrationPaymentsMutationVariables>(PrepareModuleRegistrationPaymentsDocument, options);
}
export type PrepareModuleRegistrationPaymentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PrepareModuleRegistrationPaymentsMutation, Types.PrepareModuleRegistrationPaymentsMutationVariables>;
export const MoveRegisteredCoursesToModuleDocument = gql`
    mutation MoveRegisteredCoursesToModule($course_registration_id: ID!, $course_registered_ids: [ID!]!, $programme_module_id: ID!, $ignore_unit_check: Boolean) {
  moveRegisteredCoursesToModule(
    course_registration_id: $course_registration_id
    course_registered_ids: $course_registered_ids
    programme_module_id: $programme_module_id
    ignore_unit_check: $ignore_unit_check
  ) {
    success
    message
  }
}
    `;

/**
 * __useMoveRegisteredCoursesToModuleMutation__
 *
 * To run a mutation, you first call `useMoveRegisteredCoursesToModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMoveRegisteredCoursesToModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMoveRegisteredCoursesToModuleMutation({
 *   variables: {
 *     course_registration_id: // value for 'course_registration_id'
 *     course_registered_ids: // value for 'course_registered_ids'
 *     programme_module_id: // value for 'programme_module_id'
 *     ignore_unit_check: // value for 'ignore_unit_check'
 *   },
 * });
 */
export function useMoveRegisteredCoursesToModuleMutation(options: VueApolloComposable.UseMutationOptions<Types.MoveRegisteredCoursesToModuleMutation, Types.MoveRegisteredCoursesToModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MoveRegisteredCoursesToModuleMutation, Types.MoveRegisteredCoursesToModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MoveRegisteredCoursesToModuleMutation, Types.MoveRegisteredCoursesToModuleMutationVariables>(MoveRegisteredCoursesToModuleDocument, options);
}
export type MoveRegisteredCoursesToModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MoveRegisteredCoursesToModuleMutation, Types.MoveRegisteredCoursesToModuleMutationVariables>;
export const InitiatePaymentDocument = gql`
    mutation InitiatePayment($input: InitiatePaymentInput!) {
  initiatePayment(input: $input) {
    paymentUrl
    hash
    rrr
    redirectUrl
    convenienceFee
    baseAmount
    totalAmount
    paymentMethod
    merchantCode
    payItemId
    customerEmail
    customerId
    customerName
    transactionReference
    amountInKobo
    currency
    paymentPageUrl
    inlineCheckoutUrl
    mode
    splitAccounts
  }
}
    `;

/**
 * __useInitiatePaymentMutation__
 *
 * To run a mutation, you first call `useInitiatePaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInitiatePaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useInitiatePaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.InitiatePaymentMutation, Types.InitiatePaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.InitiatePaymentMutation, Types.InitiatePaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.InitiatePaymentMutation, Types.InitiatePaymentMutationVariables>(InitiatePaymentDocument, options);
}
export type InitiatePaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.InitiatePaymentMutation, Types.InitiatePaymentMutationVariables>;
export const SetPaymentProviderDocument = gql`
    mutation SetPaymentProvider($input: PaymentProviderInput!) {
  setPaymentProvider(input: $input) {
    id
    school_id
    name
    config {
      ... on MonnifyConfig {
        monnifyApiKey: apiKey
        secretKey
        contractCode
      }
      ... on RemitaConfig {
        remitaApiKey: apiKey
        serviceTypeId
        merchantId
      }
      ... on PaystackConfig {
        paystackApiKey: apiKey
      }
    }
  }
}
    `;

/**
 * __useSetPaymentProviderMutation__
 *
 * To run a mutation, you first call `useSetPaymentProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPaymentProviderMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetPaymentProviderMutation(options: VueApolloComposable.UseMutationOptions<Types.SetPaymentProviderMutation, Types.SetPaymentProviderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetPaymentProviderMutation, Types.SetPaymentProviderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetPaymentProviderMutation, Types.SetPaymentProviderMutationVariables>(SetPaymentProviderDocument, options);
}
export type SetPaymentProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetPaymentProviderMutation, Types.SetPaymentProviderMutationVariables>;
export const TogglePaymentProviderDocument = gql`
    mutation TogglePaymentProvider($id: ID!, $is_active: Boolean!) {
  togglePaymentProvider(id: $id, is_active: $is_active) {
    id
    name
    is_active
  }
}
    `;

/**
 * __useTogglePaymentProviderMutation__
 *
 * To run a mutation, you first call `useTogglePaymentProviderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useTogglePaymentProviderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useTogglePaymentProviderMutation({
 *   variables: {
 *     id: // value for 'id'
 *     is_active: // value for 'is_active'
 *   },
 * });
 */
export function useTogglePaymentProviderMutation(options: VueApolloComposable.UseMutationOptions<Types.TogglePaymentProviderMutation, Types.TogglePaymentProviderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.TogglePaymentProviderMutation, Types.TogglePaymentProviderMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.TogglePaymentProviderMutation, Types.TogglePaymentProviderMutationVariables>(TogglePaymentProviderDocument, options);
}
export type TogglePaymentProviderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.TogglePaymentProviderMutation, Types.TogglePaymentProviderMutationVariables>;
export const RecordManualPaymentDocument = gql`
    mutation RecordManualPayment($input: RecordPaymentInput!) {
  recordPayment(input: $input) {
    id
    amount
    status
  }
}
    `;

/**
 * __useRecordManualPaymentMutation__
 *
 * To run a mutation, you first call `useRecordManualPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRecordManualPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRecordManualPaymentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRecordManualPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.RecordManualPaymentMutation, Types.RecordManualPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RecordManualPaymentMutation, Types.RecordManualPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RecordManualPaymentMutation, Types.RecordManualPaymentMutationVariables>(RecordManualPaymentDocument, options);
}
export type RecordManualPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RecordManualPaymentMutation, Types.RecordManualPaymentMutationVariables>;
export const CreatePermissionGroupDocument = gql`
    mutation CreatePermissionGroup($name: String!, $description: String, $permissions: [PermissionInput!]) {
  createPermissionGroup(
    name: $name
    description: $description
    permissions: $permissions
  ) {
    id
    name
    description
    permissions {
      id
      action
      resource
      key
    }
  }
}
    `;

/**
 * __useCreatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useCreatePermissionGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePermissionGroupMutation({
 *   variables: {
 *     name: // value for 'name'
 *     description: // value for 'description'
 *     permissions: // value for 'permissions'
 *   },
 * });
 */
export function useCreatePermissionGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.CreatePermissionGroupMutation, Types.CreatePermissionGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreatePermissionGroupMutation, Types.CreatePermissionGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreatePermissionGroupMutation, Types.CreatePermissionGroupMutationVariables>(CreatePermissionGroupDocument, options);
}
export type CreatePermissionGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreatePermissionGroupMutation, Types.CreatePermissionGroupMutationVariables>;
export const UpdatePermissionGroupDocument = gql`
    mutation UpdatePermissionGroup($id: ID!, $name: String, $description: String, $permissions: [PermissionInput!]) {
  updatePermissionGroup(
    id: $id
    name: $name
    description: $description
    permissions: $permissions
  ) {
    id
    name
    description
    permissions {
      id
      action
      resource
      key
    }
  }
}
    `;

/**
 * __useUpdatePermissionGroupMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePermissionGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     description: // value for 'description'
 *     permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdatePermissionGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdatePermissionGroupMutation, Types.UpdatePermissionGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdatePermissionGroupMutation, Types.UpdatePermissionGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdatePermissionGroupMutation, Types.UpdatePermissionGroupMutationVariables>(UpdatePermissionGroupDocument, options);
}
export type UpdatePermissionGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdatePermissionGroupMutation, Types.UpdatePermissionGroupMutationVariables>;
export const DeletePermissionGroupDocument = gql`
    mutation DeletePermissionGroup($id: ID!) {
  deletePermissionGroup(id: $id)
}
    `;

/**
 * __useDeletePermissionGroupMutation__
 *
 * To run a mutation, you first call `useDeletePermissionGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePermissionGroupMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeletePermissionGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.DeletePermissionGroupMutation, Types.DeletePermissionGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeletePermissionGroupMutation, Types.DeletePermissionGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeletePermissionGroupMutation, Types.DeletePermissionGroupMutationVariables>(DeletePermissionGroupDocument, options);
}
export type DeletePermissionGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeletePermissionGroupMutation, Types.DeletePermissionGroupMutationVariables>;
export const AssignPermissionGroupDocument = gql`
    mutation AssignPermissionGroup($user_id: ID!, $input: AssignPermissionGroupInput!) {
  assignPermissionGroup(user_id: $user_id, input: $input) {
    success
    message
  }
}
    `;

/**
 * __useAssignPermissionGroupMutation__
 *
 * To run a mutation, you first call `useAssignPermissionGroupMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignPermissionGroupMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignPermissionGroupMutation({
 *   variables: {
 *     user_id: // value for 'user_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignPermissionGroupMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignPermissionGroupMutation, Types.AssignPermissionGroupMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignPermissionGroupMutation, Types.AssignPermissionGroupMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignPermissionGroupMutation, Types.AssignPermissionGroupMutationVariables>(AssignPermissionGroupDocument, options);
}
export type AssignPermissionGroupMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignPermissionGroupMutation, Types.AssignPermissionGroupMutationVariables>;
export const RemovePermissionGroupFromUserDocument = gql`
    mutation RemovePermissionGroupFromUser($group_id: ID!, $user_id: ID!) {
  removePermissionGroupFromUser(group_id: $group_id, user_id: $user_id) {
    success
    message
  }
}
    `;

/**
 * __useRemovePermissionGroupFromUserMutation__
 *
 * To run a mutation, you first call `useRemovePermissionGroupFromUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermissionGroupFromUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemovePermissionGroupFromUserMutation({
 *   variables: {
 *     group_id: // value for 'group_id'
 *     user_id: // value for 'user_id'
 *   },
 * });
 */
export function useRemovePermissionGroupFromUserMutation(options: VueApolloComposable.UseMutationOptions<Types.RemovePermissionGroupFromUserMutation, Types.RemovePermissionGroupFromUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemovePermissionGroupFromUserMutation, Types.RemovePermissionGroupFromUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemovePermissionGroupFromUserMutation, Types.RemovePermissionGroupFromUserMutationVariables>(RemovePermissionGroupFromUserDocument, options);
}
export type RemovePermissionGroupFromUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemovePermissionGroupFromUserMutation, Types.RemovePermissionGroupFromUserMutationVariables>;
export const ApproveRoleRequestsDocument = gql`
    mutation ApproveRoleRequests($input: BatchRoleActionInput!) {
  approveRoleRequests(input: $input) {
    id
    status
    grant_type
    is_active
    reviewed_at
    reviewed_by {
      id
      name
    }
  }
}
    `;

/**
 * __useApproveRoleRequestsMutation__
 *
 * To run a mutation, you first call `useApproveRoleRequestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveRoleRequestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveRoleRequestsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApproveRoleRequestsMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveRoleRequestsMutation, Types.ApproveRoleRequestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveRoleRequestsMutation, Types.ApproveRoleRequestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveRoleRequestsMutation, Types.ApproveRoleRequestsMutationVariables>(ApproveRoleRequestsDocument, options);
}
export type ApproveRoleRequestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveRoleRequestsMutation, Types.ApproveRoleRequestsMutationVariables>;
export const RejectRoleRequestsDocument = gql`
    mutation RejectRoleRequests($input: RejectRoleInput!) {
  rejectRoleRequests(input: $input) {
    id
    status
    grant_type
    is_active
    reviewed_at
    reviewed_by {
      id
      name
    }
  }
}
    `;

/**
 * __useRejectRoleRequestsMutation__
 *
 * To run a mutation, you first call `useRejectRoleRequestsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectRoleRequestsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectRoleRequestsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRejectRoleRequestsMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectRoleRequestsMutation, Types.RejectRoleRequestsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectRoleRequestsMutation, Types.RejectRoleRequestsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectRoleRequestsMutation, Types.RejectRoleRequestsMutationVariables>(RejectRoleRequestsDocument, options);
}
export type RejectRoleRequestsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectRoleRequestsMutation, Types.RejectRoleRequestsMutationVariables>;
export const WithdrawRoleRequestDocument = gql`
    mutation WithdrawRoleRequest($id: ID!) {
  withdrawRoleRequest(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useWithdrawRoleRequestMutation__
 *
 * To run a mutation, you first call `useWithdrawRoleRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawRoleRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWithdrawRoleRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useWithdrawRoleRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.WithdrawRoleRequestMutation, Types.WithdrawRoleRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.WithdrawRoleRequestMutation, Types.WithdrawRoleRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.WithdrawRoleRequestMutation, Types.WithdrawRoleRequestMutationVariables>(WithdrawRoleRequestDocument, options);
}
export type WithdrawRoleRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.WithdrawRoleRequestMutation, Types.WithdrawRoleRequestMutationVariables>;
export const GivePermissionDocument = gql`
    mutation GivePermission($user_id: ID!, $input: PermissionInput!) {
  givePermission(user_id: $user_id, input: $input) {
    success
    message
  }
}
    `;

/**
 * __useGivePermissionMutation__
 *
 * To run a mutation, you first call `useGivePermissionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGivePermissionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGivePermissionMutation({
 *   variables: {
 *     user_id: // value for 'user_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useGivePermissionMutation(options: VueApolloComposable.UseMutationOptions<Types.GivePermissionMutation, Types.GivePermissionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GivePermissionMutation, Types.GivePermissionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GivePermissionMutation, Types.GivePermissionMutationVariables>(GivePermissionDocument, options);
}
export type GivePermissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GivePermissionMutation, Types.GivePermissionMutationVariables>;
export const RevokePermissionDocument = gql`
    mutation RevokePermission($user_id: ID!, $input: PermissionInput!) {
  revokePermission(user_id: $user_id, input: $input) {
    success
    message
  }
}
    `;

/**
 * __useRevokePermissionMutation__
 *
 * To run a mutation, you first call `useRevokePermissionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokePermissionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokePermissionMutation({
 *   variables: {
 *     user_id: // value for 'user_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRevokePermissionMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokePermissionMutation, Types.RevokePermissionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokePermissionMutation, Types.RevokePermissionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokePermissionMutation, Types.RevokePermissionMutationVariables>(RevokePermissionDocument, options);
}
export type RevokePermissionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokePermissionMutation, Types.RevokePermissionMutationVariables>;
export const UpdatePermissionGrantDocument = gql`
    mutation UpdatePermissionGrant($grant_id: ID!, $input: UpdatePermissionGrantInput!) {
  updatePermissionGrant(grant_id: $grant_id, input: $input) {
    success
    message
  }
}
    `;

/**
 * __useUpdatePermissionGrantMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionGrantMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionGrantMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePermissionGrantMutation({
 *   variables: {
 *     grant_id: // value for 'grant_id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionGrantMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdatePermissionGrantMutation, Types.UpdatePermissionGrantMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdatePermissionGrantMutation, Types.UpdatePermissionGrantMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdatePermissionGrantMutation, Types.UpdatePermissionGrantMutationVariables>(UpdatePermissionGrantDocument, options);
}
export type UpdatePermissionGrantMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdatePermissionGrantMutation, Types.UpdatePermissionGrantMutationVariables>;
export const RevokePermissionGrantDocument = gql`
    mutation RevokePermissionGrant($grant_id: ID!) {
  revokePermissionGrant(grant_id: $grant_id) {
    success
    message
  }
}
    `;

/**
 * __useRevokePermissionGrantMutation__
 *
 * To run a mutation, you first call `useRevokePermissionGrantMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokePermissionGrantMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokePermissionGrantMutation({
 *   variables: {
 *     grant_id: // value for 'grant_id'
 *   },
 * });
 */
export function useRevokePermissionGrantMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokePermissionGrantMutation, Types.RevokePermissionGrantMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokePermissionGrantMutation, Types.RevokePermissionGrantMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokePermissionGrantMutation, Types.RevokePermissionGrantMutationVariables>(RevokePermissionGrantDocument, options);
}
export type RevokePermissionGrantMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokePermissionGrantMutation, Types.RevokePermissionGrantMutationVariables>;
export const AssignResultTemplateToProgrammeDocument = gql`
    mutation AssignResultTemplateToProgramme($programme_id: ID!, $academic_calendar_id: ID!, $result_template_id: ID!, $historical_source_map: [HistoricalSourceMapInput!]) {
  assignResultTemplateToProgramme(
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
    result_template_id: $result_template_id
    historical_source_map: $historical_source_map
  ) {
    id
    program_name
    prog_code
    resultTemplates {
      id
      name
    }
  }
}
    `;

/**
 * __useAssignResultTemplateToProgrammeMutation__
 *
 * To run a mutation, you first call `useAssignResultTemplateToProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignResultTemplateToProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignResultTemplateToProgrammeMutation({
 *   variables: {
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     result_template_id: // value for 'result_template_id'
 *     historical_source_map: // value for 'historical_source_map'
 *   },
 * });
 */
export function useAssignResultTemplateToProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToProgrammeMutation, Types.AssignResultTemplateToProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToProgrammeMutation, Types.AssignResultTemplateToProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignResultTemplateToProgrammeMutation, Types.AssignResultTemplateToProgrammeMutationVariables>(AssignResultTemplateToProgrammeDocument, options);
}
export type AssignResultTemplateToProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignResultTemplateToProgrammeMutation, Types.AssignResultTemplateToProgrammeMutationVariables>;
export const AssignResultTemplateToProgrammesDocument = gql`
    mutation AssignResultTemplateToProgrammes($input: AssignResultTemplateToProgrammesInput!) {
  assignResultTemplateToProgrammes(input: $input) {
    applied
    assigned
    unchanged
    overwritten
    conflicts {
      programme_id
      programme_name
      academic_calendar_id
      calendar_name
      current_template_id
      current_template_name
    }
  }
}
    `;

/**
 * __useAssignResultTemplateToProgrammesMutation__
 *
 * To run a mutation, you first call `useAssignResultTemplateToProgrammesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignResultTemplateToProgrammesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignResultTemplateToProgrammesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAssignResultTemplateToProgrammesMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToProgrammesMutation, Types.AssignResultTemplateToProgrammesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToProgrammesMutation, Types.AssignResultTemplateToProgrammesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignResultTemplateToProgrammesMutation, Types.AssignResultTemplateToProgrammesMutationVariables>(AssignResultTemplateToProgrammesDocument, options);
}
export type AssignResultTemplateToProgrammesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignResultTemplateToProgrammesMutation, Types.AssignResultTemplateToProgrammesMutationVariables>;
export const SetProgrammesResultTemplateDefaultDocument = gql`
    mutation SetProgrammesResultTemplateDefault($programme_ids: [ID!]!, $result_template_id: ID) {
  setProgrammesResultTemplateDefault(
    programme_ids: $programme_ids
    result_template_id: $result_template_id
  ) {
    id
    default_result_template_id
    default_result_template {
      id
      name
    }
  }
}
    `;

/**
 * __useSetProgrammesResultTemplateDefaultMutation__
 *
 * To run a mutation, you first call `useSetProgrammesResultTemplateDefaultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetProgrammesResultTemplateDefaultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetProgrammesResultTemplateDefaultMutation({
 *   variables: {
 *     programme_ids: // value for 'programme_ids'
 *     result_template_id: // value for 'result_template_id'
 *   },
 * });
 */
export function useSetProgrammesResultTemplateDefaultMutation(options: VueApolloComposable.UseMutationOptions<Types.SetProgrammesResultTemplateDefaultMutation, Types.SetProgrammesResultTemplateDefaultMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetProgrammesResultTemplateDefaultMutation, Types.SetProgrammesResultTemplateDefaultMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetProgrammesResultTemplateDefaultMutation, Types.SetProgrammesResultTemplateDefaultMutationVariables>(SetProgrammesResultTemplateDefaultDocument, options);
}
export type SetProgrammesResultTemplateDefaultMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetProgrammesResultTemplateDefaultMutation, Types.SetProgrammesResultTemplateDefaultMutationVariables>;
export const AcceptCoursesForProgrammeDocument = gql`
    mutation AcceptCoursesForProgramme($target_programme_id: ID!, $course_registered_ids: [ID!]!) {
  acceptCoursesForProgramme(
    target_programme_id: $target_programme_id
    course_registered_ids: $course_registered_ids
  ) {
    id
    course {
      id
      course_code
      course_title
      unit
    }
    is_transferred
    accepted_for_programme_id
    acceptedForProgramme {
      id
      program_name
    }
    acceptedByUser {
      id
      name
    }
    accepted_at
  }
}
    `;

/**
 * __useAcceptCoursesForProgrammeMutation__
 *
 * To run a mutation, you first call `useAcceptCoursesForProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCoursesForProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptCoursesForProgrammeMutation({
 *   variables: {
 *     target_programme_id: // value for 'target_programme_id'
 *     course_registered_ids: // value for 'course_registered_ids'
 *   },
 * });
 */
export function useAcceptCoursesForProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.AcceptCoursesForProgrammeMutation, Types.AcceptCoursesForProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AcceptCoursesForProgrammeMutation, Types.AcceptCoursesForProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AcceptCoursesForProgrammeMutation, Types.AcceptCoursesForProgrammeMutationVariables>(AcceptCoursesForProgrammeDocument, options);
}
export type AcceptCoursesForProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AcceptCoursesForProgrammeMutation, Types.AcceptCoursesForProgrammeMutationVariables>;
export const RevokeCoursesFromProgrammeDocument = gql`
    mutation RevokeCoursesFromProgramme($course_registered_ids: [ID!]!) {
  revokeCoursesFromProgramme(course_registered_ids: $course_registered_ids) {
    id
    is_transferred
    accepted_for_programme_id
  }
}
    `;

/**
 * __useRevokeCoursesFromProgrammeMutation__
 *
 * To run a mutation, you first call `useRevokeCoursesFromProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCoursesFromProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRevokeCoursesFromProgrammeMutation({
 *   variables: {
 *     course_registered_ids: // value for 'course_registered_ids'
 *   },
 * });
 */
export function useRevokeCoursesFromProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.RevokeCoursesFromProgrammeMutation, Types.RevokeCoursesFromProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RevokeCoursesFromProgrammeMutation, Types.RevokeCoursesFromProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RevokeCoursesFromProgrammeMutation, Types.RevokeCoursesFromProgrammeMutationVariables>(RevokeCoursesFromProgrammeDocument, options);
}
export type RevokeCoursesFromProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RevokeCoursesFromProgrammeMutation, Types.RevokeCoursesFromProgrammeMutationVariables>;
export const CreateResultTemplateDocument = gql`
    mutation CreateResultTemplate($input: CreateResultTemplateInput!) {
  createResultTemplate(input: $input) {
    id
    name
    code
    style_code
    updated_at
  }
}
    `;

/**
 * __useCreateResultTemplateMutation__
 *
 * To run a mutation, you first call `useCreateResultTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateResultTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateResultTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateResultTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateResultTemplateMutation, Types.CreateResultTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateResultTemplateMutation, Types.CreateResultTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateResultTemplateMutation, Types.CreateResultTemplateMutationVariables>(CreateResultTemplateDocument, options);
}
export type CreateResultTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateResultTemplateMutation, Types.CreateResultTemplateMutationVariables>;
export const UpdateResultTemplateDocument = gql`
    mutation UpdateResultTemplate($input: UpdateResultTemplateInput!) {
  updateResultTemplate(input: $input) {
    id
    name
    code
    style_code
    properties
    columns {
      id
      label
      key
      type
      sequence
      is_visible
      school_assessment_type {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUpdateResultTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateResultTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResultTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateResultTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResultTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateResultTemplateMutation, Types.UpdateResultTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateResultTemplateMutation, Types.UpdateResultTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateResultTemplateMutation, Types.UpdateResultTemplateMutationVariables>(UpdateResultTemplateDocument, options);
}
export type UpdateResultTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateResultTemplateMutation, Types.UpdateResultTemplateMutationVariables>;
export const DeleteResultTemplateDocument = gql`
    mutation DeleteResultTemplate($id: ID!) {
  deleteResultTemplate(id: $id) {
    success
    message
    code
  }
}
    `;

/**
 * __useDeleteResultTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteResultTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResultTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteResultTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResultTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteResultTemplateMutation, Types.DeleteResultTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteResultTemplateMutation, Types.DeleteResultTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteResultTemplateMutation, Types.DeleteResultTemplateMutationVariables>(DeleteResultTemplateDocument, options);
}
export type DeleteResultTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteResultTemplateMutation, Types.DeleteResultTemplateMutationVariables>;
export const AssignResultTemplateToClassroomDocument = gql`
    mutation AssignResultTemplateToClassroom($academic_calendar_id: ID!, $classroom_id: ID!, $result_template_id: ID!, $historical_source_map: [HistoricalSourceMapInput!]) {
  assignResultTemplateToClassroom(
    academic_calendar_id: $academic_calendar_id
    classroom_id: $classroom_id
    result_template_id: $result_template_id
    historical_source_map: $historical_source_map
  ) {
    id
    name
  }
}
    `;

/**
 * __useAssignResultTemplateToClassroomMutation__
 *
 * To run a mutation, you first call `useAssignResultTemplateToClassroomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAssignResultTemplateToClassroomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAssignResultTemplateToClassroomMutation({
 *   variables: {
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     classroom_id: // value for 'classroom_id'
 *     result_template_id: // value for 'result_template_id'
 *     historical_source_map: // value for 'historical_source_map'
 *   },
 * });
 */
export function useAssignResultTemplateToClassroomMutation(options: VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToClassroomMutation, Types.AssignResultTemplateToClassroomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AssignResultTemplateToClassroomMutation, Types.AssignResultTemplateToClassroomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AssignResultTemplateToClassroomMutation, Types.AssignResultTemplateToClassroomMutationVariables>(AssignResultTemplateToClassroomDocument, options);
}
export type AssignResultTemplateToClassroomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AssignResultTemplateToClassroomMutation, Types.AssignResultTemplateToClassroomMutationVariables>;
export const UnassignResultTemplateFromProgrammeDocument = gql`
    mutation UnassignResultTemplateFromProgramme($programme_id: ID!, $academic_calendar_id: ID!) {
  unassignResultTemplateFromProgramme(
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
  ) {
    success
    message
  }
}
    `;

/**
 * __useUnassignResultTemplateFromProgrammeMutation__
 *
 * To run a mutation, you first call `useUnassignResultTemplateFromProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnassignResultTemplateFromProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnassignResultTemplateFromProgrammeMutation({
 *   variables: {
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useUnassignResultTemplateFromProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.UnassignResultTemplateFromProgrammeMutation, Types.UnassignResultTemplateFromProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UnassignResultTemplateFromProgrammeMutation, Types.UnassignResultTemplateFromProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UnassignResultTemplateFromProgrammeMutation, Types.UnassignResultTemplateFromProgrammeMutationVariables>(UnassignResultTemplateFromProgrammeDocument, options);
}
export type UnassignResultTemplateFromProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UnassignResultTemplateFromProgrammeMutation, Types.UnassignResultTemplateFromProgrammeMutationVariables>;
export const CreateSchemeOfWorkDocument = gql`
    mutation createSchemeOfWork($input: CreateSchemeOfWorkInput!) {
  createSchemeOfWork(input: $input) {
    id
    title
    description
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    termStructure {
      id
      name
    }
    weeks {
      id
      weekNumber
      topic
      learningObjectives
      keyConcepts
      suggestedActivities
      suggestedResources
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateSchemeOfWorkMutation__
 *
 * To run a mutation, you first call `useCreateSchemeOfWorkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchemeOfWorkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSchemeOfWorkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchemeOfWorkMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSchemeOfWorkMutation, Types.CreateSchemeOfWorkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSchemeOfWorkMutation, Types.CreateSchemeOfWorkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSchemeOfWorkMutation, Types.CreateSchemeOfWorkMutationVariables>(CreateSchemeOfWorkDocument, options);
}
export type CreateSchemeOfWorkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSchemeOfWorkMutation, Types.CreateSchemeOfWorkMutationVariables>;
export const UpdateSchemeOfWorkDocument = gql`
    mutation updateSchemeOfWork($id: ID!, $input: UpdateSchemeOfWorkInput!) {
  updateSchemeOfWork(id: $id, input: $input) {
    id
    title
    description
    updatedAt
  }
}
    `;

/**
 * __useUpdateSchemeOfWorkMutation__
 *
 * To run a mutation, you first call `useUpdateSchemeOfWorkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemeOfWorkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchemeOfWorkMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchemeOfWorkMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchemeOfWorkMutation, Types.UpdateSchemeOfWorkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchemeOfWorkMutation, Types.UpdateSchemeOfWorkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchemeOfWorkMutation, Types.UpdateSchemeOfWorkMutationVariables>(UpdateSchemeOfWorkDocument, options);
}
export type UpdateSchemeOfWorkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchemeOfWorkMutation, Types.UpdateSchemeOfWorkMutationVariables>;
export const DeleteSchemeOfWorkDocument = gql`
    mutation deleteSchemeOfWork($id: ID!) {
  deleteSchemeOfWork(id: $id)
}
    `;

/**
 * __useDeleteSchemeOfWorkMutation__
 *
 * To run a mutation, you first call `useDeleteSchemeOfWorkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemeOfWorkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSchemeOfWorkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchemeOfWorkMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSchemeOfWorkMutation, Types.DeleteSchemeOfWorkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSchemeOfWorkMutation, Types.DeleteSchemeOfWorkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSchemeOfWorkMutation, Types.DeleteSchemeOfWorkMutationVariables>(DeleteSchemeOfWorkDocument, options);
}
export type DeleteSchemeOfWorkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSchemeOfWorkMutation, Types.DeleteSchemeOfWorkMutationVariables>;
export const AddSchemeWeekDocument = gql`
    mutation addSchemeWeek($schemeOfWorkId: ID!, $input: SchemeWeekInput!) {
  addSchemeWeek(schemeOfWorkId: $schemeOfWorkId, input: $input) {
    id
    weekNumber
    topic
    learningObjectives
    keyConcepts
    suggestedActivities
    suggestedResources
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAddSchemeWeekMutation__
 *
 * To run a mutation, you first call `useAddSchemeWeekMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSchemeWeekMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSchemeWeekMutation({
 *   variables: {
 *     schemeOfWorkId: // value for 'schemeOfWorkId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddSchemeWeekMutation(options: VueApolloComposable.UseMutationOptions<Types.AddSchemeWeekMutation, Types.AddSchemeWeekMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddSchemeWeekMutation, Types.AddSchemeWeekMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddSchemeWeekMutation, Types.AddSchemeWeekMutationVariables>(AddSchemeWeekDocument, options);
}
export type AddSchemeWeekMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddSchemeWeekMutation, Types.AddSchemeWeekMutationVariables>;
export const UpdateSchemeWeekDocument = gql`
    mutation updateSchemeWeek($id: ID!, $input: UpdateSchemeWeekInput!) {
  updateSchemeWeek(id: $id, input: $input) {
    id
    weekNumber
    topic
    learningObjectives
    keyConcepts
    suggestedActivities
    suggestedResources
    updatedAt
  }
}
    `;

/**
 * __useUpdateSchemeWeekMutation__
 *
 * To run a mutation, you first call `useUpdateSchemeWeekMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemeWeekMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchemeWeekMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchemeWeekMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchemeWeekMutation, Types.UpdateSchemeWeekMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchemeWeekMutation, Types.UpdateSchemeWeekMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchemeWeekMutation, Types.UpdateSchemeWeekMutationVariables>(UpdateSchemeWeekDocument, options);
}
export type UpdateSchemeWeekMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchemeWeekMutation, Types.UpdateSchemeWeekMutationVariables>;
export const DeleteSchemeWeekDocument = gql`
    mutation deleteSchemeWeek($id: ID!) {
  deleteSchemeWeek(id: $id)
}
    `;

/**
 * __useDeleteSchemeWeekMutation__
 *
 * To run a mutation, you first call `useDeleteSchemeWeekMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchemeWeekMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSchemeWeekMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchemeWeekMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSchemeWeekMutation, Types.DeleteSchemeWeekMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSchemeWeekMutation, Types.DeleteSchemeWeekMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSchemeWeekMutation, Types.DeleteSchemeWeekMutationVariables>(DeleteSchemeWeekDocument, options);
}
export type DeleteSchemeWeekMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSchemeWeekMutation, Types.DeleteSchemeWeekMutationVariables>;
export const UpdateStudentScoresDocument = gql`
    mutation UpdateStudentScores($studentScores: [StudentScoresInput!]!, $reason: String) {
  updateStudentScores(studentScores: $studentScores, reason: $reason) {
    success
    message
    updated_count
    created_count
    enrollments {
      student_subject_enrollment_id
      updated
      created
    }
  }
}
    `;

/**
 * __useUpdateStudentScoresMutation__
 *
 * To run a mutation, you first call `useUpdateStudentScoresMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentScoresMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentScoresMutation({
 *   variables: {
 *     studentScores: // value for 'studentScores'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateStudentScoresMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentScoresMutation, Types.UpdateStudentScoresMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentScoresMutation, Types.UpdateStudentScoresMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentScoresMutation, Types.UpdateStudentScoresMutationVariables>(UpdateStudentScoresDocument, options);
}
export type UpdateStudentScoresMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentScoresMutation, Types.UpdateStudentScoresMutationVariables>;
export const ImportScoreSheetDocument = gql`
    mutation ImportScoreSheet($file: Upload!, $classroom_id: ID, $subject_id: ID!, $academic_calendar_id: ID!, $dry_run: Boolean) {
  importScoreSheet(
    file: $file
    classroom_id: $classroom_id
    subject_id: $subject_id
    academic_calendar_id: $academic_calendar_id
    dry_run: $dry_run
  ) {
    success
    message
    code
    summary {
      rows
      saved
      students
      missing_student_id
      unmatched
      non_numeric
      out_of_range
      dry_run
      issues {
        row
        student_ref
        reason
      }
    }
  }
}
    `;

/**
 * __useImportScoreSheetMutation__
 *
 * To run a mutation, you first call `useImportScoreSheetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportScoreSheetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportScoreSheetMutation({
 *   variables: {
 *     file: // value for 'file'
 *     classroom_id: // value for 'classroom_id'
 *     subject_id: // value for 'subject_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     dry_run: // value for 'dry_run'
 *   },
 * });
 */
export function useImportScoreSheetMutation(options: VueApolloComposable.UseMutationOptions<Types.ImportScoreSheetMutation, Types.ImportScoreSheetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ImportScoreSheetMutation, Types.ImportScoreSheetMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ImportScoreSheetMutation, Types.ImportScoreSheetMutationVariables>(ImportScoreSheetDocument, options);
}
export type ImportScoreSheetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ImportScoreSheetMutation, Types.ImportScoreSheetMutationVariables>;
export const CreateSessionStructureDocument = gql`
    mutation CreateSessionStructure($input: CreateSessionStructureInput!) {
  createSessionStructure(input: $input) {
    id
    school_id
    name
    description
    is_default
    created_at
    updated_at
    termsStructure {
      id
      session_structure_id
      name
      sequence
      created_at
      updated_at
      sessionStructure {
        id
        school_id
        name
        description
        is_default
        created_at
        updated_at
        sessions {
          id
          name
          started_at
          ended_at
          created_at
          updated_at
        }
      }
      academicCalendars {
        id
        school_id
        session_id
        term_structure_id
        started_at
        ended_at
        is_active
        total_school_days
        next_calender_starts_at
        created_at
        updated_at
      }
    }
    sessions {
      id
      name
      started_at
      ended_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useCreateSessionStructureMutation__
 *
 * To run a mutation, you first call `useCreateSessionStructureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionStructureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSessionStructureMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionStructureMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSessionStructureMutation, Types.CreateSessionStructureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSessionStructureMutation, Types.CreateSessionStructureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSessionStructureMutation, Types.CreateSessionStructureMutationVariables>(CreateSessionStructureDocument, options);
}
export type CreateSessionStructureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSessionStructureMutation, Types.CreateSessionStructureMutationVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($input: CreateSessionInput!) {
  createSession(input: $input) {
    id
    name
    started_at
    ended_at
    created_at
    updated_at
  }
}
    `;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSessionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSessionMutation, Types.CreateSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSessionMutation, Types.CreateSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSessionMutation, Types.CreateSessionMutationVariables>(CreateSessionDocument, options);
}
export type CreateSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSessionMutation, Types.CreateSessionMutationVariables>;
export const CreateTermStructureDocument = gql`
    mutation CreateTermStructure($input: CreateTermStructureInput!) {
  createTermStructure(input: $input) {
    id
    session_structure_id
    sequence
    name
    created_at
    updated_at
    sessionStructure {
      id
      school_id
      name
      description
      is_default
      created_at
      updated_at
      sessions {
        id
        name
        started_at
        ended_at
        created_at
        updated_at
      }
    }
    academicCalendars {
      id
      school_id
      session_id
      term_structure_id
      started_at
      ended_at
      is_active
      total_school_days
      next_calender_starts_at
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useCreateTermStructureMutation__
 *
 * To run a mutation, you first call `useCreateTermStructureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermStructureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTermStructureMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTermStructureMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTermStructureMutation, Types.CreateTermStructureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTermStructureMutation, Types.CreateTermStructureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTermStructureMutation, Types.CreateTermStructureMutationVariables>(CreateTermStructureDocument, options);
}
export type CreateTermStructureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTermStructureMutation, Types.CreateTermStructureMutationVariables>;
export const CreateAcademicCalendarDocument = gql`
    mutation CreateAcademicCalendar($input: CreateAcademicCalendarInput!) {
  createAcademicCalendar(input: $input) {
    id
    started_at
    ended_at
    is_active
    total_school_days
    next_calender_starts_at
    created_at
    updated_at
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateAcademicCalendarMutation__
 *
 * To run a mutation, you first call `useCreateAcademicCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcademicCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAcademicCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateAcademicCalendarMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateAcademicCalendarMutation, Types.CreateAcademicCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateAcademicCalendarMutation, Types.CreateAcademicCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateAcademicCalendarMutation, Types.CreateAcademicCalendarMutationVariables>(CreateAcademicCalendarDocument, options);
}
export type CreateAcademicCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateAcademicCalendarMutation, Types.CreateAcademicCalendarMutationVariables>;
export const DeleteSessionStructureDocument = gql`
    mutation DeleteSessionStructure($id: ID!) {
  deleteSessionStructure(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useDeleteSessionStructureMutation__
 *
 * To run a mutation, you first call `useDeleteSessionStructureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSessionStructureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSessionStructureMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSessionStructureMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSessionStructureMutation, Types.DeleteSessionStructureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSessionStructureMutation, Types.DeleteSessionStructureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSessionStructureMutation, Types.DeleteSessionStructureMutationVariables>(DeleteSessionStructureDocument, options);
}
export type DeleteSessionStructureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSessionStructureMutation, Types.DeleteSessionStructureMutationVariables>;
export const CreateSectionDocument = gql`
    mutation CreateSection($input: CreateSectionInput!) {
  createSection(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useCreateSectionMutation__
 *
 * To run a mutation, you first call `useCreateSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSectionMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSectionMutation, Types.CreateSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSectionMutation, Types.CreateSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSectionMutation, Types.CreateSectionMutationVariables>(CreateSectionDocument, options);
}
export type CreateSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSectionMutation, Types.CreateSectionMutationVariables>;
export const CreateClassroomSectionDocument = gql`
    mutation CreateClassroomSection($input: CreateClassroomSectionInput!) {
  createClassroomSection(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useCreateClassroomSectionMutation__
 *
 * To run a mutation, you first call `useCreateClassroomSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClassroomSectionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassroomSectionMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateClassroomSectionMutation, Types.CreateClassroomSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateClassroomSectionMutation, Types.CreateClassroomSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateClassroomSectionMutation, Types.CreateClassroomSectionMutationVariables>(CreateClassroomSectionDocument, options);
}
export type CreateClassroomSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateClassroomSectionMutation, Types.CreateClassroomSectionMutationVariables>;
export const CreateClassroomDocument = gql`
    mutation CreateClassroom($input: CreateClassroomInput!) {
  createClassroom(input: $input) {
    id
    name
    abbreviation
    sequence
  }
}
    `;

/**
 * __useCreateClassroomMutation__
 *
 * To run a mutation, you first call `useCreateClassroomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassroomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateClassroomMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassroomMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateClassroomMutation, Types.CreateClassroomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateClassroomMutation, Types.CreateClassroomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateClassroomMutation, Types.CreateClassroomMutationVariables>(CreateClassroomDocument, options);
}
export type CreateClassroomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateClassroomMutation, Types.CreateClassroomMutationVariables>;
export const UpdateClassroomSectionDocument = gql`
    mutation UpdateClassroomSection($id: ID!, $input: UpdateClassroomSectionInput!) {
  updateClassroomSection(id: $id, input: $input) {
    id
    name
    classroom {
      id
      name
    }
    section {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateClassroomSectionMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomSectionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomSectionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClassroomSectionMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassroomSectionMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateClassroomSectionMutation, Types.UpdateClassroomSectionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateClassroomSectionMutation, Types.UpdateClassroomSectionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateClassroomSectionMutation, Types.UpdateClassroomSectionMutationVariables>(UpdateClassroomSectionDocument, options);
}
export type UpdateClassroomSectionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateClassroomSectionMutation, Types.UpdateClassroomSectionMutationVariables>;
export const UpdateClassroomDocument = gql`
    mutation UpdateClassroom($id: ID!, $input: CreateClassroomInput!) {
  updateClassroom(id: $id, input: $input) {
    id
    name
    abbreviation
    sequence
  }
}
    `;

/**
 * __useUpdateClassroomMutation__
 *
 * To run a mutation, you first call `useUpdateClassroomMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClassroomMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateClassroomMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClassroomMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateClassroomMutation, Types.UpdateClassroomMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateClassroomMutation, Types.UpdateClassroomMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateClassroomMutation, Types.UpdateClassroomMutationVariables>(UpdateClassroomDocument, options);
}
export type UpdateClassroomMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateClassroomMutation, Types.UpdateClassroomMutationVariables>;
export const SetActiveAcademicCalendarDocument = gql`
    mutation SetActiveAcademicCalendar($id: ID!) {
  setActiveAcademicCalendar(id: $id) {
    id
    school_id
    session_id
    term_structure_id
    started_at
    ended_at
    is_active
    total_school_days
    next_calender_starts_at
    created_at
    updated_at
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
  }
}
    `;

/**
 * __useSetActiveAcademicCalendarMutation__
 *
 * To run a mutation, you first call `useSetActiveAcademicCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveAcademicCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetActiveAcademicCalendarMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useSetActiveAcademicCalendarMutation(options: VueApolloComposable.UseMutationOptions<Types.SetActiveAcademicCalendarMutation, Types.SetActiveAcademicCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetActiveAcademicCalendarMutation, Types.SetActiveAcademicCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetActiveAcademicCalendarMutation, Types.SetActiveAcademicCalendarMutationVariables>(SetActiveAcademicCalendarDocument, options);
}
export type SetActiveAcademicCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetActiveAcademicCalendarMutation, Types.SetActiveAcademicCalendarMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    id
    name
    started_at
    ended_at
    created_at
    updated_at
    sessionStructure {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSessionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSessionMutation, Types.UpdateSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSessionMutation, Types.UpdateSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSessionMutation, Types.UpdateSessionMutationVariables>(UpdateSessionDocument, options);
}
export type UpdateSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSessionMutation, Types.UpdateSessionMutationVariables>;
export const UpdateAcademicCalendarDocument = gql`
    mutation UpdateAcademicCalendar($input: UpdateAcademicCalendarInput!) {
  updateAcademicCalendar(input: $input) {
    id
    started_at
    ended_at
    is_active
    total_school_days
    next_calender_starts_at
    created_at
    updated_at
    session {
      id
      name
    }
    termStructure {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateAcademicCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateAcademicCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAcademicCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAcademicCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAcademicCalendarMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateAcademicCalendarMutation, Types.UpdateAcademicCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateAcademicCalendarMutation, Types.UpdateAcademicCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateAcademicCalendarMutation, Types.UpdateAcademicCalendarMutationVariables>(UpdateAcademicCalendarDocument, options);
}
export type UpdateAcademicCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateAcademicCalendarMutation, Types.UpdateAcademicCalendarMutationVariables>;
export const BulkUpdateStudentsDocument = gql`
    mutation BulkUpdateStudents($input: BulkUpdateStudentsInput!) {
  bulkUpdateStudents(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useBulkUpdateStudentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkUpdateStudentsMutation, Types.BulkUpdateStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkUpdateStudentsMutation, Types.BulkUpdateStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkUpdateStudentsMutation, Types.BulkUpdateStudentsMutationVariables>(BulkUpdateStudentsDocument, options);
}
export type BulkUpdateStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkUpdateStudentsMutation, Types.BulkUpdateStudentsMutationVariables>;
export const DisableStudentsDocument = gql`
    mutation DisableStudents($input: DisableStudentsInput!) {
  disableStudents(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useDisableStudentsMutation__
 *
 * To run a mutation, you first call `useDisableStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDisableStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDisableStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDisableStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.DisableStudentsMutation, Types.DisableStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DisableStudentsMutation, Types.DisableStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DisableStudentsMutation, Types.DisableStudentsMutationVariables>(DisableStudentsDocument, options);
}
export type DisableStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DisableStudentsMutation, Types.DisableStudentsMutationVariables>;
export const EnableStudentsDocument = gql`
    mutation EnableStudents($input: EnableStudentsInput!) {
  enableStudents(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useEnableStudentsMutation__
 *
 * To run a mutation, you first call `useEnableStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnableStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnableStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEnableStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.EnableStudentsMutation, Types.EnableStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EnableStudentsMutation, Types.EnableStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EnableStudentsMutation, Types.EnableStudentsMutationVariables>(EnableStudentsDocument, options);
}
export type EnableStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EnableStudentsMutation, Types.EnableStudentsMutationVariables>;
export const UpdateStudentStatusDocument = gql`
    mutation UpdateStudentStatus($input: UpdateStudentStatusInput!) {
  updateStudentStatus(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useUpdateStudentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStudentStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudentStatusMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentStatusMutation, Types.UpdateStudentStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentStatusMutation, Types.UpdateStudentStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentStatusMutation, Types.UpdateStudentStatusMutationVariables>(UpdateStudentStatusDocument, options);
}
export type UpdateStudentStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentStatusMutation, Types.UpdateStudentStatusMutationVariables>;
export const BulkResetStudentPasswordsDocument = gql`
    mutation BulkResetStudentPasswords($input: BulkResetStudentPasswordsInput!) {
  bulkResetStudentPasswords(input: $input) {
    success
    message
    code
    reset_count
    failed_count
    results {
      student_id
      student_name
      success
      message
    }
  }
}
    `;

/**
 * __useBulkResetStudentPasswordsMutation__
 *
 * To run a mutation, you first call `useBulkResetStudentPasswordsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkResetStudentPasswordsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkResetStudentPasswordsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkResetStudentPasswordsMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkResetStudentPasswordsMutation, Types.BulkResetStudentPasswordsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkResetStudentPasswordsMutation, Types.BulkResetStudentPasswordsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkResetStudentPasswordsMutation, Types.BulkResetStudentPasswordsMutationVariables>(BulkResetStudentPasswordsDocument, options);
}
export type BulkResetStudentPasswordsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkResetStudentPasswordsMutation, Types.BulkResetStudentPasswordsMutationVariables>;
export const ExportStudentsDocument = gql`
    mutation ExportStudents($input: ExportStudentsInput!) {
  exportStudents(input: $input) {
    id
    type
    status
    progress
    file_name
    file_url
    file_size
    error_message
    expires_at
    created_at
    updated_at
  }
}
    `;

/**
 * __useExportStudentsMutation__
 *
 * To run a mutation, you first call `useExportStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useExportStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportStudentsMutation, Types.ExportStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportStudentsMutation, Types.ExportStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportStudentsMutation, Types.ExportStudentsMutationVariables>(ExportStudentsDocument, options);
}
export type ExportStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportStudentsMutation, Types.ExportStudentsMutationVariables>;
export const StudentDisablementHistoryDocument = gql`
    query StudentDisablementHistory($student_id: ID!) {
  studentDisablementHistory(student_id: $student_id) {
    id
    student_id
    disabled_at
    disabled_reason
    enabled_at
    enabled_reason
    is_current
    created_at
    disabledByUser {
      id
      name
    }
    enabledByUser {
      id
      name
    }
  }
}
    `;

/**
 * __useStudentDisablementHistoryQuery__
 *
 * To run a query within a Vue component, call `useStudentDisablementHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDisablementHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDisablementHistoryQuery({
 *   student_id: // value for 'student_id'
 * });
 */
export function useStudentDisablementHistoryQuery(variables: Types.StudentDisablementHistoryQueryVariables | VueCompositionApi.Ref<Types.StudentDisablementHistoryQueryVariables> | ReactiveFunction<Types.StudentDisablementHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>(StudentDisablementHistoryDocument, variables, options);
}
export function useStudentDisablementHistoryLazyQuery(variables?: Types.StudentDisablementHistoryQueryVariables | VueCompositionApi.Ref<Types.StudentDisablementHistoryQueryVariables> | ReactiveFunction<Types.StudentDisablementHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>(StudentDisablementHistoryDocument, variables, options);
}
export type StudentDisablementHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDisablementHistoryQuery, Types.StudentDisablementHistoryQueryVariables>;
export const CheckStudentAccessDocument = gql`
    query CheckStudentAccess {
  checkStudentAccess {
    is_disabled
    reason
    disabled_at
  }
}
    `;

/**
 * __useCheckStudentAccessQuery__
 *
 * To run a query within a Vue component, call `useCheckStudentAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStudentAccessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCheckStudentAccessQuery();
 */
export function useCheckStudentAccessQuery(options: VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>(CheckStudentAccessDocument, {}, options);
}
export function useCheckStudentAccessLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>(CheckStudentAccessDocument, {}, options);
}
export type CheckStudentAccessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.CheckStudentAccessQuery, Types.CheckStudentAccessQueryVariables>;
export const DeenrollStudentsDocument = gql`
    mutation DeenrollStudents($input: DeenrollStudentsInput!) {
  deenrollStudents(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useDeenrollStudentsMutation__
 *
 * To run a mutation, you first call `useDeenrollStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeenrollStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeenrollStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeenrollStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.DeenrollStudentsMutation, Types.DeenrollStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeenrollStudentsMutation, Types.DeenrollStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeenrollStudentsMutation, Types.DeenrollStudentsMutationVariables>(DeenrollStudentsDocument, options);
}
export type DeenrollStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeenrollStudentsMutation, Types.DeenrollStudentsMutationVariables>;
export const EnrollStudentsInCalendarDocument = gql`
    mutation EnrollStudentsInCalendar($input: EnrollStudentsInCalendarInput!) {
  enrollStudentsInCalendar(input: $input) {
    success
    message
    code
  }
}
    `;

/**
 * __useEnrollStudentsInCalendarMutation__
 *
 * To run a mutation, you first call `useEnrollStudentsInCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEnrollStudentsInCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEnrollStudentsInCalendarMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEnrollStudentsInCalendarMutation(options: VueApolloComposable.UseMutationOptions<Types.EnrollStudentsInCalendarMutation, Types.EnrollStudentsInCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EnrollStudentsInCalendarMutation, Types.EnrollStudentsInCalendarMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EnrollStudentsInCalendarMutation, Types.EnrollStudentsInCalendarMutationVariables>(EnrollStudentsInCalendarDocument, options);
}
export type EnrollStudentsInCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EnrollStudentsInCalendarMutation, Types.EnrollStudentsInCalendarMutationVariables>;
export const CreateStudentDocument = gql`
    mutation createStudent($createStudentInput: CreateStudentInput!) {
  createStudent(createStudentInput: $createStudentInput) {
    id
    matric_no
    first_name
    surname
    other_name
    dob
    email
    gender
    phone
    home_address
    nationality
    state
    photo
  }
}
    `;

/**
 * __useCreateStudentMutation__
 *
 * To run a mutation, you first call `useCreateStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStudentMutation({
 *   variables: {
 *     createStudentInput: // value for 'createStudentInput'
 *   },
 * });
 */
export function useCreateStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateStudentMutation, Types.CreateStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateStudentMutation, Types.CreateStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateStudentMutation, Types.CreateStudentMutationVariables>(CreateStudentDocument, options);
}
export type CreateStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateStudentMutation, Types.CreateStudentMutationVariables>;
export const EditStudentDocument = gql`
    mutation editStudent($input: EditStudentInput!) {
  editStudent(input: $input) {
    id
    matric_no
    first_name
    surname
    other_name
    dob
    email
    gender
    phone
    home_address
    nationality
    state
    city
    photo
  }
}
    `;

/**
 * __useEditStudentMutation__
 *
 * To run a mutation, you first call `useEditStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditStudentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEditStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.EditStudentMutation, Types.EditStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EditStudentMutation, Types.EditStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EditStudentMutation, Types.EditStudentMutationVariables>(EditStudentDocument, options);
}
export type EditStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EditStudentMutation, Types.EditStudentMutationVariables>;
export const DeleteStudentDocument = gql`
    mutation DeleteStudent($id: ID!) {
  deleteStudent(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteStudentMutation__
 *
 * To run a mutation, you first call `useDeleteStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteStudentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteStudentMutation, Types.DeleteStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteStudentMutation, Types.DeleteStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteStudentMutation, Types.DeleteStudentMutationVariables>(DeleteStudentDocument, options);
}
export type DeleteStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteStudentMutation, Types.DeleteStudentMutationVariables>;
export const PromoteStudentsDocument = gql`
    mutation PromoteStudents($input: PromoteStudentsInput!) {
  promoteStudents(input: $input) {
    success
    message
  }
}
    `;

/**
 * __usePromoteStudentsMutation__
 *
 * To run a mutation, you first call `usePromoteStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePromoteStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePromoteStudentsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePromoteStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.PromoteStudentsMutation, Types.PromoteStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PromoteStudentsMutation, Types.PromoteStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PromoteStudentsMutation, Types.PromoteStudentsMutationVariables>(PromoteStudentsDocument, options);
}
export type PromoteStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PromoteStudentsMutation, Types.PromoteStudentsMutationVariables>;
export const MarkStudentAttendanceDocument = gql`
    mutation MarkStudentAttendance($input: [MarkStudentAttendanceInput!]!) {
  markStudentAttendance(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useMarkStudentAttendanceMutation__
 *
 * To run a mutation, you first call `useMarkStudentAttendanceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkStudentAttendanceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkStudentAttendanceMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useMarkStudentAttendanceMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkStudentAttendanceMutation, Types.MarkStudentAttendanceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkStudentAttendanceMutation, Types.MarkStudentAttendanceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkStudentAttendanceMutation, Types.MarkStudentAttendanceMutationVariables>(MarkStudentAttendanceDocument, options);
}
export type MarkStudentAttendanceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkStudentAttendanceMutation, Types.MarkStudentAttendanceMutationVariables>;
export const UpdateAttendanceSummaryDocument = gql`
    mutation UpdateAttendanceSummary($input: UpdateStudentAttendanceSummaryInput!) {
  updateStudentAttendanceSummary(input: $input) {
    success
    message
  }
}
    `;

/**
 * __useUpdateAttendanceSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateAttendanceSummaryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttendanceSummaryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAttendanceSummaryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttendanceSummaryMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateAttendanceSummaryMutation, Types.UpdateAttendanceSummaryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateAttendanceSummaryMutation, Types.UpdateAttendanceSummaryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateAttendanceSummaryMutation, Types.UpdateAttendanceSummaryMutationVariables>(UpdateAttendanceSummaryDocument, options);
}
export type UpdateAttendanceSummaryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateAttendanceSummaryMutation, Types.UpdateAttendanceSummaryMutationVariables>;
export const PreviewStudentImportDocument = gql`
    mutation PreviewStudentImport($students: [StudentImportRecordInput!]!, $classroom_section_id: Int!, $programme_id: Int, $academic_calendar_id: Int, $campus_id: Int) {
  previewStudentImport(
    students: $students
    classroom_section_id: $classroom_section_id
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
    campus_id: $campus_id
  ) {
    total_rows
    successful
    failed
    errors {
      row
      errors
    }
  }
}
    `;

/**
 * __usePreviewStudentImportMutation__
 *
 * To run a mutation, you first call `usePreviewStudentImportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewStudentImportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewStudentImportMutation({
 *   variables: {
 *     students: // value for 'students'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     campus_id: // value for 'campus_id'
 *   },
 * });
 */
export function usePreviewStudentImportMutation(options: VueApolloComposable.UseMutationOptions<Types.PreviewStudentImportMutation, Types.PreviewStudentImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PreviewStudentImportMutation, Types.PreviewStudentImportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PreviewStudentImportMutation, Types.PreviewStudentImportMutationVariables>(PreviewStudentImportDocument, options);
}
export type PreviewStudentImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PreviewStudentImportMutation, Types.PreviewStudentImportMutationVariables>;
export const ImportStudentsDocument = gql`
    mutation ImportStudents($students: [StudentImportRecordInput!]!, $classroom_section_id: Int!, $programme_id: Int, $academic_calendar_id: Int, $campus_id: Int) {
  importStudents(
    students: $students
    classroom_section_id: $classroom_section_id
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
    campus_id: $campus_id
  ) {
    total_rows
    successful
    failed
    queued
    student_import_id
    errors {
      row
      errors
    }
  }
}
    `;

/**
 * __useImportStudentsMutation__
 *
 * To run a mutation, you first call `useImportStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportStudentsMutation({
 *   variables: {
 *     students: // value for 'students'
 *     classroom_section_id: // value for 'classroom_section_id'
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *     campus_id: // value for 'campus_id'
 *   },
 * });
 */
export function useImportStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.ImportStudentsMutation, Types.ImportStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ImportStudentsMutation, Types.ImportStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ImportStudentsMutation, Types.ImportStudentsMutationVariables>(ImportStudentsDocument, options);
}
export type ImportStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ImportStudentsMutation, Types.ImportStudentsMutationVariables>;
export const SaveStudentResultFeedbackDocument = gql`
    mutation SaveStudentResultFeedback($input: SaveStudentResultFeedbackInput!) {
  saveStudentResultFeedback(input: $input) {
    id
    comment
    rating
    rating_label
    updated_at
  }
}
    `;

/**
 * __useSaveStudentResultFeedbackMutation__
 *
 * To run a mutation, you first call `useSaveStudentResultFeedbackMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveStudentResultFeedbackMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveStudentResultFeedbackMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveStudentResultFeedbackMutation(options: VueApolloComposable.UseMutationOptions<Types.SaveStudentResultFeedbackMutation, Types.SaveStudentResultFeedbackMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SaveStudentResultFeedbackMutation, Types.SaveStudentResultFeedbackMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SaveStudentResultFeedbackMutation, Types.SaveStudentResultFeedbackMutationVariables>(SaveStudentResultFeedbackDocument, options);
}
export type SaveStudentResultFeedbackMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SaveStudentResultFeedbackMutation, Types.SaveStudentResultFeedbackMutationVariables>;
export const GenerateStudentIdCardDocument = gql`
    mutation GenerateStudentIdCard($student_id: ID!) {
  generateStudentIdCard(student_id: $student_id) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useGenerateStudentIdCardMutation__
 *
 * To run a mutation, you first call `useGenerateStudentIdCardMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStudentIdCardMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateStudentIdCardMutation({
 *   variables: {
 *     student_id: // value for 'student_id'
 *   },
 * });
 */
export function useGenerateStudentIdCardMutation(options: VueApolloComposable.UseMutationOptions<Types.GenerateStudentIdCardMutation, Types.GenerateStudentIdCardMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.GenerateStudentIdCardMutation, Types.GenerateStudentIdCardMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.GenerateStudentIdCardMutation, Types.GenerateStudentIdCardMutationVariables>(GenerateStudentIdCardDocument, options);
}
export type GenerateStudentIdCardMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.GenerateStudentIdCardMutation, Types.GenerateStudentIdCardMutationVariables>;
export const SetSubjectOfferingDocument = gql`
    mutation setSubjectOffering($subjectId: ID!, $input: SubjectOfferingInput!) {
  setSubjectOffering(subjectId: $subjectId, input: $input) {
    id
    status
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    section {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSetSubjectOfferingMutation__
 *
 * To run a mutation, you first call `useSetSubjectOfferingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetSubjectOfferingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetSubjectOfferingMutation({
 *   variables: {
 *     subjectId: // value for 'subjectId'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSetSubjectOfferingMutation(options: VueApolloComposable.UseMutationOptions<Types.SetSubjectOfferingMutation, Types.SetSubjectOfferingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetSubjectOfferingMutation, Types.SetSubjectOfferingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetSubjectOfferingMutation, Types.SetSubjectOfferingMutationVariables>(SetSubjectOfferingDocument, options);
}
export type SetSubjectOfferingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetSubjectOfferingMutation, Types.SetSubjectOfferingMutationVariables>;
export const SetSubjectOfferingsDocument = gql`
    mutation setSubjectOfferings($subjectId: ID!, $offerings: [SubjectOfferingInput!]!) {
  setSubjectOfferings(subjectId: $subjectId, offerings: $offerings) {
    id
    status
    subject {
      id
      name
    }
    classroom {
      id
      name
    }
    section {
      id
      name
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSetSubjectOfferingsMutation__
 *
 * To run a mutation, you first call `useSetSubjectOfferingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetSubjectOfferingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetSubjectOfferingsMutation({
 *   variables: {
 *     subjectId: // value for 'subjectId'
 *     offerings: // value for 'offerings'
 *   },
 * });
 */
export function useSetSubjectOfferingsMutation(options: VueApolloComposable.UseMutationOptions<Types.SetSubjectOfferingsMutation, Types.SetSubjectOfferingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetSubjectOfferingsMutation, Types.SetSubjectOfferingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetSubjectOfferingsMutation, Types.SetSubjectOfferingsMutationVariables>(SetSubjectOfferingsDocument, options);
}
export type SetSubjectOfferingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetSubjectOfferingsMutation, Types.SetSubjectOfferingsMutationVariables>;
export const DeleteSubjectOfferingDocument = gql`
    mutation deleteSubjectOffering($subjectId: ID!, $classroom_id: ID!, $section_id: ID) {
  deleteSubjectOffering(
    subjectId: $subjectId
    classroom_id: $classroom_id
    section_id: $section_id
  ) {
    success
    message
  }
}
    `;

/**
 * __useDeleteSubjectOfferingMutation__
 *
 * To run a mutation, you first call `useDeleteSubjectOfferingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubjectOfferingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSubjectOfferingMutation({
 *   variables: {
 *     subjectId: // value for 'subjectId'
 *     classroom_id: // value for 'classroom_id'
 *     section_id: // value for 'section_id'
 *   },
 * });
 */
export function useDeleteSubjectOfferingMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSubjectOfferingMutation, Types.DeleteSubjectOfferingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSubjectOfferingMutation, Types.DeleteSubjectOfferingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSubjectOfferingMutation, Types.DeleteSubjectOfferingMutationVariables>(DeleteSubjectOfferingDocument, options);
}
export type DeleteSubjectOfferingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSubjectOfferingMutation, Types.DeleteSubjectOfferingMutationVariables>;
export const CreateSummaryTemplateDocument = gql`
    mutation CreateSummaryTemplate($input: CreateSummaryTemplateInput!) {
  createSummaryTemplate(input: $input) {
    id
    name
    description
    properties
    columns {
      id
      label
      key
      type
      group
      sequence
      is_visible
      calculation_function
      calculation_arguments
    }
  }
}
    `;

/**
 * __useCreateSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSummaryTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSummaryTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSummaryTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSummaryTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSummaryTemplateMutation, Types.CreateSummaryTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSummaryTemplateMutation, Types.CreateSummaryTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSummaryTemplateMutation, Types.CreateSummaryTemplateMutationVariables>(CreateSummaryTemplateDocument, options);
}
export type CreateSummaryTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSummaryTemplateMutation, Types.CreateSummaryTemplateMutationVariables>;
export const UpdateSummaryTemplateDocument = gql`
    mutation UpdateSummaryTemplate($input: UpdateSummaryTemplateInput!) {
  updateSummaryTemplate(input: $input) {
    id
    name
    description
    properties
    columns {
      id
      label
      key
      type
      group
      sequence
      is_visible
      calculation_function
      calculation_arguments
    }
  }
}
    `;

/**
 * __useUpdateSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSummaryTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSummaryTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSummaryTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSummaryTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSummaryTemplateMutation, Types.UpdateSummaryTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSummaryTemplateMutation, Types.UpdateSummaryTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSummaryTemplateMutation, Types.UpdateSummaryTemplateMutationVariables>(UpdateSummaryTemplateDocument, options);
}
export type UpdateSummaryTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSummaryTemplateMutation, Types.UpdateSummaryTemplateMutationVariables>;
export const DeleteSummaryTemplateDocument = gql`
    mutation DeleteSummaryTemplate($id: ID!) {
  deleteSummaryTemplate(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteSummaryTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSummaryTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSummaryTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSummaryTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSummaryTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSummaryTemplateMutation, Types.DeleteSummaryTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSummaryTemplateMutation, Types.DeleteSummaryTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSummaryTemplateMutation, Types.DeleteSummaryTemplateMutationVariables>(DeleteSummaryTemplateDocument, options);
}
export type DeleteSummaryTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSummaryTemplateMutation, Types.DeleteSummaryTemplateMutationVariables>;
export const InviteTeacherDocument = gql`
    mutation InviteTeacher($email: String!, $school_permission_group_id: ID) {
  inviteTeacher(
    email: $email
    school_permission_group_id: $school_permission_group_id
  ) {
    id
    email
    status
    permissionGroup {
      id
      name
    }
  }
}
    `;

/**
 * __useInviteTeacherMutation__
 *
 * To run a mutation, you first call `useInviteTeacherMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeacherMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInviteTeacherMutation({
 *   variables: {
 *     email: // value for 'email'
 *     school_permission_group_id: // value for 'school_permission_group_id'
 *   },
 * });
 */
export function useInviteTeacherMutation(options: VueApolloComposable.UseMutationOptions<Types.InviteTeacherMutation, Types.InviteTeacherMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.InviteTeacherMutation, Types.InviteTeacherMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.InviteTeacherMutation, Types.InviteTeacherMutationVariables>(InviteTeacherDocument, options);
}
export type InviteTeacherMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.InviteTeacherMutation, Types.InviteTeacherMutationVariables>;
export const BulkInviteStaffDocument = gql`
    mutation BulkInviteStaff($input: BulkInviteStaffInput!) {
  bulkInviteStaff(input: $input) {
    results {
      email
      status
      invitation_id
    }
    summary {
      total
      sent
      skipped
    }
  }
}
    `;

/**
 * __useBulkInviteStaffMutation__
 *
 * To run a mutation, you first call `useBulkInviteStaffMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkInviteStaffMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkInviteStaffMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkInviteStaffMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkInviteStaffMutation, Types.BulkInviteStaffMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkInviteStaffMutation, Types.BulkInviteStaffMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkInviteStaffMutation, Types.BulkInviteStaffMutationVariables>(BulkInviteStaffDocument, options);
}
export type BulkInviteStaffMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkInviteStaffMutation, Types.BulkInviteStaffMutationVariables>;
export const AcceptSchoolInvitationDocument = gql`
    mutation AcceptSchoolInvitation($token: String!, $password: String) {
  acceptSchoolInvitation(token: $token, password: $password) {
    id
    name
  }
}
    `;

/**
 * __useAcceptSchoolInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptSchoolInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcceptSchoolInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcceptSchoolInvitationMutation({
 *   variables: {
 *     token: // value for 'token'
 *     password: // value for 'password'
 *   },
 * });
 */
export function useAcceptSchoolInvitationMutation(options: VueApolloComposable.UseMutationOptions<Types.AcceptSchoolInvitationMutation, Types.AcceptSchoolInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AcceptSchoolInvitationMutation, Types.AcceptSchoolInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AcceptSchoolInvitationMutation, Types.AcceptSchoolInvitationMutationVariables>(AcceptSchoolInvitationDocument, options);
}
export type AcceptSchoolInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AcceptSchoolInvitationMutation, Types.AcceptSchoolInvitationMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: UserRegisterInput!) {
  registerUser(input: $input) {
    token
    user {
      __typename
      ... on User {
        id
        name
        userEmail: email
      }
      ... on Staff {
        id
        name
        staffEmail: email
      }
      ... on Teacher {
        id
        teacherEmail: email
      }
    }
  }
}
    `;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegisterUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(options: VueApolloComposable.UseMutationOptions<Types.RegisterUserMutation, Types.RegisterUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RegisterUserMutation, Types.RegisterUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RegisterUserMutation, Types.RegisterUserMutationVariables>(RegisterUserDocument, options);
}
export type RegisterUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RegisterUserMutation, Types.RegisterUserMutationVariables>;
export const RejectSchoolInvitationDocument = gql`
    mutation RejectSchoolInvitation($token: String!) {
  rejectSchoolInvitation(token: $token)
}
    `;

/**
 * __useRejectSchoolInvitationMutation__
 *
 * To run a mutation, you first call `useRejectSchoolInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectSchoolInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectSchoolInvitationMutation({
 *   variables: {
 *     token: // value for 'token'
 *   },
 * });
 */
export function useRejectSchoolInvitationMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectSchoolInvitationMutation, Types.RejectSchoolInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectSchoolInvitationMutation, Types.RejectSchoolInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectSchoolInvitationMutation, Types.RejectSchoolInvitationMutationVariables>(RejectSchoolInvitationDocument, options);
}
export type RejectSchoolInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectSchoolInvitationMutation, Types.RejectSchoolInvitationMutationVariables>;
export const ResendSchoolInvitationDocument = gql`
    mutation ResendSchoolInvitation($id: ID!) {
  resendSchoolInvitation(id: $id) {
    id
    email
    status
  }
}
    `;

/**
 * __useResendSchoolInvitationMutation__
 *
 * To run a mutation, you first call `useResendSchoolInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResendSchoolInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResendSchoolInvitationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useResendSchoolInvitationMutation(options: VueApolloComposable.UseMutationOptions<Types.ResendSchoolInvitationMutation, Types.ResendSchoolInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResendSchoolInvitationMutation, Types.ResendSchoolInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResendSchoolInvitationMutation, Types.ResendSchoolInvitationMutationVariables>(ResendSchoolInvitationDocument, options);
}
export type ResendSchoolInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResendSchoolInvitationMutation, Types.ResendSchoolInvitationMutationVariables>;
export const DeleteSchoolInvitationDocument = gql`
    mutation DeleteSchoolInvitation($id: ID!) {
  deleteSchoolInvitation(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteSchoolInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolInvitationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolInvitationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSchoolInvitationMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSchoolInvitationMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteSchoolInvitationMutation, Types.DeleteSchoolInvitationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteSchoolInvitationMutation, Types.DeleteSchoolInvitationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteSchoolInvitationMutation, Types.DeleteSchoolInvitationMutationVariables>(DeleteSchoolInvitationDocument, options);
}
export type DeleteSchoolInvitationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteSchoolInvitationMutation, Types.DeleteSchoolInvitationMutationVariables>;
export const RequestRoleDocument = gql`
    mutation requestRole($input: RequestRoleInput!) {
  requestRole(input: $input) {
    id
    grant_type
    status
    is_active
    is_primary
    starts_at
    ends_at
    permissionGroup {
      id
      name
    }
    scopes {
      id
      scope_type
      scope_value
    }
  }
}
    `;

/**
 * __useRequestRoleMutation__
 *
 * To run a mutation, you first call `useRequestRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestRoleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRequestRoleMutation(options: VueApolloComposable.UseMutationOptions<Types.RequestRoleMutation, Types.RequestRoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RequestRoleMutation, Types.RequestRoleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RequestRoleMutation, Types.RequestRoleMutationVariables>(RequestRoleDocument, options);
}
export type RequestRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RequestRoleMutation, Types.RequestRoleMutationVariables>;
export const CreateFacultyDocument = gql`
    mutation CreateFaculty($input: facultyInput!) {
  createFaculty(input: $input) {
    id
    faculty_name
    school_id
    type
    is_active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateFacultyMutation__
 *
 * To run a mutation, you first call `useCreateFacultyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateFacultyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateFacultyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateFacultyMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateFacultyMutation, Types.CreateFacultyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateFacultyMutation, Types.CreateFacultyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateFacultyMutation, Types.CreateFacultyMutationVariables>(CreateFacultyDocument, options);
}
export type CreateFacultyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateFacultyMutation, Types.CreateFacultyMutationVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: departmentInput!) {
  createDepartment(input: $input) {
    id
    department_name
    type
    is_active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateDepartmentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartmentMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateDepartmentMutation, Types.CreateDepartmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateDepartmentMutation, Types.CreateDepartmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateDepartmentMutation, Types.CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
}
export type CreateDepartmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateDepartmentMutation, Types.CreateDepartmentMutationVariables>;
export const CreateProgrammeDocument = gql`
    mutation CreateProgramme($input: programmeInput!) {
  createProgramme(input: $input) {
    id
    program_name
    prog_code
    department_id
    delivery_mode
    min_units_per_registration
    max_units_per_registration
    module_result_mode
    is_active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateProgrammeMutation__
 *
 * To run a mutation, you first call `useCreateProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProgrammeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateProgrammeMutation, Types.CreateProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateProgrammeMutation, Types.CreateProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateProgrammeMutation, Types.CreateProgrammeMutationVariables>(CreateProgrammeDocument, options);
}
export type CreateProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateProgrammeMutation, Types.CreateProgrammeMutationVariables>;
export const UpdateFacultyDocument = gql`
    mutation UpdateFaculty($id: ID!, $input: facultyInput!) {
  updateFaculty(id: $id, input: $input) {
    id
    faculty_name
    type
    is_active
    updatedAt
  }
}
    `;

/**
 * __useUpdateFacultyMutation__
 *
 * To run a mutation, you first call `useUpdateFacultyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacultyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateFacultyMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacultyMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateFacultyMutation, Types.UpdateFacultyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateFacultyMutation, Types.UpdateFacultyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateFacultyMutation, Types.UpdateFacultyMutationVariables>(UpdateFacultyDocument, options);
}
export type UpdateFacultyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateFacultyMutation, Types.UpdateFacultyMutationVariables>;
export const DeleteFacultyDocument = gql`
    mutation DeleteFaculty($id: ID!) {
  deleteFaculty(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteFacultyMutation__
 *
 * To run a mutation, you first call `useDeleteFacultyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFacultyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteFacultyMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFacultyMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteFacultyMutation, Types.DeleteFacultyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteFacultyMutation, Types.DeleteFacultyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteFacultyMutation, Types.DeleteFacultyMutationVariables>(DeleteFacultyDocument, options);
}
export type DeleteFacultyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteFacultyMutation, Types.DeleteFacultyMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($id: ID!, $input: DepartmentUpdateInput!) {
  updateDepartment(id: $id, input: $input) {
    id
    department_name
    faculty_id
    type
    is_active
    updatedAt
  }
}
    `;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateDepartmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateDepartmentMutation, Types.UpdateDepartmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateDepartmentMutation, Types.UpdateDepartmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateDepartmentMutation, Types.UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
}
export type UpdateDepartmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateDepartmentMutation, Types.UpdateDepartmentMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($id: ID!) {
  deleteDepartment(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteDepartmentMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteDepartmentMutation, Types.DeleteDepartmentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteDepartmentMutation, Types.DeleteDepartmentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteDepartmentMutation, Types.DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, options);
}
export type DeleteDepartmentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteDepartmentMutation, Types.DeleteDepartmentMutationVariables>;
export const UpdateProgrammeDocument = gql`
    mutation UpdateProgramme($id: ID!, $input: programmeUpdateInput!) {
  updateProgramme(id: $id, input: $input) {
    id
    program_name
    prog_code
    department_id
    degree
    type
    duration
    min_units
    calculation_method
    delivery_mode
    min_units_per_registration
    max_units_per_registration
    module_result_mode
    graduation_criteria
    is_active
    updatedAt
  }
}
    `;

/**
 * __useUpdateProgrammeMutation__
 *
 * To run a mutation, you first call `useUpdateProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProgrammeMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateProgrammeMutation, Types.UpdateProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateProgrammeMutation, Types.UpdateProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateProgrammeMutation, Types.UpdateProgrammeMutationVariables>(UpdateProgrammeDocument, options);
}
export type UpdateProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateProgrammeMutation, Types.UpdateProgrammeMutationVariables>;
export const DeleteProgrammeDocument = gql`
    mutation DeleteProgramme($id: ID!) {
  deleteProgramme(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteProgrammeMutation__
 *
 * To run a mutation, you first call `useDeleteProgrammeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgrammeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProgrammeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProgrammeMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteProgrammeMutation, Types.DeleteProgrammeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteProgrammeMutation, Types.DeleteProgrammeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteProgrammeMutation, Types.DeleteProgrammeMutationVariables>(DeleteProgrammeDocument, options);
}
export type DeleteProgrammeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteProgrammeMutation, Types.DeleteProgrammeMutationVariables>;
export const CreateCourseDocument = gql`
    mutation CreateCourse($input: CourseCreateInput!) {
  createCourse(input: $input) {
    id
    course_title
    course_instance_id
    course_instance_year
    course_code
    is_active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCourseMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCourseMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCourseMutation, Types.CreateCourseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCourseMutation, Types.CreateCourseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCourseMutation, Types.CreateCourseMutationVariables>(CreateCourseDocument, options);
}
export type CreateCourseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCourseMutation, Types.CreateCourseMutationVariables>;
export const CreateCurriculumDocument = gql`
    mutation CreateCurriculum($input: createCurriculumInput!) {
  createCurriculum(input: $input)
}
    `;

/**
 * __useCreateCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCurriculumMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCurriculumMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCurriculumMutation, Types.CreateCurriculumMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCurriculumMutation, Types.CreateCurriculumMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCurriculumMutation, Types.CreateCurriculumMutationVariables>(CreateCurriculumDocument, options);
}
export type CreateCurriculumMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCurriculumMutation, Types.CreateCurriculumMutationVariables>;
export const UpdateCurriculumDocument = gql`
    mutation UpdateCurriculum($id: ID!, $input: updateCurriculumInput) {
  updateCurriculum(id: $id, input: $input) {
    id
    course_id
    programme_id
    status
    semester
    course_registration_level
    programme_module_id
    school_id
    is_active
    course {
      id
      course_title
    }
    programme {
      id
      program_name
    }
    programmeModule {
      id
      name
      sequence
    }
  }
}
    `;

/**
 * __useUpdateCurriculumMutation__
 *
 * To run a mutation, you first call `useUpdateCurriculumMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurriculumMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCurriculumMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurriculumMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCurriculumMutation, Types.UpdateCurriculumMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCurriculumMutation, Types.UpdateCurriculumMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCurriculumMutation, Types.UpdateCurriculumMutationVariables>(UpdateCurriculumDocument, options);
}
export type UpdateCurriculumMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCurriculumMutation, Types.UpdateCurriculumMutationVariables>;
export const DeleteCurriculumDocument = gql`
    mutation DeleteCurriculum($id: ID!) {
  deleteCurriculum(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteCurriculumMutation__
 *
 * To run a mutation, you first call `useDeleteCurriculumMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurriculumMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCurriculumMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCurriculumMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCurriculumMutation, Types.DeleteCurriculumMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCurriculumMutation, Types.DeleteCurriculumMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCurriculumMutation, Types.DeleteCurriculumMutationVariables>(DeleteCurriculumDocument, options);
}
export type DeleteCurriculumMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCurriculumMutation, Types.DeleteCurriculumMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($id: ID!, $input: CourseUpdateInput!) {
  updateCourse(id: $id, input: $input) {
    id
    course_instance_id
    course_instance_year
    course_code
    course_title
    unit
    school_id
    is_active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCourseMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCourseMutation, Types.UpdateCourseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCourseMutation, Types.UpdateCourseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCourseMutation, Types.UpdateCourseMutationVariables>(UpdateCourseDocument, options);
}
export type UpdateCourseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCourseMutation, Types.UpdateCourseMutationVariables>;
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($id: ID!) {
  deleteCourse(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteCourseMutation__
 *
 * To run a mutation, you first call `useDeleteCourseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCourseMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourseMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCourseMutation, Types.DeleteCourseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCourseMutation, Types.DeleteCourseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCourseMutation, Types.DeleteCourseMutationVariables>(DeleteCourseDocument, options);
}
export type DeleteCourseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCourseMutation, Types.DeleteCourseMutationVariables>;
export const AddCourseToRegDocument = gql`
    mutation AddCourseToReg($input: addCourseToRegInput!) {
  addCourseMutation(input: $input) {
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useAddCourseToRegMutation__
 *
 * To run a mutation, you first call `useAddCourseToRegMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCourseToRegMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCourseToRegMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddCourseToRegMutation(options: VueApolloComposable.UseMutationOptions<Types.AddCourseToRegMutation, Types.AddCourseToRegMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddCourseToRegMutation, Types.AddCourseToRegMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddCourseToRegMutation, Types.AddCourseToRegMutationVariables>(AddCourseToRegDocument, options);
}
export type AddCourseToRegMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddCourseToRegMutation, Types.AddCourseToRegMutationVariables>;
export const DropCourseFromRegDocument = gql`
    mutation DropCourseFromReg($input: dropCourseFromRegInput!) {
  dropCourseMutation(input: $input) {
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useDropCourseFromRegMutation__
 *
 * To run a mutation, you first call `useDropCourseFromRegMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDropCourseFromRegMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDropCourseFromRegMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDropCourseFromRegMutation(options: VueApolloComposable.UseMutationOptions<Types.DropCourseFromRegMutation, Types.DropCourseFromRegMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DropCourseFromRegMutation, Types.DropCourseFromRegMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DropCourseFromRegMutation, Types.DropCourseFromRegMutationVariables>(DropCourseFromRegDocument, options);
}
export type DropCourseFromRegMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DropCourseFromRegMutation, Types.DropCourseFromRegMutationVariables>;
export const UpdateCourseRegisteredFieldsDocument = gql`
    mutation UpdateCourseRegisteredFields($input: updateCourseRegisteredFieldsInput!) {
  updateCourseRegisteredFields(input: $input) {
    id
    student_course_registration_id
    course_id
    course_status
    accepted_for_programme_id
    is_transferred
    accepted_by
    accepted_at
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUpdateCourseRegisteredFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateCourseRegisteredFieldsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseRegisteredFieldsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCourseRegisteredFieldsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseRegisteredFieldsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCourseRegisteredFieldsMutation, Types.UpdateCourseRegisteredFieldsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCourseRegisteredFieldsMutation, Types.UpdateCourseRegisteredFieldsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCourseRegisteredFieldsMutation, Types.UpdateCourseRegisteredFieldsMutationVariables>(UpdateCourseRegisteredFieldsDocument, options);
}
export type UpdateCourseRegisteredFieldsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCourseRegisteredFieldsMutation, Types.UpdateCourseRegisteredFieldsMutationVariables>;
export const LecturerSubmitCoursesInSemesterDocument = gql`
    mutation LecturerSubmitCoursesInSemester($input: lecturerSubmitCoursesInSemesterInput!) {
  lecturerSubmitCoursesInSemester(input: $input) {
    id
    course_id
    academic_calendar_id
    school_id
    course {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useLecturerSubmitCoursesInSemesterMutation__
 *
 * To run a mutation, you first call `useLecturerSubmitCoursesInSemesterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLecturerSubmitCoursesInSemesterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLecturerSubmitCoursesInSemesterMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useLecturerSubmitCoursesInSemesterMutation(options: VueApolloComposable.UseMutationOptions<Types.LecturerSubmitCoursesInSemesterMutation, Types.LecturerSubmitCoursesInSemesterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LecturerSubmitCoursesInSemesterMutation, Types.LecturerSubmitCoursesInSemesterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LecturerSubmitCoursesInSemesterMutation, Types.LecturerSubmitCoursesInSemesterMutationVariables>(LecturerSubmitCoursesInSemesterDocument, options);
}
export type LecturerSubmitCoursesInSemesterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LecturerSubmitCoursesInSemesterMutation, Types.LecturerSubmitCoursesInSemesterMutationVariables>;
export const ApproveOrDenyCourseDocument = gql`
    mutation ApproveOrDenyCourse($input: approveOrDenyCourseInput!) {
  approveOrDenyCourse(input: $input) {
    id
    is_approved
    approved_at
    denied_at
    approved_by_id
    denied_by_id
  }
}
    `;

/**
 * __useApproveOrDenyCourseMutation__
 *
 * To run a mutation, you first call `useApproveOrDenyCourseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrDenyCourseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveOrDenyCourseMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApproveOrDenyCourseMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveOrDenyCourseMutation, Types.ApproveOrDenyCourseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveOrDenyCourseMutation, Types.ApproveOrDenyCourseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveOrDenyCourseMutation, Types.ApproveOrDenyCourseMutationVariables>(ApproveOrDenyCourseDocument, options);
}
export type ApproveOrDenyCourseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveOrDenyCourseMutation, Types.ApproveOrDenyCourseMutationVariables>;
export const AllocateCoursesToLecturerDocument = gql`
    mutation AllocateCoursesToLecturer($input: allocateCoursesToLecturerInSemesterByHODOrAdminInput!) {
  allocateCoursesToLecturerInSemesterByHODOrAdmin(input: $input) {
    id
    school_staff_id
    course_id
    academic_calendar_id
    is_approved
    approved_at
    denied_at
    created_at
    updated_at
    user {
      id
      name
    }
    course {
      id
      course_code
      course_title
      course_instance_id
      course_instance_year
      unit
    }
  }
}
    `;

/**
 * __useAllocateCoursesToLecturerMutation__
 *
 * To run a mutation, you first call `useAllocateCoursesToLecturerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAllocateCoursesToLecturerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAllocateCoursesToLecturerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAllocateCoursesToLecturerMutation(options: VueApolloComposable.UseMutationOptions<Types.AllocateCoursesToLecturerMutation, Types.AllocateCoursesToLecturerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AllocateCoursesToLecturerMutation, Types.AllocateCoursesToLecturerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AllocateCoursesToLecturerMutation, Types.AllocateCoursesToLecturerMutationVariables>(AllocateCoursesToLecturerDocument, options);
}
export type AllocateCoursesToLecturerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AllocateCoursesToLecturerMutation, Types.AllocateCoursesToLecturerMutationVariables>;
export const UpdateRegistrationFieldsDocument = gql`
    mutation UpdateRegistrationFields($input: updateCourseRegistrationFieldsInput!) {
  updateRegistrationFields(input: $input) {
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    academic_calendar_id
    authorization_status
    approval_status
    rejection_reason
    programme {
      id
      program_name
    }
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useUpdateRegistrationFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrationFieldsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrationFieldsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRegistrationFieldsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegistrationFieldsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateRegistrationFieldsMutation, Types.UpdateRegistrationFieldsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateRegistrationFieldsMutation, Types.UpdateRegistrationFieldsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateRegistrationFieldsMutation, Types.UpdateRegistrationFieldsMutationVariables>(UpdateRegistrationFieldsDocument, options);
}
export type UpdateRegistrationFieldsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateRegistrationFieldsMutation, Types.UpdateRegistrationFieldsMutationVariables>;
export const UpdateRegistrationScoresDocument = gql`
    mutation UpdateRegistrationScores($courseScores: [CourseScoreInput!]!) {
  updateRegistrationScores(courseScores: $courseScores) {
    success
    message
    updated_count
    created_count
  }
}
    `;

/**
 * __useUpdateRegistrationScoresMutation__
 *
 * To run a mutation, you first call `useUpdateRegistrationScoresMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegistrationScoresMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRegistrationScoresMutation({
 *   variables: {
 *     courseScores: // value for 'courseScores'
 *   },
 * });
 */
export function useUpdateRegistrationScoresMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateRegistrationScoresMutation, Types.UpdateRegistrationScoresMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateRegistrationScoresMutation, Types.UpdateRegistrationScoresMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateRegistrationScoresMutation, Types.UpdateRegistrationScoresMutationVariables>(UpdateRegistrationScoresDocument, options);
}
export type UpdateRegistrationScoresMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateRegistrationScoresMutation, Types.UpdateRegistrationScoresMutationVariables>;
export const DeallocateCourseFromLecturerDocument = gql`
    mutation DeallocateCourseFromLecturer($input: allocateCoursesToLecturerInSemesterByHODOrAdminInput!) {
  deallocateCourseFromLecturer(input: $input) {
    id
    school_staff_id
    course_id
    academic_calendar_id
    is_approved
    approved_at
    denied_at
    created_at
    updated_at
    user {
      id
      name
    }
    course {
      id
      course_code
      course_title
    }
  }
}
    `;

/**
 * __useDeallocateCourseFromLecturerMutation__
 *
 * To run a mutation, you first call `useDeallocateCourseFromLecturerMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeallocateCourseFromLecturerMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeallocateCourseFromLecturerMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeallocateCourseFromLecturerMutation(options: VueApolloComposable.UseMutationOptions<Types.DeallocateCourseFromLecturerMutation, Types.DeallocateCourseFromLecturerMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeallocateCourseFromLecturerMutation, Types.DeallocateCourseFromLecturerMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeallocateCourseFromLecturerMutation, Types.DeallocateCourseFromLecturerMutationVariables>(DeallocateCourseFromLecturerDocument, options);
}
export type DeallocateCourseFromLecturerMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeallocateCourseFromLecturerMutation, Types.DeallocateCourseFromLecturerMutationVariables>;
export const ApproveStudentCourseRegistrationDocument = gql`
    mutation ApproveStudentCourseRegistration($input: ApproveStudentRegistrationInput!) {
  approveStudentCourseRegistration(input: $input) {
    id
    approval_status
  }
}
    `;

/**
 * __useApproveStudentCourseRegistrationMutation__
 *
 * To run a mutation, you first call `useApproveStudentCourseRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveStudentCourseRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveStudentCourseRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useApproveStudentCourseRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveStudentCourseRegistrationMutation, Types.ApproveStudentCourseRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveStudentCourseRegistrationMutation, Types.ApproveStudentCourseRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveStudentCourseRegistrationMutation, Types.ApproveStudentCourseRegistrationMutationVariables>(ApproveStudentCourseRegistrationDocument, options);
}
export type ApproveStudentCourseRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveStudentCourseRegistrationMutation, Types.ApproveStudentCourseRegistrationMutationVariables>;
export const RejectStudentCourseRegistrationDocument = gql`
    mutation RejectStudentCourseRegistration($input: RejectStudentRegistrationInput!) {
  rejectStudentCourseRegistration(input: $input) {
    id
    approval_status
  }
}
    `;

/**
 * __useRejectStudentCourseRegistrationMutation__
 *
 * To run a mutation, you first call `useRejectStudentCourseRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectStudentCourseRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectStudentCourseRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useRejectStudentCourseRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectStudentCourseRegistrationMutation, Types.RejectStudentCourseRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectStudentCourseRegistrationMutation, Types.RejectStudentCourseRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectStudentCourseRegistrationMutation, Types.RejectStudentCourseRegistrationMutationVariables>(RejectStudentCourseRegistrationDocument, options);
}
export type RejectStudentCourseRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectStudentCourseRegistrationMutation, Types.RejectStudentCourseRegistrationMutationVariables>;
export const EndorseCourseRegistrationByHodDocument = gql`
    mutation EndorseCourseRegistrationByHOD($input: ApproveStudentRegistrationInput!) {
  endorseCourseRegistrationByHOD(input: $input) {
    id
    approval_status
  }
}
    `;

/**
 * __useEndorseCourseRegistrationByHodMutation__
 *
 * To run a mutation, you first call `useEndorseCourseRegistrationByHodMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEndorseCourseRegistrationByHodMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEndorseCourseRegistrationByHodMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEndorseCourseRegistrationByHodMutation(options: VueApolloComposable.UseMutationOptions<Types.EndorseCourseRegistrationByHodMutation, Types.EndorseCourseRegistrationByHodMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.EndorseCourseRegistrationByHodMutation, Types.EndorseCourseRegistrationByHodMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.EndorseCourseRegistrationByHodMutation, Types.EndorseCourseRegistrationByHodMutationVariables>(EndorseCourseRegistrationByHodDocument, options);
}
export type EndorseCourseRegistrationByHodMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.EndorseCourseRegistrationByHodMutation, Types.EndorseCourseRegistrationByHodMutationVariables>;
export const OverrideCourseRegistrationApprovalDocument = gql`
    mutation OverrideCourseRegistrationApproval($input: OverrideRegistrationApprovalInput!) {
  overrideCourseRegistrationApproval(input: $input) {
    id
    approval_status
  }
}
    `;

/**
 * __useOverrideCourseRegistrationApprovalMutation__
 *
 * To run a mutation, you first call `useOverrideCourseRegistrationApprovalMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useOverrideCourseRegistrationApprovalMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useOverrideCourseRegistrationApprovalMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useOverrideCourseRegistrationApprovalMutation(options: VueApolloComposable.UseMutationOptions<Types.OverrideCourseRegistrationApprovalMutation, Types.OverrideCourseRegistrationApprovalMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.OverrideCourseRegistrationApprovalMutation, Types.OverrideCourseRegistrationApprovalMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.OverrideCourseRegistrationApprovalMutation, Types.OverrideCourseRegistrationApprovalMutationVariables>(OverrideCourseRegistrationApprovalDocument, options);
}
export type OverrideCourseRegistrationApprovalMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.OverrideCourseRegistrationApprovalMutation, Types.OverrideCourseRegistrationApprovalMutationVariables>;
export const SenateApproveStudentRegistrationDocument = gql`
    mutation SenateApproveStudentRegistration($input: ApproveStudentRegistrationInput!) {
  senateApproveStudentRegistration(input: $input) {
    id
    approval_status
    senate_approval_status
  }
}
    `;

/**
 * __useSenateApproveStudentRegistrationMutation__
 *
 * To run a mutation, you first call `useSenateApproveStudentRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSenateApproveStudentRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSenateApproveStudentRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSenateApproveStudentRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.SenateApproveStudentRegistrationMutation, Types.SenateApproveStudentRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SenateApproveStudentRegistrationMutation, Types.SenateApproveStudentRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SenateApproveStudentRegistrationMutation, Types.SenateApproveStudentRegistrationMutationVariables>(SenateApproveStudentRegistrationDocument, options);
}
export type SenateApproveStudentRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SenateApproveStudentRegistrationMutation, Types.SenateApproveStudentRegistrationMutationVariables>;
export const CreateCampusDocument = gql`
    mutation CreateCampus($input: campusInput!) {
  createCampus(input: $input) {
    id
    name
    school_id
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateCampusMutation__
 *
 * To run a mutation, you first call `useCreateCampusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCampusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampusMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCampusMutation, Types.CreateCampusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCampusMutation, Types.CreateCampusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCampusMutation, Types.CreateCampusMutationVariables>(CreateCampusDocument, options);
}
export type CreateCampusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCampusMutation, Types.CreateCampusMutationVariables>;
export const UpdateCampusDocument = gql`
    mutation UpdateCampus($id: Int!, $input: campusInput!) {
  updateCampus(id: $id, input: $input) {
    id
    name
    updatedAt
  }
}
    `;

/**
 * __useUpdateCampusMutation__
 *
 * To run a mutation, you first call `useUpdateCampusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCampusMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampusMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCampusMutation, Types.UpdateCampusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCampusMutation, Types.UpdateCampusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCampusMutation, Types.UpdateCampusMutationVariables>(UpdateCampusDocument, options);
}
export type UpdateCampusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCampusMutation, Types.UpdateCampusMutationVariables>;
export const DeleteCampusDocument = gql`
    mutation DeleteCampus($id: Int!) {
  deleteCampus(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteCampusMutation__
 *
 * To run a mutation, you first call `useDeleteCampusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCampusMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampusMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteCampusMutation, Types.DeleteCampusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteCampusMutation, Types.DeleteCampusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteCampusMutation, Types.DeleteCampusMutationVariables>(DeleteCampusDocument, options);
}
export type DeleteCampusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteCampusMutation, Types.DeleteCampusMutationVariables>;
export const PublishResultDocument = gql`
    mutation PublishResult($studentId: ID!, $calendarId: ID!) {
  publishStudentResult(student_id: $studentId, academic_calendar_id: $calendarId) {
    id
    status
    created_at
  }
}
    `;

/**
 * __usePublishResultMutation__
 *
 * To run a mutation, you first call `usePublishResultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishResultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishResultMutation({
 *   variables: {
 *     studentId: // value for 'studentId'
 *     calendarId: // value for 'calendarId'
 *   },
 * });
 */
export function usePublishResultMutation(options: VueApolloComposable.UseMutationOptions<Types.PublishResultMutation, Types.PublishResultMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.PublishResultMutation, Types.PublishResultMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.PublishResultMutation, Types.PublishResultMutationVariables>(PublishResultDocument, options);
}
export type PublishResultMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.PublishResultMutation, Types.PublishResultMutationVariables>;
export const AdminSubmitCourseRegistrationDocument = gql`
    mutation AdminSubmitCourseRegistration($input: adminCourseRegistrationInput!) {
  adminSubmitCourseRegistration(input: $input) {
    id
    student_id
    academic_session
    semester
    registration_level
    programme_id
    academic_calendar_id
    approval_status
    programme {
      id
      program_name
    }
    student {
      id
      first_name
      surname
      matric_no
    }
    coursesRegistered {
      programme_module_id
      module_name
      module_sequence
      id
      course_id
      course_status
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
}
    `;

/**
 * __useAdminSubmitCourseRegistrationMutation__
 *
 * To run a mutation, you first call `useAdminSubmitCourseRegistrationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAdminSubmitCourseRegistrationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAdminSubmitCourseRegistrationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAdminSubmitCourseRegistrationMutation(options: VueApolloComposable.UseMutationOptions<Types.AdminSubmitCourseRegistrationMutation, Types.AdminSubmitCourseRegistrationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AdminSubmitCourseRegistrationMutation, Types.AdminSubmitCourseRegistrationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AdminSubmitCourseRegistrationMutation, Types.AdminSubmitCourseRegistrationMutationVariables>(AdminSubmitCourseRegistrationDocument, options);
}
export type AdminSubmitCourseRegistrationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AdminSubmitCourseRegistrationMutation, Types.AdminSubmitCourseRegistrationMutationVariables>;
export const AllocateStudentsToLecturersRandomlyDocument = gql`
    mutation AllocateStudentsToLecturersRandomly($course_id: ID!, $course_lecturer_ids: [ID!]!, $group_by: AllocationGroupBy, $academic_calendar_id: ID) {
  allocateStudentsToLecturersRandomly(
    course_id: $course_id
    course_lecturer_ids: $course_lecturer_ids
    group_by: $group_by
    academic_calendar_id: $academic_calendar_id
  ) {
    ...StudentAllocationResultFields
  }
}
    ${StudentAllocationResultFieldsFragmentDoc}`;

/**
 * __useAllocateStudentsToLecturersRandomlyMutation__
 *
 * To run a mutation, you first call `useAllocateStudentsToLecturersRandomlyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAllocateStudentsToLecturersRandomlyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAllocateStudentsToLecturersRandomlyMutation({
 *   variables: {
 *     course_id: // value for 'course_id'
 *     course_lecturer_ids: // value for 'course_lecturer_ids'
 *     group_by: // value for 'group_by'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useAllocateStudentsToLecturersRandomlyMutation(options: VueApolloComposable.UseMutationOptions<Types.AllocateStudentsToLecturersRandomlyMutation, Types.AllocateStudentsToLecturersRandomlyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AllocateStudentsToLecturersRandomlyMutation, Types.AllocateStudentsToLecturersRandomlyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AllocateStudentsToLecturersRandomlyMutation, Types.AllocateStudentsToLecturersRandomlyMutationVariables>(AllocateStudentsToLecturersRandomlyDocument, options);
}
export type AllocateStudentsToLecturersRandomlyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AllocateStudentsToLecturersRandomlyMutation, Types.AllocateStudentsToLecturersRandomlyMutationVariables>;
export const AllocateStudentsToLecturerManuallyDocument = gql`
    mutation AllocateStudentsToLecturerManually($course_lecturer_id: ID!, $course_registered_ids: [ID!]!) {
  allocateStudentsToLecturerManually(
    course_lecturer_id: $course_lecturer_id
    course_registered_ids: $course_registered_ids
  ) {
    ...StudentAllocationResultFields
  }
}
    ${StudentAllocationResultFieldsFragmentDoc}`;

/**
 * __useAllocateStudentsToLecturerManuallyMutation__
 *
 * To run a mutation, you first call `useAllocateStudentsToLecturerManuallyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAllocateStudentsToLecturerManuallyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAllocateStudentsToLecturerManuallyMutation({
 *   variables: {
 *     course_lecturer_id: // value for 'course_lecturer_id'
 *     course_registered_ids: // value for 'course_registered_ids'
 *   },
 * });
 */
export function useAllocateStudentsToLecturerManuallyMutation(options: VueApolloComposable.UseMutationOptions<Types.AllocateStudentsToLecturerManuallyMutation, Types.AllocateStudentsToLecturerManuallyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AllocateStudentsToLecturerManuallyMutation, Types.AllocateStudentsToLecturerManuallyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AllocateStudentsToLecturerManuallyMutation, Types.AllocateStudentsToLecturerManuallyMutationVariables>(AllocateStudentsToLecturerManuallyDocument, options);
}
export type AllocateStudentsToLecturerManuallyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AllocateStudentsToLecturerManuallyMutation, Types.AllocateStudentsToLecturerManuallyMutationVariables>;
export const ReallocateStudentsDocument = gql`
    mutation ReallocateStudents($course_registered_ids: [ID!]!, $target_course_lecturer_id: ID!) {
  reallocateStudents(
    course_registered_ids: $course_registered_ids
    target_course_lecturer_id: $target_course_lecturer_id
  ) {
    ...StudentAllocationResultFields
  }
}
    ${StudentAllocationResultFieldsFragmentDoc}`;

/**
 * __useReallocateStudentsMutation__
 *
 * To run a mutation, you first call `useReallocateStudentsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReallocateStudentsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReallocateStudentsMutation({
 *   variables: {
 *     course_registered_ids: // value for 'course_registered_ids'
 *     target_course_lecturer_id: // value for 'target_course_lecturer_id'
 *   },
 * });
 */
export function useReallocateStudentsMutation(options: VueApolloComposable.UseMutationOptions<Types.ReallocateStudentsMutation, Types.ReallocateStudentsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReallocateStudentsMutation, Types.ReallocateStudentsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReallocateStudentsMutation, Types.ReallocateStudentsMutationVariables>(ReallocateStudentsDocument, options);
}
export type ReallocateStudentsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReallocateStudentsMutation, Types.ReallocateStudentsMutationVariables>;
export const ClearStudentLecturerAllocationsDocument = gql`
    mutation ClearStudentLecturerAllocations($course_id: ID!, $academic_calendar_id: ID) {
  clearStudentLecturerAllocations(
    course_id: $course_id
    academic_calendar_id: $academic_calendar_id
  ) {
    success
    message
  }
}
    `;

/**
 * __useClearStudentLecturerAllocationsMutation__
 *
 * To run a mutation, you first call `useClearStudentLecturerAllocationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useClearStudentLecturerAllocationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useClearStudentLecturerAllocationsMutation({
 *   variables: {
 *     course_id: // value for 'course_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useClearStudentLecturerAllocationsMutation(options: VueApolloComposable.UseMutationOptions<Types.ClearStudentLecturerAllocationsMutation, Types.ClearStudentLecturerAllocationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ClearStudentLecturerAllocationsMutation, Types.ClearStudentLecturerAllocationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ClearStudentLecturerAllocationsMutation, Types.ClearStudentLecturerAllocationsMutationVariables>(ClearStudentLecturerAllocationsDocument, options);
}
export type ClearStudentLecturerAllocationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ClearStudentLecturerAllocationsMutation, Types.ClearStudentLecturerAllocationsMutationVariables>;
export const SetPendingApprovalNotificationPreferenceDocument = gql`
    mutation SetPendingApprovalNotificationPreference($subscribed: Boolean!, $departmentId: ID, $programmeId: ID) {
  setPendingApprovalNotificationSubscription(
    subscribed: $subscribed
    departmentId: $departmentId
    programmeId: $programmeId
  ) {
    topic
    subscribed
    scopes {
      id
      schoolWide
      departmentId
      departmentName
      programmeId
      programmeName
    }
  }
}
    `;

/**
 * __useSetPendingApprovalNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetPendingApprovalNotificationPreferenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPendingApprovalNotificationPreferenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPendingApprovalNotificationPreferenceMutation({
 *   variables: {
 *     subscribed: // value for 'subscribed'
 *     departmentId: // value for 'departmentId'
 *     programmeId: // value for 'programmeId'
 *   },
 * });
 */
export function useSetPendingApprovalNotificationPreferenceMutation(options: VueApolloComposable.UseMutationOptions<Types.SetPendingApprovalNotificationPreferenceMutation, Types.SetPendingApprovalNotificationPreferenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetPendingApprovalNotificationPreferenceMutation, Types.SetPendingApprovalNotificationPreferenceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetPendingApprovalNotificationPreferenceMutation, Types.SetPendingApprovalNotificationPreferenceMutationVariables>(SetPendingApprovalNotificationPreferenceDocument, options);
}
export type SetPendingApprovalNotificationPreferenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetPendingApprovalNotificationPreferenceMutation, Types.SetPendingApprovalNotificationPreferenceMutationVariables>;
export const BulkCourseRegistrationActionDocument = gql`
    mutation BulkCourseRegistrationAction($input: BulkCourseRegistrationActionInput!) {
  bulkCourseRegistrationAction(input: $input) {
    success
    message
    affected_count
    skipped_count
  }
}
    `;

/**
 * __useBulkCourseRegistrationActionMutation__
 *
 * To run a mutation, you first call `useBulkCourseRegistrationActionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkCourseRegistrationActionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkCourseRegistrationActionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useBulkCourseRegistrationActionMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkCourseRegistrationActionMutation, Types.BulkCourseRegistrationActionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkCourseRegistrationActionMutation, Types.BulkCourseRegistrationActionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkCourseRegistrationActionMutation, Types.BulkCourseRegistrationActionMutationVariables>(BulkCourseRegistrationActionDocument, options);
}
export type BulkCourseRegistrationActionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkCourseRegistrationActionMutation, Types.BulkCourseRegistrationActionMutationVariables>;
export const BulkSwapCourseDocument = gql`
    mutation BulkSwapCourse($old_course_id: ID!, $new_course_id: ID!, $programme_id: ID!, $academic_calendar_id: ID) {
  bulkSwapCourse(
    old_course_id: $old_course_id
    new_course_id: $new_course_id
    programme_id: $programme_id
    academic_calendar_id: $academic_calendar_id
  ) {
    success
    message
  }
}
    `;

/**
 * __useBulkSwapCourseMutation__
 *
 * To run a mutation, you first call `useBulkSwapCourseMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkSwapCourseMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkSwapCourseMutation({
 *   variables: {
 *     old_course_id: // value for 'old_course_id'
 *     new_course_id: // value for 'new_course_id'
 *     programme_id: // value for 'programme_id'
 *     academic_calendar_id: // value for 'academic_calendar_id'
 *   },
 * });
 */
export function useBulkSwapCourseMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkSwapCourseMutation, Types.BulkSwapCourseMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkSwapCourseMutation, Types.BulkSwapCourseMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkSwapCourseMutation, Types.BulkSwapCourseMutationVariables>(BulkSwapCourseDocument, options);
}
export type BulkSwapCourseMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkSwapCourseMutation, Types.BulkSwapCourseMutationVariables>;
export const BulkUpdateRegistrationLevelDocument = gql`
    mutation BulkUpdateRegistrationLevel($registration_ids: [ID!]!, $registration_level: String, $programme_id: ID) {
  bulkUpdateRegistrationLevel(
    registration_ids: $registration_ids
    registration_level: $registration_level
    programme_id: $programme_id
  ) {
    success
    message
    affected_count
    skipped_count
  }
}
    `;

/**
 * __useBulkUpdateRegistrationLevelMutation__
 *
 * To run a mutation, you first call `useBulkUpdateRegistrationLevelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateRegistrationLevelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useBulkUpdateRegistrationLevelMutation({
 *   variables: {
 *     registration_ids: // value for 'registration_ids'
 *     registration_level: // value for 'registration_level'
 *     programme_id: // value for 'programme_id'
 *   },
 * });
 */
export function useBulkUpdateRegistrationLevelMutation(options: VueApolloComposable.UseMutationOptions<Types.BulkUpdateRegistrationLevelMutation, Types.BulkUpdateRegistrationLevelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.BulkUpdateRegistrationLevelMutation, Types.BulkUpdateRegistrationLevelMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.BulkUpdateRegistrationLevelMutation, Types.BulkUpdateRegistrationLevelMutationVariables>(BulkUpdateRegistrationLevelDocument, options);
}
export type BulkUpdateRegistrationLevelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.BulkUpdateRegistrationLevelMutation, Types.BulkUpdateRegistrationLevelMutationVariables>;
export const CreateProgrammeModuleDocument = gql`
    mutation CreateProgrammeModule($input: createProgrammeModuleInput!) {
  createProgrammeModule(input: $input) {
    id
    programme_id
    session_id
    academic_calendar_id
    name
    sequence
    registration_fee
    retake_fee
    registration_fee_item_template_id
    retake_fee_item_template_id
    min_units_per_registration
    max_units_per_registration
    started_at
    ended_at
    is_active
    is_open
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateProgrammeModuleMutation__
 *
 * To run a mutation, you first call `useCreateProgrammeModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgrammeModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateProgrammeModuleMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgrammeModuleMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateProgrammeModuleMutation, Types.CreateProgrammeModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateProgrammeModuleMutation, Types.CreateProgrammeModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateProgrammeModuleMutation, Types.CreateProgrammeModuleMutationVariables>(CreateProgrammeModuleDocument, options);
}
export type CreateProgrammeModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateProgrammeModuleMutation, Types.CreateProgrammeModuleMutationVariables>;
export const UpdateProgrammeModuleDocument = gql`
    mutation UpdateProgrammeModule($id: ID!, $input: updateProgrammeModuleInput!) {
  updateProgrammeModule(id: $id, input: $input) {
    id
    programme_id
    session_id
    academic_calendar_id
    name
    sequence
    registration_fee
    retake_fee
    registration_fee_item_template_id
    retake_fee_item_template_id
    min_units_per_registration
    max_units_per_registration
    started_at
    ended_at
    is_active
    is_open
    updatedAt
  }
}
    `;

/**
 * __useUpdateProgrammeModuleMutation__
 *
 * To run a mutation, you first call `useUpdateProgrammeModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgrammeModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateProgrammeModuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgrammeModuleMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateProgrammeModuleMutation, Types.UpdateProgrammeModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateProgrammeModuleMutation, Types.UpdateProgrammeModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateProgrammeModuleMutation, Types.UpdateProgrammeModuleMutationVariables>(UpdateProgrammeModuleDocument, options);
}
export type UpdateProgrammeModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateProgrammeModuleMutation, Types.UpdateProgrammeModuleMutationVariables>;
export const ToggleProgrammeModuleDocument = gql`
    mutation ToggleProgrammeModule($id: ID!, $is_active: Boolean!) {
  toggleProgrammeModule(id: $id, is_active: $is_active) {
    id
    is_active
    is_open
  }
}
    `;

/**
 * __useToggleProgrammeModuleMutation__
 *
 * To run a mutation, you first call `useToggleProgrammeModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useToggleProgrammeModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useToggleProgrammeModuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *     is_active: // value for 'is_active'
 *   },
 * });
 */
export function useToggleProgrammeModuleMutation(options: VueApolloComposable.UseMutationOptions<Types.ToggleProgrammeModuleMutation, Types.ToggleProgrammeModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ToggleProgrammeModuleMutation, Types.ToggleProgrammeModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ToggleProgrammeModuleMutation, Types.ToggleProgrammeModuleMutationVariables>(ToggleProgrammeModuleDocument, options);
}
export type ToggleProgrammeModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ToggleProgrammeModuleMutation, Types.ToggleProgrammeModuleMutationVariables>;
export const DeleteProgrammeModuleDocument = gql`
    mutation DeleteProgrammeModule($id: ID!) {
  deleteProgrammeModule(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useDeleteProgrammeModuleMutation__
 *
 * To run a mutation, you first call `useDeleteProgrammeModuleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgrammeModuleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProgrammeModuleMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProgrammeModuleMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteProgrammeModuleMutation, Types.DeleteProgrammeModuleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteProgrammeModuleMutation, Types.DeleteProgrammeModuleMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteProgrammeModuleMutation, Types.DeleteProgrammeModuleMutationVariables>(DeleteProgrammeModuleDocument, options);
}
export type DeleteProgrammeModuleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteProgrammeModuleMutation, Types.DeleteProgrammeModuleMutationVariables>;
export const SetCoursePrerequisitesDocument = gql`
    mutation SetCoursePrerequisites($course_id: ID!, $prerequisite_course_ids: [ID!]!) {
  setCoursePrerequisites(
    course_id: $course_id
    prerequisite_course_ids: $prerequisite_course_ids
  ) {
    id
    course_id
    prerequisite_course_id
    prerequisiteCourse {
      id
      course_code
      course_title
      unit
    }
  }
}
    `;

/**
 * __useSetCoursePrerequisitesMutation__
 *
 * To run a mutation, you first call `useSetCoursePrerequisitesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCoursePrerequisitesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCoursePrerequisitesMutation({
 *   variables: {
 *     course_id: // value for 'course_id'
 *     prerequisite_course_ids: // value for 'prerequisite_course_ids'
 *   },
 * });
 */
export function useSetCoursePrerequisitesMutation(options: VueApolloComposable.UseMutationOptions<Types.SetCoursePrerequisitesMutation, Types.SetCoursePrerequisitesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetCoursePrerequisitesMutation, Types.SetCoursePrerequisitesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetCoursePrerequisitesMutation, Types.SetCoursePrerequisitesMutationVariables>(SetCoursePrerequisitesDocument, options);
}
export type SetCoursePrerequisitesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetCoursePrerequisitesMutation, Types.SetCoursePrerequisitesMutationVariables>;
export const RemoveCoursePrerequisiteDocument = gql`
    mutation RemoveCoursePrerequisite($id: ID!) {
  removeCoursePrerequisite(id: $id) {
    success
    message
  }
}
    `;

/**
 * __useRemoveCoursePrerequisiteMutation__
 *
 * To run a mutation, you first call `useRemoveCoursePrerequisiteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoursePrerequisiteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveCoursePrerequisiteMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCoursePrerequisiteMutation(options: VueApolloComposable.UseMutationOptions<Types.RemoveCoursePrerequisiteMutation, Types.RemoveCoursePrerequisiteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemoveCoursePrerequisiteMutation, Types.RemoveCoursePrerequisiteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemoveCoursePrerequisiteMutation, Types.RemoveCoursePrerequisiteMutationVariables>(RemoveCoursePrerequisiteDocument, options);
}
export type RemoveCoursePrerequisiteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemoveCoursePrerequisiteMutation, Types.RemoveCoursePrerequisiteMutationVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($input: CreateTicketCategoryInput!) {
  createTicketCategory(input: $input) {
    id
    name
    priority
    auto_response
    is_active
  }
}
    `;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateCategoryMutation, Types.CreateCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateCategoryMutation, Types.CreateCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateCategoryMutation, Types.CreateCategoryMutationVariables>(CreateCategoryDocument, options);
}
export type CreateCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateCategoryMutation, Types.CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($id: ID!, $name: String, $priority: TicketPriority, $auto_response: String) {
  updateTicketCategory(
    id: $id
    name: $name
    priority: $priority
    auto_response: $auto_response
  ) {
    id
    name
    priority
    auto_response
    is_active
  }
}
    `;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *     name: // value for 'name'
 *     priority: // value for 'priority'
 *     auto_response: // value for 'auto_response'
 *   },
 * });
 */
export function useUpdateCategoryMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateCategoryMutation, Types.UpdateCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateCategoryMutation, Types.UpdateCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateCategoryMutation, Types.UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
}
export type UpdateCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateCategoryMutation, Types.UpdateCategoryMutationVariables>;
export const CreateTicketDocument = gql`
    mutation CreateTicket($input: CreateTicketInput!) {
  createTicket(input: $input) {
    id
    subject
    status
    priority
    created_at
  }
}
    `;

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTicketMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTicketMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTicketMutation, Types.CreateTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>(CreateTicketDocument, options);
}
export type CreateTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTicketMutation, Types.CreateTicketMutationVariables>;
export const ReplyTicketDocument = gql`
    mutation ReplyTicket($input: ReplyTicketInput!) {
  replyTicket(input: $input) {
    id
    message
    sender {
      ... on User {
        id
        name
      }
      ... on Student {
        id
        surname
        first_name
      }
    }
    attachments {
      id
      file {
        url
        original_name
      }
    }
    created_at
    scheduled_at
    status
  }
}
    `;

/**
 * __useReplyTicketMutation__
 *
 * To run a mutation, you first call `useReplyTicketMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplyTicketMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplyTicketMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useReplyTicketMutation(options: VueApolloComposable.UseMutationOptions<Types.ReplyTicketMutation, Types.ReplyTicketMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReplyTicketMutation, Types.ReplyTicketMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReplyTicketMutation, Types.ReplyTicketMutationVariables>(ReplyTicketDocument, options);
}
export type ReplyTicketMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReplyTicketMutation, Types.ReplyTicketMutationVariables>;
export const UpdateTicketStatusDocument = gql`
    mutation UpdateTicketStatus($input: UpdateTicketStatusInput!) {
  updateTicketStatus(input: $input) {
    id
    status
  }
}
    `;

/**
 * __useUpdateTicketStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTicketStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTicketStatusMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTicketStatusMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTicketStatusMutation, Types.UpdateTicketStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTicketStatusMutation, Types.UpdateTicketStatusMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTicketStatusMutation, Types.UpdateTicketStatusMutationVariables>(UpdateTicketStatusDocument, options);
}
export type UpdateTicketStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTicketStatusMutation, Types.UpdateTicketStatusMutationVariables>;
export const MyNotificationsDocument = gql`
    query MyNotifications($first: Int, $page: Int, $unread_only: Boolean) {
  myNotifications(first: $first, page: $page, unread_only: $unread_only) {
    data {
      id
      title
      message
      type
      metadata
      read_at
      created_at
    }
    paginatorInfo {
      currentPage
      lastPage
      total
      hasMorePages
    }
  }
}
    `;

/**
 * __useMyNotificationsQuery__
 *
 * To run a query within a Vue component, call `useMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyNotificationsQuery({
 *   first: // value for 'first'
 *   page: // value for 'page'
 *   unread_only: // value for 'unread_only'
 * });
 */
export function useMyNotificationsQuery(variables: Types.MyNotificationsQueryVariables | VueCompositionApi.Ref<Types.MyNotificationsQueryVariables> | ReactiveFunction<Types.MyNotificationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>(MyNotificationsDocument, variables, options);
}
export function useMyNotificationsLazyQuery(variables: Types.MyNotificationsQueryVariables | VueCompositionApi.Ref<Types.MyNotificationsQueryVariables> | ReactiveFunction<Types.MyNotificationsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>(MyNotificationsDocument, variables, options);
}
export type MyNotificationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.MyNotificationsQuery, Types.MyNotificationsQueryVariables>;
export const MyUnreadNotificationCountDocument = gql`
    query MyUnreadNotificationCount {
  myUnreadNotificationCount
}
    `;

/**
 * __useMyUnreadNotificationCountQuery__
 *
 * To run a query within a Vue component, call `useMyUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyUnreadNotificationCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyUnreadNotificationCountQuery();
 */
export function useMyUnreadNotificationCountQuery(options: VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>(MyUnreadNotificationCountDocument, {}, options);
}
export function useMyUnreadNotificationCountLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>(MyUnreadNotificationCountDocument, {}, options);
}
export type MyUnreadNotificationCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.MyUnreadNotificationCountQuery, Types.MyUnreadNotificationCountQueryVariables>;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($id: ID!) {
  markNotificationRead(id: $id)
}
    `;

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkNotificationReadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkNotificationReadMutation, Types.MarkNotificationReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkNotificationReadMutation, Types.MarkNotificationReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkNotificationReadMutation, Types.MarkNotificationReadMutationVariables>(MarkNotificationReadDocument, options);
}
export type MarkNotificationReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkNotificationReadMutation, Types.MarkNotificationReadMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation MarkAllNotificationsRead {
  markAllNotificationsRead
}
    `;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkAllNotificationsReadMutation();
 */
export function useMarkAllNotificationsReadMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, options);
}
export type MarkAllNotificationsReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkAllNotificationsReadMutation, Types.MarkAllNotificationsReadMutationVariables>;
export const NigerianStateListDocument = gql`
    query NigerianStateList {
  nigerianStates {
    name
    lgas
  }
}
    `;

/**
 * __useNigerianStateListQuery__
 *
 * To run a query within a Vue component, call `useNigerianStateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNigerianStateListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useNigerianStateListQuery();
 */
export function useNigerianStateListQuery(options: VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>(NigerianStateListDocument, {}, options);
}
export function useNigerianStateListLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>(NigerianStateListDocument, {}, options);
}
export type NigerianStateListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.NigerianStateListQuery, Types.NigerianStateListQueryVariables>;
export const AvailableReportsDocument = gql`
    query AvailableReports {
  availableReports {
    key
    title
    description
    category
    formats
  }
}
    `;

/**
 * __useAvailableReportsQuery__
 *
 * To run a query within a Vue component, call `useAvailableReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableReportsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAvailableReportsQuery();
 */
export function useAvailableReportsQuery(options: VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>(AvailableReportsDocument, {}, options);
}
export function useAvailableReportsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>(AvailableReportsDocument, {}, options);
}
export type AvailableReportsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AvailableReportsQuery, Types.AvailableReportsQueryVariables>;
export const ReportDefinitionDocument = gql`
    query ReportDefinition($key: String!) {
  reportDefinition(key: $key) {
    key
    title
    description
    category
    formats
    filters {
      key
      label
      type
      required
      default_value
      help
      options {
        value
        label
      }
    }
  }
}
    `;

/**
 * __useReportDefinitionQuery__
 *
 * To run a query within a Vue component, call `useReportDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDefinitionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportDefinitionQuery({
 *   key: // value for 'key'
 * });
 */
export function useReportDefinitionQuery(variables: Types.ReportDefinitionQueryVariables | VueCompositionApi.Ref<Types.ReportDefinitionQueryVariables> | ReactiveFunction<Types.ReportDefinitionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>(ReportDefinitionDocument, variables, options);
}
export function useReportDefinitionLazyQuery(variables?: Types.ReportDefinitionQueryVariables | VueCompositionApi.Ref<Types.ReportDefinitionQueryVariables> | ReactiveFunction<Types.ReportDefinitionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>(ReportDefinitionDocument, variables, options);
}
export type ReportDefinitionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ReportDefinitionQuery, Types.ReportDefinitionQueryVariables>;
export const RunReportDocument = gql`
    query RunReport($key: String!, $filters: [ReportFilterValueInput!]) {
  runReport(key: $key, filters: $filters) {
    key
    title
    subtitle
    notes
    truncated
    generated_at
    parameters {
      label
      value
    }
    sections {
      heading
      subheading
      total_rows
      rows
      columns {
        key
        label
        align
      }
      summary {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useRunReportQuery__
 *
 * To run a query within a Vue component, call `useRunReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRunReportQuery({
 *   key: // value for 'key'
 *   filters: // value for 'filters'
 * });
 */
export function useRunReportQuery(variables: Types.RunReportQueryVariables | VueCompositionApi.Ref<Types.RunReportQueryVariables> | ReactiveFunction<Types.RunReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.RunReportQuery, Types.RunReportQueryVariables>(RunReportDocument, variables, options);
}
export function useRunReportLazyQuery(variables?: Types.RunReportQueryVariables | VueCompositionApi.Ref<Types.RunReportQueryVariables> | ReactiveFunction<Types.RunReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.RunReportQuery, Types.RunReportQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.RunReportQuery, Types.RunReportQueryVariables>(RunReportDocument, variables, options);
}
export type RunReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.RunReportQuery, Types.RunReportQueryVariables>;
export const ReportStudentOptionsDocument = gql`
    query ReportStudentOptions($key: String!, $search: String!) {
  reportStudentOptions(key: $key, search: $search) {
    value
    label
  }
}
    `;

/**
 * __useReportStudentOptionsQuery__
 *
 * To run a query within a Vue component, call `useReportStudentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportStudentOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useReportStudentOptionsQuery({
 *   key: // value for 'key'
 *   search: // value for 'search'
 * });
 */
export function useReportStudentOptionsQuery(variables: Types.ReportStudentOptionsQueryVariables | VueCompositionApi.Ref<Types.ReportStudentOptionsQueryVariables> | ReactiveFunction<Types.ReportStudentOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>(ReportStudentOptionsDocument, variables, options);
}
export function useReportStudentOptionsLazyQuery(variables?: Types.ReportStudentOptionsQueryVariables | VueCompositionApi.Ref<Types.ReportStudentOptionsQueryVariables> | ReactiveFunction<Types.ReportStudentOptionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>(ReportStudentOptionsDocument, variables, options);
}
export type ReportStudentOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.ReportStudentOptionsQuery, Types.ReportStudentOptionsQueryVariables>;
export const ExportReportDocument = gql`
    mutation ExportReport($key: String!, $format: String!, $filters: [ReportFilterValueInput!]) {
  exportReport(key: $key, format: $format, filters: $filters) {
    id
    type
    status
    progress
    file_name
    error_message
    created_at
  }
}
    `;

/**
 * __useExportReportMutation__
 *
 * To run a mutation, you first call `useExportReportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportReportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportReportMutation({
 *   variables: {
 *     key: // value for 'key'
 *     format: // value for 'format'
 *     filters: // value for 'filters'
 *   },
 * });
 */
export function useExportReportMutation(options: VueApolloComposable.UseMutationOptions<Types.ExportReportMutation, Types.ExportReportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ExportReportMutation, Types.ExportReportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ExportReportMutation, Types.ExportReportMutationVariables>(ExportReportDocument, options);
}
export type ExportReportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ExportReportMutation, Types.ExportReportMutationVariables>;
export const StudentAnnouncementsDocument = gql`
    query StudentAnnouncements {
  studentAnnouncements {
    ...SchoolNoticeFields
  }
}
    ${SchoolNoticeFieldsFragmentDoc}`;

/**
 * __useStudentAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useStudentAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentAnnouncementsQuery();
 */
export function useStudentAnnouncementsQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>(StudentAnnouncementsDocument, {}, options);
}
export function useStudentAnnouncementsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>(StudentAnnouncementsDocument, {}, options);
}
export type StudentAnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentAnnouncementsQuery, Types.StudentAnnouncementsQueryVariables>;
export const PendingAnnouncementAcknowledgementsDocument = gql`
    query PendingAnnouncementAcknowledgements {
  pendingAnnouncementAcknowledgements {
    ...SchoolNoticeFields
  }
}
    ${SchoolNoticeFieldsFragmentDoc}`;

/**
 * __usePendingAnnouncementAcknowledgementsQuery__
 *
 * To run a query within a Vue component, call `usePendingAnnouncementAcknowledgementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingAnnouncementAcknowledgementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePendingAnnouncementAcknowledgementsQuery();
 */
export function usePendingAnnouncementAcknowledgementsQuery(options: VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>(PendingAnnouncementAcknowledgementsDocument, {}, options);
}
export function usePendingAnnouncementAcknowledgementsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>(PendingAnnouncementAcknowledgementsDocument, {}, options);
}
export type PendingAnnouncementAcknowledgementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.PendingAnnouncementAcknowledgementsQuery, Types.PendingAnnouncementAcknowledgementsQueryVariables>;
export const MarkSchoolAnnouncementReadDocument = gql`
    mutation MarkSchoolAnnouncementRead($id: ID!) {
  markSchoolAnnouncementRead(id: $id) {
    id
    read_at
  }
}
    `;

/**
 * __useMarkSchoolAnnouncementReadMutation__
 *
 * To run a mutation, you first call `useMarkSchoolAnnouncementReadMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkSchoolAnnouncementReadMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkSchoolAnnouncementReadMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useMarkSchoolAnnouncementReadMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkSchoolAnnouncementReadMutation, Types.MarkSchoolAnnouncementReadMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkSchoolAnnouncementReadMutation, Types.MarkSchoolAnnouncementReadMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkSchoolAnnouncementReadMutation, Types.MarkSchoolAnnouncementReadMutationVariables>(MarkSchoolAnnouncementReadDocument, options);
}
export type MarkSchoolAnnouncementReadMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkSchoolAnnouncementReadMutation, Types.MarkSchoolAnnouncementReadMutationVariables>;
export const AcknowledgeSchoolAnnouncementDocument = gql`
    mutation AcknowledgeSchoolAnnouncement($id: ID!) {
  acknowledgeSchoolAnnouncement(id: $id) {
    id
    read_at
    acknowledged_at
  }
}
    `;

/**
 * __useAcknowledgeSchoolAnnouncementMutation__
 *
 * To run a mutation, you first call `useAcknowledgeSchoolAnnouncementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeSchoolAnnouncementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAcknowledgeSchoolAnnouncementMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useAcknowledgeSchoolAnnouncementMutation(options: VueApolloComposable.UseMutationOptions<Types.AcknowledgeSchoolAnnouncementMutation, Types.AcknowledgeSchoolAnnouncementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AcknowledgeSchoolAnnouncementMutation, Types.AcknowledgeSchoolAnnouncementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AcknowledgeSchoolAnnouncementMutation, Types.AcknowledgeSchoolAnnouncementMutationVariables>(AcknowledgeSchoolAnnouncementDocument, options);
}
export type AcknowledgeSchoolAnnouncementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AcknowledgeSchoolAnnouncementMutation, Types.AcknowledgeSchoolAnnouncementMutationVariables>;
export const SchoolAnnouncementsDocument = gql`
    query SchoolAnnouncements($include_inactive: Boolean) {
  schoolAnnouncements(include_inactive: $include_inactive) {
    ...SchoolNoticeFields
    is_active
    audience_type
    recipient_count
    read_count
    acknowledged_count
    audiences {
      id
      audience_type
      audience_id
      name
    }
  }
}
    ${SchoolNoticeFieldsFragmentDoc}`;

/**
 * __useSchoolAnnouncementsQuery__
 *
 * To run a query within a Vue component, call `useSchoolAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolAnnouncementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSchoolAnnouncementsQuery({
 *   include_inactive: // value for 'include_inactive'
 * });
 */
export function useSchoolAnnouncementsQuery(variables: Types.SchoolAnnouncementsQueryVariables | VueCompositionApi.Ref<Types.SchoolAnnouncementsQueryVariables> | ReactiveFunction<Types.SchoolAnnouncementsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>(SchoolAnnouncementsDocument, variables, options);
}
export function useSchoolAnnouncementsLazyQuery(variables: Types.SchoolAnnouncementsQueryVariables | VueCompositionApi.Ref<Types.SchoolAnnouncementsQueryVariables> | ReactiveFunction<Types.SchoolAnnouncementsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>(SchoolAnnouncementsDocument, variables, options);
}
export type SchoolAnnouncementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.SchoolAnnouncementsQuery, Types.SchoolAnnouncementsQueryVariables>;
export const CreateSchoolAnnouncementDocument = gql`
    mutation CreateSchoolAnnouncement($input: CreateSchoolAnnouncementInput!) {
  createSchoolAnnouncement(input: $input) {
    id
    title
  }
}
    `;

/**
 * __useCreateSchoolAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateSchoolAnnouncementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolAnnouncementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateSchoolAnnouncementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchoolAnnouncementMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateSchoolAnnouncementMutation, Types.CreateSchoolAnnouncementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateSchoolAnnouncementMutation, Types.CreateSchoolAnnouncementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateSchoolAnnouncementMutation, Types.CreateSchoolAnnouncementMutationVariables>(CreateSchoolAnnouncementDocument, options);
}
export type CreateSchoolAnnouncementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateSchoolAnnouncementMutation, Types.CreateSchoolAnnouncementMutationVariables>;
export const UpdateSchoolAnnouncementDocument = gql`
    mutation UpdateSchoolAnnouncement($input: UpdateSchoolAnnouncementInput!) {
  updateSchoolAnnouncement(input: $input) {
    id
    title
    is_active
  }
}
    `;

/**
 * __useUpdateSchoolAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolAnnouncementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolAnnouncementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchoolAnnouncementMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolAnnouncementMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateSchoolAnnouncementMutation, Types.UpdateSchoolAnnouncementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateSchoolAnnouncementMutation, Types.UpdateSchoolAnnouncementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateSchoolAnnouncementMutation, Types.UpdateSchoolAnnouncementMutationVariables>(UpdateSchoolAnnouncementDocument, options);
}
export type UpdateSchoolAnnouncementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateSchoolAnnouncementMutation, Types.UpdateSchoolAnnouncementMutationVariables>;
export const AnnouncementAudienceOptionsDocument = gql`
    query AnnouncementAudienceOptions {
  getSchool {
    id
    classroomSections {
      id
      name
      classroom {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAnnouncementAudienceOptionsQuery__
 *
 * To run a query within a Vue component, call `useAnnouncementAudienceOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementAudienceOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAnnouncementAudienceOptionsQuery();
 */
export function useAnnouncementAudienceOptionsQuery(options: VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>(AnnouncementAudienceOptionsDocument, {}, options);
}
export function useAnnouncementAudienceOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>(AnnouncementAudienceOptionsDocument, {}, options);
}
export type AnnouncementAudienceOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.AnnouncementAudienceOptionsQuery, Types.AnnouncementAudienceOptionsQueryVariables>;
export const StudentDataRequestsDocument = gql`
    query StudentDataRequests($status: StudentDataRequestStatus) {
  studentDataRequests(status: $status) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useStudentDataRequestsQuery__
 *
 * To run a query within a Vue component, call `useStudentDataRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDataRequestsQuery({
 *   status: // value for 'status'
 * });
 */
export function useStudentDataRequestsQuery(variables: Types.StudentDataRequestsQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestsQueryVariables> | ReactiveFunction<Types.StudentDataRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>(StudentDataRequestsDocument, variables, options);
}
export function useStudentDataRequestsLazyQuery(variables: Types.StudentDataRequestsQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestsQueryVariables> | ReactiveFunction<Types.StudentDataRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>(StudentDataRequestsDocument, variables, options);
}
export type StudentDataRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDataRequestsQuery, Types.StudentDataRequestsQueryVariables>;
export const StudentDataRequestDocument = gql`
    query StudentDataRequest($id: ID!) {
  studentDataRequest(id: $id) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useStudentDataRequestQuery__
 *
 * To run a query within a Vue component, call `useStudentDataRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDataRequestQuery({
 *   id: // value for 'id'
 * });
 */
export function useStudentDataRequestQuery(variables: Types.StudentDataRequestQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestQueryVariables> | ReactiveFunction<Types.StudentDataRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>(StudentDataRequestDocument, variables, options);
}
export function useStudentDataRequestLazyQuery(variables?: Types.StudentDataRequestQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestQueryVariables> | ReactiveFunction<Types.StudentDataRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>(StudentDataRequestDocument, variables, options);
}
export type StudentDataRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDataRequestQuery, Types.StudentDataRequestQueryVariables>;
export const StudentDataRequestRecipientsDocument = gql`
    query StudentDataRequestRecipients($request_id: ID!, $filter: StudentDataRequestRecipientFilter, $search: String, $first: Int, $page: Int) {
  studentDataRequestRecipients(
    request_id: $request_id
    filter: $filter
    search: $search
    first: $first
    page: $page
  ) {
    data {
      student_id
      student_name
      matric_no
      class_name
      completed_at
      last_reminded_at
      reminder_count
      missing
    }
    paginatorInfo {
      currentPage
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useStudentDataRequestRecipientsQuery__
 *
 * To run a query within a Vue component, call `useStudentDataRequestRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataRequestRecipientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDataRequestRecipientsQuery({
 *   request_id: // value for 'request_id'
 *   filter: // value for 'filter'
 *   search: // value for 'search'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useStudentDataRequestRecipientsQuery(variables: Types.StudentDataRequestRecipientsQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestRecipientsQueryVariables> | ReactiveFunction<Types.StudentDataRequestRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>(StudentDataRequestRecipientsDocument, variables, options);
}
export function useStudentDataRequestRecipientsLazyQuery(variables?: Types.StudentDataRequestRecipientsQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestRecipientsQueryVariables> | ReactiveFunction<Types.StudentDataRequestRecipientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>(StudentDataRequestRecipientsDocument, variables, options);
}
export type StudentDataRequestRecipientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDataRequestRecipientsQuery, Types.StudentDataRequestRecipientsQueryVariables>;
export const StudentDataRequestAudienceCountDocument = gql`
    query StudentDataRequestAudienceCount($audience: StudentDataRequestAudienceInput!) {
  studentDataRequestAudienceCount(audience: $audience)
}
    `;

/**
 * __useStudentDataRequestAudienceCountQuery__
 *
 * To run a query within a Vue component, call `useStudentDataRequestAudienceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataRequestAudienceCountQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDataRequestAudienceCountQuery({
 *   audience: // value for 'audience'
 * });
 */
export function useStudentDataRequestAudienceCountQuery(variables: Types.StudentDataRequestAudienceCountQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestAudienceCountQueryVariables> | ReactiveFunction<Types.StudentDataRequestAudienceCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>(StudentDataRequestAudienceCountDocument, variables, options);
}
export function useStudentDataRequestAudienceCountLazyQuery(variables?: Types.StudentDataRequestAudienceCountQueryVariables | VueCompositionApi.Ref<Types.StudentDataRequestAudienceCountQueryVariables> | ReactiveFunction<Types.StudentDataRequestAudienceCountQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>(StudentDataRequestAudienceCountDocument, variables, options);
}
export type StudentDataRequestAudienceCountQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDataRequestAudienceCountQuery, Types.StudentDataRequestAudienceCountQueryVariables>;
export const StudentDataRequestFieldChoicesDocument = gql`
    query StudentDataRequestFieldChoices {
  studentDataRequestFieldChoices {
    key
    label
  }
}
    `;

/**
 * __useStudentDataRequestFieldChoicesQuery__
 *
 * To run a query within a Vue component, call `useStudentDataRequestFieldChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDataRequestFieldChoicesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDataRequestFieldChoicesQuery();
 */
export function useStudentDataRequestFieldChoicesQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>(StudentDataRequestFieldChoicesDocument, {}, options);
}
export function useStudentDataRequestFieldChoicesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>(StudentDataRequestFieldChoicesDocument, {}, options);
}
export type StudentDataRequestFieldChoicesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDataRequestFieldChoicesQuery, Types.StudentDataRequestFieldChoicesQueryVariables>;
export const MyStudentDataRequestsDocument = gql`
    query MyStudentDataRequests {
  myStudentDataRequests {
    id
    title
    message
    due_on
    is_overdue
    blocks_portal
    completed
    fields {
      key
      label
      required
      filled
      fillable
    }
  }
}
    `;

/**
 * __useMyStudentDataRequestsQuery__
 *
 * To run a query within a Vue component, call `useMyStudentDataRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyStudentDataRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyStudentDataRequestsQuery();
 */
export function useMyStudentDataRequestsQuery(options: VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>(MyStudentDataRequestsDocument, {}, options);
}
export function useMyStudentDataRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>(MyStudentDataRequestsDocument, {}, options);
}
export type MyStudentDataRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.MyStudentDataRequestsQuery, Types.MyStudentDataRequestsQueryVariables>;
export const CreateStudentDataRequestDocument = gql`
    mutation CreateStudentDataRequest($input: CreateStudentDataRequestInput!) {
  createStudentDataRequest(input: $input) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useCreateStudentDataRequestMutation__
 *
 * To run a mutation, you first call `useCreateStudentDataRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateStudentDataRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateStudentDataRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateStudentDataRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateStudentDataRequestMutation, Types.CreateStudentDataRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateStudentDataRequestMutation, Types.CreateStudentDataRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateStudentDataRequestMutation, Types.CreateStudentDataRequestMutationVariables>(CreateStudentDataRequestDocument, options);
}
export type CreateStudentDataRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateStudentDataRequestMutation, Types.CreateStudentDataRequestMutationVariables>;
export const UpdateStudentDataRequestDocument = gql`
    mutation UpdateStudentDataRequest($id: ID!, $input: UpdateStudentDataRequestInput!) {
  updateStudentDataRequest(id: $id, input: $input) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useUpdateStudentDataRequestMutation__
 *
 * To run a mutation, you first call `useUpdateStudentDataRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentDataRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentDataRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStudentDataRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentDataRequestMutation, Types.UpdateStudentDataRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentDataRequestMutation, Types.UpdateStudentDataRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentDataRequestMutation, Types.UpdateStudentDataRequestMutationVariables>(UpdateStudentDataRequestDocument, options);
}
export type UpdateStudentDataRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentDataRequestMutation, Types.UpdateStudentDataRequestMutationVariables>;
export const CloseStudentDataRequestDocument = gql`
    mutation CloseStudentDataRequest($id: ID!) {
  closeStudentDataRequest(id: $id) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useCloseStudentDataRequestMutation__
 *
 * To run a mutation, you first call `useCloseStudentDataRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCloseStudentDataRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCloseStudentDataRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCloseStudentDataRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.CloseStudentDataRequestMutation, Types.CloseStudentDataRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CloseStudentDataRequestMutation, Types.CloseStudentDataRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CloseStudentDataRequestMutation, Types.CloseStudentDataRequestMutationVariables>(CloseStudentDataRequestDocument, options);
}
export type CloseStudentDataRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CloseStudentDataRequestMutation, Types.CloseStudentDataRequestMutationVariables>;
export const ReopenStudentDataRequestDocument = gql`
    mutation ReopenStudentDataRequest($id: ID!, $due_on: Date) {
  reopenStudentDataRequest(id: $id, due_on: $due_on) {
    ...StudentDataRequestFields
  }
}
    ${StudentDataRequestFieldsFragmentDoc}`;

/**
 * __useReopenStudentDataRequestMutation__
 *
 * To run a mutation, you first call `useReopenStudentDataRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReopenStudentDataRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReopenStudentDataRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     due_on: // value for 'due_on'
 *   },
 * });
 */
export function useReopenStudentDataRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.ReopenStudentDataRequestMutation, Types.ReopenStudentDataRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReopenStudentDataRequestMutation, Types.ReopenStudentDataRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReopenStudentDataRequestMutation, Types.ReopenStudentDataRequestMutationVariables>(ReopenStudentDataRequestDocument, options);
}
export type ReopenStudentDataRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReopenStudentDataRequestMutation, Types.ReopenStudentDataRequestMutationVariables>;
export const RemindStudentDataRequestDocument = gql`
    mutation RemindStudentDataRequest($id: ID!, $student_ids: [ID!]) {
  remindStudentDataRequest(id: $id, student_ids: $student_ids)
}
    `;

/**
 * __useRemindStudentDataRequestMutation__
 *
 * To run a mutation, you first call `useRemindStudentDataRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemindStudentDataRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemindStudentDataRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     student_ids: // value for 'student_ids'
 *   },
 * });
 */
export function useRemindStudentDataRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.RemindStudentDataRequestMutation, Types.RemindStudentDataRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RemindStudentDataRequestMutation, Types.RemindStudentDataRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RemindStudentDataRequestMutation, Types.RemindStudentDataRequestMutationVariables>(RemindStudentDataRequestDocument, options);
}
export type RemindStudentDataRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RemindStudentDataRequestMutation, Types.RemindStudentDataRequestMutationVariables>;
export const StudentDocumentFieldListDocument = gql`
    query StudentDocumentFieldList {
  studentDocumentFields {
    key
    label
  }
}
    `;

/**
 * __useStudentDocumentFieldListQuery__
 *
 * To run a query within a Vue component, call `useStudentDocumentFieldListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDocumentFieldListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentDocumentFieldListQuery();
 */
export function useStudentDocumentFieldListQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>(StudentDocumentFieldListDocument, {}, options);
}
export function useStudentDocumentFieldListLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>(StudentDocumentFieldListDocument, {}, options);
}
export type StudentDocumentFieldListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentDocumentFieldListQuery, Types.StudentDocumentFieldListQueryVariables>;
export const MyStudentProfileFormDocument = gql`
    query MyStudentProfileForm {
  myStudentProfileForm {
    ...StudentProfileFormFields
  }
}
    ${StudentProfileFormFieldsFragmentDoc}`;

/**
 * __useMyStudentProfileFormQuery__
 *
 * To run a query within a Vue component, call `useMyStudentProfileFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyStudentProfileFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyStudentProfileFormQuery();
 */
export function useMyStudentProfileFormQuery(options: VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>(MyStudentProfileFormDocument, {}, options);
}
export function useMyStudentProfileFormLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>(MyStudentProfileFormDocument, {}, options);
}
export type MyStudentProfileFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.MyStudentProfileFormQuery, Types.MyStudentProfileFormQueryVariables>;
export const UpdateMyStudentProfileFormDocument = gql`
    mutation UpdateMyStudentProfileForm($values: [StudentProfileValueInput!]!) {
  updateMyStudentProfileForm(values: $values) {
    ...StudentProfileFormFields
  }
}
    ${StudentProfileFormFieldsFragmentDoc}`;

/**
 * __useUpdateMyStudentProfileFormMutation__
 *
 * To run a mutation, you first call `useUpdateMyStudentProfileFormMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyStudentProfileFormMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMyStudentProfileFormMutation({
 *   variables: {
 *     values: // value for 'values'
 *   },
 * });
 */
export function useUpdateMyStudentProfileFormMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateMyStudentProfileFormMutation, Types.UpdateMyStudentProfileFormMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateMyStudentProfileFormMutation, Types.UpdateMyStudentProfileFormMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateMyStudentProfileFormMutation, Types.UpdateMyStudentProfileFormMutationVariables>(UpdateMyStudentProfileFormDocument, options);
}
export type UpdateMyStudentProfileFormMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateMyStudentProfileFormMutation, Types.UpdateMyStudentProfileFormMutationVariables>;
export const StudentProfileFieldSettingsDocument = gql`
    query StudentProfileFieldSettings {
  studentProfileFieldSettings {
    key
    label
    type
    access
    values_count
  }
}
    `;

/**
 * __useStudentProfileFieldSettingsQuery__
 *
 * To run a query within a Vue component, call `useStudentProfileFieldSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentProfileFieldSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStudentProfileFieldSettingsQuery();
 */
export function useStudentProfileFieldSettingsQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>(StudentProfileFieldSettingsDocument, {}, options);
}
export function useStudentProfileFieldSettingsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>(StudentProfileFieldSettingsDocument, {}, options);
}
export type StudentProfileFieldSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.StudentProfileFieldSettingsQuery, Types.StudentProfileFieldSettingsQueryVariables>;
export const UpdateStudentProfileFieldSettingsDocument = gql`
    mutation UpdateStudentProfileFieldSettings($fields: [StudentProfileFieldSettingInput!]!) {
  updateStudentProfileFieldSettings(fields: $fields) {
    key
    label
    type
    access
    values_count
  }
}
    `;

/**
 * __useUpdateStudentProfileFieldSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateStudentProfileFieldSettingsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentProfileFieldSettingsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateStudentProfileFieldSettingsMutation({
 *   variables: {
 *     fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateStudentProfileFieldSettingsMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateStudentProfileFieldSettingsMutation, Types.UpdateStudentProfileFieldSettingsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateStudentProfileFieldSettingsMutation, Types.UpdateStudentProfileFieldSettingsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateStudentProfileFieldSettingsMutation, Types.UpdateStudentProfileFieldSettingsMutationVariables>(UpdateStudentProfileFieldSettingsDocument, options);
}
export type UpdateStudentProfileFieldSettingsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateStudentProfileFieldSettingsMutation, Types.UpdateStudentProfileFieldSettingsMutationVariables>;
export const OnTicketMessageSentDocument = gql`
    subscription OnTicketMessageSent($ticket_id: ID!) {
  ticketMessageSent(ticket_id: $ticket_id) {
    id
    message
    created_at
    status
    scheduled_at
    sender {
      ... on User {
        id
        name
      }
      ... on Student {
        id
        surname
        first_name
      }
    }
    attachments {
      id
      file {
        url
        original_name
        mime_type
      }
    }
  }
}
    `;

/**
 * __useOnTicketMessageSentSubscription__
 *
 * To run a query within a Vue component, call `useOnTicketMessageSentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTicketMessageSentSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOnTicketMessageSentSubscription({
 *   ticket_id: // value for 'ticket_id'
 * });
 */
export function useOnTicketMessageSentSubscription(variables: Types.OnTicketMessageSentSubscriptionVariables | VueCompositionApi.Ref<Types.OnTicketMessageSentSubscriptionVariables> | ReactiveFunction<Types.OnTicketMessageSentSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.OnTicketMessageSentSubscription, Types.OnTicketMessageSentSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.OnTicketMessageSentSubscription, Types.OnTicketMessageSentSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.OnTicketMessageSentSubscription, Types.OnTicketMessageSentSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.OnTicketMessageSentSubscription, Types.OnTicketMessageSentSubscriptionVariables>(OnTicketMessageSentDocument, variables, options);
}
export type OnTicketMessageSentSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.OnTicketMessageSentSubscription, Types.OnTicketMessageSentSubscriptionVariables>;
export const OnUserNotificationDocument = gql`
    subscription OnUserNotification($id: ID!, $type: String!) {
  userNotification(id: $id, type: $type) {
    id
    read_at
    title
    message
    created_at
    type
    metadata
  }
}
    `;

/**
 * __useOnUserNotificationSubscription__
 *
 * To run a query within a Vue component, call `useOnUserNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUserNotificationSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useOnUserNotificationSubscription({
 *   id: // value for 'id'
 *   type: // value for 'type'
 * });
 */
export function useOnUserNotificationSubscription(variables: Types.OnUserNotificationSubscriptionVariables | VueCompositionApi.Ref<Types.OnUserNotificationSubscriptionVariables> | ReactiveFunction<Types.OnUserNotificationSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Types.OnUserNotificationSubscription, Types.OnUserNotificationSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Types.OnUserNotificationSubscription, Types.OnUserNotificationSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Types.OnUserNotificationSubscription, Types.OnUserNotificationSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<Types.OnUserNotificationSubscription, Types.OnUserNotificationSubscriptionVariables>(OnUserNotificationDocument, variables, options);
}
export type OnUserNotificationSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Types.OnUserNotificationSubscription, Types.OnUserNotificationSubscriptionVariables>;
export const CreateTranscriptTypeDocument = gql`
    mutation CreateTranscriptType($input: CreateTranscriptTypeInput!) {
  createTranscriptType(input: $input) {
    ...TranscriptTypeFields
  }
}
    ${TranscriptTypeFieldsFragmentDoc}`;

/**
 * __useCreateTranscriptTypeMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTranscriptTypeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranscriptTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTranscriptTypeMutation, Types.CreateTranscriptTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTranscriptTypeMutation, Types.CreateTranscriptTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTranscriptTypeMutation, Types.CreateTranscriptTypeMutationVariables>(CreateTranscriptTypeDocument, options);
}
export type CreateTranscriptTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTranscriptTypeMutation, Types.CreateTranscriptTypeMutationVariables>;
export const UpdateTranscriptTypeDocument = gql`
    mutation UpdateTranscriptType($input: UpdateTranscriptTypeInput!) {
  updateTranscriptType(input: $input) {
    ...TranscriptTypeFields
  }
}
    ${TranscriptTypeFieldsFragmentDoc}`;

/**
 * __useUpdateTranscriptTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTranscriptTypeMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranscriptTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptTypeMutation, Types.UpdateTranscriptTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptTypeMutation, Types.UpdateTranscriptTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTranscriptTypeMutation, Types.UpdateTranscriptTypeMutationVariables>(UpdateTranscriptTypeDocument, options);
}
export type UpdateTranscriptTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTranscriptTypeMutation, Types.UpdateTranscriptTypeMutationVariables>;
export const DeleteTranscriptTypeDocument = gql`
    mutation DeleteTranscriptType($id: ID!) {
  deleteTranscriptType(id: $id)
}
    `;

/**
 * __useDeleteTranscriptTypeMutation__
 *
 * To run a mutation, you first call `useDeleteTranscriptTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranscriptTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTranscriptTypeMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTranscriptTypeMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteTranscriptTypeMutation, Types.DeleteTranscriptTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteTranscriptTypeMutation, Types.DeleteTranscriptTypeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteTranscriptTypeMutation, Types.DeleteTranscriptTypeMutationVariables>(DeleteTranscriptTypeDocument, options);
}
export type DeleteTranscriptTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteTranscriptTypeMutation, Types.DeleteTranscriptTypeMutationVariables>;
export const ApproveTranscriptRequestDocument = gql`
    mutation ApproveTranscriptRequest($id: ID!) {
  approveTranscriptRequest(id: $id) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useApproveTranscriptRequestMutation__
 *
 * To run a mutation, you first call `useApproveTranscriptRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveTranscriptRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveTranscriptRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useApproveTranscriptRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.ApproveTranscriptRequestMutation, Types.ApproveTranscriptRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ApproveTranscriptRequestMutation, Types.ApproveTranscriptRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ApproveTranscriptRequestMutation, Types.ApproveTranscriptRequestMutationVariables>(ApproveTranscriptRequestDocument, options);
}
export type ApproveTranscriptRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ApproveTranscriptRequestMutation, Types.ApproveTranscriptRequestMutationVariables>;
export const RejectTranscriptRequestDocument = gql`
    mutation RejectTranscriptRequest($id: ID!, $reason: String!) {
  rejectTranscriptRequest(id: $id, reason: $reason) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useRejectTranscriptRequestMutation__
 *
 * To run a mutation, you first call `useRejectTranscriptRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectTranscriptRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectTranscriptRequestMutation({
 *   variables: {
 *     id: // value for 'id'
 *     reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectTranscriptRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.RejectTranscriptRequestMutation, Types.RejectTranscriptRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RejectTranscriptRequestMutation, Types.RejectTranscriptRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RejectTranscriptRequestMutation, Types.RejectTranscriptRequestMutationVariables>(RejectTranscriptRequestDocument, options);
}
export type RejectTranscriptRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RejectTranscriptRequestMutation, Types.RejectTranscriptRequestMutationVariables>;
export const RegenerateTranscriptDataDocument = gql`
    mutation RegenerateTranscriptData($transcript_request_id: ID!) {
  regenerateTranscriptData(transcript_request_id: $transcript_request_id) {
    ...GeneratedTranscriptFields
  }
}
    ${GeneratedTranscriptFieldsFragmentDoc}`;

/**
 * __useRegenerateTranscriptDataMutation__
 *
 * To run a mutation, you first call `useRegenerateTranscriptDataMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateTranscriptDataMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRegenerateTranscriptDataMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *   },
 * });
 */
export function useRegenerateTranscriptDataMutation(options: VueApolloComposable.UseMutationOptions<Types.RegenerateTranscriptDataMutation, Types.RegenerateTranscriptDataMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.RegenerateTranscriptDataMutation, Types.RegenerateTranscriptDataMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.RegenerateTranscriptDataMutation, Types.RegenerateTranscriptDataMutationVariables>(RegenerateTranscriptDataDocument, options);
}
export type RegenerateTranscriptDataMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.RegenerateTranscriptDataMutation, Types.RegenerateTranscriptDataMutationVariables>;
export const AdminGenerateTranscriptDocument = gql`
    mutation AdminGenerateTranscript($input: AdminGenerateTranscriptInput!) {
  adminGenerateTranscript(input: $input) {
    ...GeneratedTranscriptFields
  }
}
    ${GeneratedTranscriptFieldsFragmentDoc}`;

/**
 * __useAdminGenerateTranscriptMutation__
 *
 * To run a mutation, you first call `useAdminGenerateTranscriptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAdminGenerateTranscriptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAdminGenerateTranscriptMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAdminGenerateTranscriptMutation(options: VueApolloComposable.UseMutationOptions<Types.AdminGenerateTranscriptMutation, Types.AdminGenerateTranscriptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AdminGenerateTranscriptMutation, Types.AdminGenerateTranscriptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AdminGenerateTranscriptMutation, Types.AdminGenerateTranscriptMutationVariables>(AdminGenerateTranscriptDocument, options);
}
export type AdminGenerateTranscriptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AdminGenerateTranscriptMutation, Types.AdminGenerateTranscriptMutationVariables>;
export const AddTranscriptRequestNoteDocument = gql`
    mutation AddTranscriptRequestNote($transcript_request_id: ID!, $content: String!, $is_visible_to_applicant: Boolean) {
  addTranscriptRequestNote(
    transcript_request_id: $transcript_request_id
    content: $content
    is_visible_to_applicant: $is_visible_to_applicant
  ) {
    ...TranscriptActivityFields
  }
}
    ${TranscriptActivityFieldsFragmentDoc}`;

/**
 * __useAddTranscriptRequestNoteMutation__
 *
 * To run a mutation, you first call `useAddTranscriptRequestNoteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddTranscriptRequestNoteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddTranscriptRequestNoteMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *     content: // value for 'content'
 *     is_visible_to_applicant: // value for 'is_visible_to_applicant'
 *   },
 * });
 */
export function useAddTranscriptRequestNoteMutation(options: VueApolloComposable.UseMutationOptions<Types.AddTranscriptRequestNoteMutation, Types.AddTranscriptRequestNoteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.AddTranscriptRequestNoteMutation, Types.AddTranscriptRequestNoteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.AddTranscriptRequestNoteMutation, Types.AddTranscriptRequestNoteMutationVariables>(AddTranscriptRequestNoteDocument, options);
}
export type AddTranscriptRequestNoteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.AddTranscriptRequestNoteMutation, Types.AddTranscriptRequestNoteMutationVariables>;
export const LinkTranscriptApplicantToStudentDocument = gql`
    mutation LinkTranscriptApplicantToStudent($transcript_request_id: ID!, $student_id: ID!) {
  linkTranscriptApplicantToStudent(
    transcript_request_id: $transcript_request_id
    student_id: $student_id
  ) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useLinkTranscriptApplicantToStudentMutation__
 *
 * To run a mutation, you first call `useLinkTranscriptApplicantToStudentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useLinkTranscriptApplicantToStudentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useLinkTranscriptApplicantToStudentMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *     student_id: // value for 'student_id'
 *   },
 * });
 */
export function useLinkTranscriptApplicantToStudentMutation(options: VueApolloComposable.UseMutationOptions<Types.LinkTranscriptApplicantToStudentMutation, Types.LinkTranscriptApplicantToStudentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.LinkTranscriptApplicantToStudentMutation, Types.LinkTranscriptApplicantToStudentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.LinkTranscriptApplicantToStudentMutation, Types.LinkTranscriptApplicantToStudentMutationVariables>(LinkTranscriptApplicantToStudentDocument, options);
}
export type LinkTranscriptApplicantToStudentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.LinkTranscriptApplicantToStudentMutation, Types.LinkTranscriptApplicantToStudentMutationVariables>;
export const MarkTranscriptDispatchedDocument = gql`
    mutation MarkTranscriptDispatched($transcript_request_id: ID!) {
  markTranscriptDispatched(transcript_request_id: $transcript_request_id) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useMarkTranscriptDispatchedMutation__
 *
 * To run a mutation, you first call `useMarkTranscriptDispatchedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMarkTranscriptDispatchedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMarkTranscriptDispatchedMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *   },
 * });
 */
export function useMarkTranscriptDispatchedMutation(options: VueApolloComposable.UseMutationOptions<Types.MarkTranscriptDispatchedMutation, Types.MarkTranscriptDispatchedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.MarkTranscriptDispatchedMutation, Types.MarkTranscriptDispatchedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.MarkTranscriptDispatchedMutation, Types.MarkTranscriptDispatchedMutationVariables>(MarkTranscriptDispatchedDocument, options);
}
export type MarkTranscriptDispatchedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.MarkTranscriptDispatchedMutation, Types.MarkTranscriptDispatchedMutationVariables>;
export const UpdateTranscriptCoverLetterDocument = gql`
    mutation UpdateTranscriptCoverLetter($generated_transcript_id: ID!, $cover_letter: String!) {
  updateTranscriptCoverLetter(
    generated_transcript_id: $generated_transcript_id
    cover_letter: $cover_letter
  ) {
    ...GeneratedTranscriptFields
  }
}
    ${GeneratedTranscriptFieldsFragmentDoc}`;

/**
 * __useUpdateTranscriptCoverLetterMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptCoverLetterMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptCoverLetterMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTranscriptCoverLetterMutation({
 *   variables: {
 *     generated_transcript_id: // value for 'generated_transcript_id'
 *     cover_letter: // value for 'cover_letter'
 *   },
 * });
 */
export function useUpdateTranscriptCoverLetterMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptCoverLetterMutation, Types.UpdateTranscriptCoverLetterMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptCoverLetterMutation, Types.UpdateTranscriptCoverLetterMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTranscriptCoverLetterMutation, Types.UpdateTranscriptCoverLetterMutationVariables>(UpdateTranscriptCoverLetterDocument, options);
}
export type UpdateTranscriptCoverLetterMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTranscriptCoverLetterMutation, Types.UpdateTranscriptCoverLetterMutationVariables>;
export const CreateTranscriptTemplateDocument = gql`
    mutation CreateTranscriptTemplate($input: CreateTranscriptTemplateInput!) {
  createTranscriptTemplate(input: $input) {
    ...TranscriptTemplateFields
  }
}
    ${TranscriptTemplateFieldsFragmentDoc}`;

/**
 * __useCreateTranscriptTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTranscriptTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranscriptTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTranscriptTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTranscriptTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.CreateTranscriptTemplateMutation, Types.CreateTranscriptTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.CreateTranscriptTemplateMutation, Types.CreateTranscriptTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.CreateTranscriptTemplateMutation, Types.CreateTranscriptTemplateMutationVariables>(CreateTranscriptTemplateDocument, options);
}
export type CreateTranscriptTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.CreateTranscriptTemplateMutation, Types.CreateTranscriptTemplateMutationVariables>;
export const UpdateTranscriptTemplateDocument = gql`
    mutation UpdateTranscriptTemplate($input: UpdateTranscriptTemplateInput!) {
  updateTranscriptTemplate(input: $input) {
    ...TranscriptTemplateFields
  }
}
    ${TranscriptTemplateFieldsFragmentDoc}`;

/**
 * __useUpdateTranscriptTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTranscriptTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTranscriptTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateTranscriptTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTranscriptTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptTemplateMutation, Types.UpdateTranscriptTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdateTranscriptTemplateMutation, Types.UpdateTranscriptTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdateTranscriptTemplateMutation, Types.UpdateTranscriptTemplateMutationVariables>(UpdateTranscriptTemplateDocument, options);
}
export type UpdateTranscriptTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdateTranscriptTemplateMutation, Types.UpdateTranscriptTemplateMutationVariables>;
export const DeleteTranscriptTemplateDocument = gql`
    mutation DeleteTranscriptTemplate($id: ID!) {
  deleteTranscriptTemplate(id: $id)
}
    `;

/**
 * __useDeleteTranscriptTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTranscriptTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranscriptTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTranscriptTemplateMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTranscriptTemplateMutation(options: VueApolloComposable.UseMutationOptions<Types.DeleteTranscriptTemplateMutation, Types.DeleteTranscriptTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DeleteTranscriptTemplateMutation, Types.DeleteTranscriptTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DeleteTranscriptTemplateMutation, Types.DeleteTranscriptTemplateMutationVariables>(DeleteTranscriptTemplateDocument, options);
}
export type DeleteTranscriptTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DeleteTranscriptTemplateMutation, Types.DeleteTranscriptTemplateMutationVariables>;
export const SetProgrammeTranscriptTemplateDefaultDocument = gql`
    mutation SetProgrammeTranscriptTemplateDefault($programme_id: ID!, $transcript_template_id: ID) {
  setProgrammeTranscriptTemplateDefault(
    programme_id: $programme_id
    transcript_template_id: $transcript_template_id
  ) {
    id
    program_name
  }
}
    `;

/**
 * __useSetProgrammeTranscriptTemplateDefaultMutation__
 *
 * To run a mutation, you first call `useSetProgrammeTranscriptTemplateDefaultMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetProgrammeTranscriptTemplateDefaultMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetProgrammeTranscriptTemplateDefaultMutation({
 *   variables: {
 *     programme_id: // value for 'programme_id'
 *     transcript_template_id: // value for 'transcript_template_id'
 *   },
 * });
 */
export function useSetProgrammeTranscriptTemplateDefaultMutation(options: VueApolloComposable.UseMutationOptions<Types.SetProgrammeTranscriptTemplateDefaultMutation, Types.SetProgrammeTranscriptTemplateDefaultMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SetProgrammeTranscriptTemplateDefaultMutation, Types.SetProgrammeTranscriptTemplateDefaultMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SetProgrammeTranscriptTemplateDefaultMutation, Types.SetProgrammeTranscriptTemplateDefaultMutationVariables>(SetProgrammeTranscriptTemplateDefaultDocument, options);
}
export type SetProgrammeTranscriptTemplateDefaultMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SetProgrammeTranscriptTemplateDefaultMutation, Types.SetProgrammeTranscriptTemplateDefaultMutationVariables>;
export const UpdatePdfTranscriptConfigDocument = gql`
    mutation UpdatePdfTranscriptConfig($input: PdfTranscriptConfigInput!) {
  updatePdfTranscriptConfig(input: $input) {
    preset
    logo_position
    logo_height
    show_school_name
    show_school_address
    show_report_title
    report_title
    report_subtitle
    font_family
    font_size
    header_font_size
    table_header_font_size
    row_padding
    show_borders
    striped_rows
    alternate_row_color
    show_student_info
    student_info_fields
    student_info_layout
    show_cover_letter
    show_cumulative
    show_semester_summary
    show_partial_footnote
    show_footer
    footer_text
    show_estamp
    show_signature_lines
    signature_labels
    page_size
    page_orientation
    page_margin
    show_watermark
    watermark_text
  }
}
    `;

/**
 * __useUpdatePdfTranscriptConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePdfTranscriptConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePdfTranscriptConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePdfTranscriptConfigMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePdfTranscriptConfigMutation(options: VueApolloComposable.UseMutationOptions<Types.UpdatePdfTranscriptConfigMutation, Types.UpdatePdfTranscriptConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.UpdatePdfTranscriptConfigMutation, Types.UpdatePdfTranscriptConfigMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.UpdatePdfTranscriptConfigMutation, Types.UpdatePdfTranscriptConfigMutationVariables>(UpdatePdfTranscriptConfigDocument, options);
}
export type UpdatePdfTranscriptConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.UpdatePdfTranscriptConfigMutation, Types.UpdatePdfTranscriptConfigMutationVariables>;
export const SubmitTranscriptRequestDocument = gql`
    mutation SubmitTranscriptRequest($input: SubmitTranscriptRequestInput!) {
  submitTranscriptRequest(input: $input) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useSubmitTranscriptRequestMutation__
 *
 * To run a mutation, you first call `useSubmitTranscriptRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTranscriptRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitTranscriptRequestMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSubmitTranscriptRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitTranscriptRequestMutation, Types.SubmitTranscriptRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitTranscriptRequestMutation, Types.SubmitTranscriptRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitTranscriptRequestMutation, Types.SubmitTranscriptRequestMutationVariables>(SubmitTranscriptRequestDocument, options);
}
export type SubmitTranscriptRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitTranscriptRequestMutation, Types.SubmitTranscriptRequestMutationVariables>;
export const ConfirmTranscriptPaymentDocument = gql`
    mutation ConfirmTranscriptPayment($transcript_request_id: ID!, $payment_reference: String!) {
  confirmTranscriptPayment(
    transcript_request_id: $transcript_request_id
    payment_reference: $payment_reference
  ) {
    ...TranscriptRequestFields
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useConfirmTranscriptPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmTranscriptPaymentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTranscriptPaymentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConfirmTranscriptPaymentMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *     payment_reference: // value for 'payment_reference'
 *   },
 * });
 */
export function useConfirmTranscriptPaymentMutation(options: VueApolloComposable.UseMutationOptions<Types.ConfirmTranscriptPaymentMutation, Types.ConfirmTranscriptPaymentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ConfirmTranscriptPaymentMutation, Types.ConfirmTranscriptPaymentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ConfirmTranscriptPaymentMutation, Types.ConfirmTranscriptPaymentMutationVariables>(ConfirmTranscriptPaymentDocument, options);
}
export type ConfirmTranscriptPaymentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ConfirmTranscriptPaymentMutation, Types.ConfirmTranscriptPaymentMutationVariables>;
export const ReplyToTranscriptRequestDocument = gql`
    mutation ReplyToTranscriptRequest($transcript_request_id: ID!, $content: String!, $attachment: Upload) {
  replyToTranscriptRequest(
    transcript_request_id: $transcript_request_id
    content: $content
    attachment: $attachment
  ) {
    ...TranscriptActivityFields
  }
}
    ${TranscriptActivityFieldsFragmentDoc}`;

/**
 * __useReplyToTranscriptRequestMutation__
 *
 * To run a mutation, you first call `useReplyToTranscriptRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplyToTranscriptRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplyToTranscriptRequestMutation({
 *   variables: {
 *     transcript_request_id: // value for 'transcript_request_id'
 *     content: // value for 'content'
 *     attachment: // value for 'attachment'
 *   },
 * });
 */
export function useReplyToTranscriptRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.ReplyToTranscriptRequestMutation, Types.ReplyToTranscriptRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReplyToTranscriptRequestMutation, Types.ReplyToTranscriptRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReplyToTranscriptRequestMutation, Types.ReplyToTranscriptRequestMutationVariables>(ReplyToTranscriptRequestDocument, options);
}
export type ReplyToTranscriptRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReplyToTranscriptRequestMutation, Types.ReplyToTranscriptRequestMutationVariables>;
export const ReplyToTranscriptRequestPublicDocument = gql`
    mutation ReplyToTranscriptRequestPublic($tracking_code: String!, $applicant_email: String!, $content: String!, $attachment: Upload) {
  replyToTranscriptRequestPublic(
    tracking_code: $tracking_code
    applicant_email: $applicant_email
    content: $content
    attachment: $attachment
  ) {
    ...TranscriptActivityFields
  }
}
    ${TranscriptActivityFieldsFragmentDoc}`;

/**
 * __useReplyToTranscriptRequestPublicMutation__
 *
 * To run a mutation, you first call `useReplyToTranscriptRequestPublicMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useReplyToTranscriptRequestPublicMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useReplyToTranscriptRequestPublicMutation({
 *   variables: {
 *     tracking_code: // value for 'tracking_code'
 *     applicant_email: // value for 'applicant_email'
 *     content: // value for 'content'
 *     attachment: // value for 'attachment'
 *   },
 * });
 */
export function useReplyToTranscriptRequestPublicMutation(options: VueApolloComposable.UseMutationOptions<Types.ReplyToTranscriptRequestPublicMutation, Types.ReplyToTranscriptRequestPublicMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ReplyToTranscriptRequestPublicMutation, Types.ReplyToTranscriptRequestPublicMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ReplyToTranscriptRequestPublicMutation, Types.ReplyToTranscriptRequestPublicMutationVariables>(ReplyToTranscriptRequestPublicDocument, options);
}
export type ReplyToTranscriptRequestPublicMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ReplyToTranscriptRequestPublicMutation, Types.ReplyToTranscriptRequestPublicMutationVariables>;
export const SubmitPublicTranscriptRequestDocument = gql`
    mutation SubmitPublicTranscriptRequest($school_slug: String!, $transcript_type_id: ID!, $applicant_name: String!, $applicant_email: String!, $applicant_phone: String, $matric_no: String, $student_status: StudentAcademicStatusEnum!, $supporting_document: Upload, $applicant_category: ApplicantCategoryEnum!, $programme_id: ID, $programme_name: String, $year_of_admission: String, $year_of_graduation: String, $destination_address: String, $destination_institution: String, $recipient_email: String, $courier_name: String, $courier_address: String, $courier_phone: String, $number_of_copies: Int, $complaint_note: String) {
  submitPublicTranscriptRequest(
    school_slug: $school_slug
    transcript_type_id: $transcript_type_id
    applicant_name: $applicant_name
    applicant_email: $applicant_email
    applicant_phone: $applicant_phone
    matric_no: $matric_no
    student_status: $student_status
    supporting_document: $supporting_document
    applicant_category: $applicant_category
    programme_id: $programme_id
    programme_name: $programme_name
    year_of_admission: $year_of_admission
    year_of_graduation: $year_of_graduation
    destination_address: $destination_address
    destination_institution: $destination_institution
    recipient_email: $recipient_email
    courier_name: $courier_name
    courier_address: $courier_address
    courier_phone: $courier_phone
    number_of_copies: $number_of_copies
    complaint_note: $complaint_note
  ) {
    id
    tracking_code
    status
    applicant_name
    applicant_email
    bill {
      id
      amount
      net_amount
      status
    }
  }
}
    `;

/**
 * __useSubmitPublicTranscriptRequestMutation__
 *
 * To run a mutation, you first call `useSubmitPublicTranscriptRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPublicTranscriptRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSubmitPublicTranscriptRequestMutation({
 *   variables: {
 *     school_slug: // value for 'school_slug'
 *     transcript_type_id: // value for 'transcript_type_id'
 *     applicant_name: // value for 'applicant_name'
 *     applicant_email: // value for 'applicant_email'
 *     applicant_phone: // value for 'applicant_phone'
 *     matric_no: // value for 'matric_no'
 *     student_status: // value for 'student_status'
 *     supporting_document: // value for 'supporting_document'
 *     applicant_category: // value for 'applicant_category'
 *     programme_id: // value for 'programme_id'
 *     programme_name: // value for 'programme_name'
 *     year_of_admission: // value for 'year_of_admission'
 *     year_of_graduation: // value for 'year_of_graduation'
 *     destination_address: // value for 'destination_address'
 *     destination_institution: // value for 'destination_institution'
 *     recipient_email: // value for 'recipient_email'
 *     courier_name: // value for 'courier_name'
 *     courier_address: // value for 'courier_address'
 *     courier_phone: // value for 'courier_phone'
 *     number_of_copies: // value for 'number_of_copies'
 *     complaint_note: // value for 'complaint_note'
 *   },
 * });
 */
export function useSubmitPublicTranscriptRequestMutation(options: VueApolloComposable.UseMutationOptions<Types.SubmitPublicTranscriptRequestMutation, Types.SubmitPublicTranscriptRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.SubmitPublicTranscriptRequestMutation, Types.SubmitPublicTranscriptRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.SubmitPublicTranscriptRequestMutation, Types.SubmitPublicTranscriptRequestMutationVariables>(SubmitPublicTranscriptRequestDocument, options);
}
export type SubmitPublicTranscriptRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.SubmitPublicTranscriptRequestMutation, Types.SubmitPublicTranscriptRequestMutationVariables>;
export const ResolveMatricRetrievalAttemptDocument = gql`
    mutation ResolveMatricRetrievalAttempt($id: ID!, $student_id: ID!, $admin_notes: String) {
  resolveMatricRetrievalAttempt(
    id: $id
    student_id: $student_id
    admin_notes: $admin_notes
  ) {
    id
    status
    matchedStudent {
      id
      matric_no
      first_name
      surname
    }
    resolver {
      id
      name
    }
    resolved_at
    admin_notes
  }
}
    `;

/**
 * __useResolveMatricRetrievalAttemptMutation__
 *
 * To run a mutation, you first call `useResolveMatricRetrievalAttemptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResolveMatricRetrievalAttemptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResolveMatricRetrievalAttemptMutation({
 *   variables: {
 *     id: // value for 'id'
 *     student_id: // value for 'student_id'
 *     admin_notes: // value for 'admin_notes'
 *   },
 * });
 */
export function useResolveMatricRetrievalAttemptMutation(options: VueApolloComposable.UseMutationOptions<Types.ResolveMatricRetrievalAttemptMutation, Types.ResolveMatricRetrievalAttemptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.ResolveMatricRetrievalAttemptMutation, Types.ResolveMatricRetrievalAttemptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.ResolveMatricRetrievalAttemptMutation, Types.ResolveMatricRetrievalAttemptMutationVariables>(ResolveMatricRetrievalAttemptDocument, options);
}
export type ResolveMatricRetrievalAttemptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.ResolveMatricRetrievalAttemptMutation, Types.ResolveMatricRetrievalAttemptMutationVariables>;
export const DismissMatricRetrievalAttemptDocument = gql`
    mutation DismissMatricRetrievalAttempt($id: ID!, $admin_notes: String) {
  dismissMatricRetrievalAttempt(id: $id, admin_notes: $admin_notes) {
    id
    status
    resolver {
      id
      name
    }
    resolved_at
    admin_notes
  }
}
    `;

/**
 * __useDismissMatricRetrievalAttemptMutation__
 *
 * To run a mutation, you first call `useDismissMatricRetrievalAttemptMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDismissMatricRetrievalAttemptMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDismissMatricRetrievalAttemptMutation({
 *   variables: {
 *     id: // value for 'id'
 *     admin_notes: // value for 'admin_notes'
 *   },
 * });
 */
export function useDismissMatricRetrievalAttemptMutation(options: VueApolloComposable.UseMutationOptions<Types.DismissMatricRetrievalAttemptMutation, Types.DismissMatricRetrievalAttemptMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Types.DismissMatricRetrievalAttemptMutation, Types.DismissMatricRetrievalAttemptMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<Types.DismissMatricRetrievalAttemptMutation, Types.DismissMatricRetrievalAttemptMutationVariables>(DismissMatricRetrievalAttemptDocument, options);
}
export type DismissMatricRetrievalAttemptMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Types.DismissMatricRetrievalAttemptMutation, Types.DismissMatricRetrievalAttemptMutationVariables>;
export const GetTranscriptTypesDocument = gql`
    query GetTranscriptTypes {
  transcriptTypes {
    ...TranscriptTypeFields
  }
}
    ${TranscriptTypeFieldsFragmentDoc}`;

/**
 * __useGetTranscriptTypesQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptTypesQuery();
 */
export function useGetTranscriptTypesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>(GetTranscriptTypesDocument, {}, options);
}
export function useGetTranscriptTypesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>(GetTranscriptTypesDocument, {}, options);
}
export type GetTranscriptTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptTypesQuery, Types.GetTranscriptTypesQueryVariables>;
export const GetTranscriptRequestsDocument = gql`
    query GetTranscriptRequests($status: TranscriptRequestStatusEnum, $transcript_type_id: ID, $applicant_category: ApplicantCategoryEnum, $search: String, $date_from: Date, $date_to: Date, $first: Int = 15, $page: Int = 1) {
  transcriptRequests(
    filter: {status: $status, transcript_type_id: $transcript_type_id, applicant_category: $applicant_category, search: $search, date_from: $date_from, date_to: $date_to}
    first: $first
    page: $page
  ) {
    data {
      ...TranscriptRequestFields
    }
    paginatorInfo {
      currentPage
      perPage
      total
      lastPage
      hasMorePages
    }
  }
}
    ${TranscriptRequestFieldsFragmentDoc}`;

/**
 * __useGetTranscriptRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptRequestsQuery({
 *   status: // value for 'status'
 *   transcript_type_id: // value for 'transcript_type_id'
 *   applicant_category: // value for 'applicant_category'
 *   search: // value for 'search'
 *   date_from: // value for 'date_from'
 *   date_to: // value for 'date_to'
 *   first: // value for 'first'
 *   page: // value for 'page'
 * });
 */
export function useGetTranscriptRequestsQuery(variables: Types.GetTranscriptRequestsQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestsQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>(GetTranscriptRequestsDocument, variables, options);
}
export function useGetTranscriptRequestsLazyQuery(variables: Types.GetTranscriptRequestsQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestsQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>(GetTranscriptRequestsDocument, variables, options);
}
export type GetTranscriptRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptRequestsQuery, Types.GetTranscriptRequestsQueryVariables>;
export const GetTranscriptRequestDocument = gql`
    query GetTranscriptRequest($id: ID!) {
  transcriptRequest(id: $id) {
    ...TranscriptRequestFields
    generatedTranscript {
      ...GeneratedTranscriptFields
    }
    activities {
      ...TranscriptActivityFields
    }
    bill {
      id
      status
      amount
      net_amount
      amount_paid
      balance
      due_date
    }
  }
}
    ${TranscriptRequestFieldsFragmentDoc}
${GeneratedTranscriptFieldsFragmentDoc}
${TranscriptActivityFieldsFragmentDoc}`;

/**
 * __useGetTranscriptRequestQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptRequestQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTranscriptRequestQuery(variables: Types.GetTranscriptRequestQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>(GetTranscriptRequestDocument, variables, options);
}
export function useGetTranscriptRequestLazyQuery(variables?: Types.GetTranscriptRequestQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>(GetTranscriptRequestDocument, variables, options);
}
export type GetTranscriptRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptRequestQuery, Types.GetTranscriptRequestQueryVariables>;
export const GetGeneratedTranscriptDocument = gql`
    query GetGeneratedTranscript($id: ID!) {
  generatedTranscript(id: $id) {
    ...GeneratedTranscriptFields
    student {
      id
      first_name
      surname
      matric_no
    }
    transcriptRequest {
      id
      tracking_code
      status
    }
  }
}
    ${GeneratedTranscriptFieldsFragmentDoc}`;

/**
 * __useGetGeneratedTranscriptQuery__
 *
 * To run a query within a Vue component, call `useGetGeneratedTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedTranscriptQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetGeneratedTranscriptQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetGeneratedTranscriptQuery(variables: Types.GetGeneratedTranscriptQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedTranscriptQueryVariables> | ReactiveFunction<Types.GetGeneratedTranscriptQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>(GetGeneratedTranscriptDocument, variables, options);
}
export function useGetGeneratedTranscriptLazyQuery(variables?: Types.GetGeneratedTranscriptQueryVariables | VueCompositionApi.Ref<Types.GetGeneratedTranscriptQueryVariables> | ReactiveFunction<Types.GetGeneratedTranscriptQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>(GetGeneratedTranscriptDocument, variables, options);
}
export type GetGeneratedTranscriptQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetGeneratedTranscriptQuery, Types.GetGeneratedTranscriptQueryVariables>;
export const GetPublicTranscriptTypesDocument = gql`
    query GetPublicTranscriptTypes($school_slug: String!) {
  publicTranscriptTypes(school_slug: $school_slug) {
    id
    name
    slug
    description
    category
    is_active
    billItemTemplate {
      id
      name
      default_amount
    }
  }
}
    `;

/**
 * __useGetPublicTranscriptTypesQuery__
 *
 * To run a query within a Vue component, call `useGetPublicTranscriptTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTranscriptTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPublicTranscriptTypesQuery({
 *   school_slug: // value for 'school_slug'
 * });
 */
export function useGetPublicTranscriptTypesQuery(variables: Types.GetPublicTranscriptTypesQueryVariables | VueCompositionApi.Ref<Types.GetPublicTranscriptTypesQueryVariables> | ReactiveFunction<Types.GetPublicTranscriptTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>(GetPublicTranscriptTypesDocument, variables, options);
}
export function useGetPublicTranscriptTypesLazyQuery(variables?: Types.GetPublicTranscriptTypesQueryVariables | VueCompositionApi.Ref<Types.GetPublicTranscriptTypesQueryVariables> | ReactiveFunction<Types.GetPublicTranscriptTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>(GetPublicTranscriptTypesDocument, variables, options);
}
export type GetPublicTranscriptTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPublicTranscriptTypesQuery, Types.GetPublicTranscriptTypesQueryVariables>;
export const GetTranscriptRequestStatusDocument = gql`
    query GetTranscriptRequestStatus($tracking_code: String!) {
  transcriptRequestStatus(tracking_code: $tracking_code) {
    tracking_code
    status
    applicant_name
    transcript_type
    submitted_at
    approved_at
    rejection_reason
    can_download
    activities {
      id
      type
      content
      old_status
      new_status
      is_visible_to_applicant
      created_at
    }
  }
}
    `;

/**
 * __useGetTranscriptRequestStatusQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptRequestStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptRequestStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptRequestStatusQuery({
 *   tracking_code: // value for 'tracking_code'
 * });
 */
export function useGetTranscriptRequestStatusQuery(variables: Types.GetTranscriptRequestStatusQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestStatusQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>(GetTranscriptRequestStatusDocument, variables, options);
}
export function useGetTranscriptRequestStatusLazyQuery(variables?: Types.GetTranscriptRequestStatusQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptRequestStatusQueryVariables> | ReactiveFunction<Types.GetTranscriptRequestStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>(GetTranscriptRequestStatusDocument, variables, options);
}
export type GetTranscriptRequestStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptRequestStatusQuery, Types.GetTranscriptRequestStatusQueryVariables>;
export const RetrieveMatricNoDocument = gql`
    query RetrieveMatricNo($input: RetrieveMatricNoInput!, $school_slug: String!) {
  retrieveMatricNo(input: $input, school_slug: $school_slug) {
    found
    student_id
    matric_no
    message
  }
}
    `;

/**
 * __useRetrieveMatricNoQuery__
 *
 * To run a query within a Vue component, call `useRetrieveMatricNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveMatricNoQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRetrieveMatricNoQuery({
 *   input: // value for 'input'
 *   school_slug: // value for 'school_slug'
 * });
 */
export function useRetrieveMatricNoQuery(variables: Types.RetrieveMatricNoQueryVariables | VueCompositionApi.Ref<Types.RetrieveMatricNoQueryVariables> | ReactiveFunction<Types.RetrieveMatricNoQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>(RetrieveMatricNoDocument, variables, options);
}
export function useRetrieveMatricNoLazyQuery(variables?: Types.RetrieveMatricNoQueryVariables | VueCompositionApi.Ref<Types.RetrieveMatricNoQueryVariables> | ReactiveFunction<Types.RetrieveMatricNoQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>(RetrieveMatricNoDocument, variables, options);
}
export type RetrieveMatricNoQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.RetrieveMatricNoQuery, Types.RetrieveMatricNoQueryVariables>;
export const GetPublicProgrammesDocument = gql`
    query GetPublicProgrammes($school_slug: String!) {
  publicProgrammes(school_slug: $school_slug) {
    id
    program_name
    prog_code
  }
}
    `;

/**
 * __useGetPublicProgrammesQuery__
 *
 * To run a query within a Vue component, call `useGetPublicProgrammesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProgrammesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPublicProgrammesQuery({
 *   school_slug: // value for 'school_slug'
 * });
 */
export function useGetPublicProgrammesQuery(variables: Types.GetPublicProgrammesQueryVariables | VueCompositionApi.Ref<Types.GetPublicProgrammesQueryVariables> | ReactiveFunction<Types.GetPublicProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>(GetPublicProgrammesDocument, variables, options);
}
export function useGetPublicProgrammesLazyQuery(variables?: Types.GetPublicProgrammesQueryVariables | VueCompositionApi.Ref<Types.GetPublicProgrammesQueryVariables> | ReactiveFunction<Types.GetPublicProgrammesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>(GetPublicProgrammesDocument, variables, options);
}
export type GetPublicProgrammesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPublicProgrammesQuery, Types.GetPublicProgrammesQueryVariables>;
export const GetTranscriptTemplatesDocument = gql`
    query GetTranscriptTemplates {
  transcriptTemplates {
    ...TranscriptTemplateFields
  }
}
    ${TranscriptTemplateFieldsFragmentDoc}`;

/**
 * __useGetTranscriptTemplatesQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptTemplatesQuery();
 */
export function useGetTranscriptTemplatesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>(GetTranscriptTemplatesDocument, {}, options);
}
export function useGetTranscriptTemplatesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>(GetTranscriptTemplatesDocument, {}, options);
}
export type GetTranscriptTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptTemplatesQuery, Types.GetTranscriptTemplatesQueryVariables>;
export const GetTranscriptTemplateDocument = gql`
    query GetTranscriptTemplate($id: ID!) {
  transcriptTemplate(id: $id) {
    ...TranscriptTemplateFields
  }
}
    ${TranscriptTemplateFieldsFragmentDoc}`;

/**
 * __useGetTranscriptTemplateQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptTemplateQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetTranscriptTemplateQuery(variables: Types.GetTranscriptTemplateQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptTemplateQueryVariables> | ReactiveFunction<Types.GetTranscriptTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>(GetTranscriptTemplateDocument, variables, options);
}
export function useGetTranscriptTemplateLazyQuery(variables?: Types.GetTranscriptTemplateQueryVariables | VueCompositionApi.Ref<Types.GetTranscriptTemplateQueryVariables> | ReactiveFunction<Types.GetTranscriptTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>(GetTranscriptTemplateDocument, variables, options);
}
export type GetTranscriptTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptTemplateQuery, Types.GetTranscriptTemplateQueryVariables>;
export const GetTranscriptDesignOptionsDocument = gql`
    query GetTranscriptDesignOptions {
  transcriptDesignOptions {
    value
    label
    description
  }
}
    `;

/**
 * __useGetTranscriptDesignOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptDesignOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptDesignOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptDesignOptionsQuery();
 */
export function useGetTranscriptDesignOptionsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>(GetTranscriptDesignOptionsDocument, {}, options);
}
export function useGetTranscriptDesignOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>(GetTranscriptDesignOptionsDocument, {}, options);
}
export type GetTranscriptDesignOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptDesignOptionsQuery, Types.GetTranscriptDesignOptionsQueryVariables>;
export const GetTranscriptPresetOptionsDocument = gql`
    query GetTranscriptPresetOptions {
  transcriptPresetOptions {
    key
    name
    description
    config
  }
}
    `;

/**
 * __useGetTranscriptPresetOptionsQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptPresetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptPresetOptionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptPresetOptionsQuery();
 */
export function useGetTranscriptPresetOptionsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>(GetTranscriptPresetOptionsDocument, {}, options);
}
export function useGetTranscriptPresetOptionsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>(GetTranscriptPresetOptionsDocument, {}, options);
}
export type GetTranscriptPresetOptionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptPresetOptionsQuery, Types.GetTranscriptPresetOptionsQueryVariables>;
export const GetPdfTranscriptConfigDocument = gql`
    query GetPdfTranscriptConfig {
  pdfTranscriptConfig {
    preset
    logo_position
    logo_height
    show_school_name
    show_school_address
    show_report_title
    report_title
    report_subtitle
    font_family
    font_size
    header_font_size
    table_header_font_size
    row_padding
    show_borders
    striped_rows
    alternate_row_color
    show_student_info
    student_info_fields
    student_info_layout
    show_cover_letter
    show_cumulative
    show_semester_summary
    show_partial_footnote
    show_footer
    footer_text
    show_estamp
    show_signature_lines
    signature_labels
    page_size
    page_orientation
    page_margin
    show_watermark
    watermark_text
  }
}
    `;

/**
 * __useGetPdfTranscriptConfigQuery__
 *
 * To run a query within a Vue component, call `useGetPdfTranscriptConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfTranscriptConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPdfTranscriptConfigQuery();
 */
export function useGetPdfTranscriptConfigQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>(GetPdfTranscriptConfigDocument, {}, options);
}
export function useGetPdfTranscriptConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>(GetPdfTranscriptConfigDocument, {}, options);
}
export type GetPdfTranscriptConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPdfTranscriptConfigQuery, Types.GetPdfTranscriptConfigQueryVariables>;
export const GetPdfTranscriptPresetsDocument = gql`
    query GetPdfTranscriptPresets {
  pdfTranscriptPresets {
    key
    name
    description
    config
  }
}
    `;

/**
 * __useGetPdfTranscriptPresetsQuery__
 *
 * To run a query within a Vue component, call `useGetPdfTranscriptPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdfTranscriptPresetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetPdfTranscriptPresetsQuery();
 */
export function useGetPdfTranscriptPresetsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>(GetPdfTranscriptPresetsDocument, {}, options);
}
export function useGetPdfTranscriptPresetsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>(GetPdfTranscriptPresetsDocument, {}, options);
}
export type GetPdfTranscriptPresetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetPdfTranscriptPresetsQuery, Types.GetPdfTranscriptPresetsQueryVariables>;
export const GetTranscriptStudentInfoFieldsDocument = gql`
    query GetTranscriptStudentInfoFields {
  transcriptStudentInfoFields {
    key
    label
  }
}
    `;

/**
 * __useGetTranscriptStudentInfoFieldsQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptStudentInfoFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptStudentInfoFieldsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptStudentInfoFieldsQuery();
 */
export function useGetTranscriptStudentInfoFieldsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>(GetTranscriptStudentInfoFieldsDocument, {}, options);
}
export function useGetTranscriptStudentInfoFieldsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>(GetTranscriptStudentInfoFieldsDocument, {}, options);
}
export type GetTranscriptStudentInfoFieldsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptStudentInfoFieldsQuery, Types.GetTranscriptStudentInfoFieldsQueryVariables>;
export const GetTranscriptFontFamiliesDocument = gql`
    query GetTranscriptFontFamilies {
  transcriptFontFamilies {
    key
    label
  }
}
    `;

/**
 * __useGetTranscriptFontFamiliesQuery__
 *
 * To run a query within a Vue component, call `useGetTranscriptFontFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTranscriptFontFamiliesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetTranscriptFontFamiliesQuery();
 */
export function useGetTranscriptFontFamiliesQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>(GetTranscriptFontFamiliesDocument, {}, options);
}
export function useGetTranscriptFontFamiliesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>(GetTranscriptFontFamiliesDocument, {}, options);
}
export type GetTranscriptFontFamiliesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetTranscriptFontFamiliesQuery, Types.GetTranscriptFontFamiliesQueryVariables>;
export const DownloadTranscriptPdfDocument = gql`
    query DownloadTranscriptPdf($generated_transcript_id: ID!, $category: TranscriptTypeCategoryEnum) {
  downloadTranscriptPdf(
    generated_transcript_id: $generated_transcript_id
    category: $category
  ) {
    id
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useDownloadTranscriptPdfQuery__
 *
 * To run a query within a Vue component, call `useDownloadTranscriptPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadTranscriptPdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadTranscriptPdfQuery({
 *   generated_transcript_id: // value for 'generated_transcript_id'
 *   category: // value for 'category'
 * });
 */
export function useDownloadTranscriptPdfQuery(variables: Types.DownloadTranscriptPdfQueryVariables | VueCompositionApi.Ref<Types.DownloadTranscriptPdfQueryVariables> | ReactiveFunction<Types.DownloadTranscriptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>(DownloadTranscriptPdfDocument, variables, options);
}
export function useDownloadTranscriptPdfLazyQuery(variables?: Types.DownloadTranscriptPdfQueryVariables | VueCompositionApi.Ref<Types.DownloadTranscriptPdfQueryVariables> | ReactiveFunction<Types.DownloadTranscriptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>(DownloadTranscriptPdfDocument, variables, options);
}
export type DownloadTranscriptPdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadTranscriptPdfQuery, Types.DownloadTranscriptPdfQueryVariables>;
export const DownloadPublicTranscriptPdfDocument = gql`
    query DownloadPublicTranscriptPdf($tracking_code: String!, $applicant_email: String!) {
  downloadPublicTranscriptPdf(
    tracking_code: $tracking_code
    applicant_email: $applicant_email
  ) {
    id
    status
    progress
    file_name
    file_url
    error_message
  }
}
    `;

/**
 * __useDownloadPublicTranscriptPdfQuery__
 *
 * To run a query within a Vue component, call `useDownloadPublicTranscriptPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPublicTranscriptPdfQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDownloadPublicTranscriptPdfQuery({
 *   tracking_code: // value for 'tracking_code'
 *   applicant_email: // value for 'applicant_email'
 * });
 */
export function useDownloadPublicTranscriptPdfQuery(variables: Types.DownloadPublicTranscriptPdfQueryVariables | VueCompositionApi.Ref<Types.DownloadPublicTranscriptPdfQueryVariables> | ReactiveFunction<Types.DownloadPublicTranscriptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>(DownloadPublicTranscriptPdfDocument, variables, options);
}
export function useDownloadPublicTranscriptPdfLazyQuery(variables?: Types.DownloadPublicTranscriptPdfQueryVariables | VueCompositionApi.Ref<Types.DownloadPublicTranscriptPdfQueryVariables> | ReactiveFunction<Types.DownloadPublicTranscriptPdfQueryVariables>, options: VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>(DownloadPublicTranscriptPdfDocument, variables, options);
}
export type DownloadPublicTranscriptPdfQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.DownloadPublicTranscriptPdfQuery, Types.DownloadPublicTranscriptPdfQueryVariables>;
export const GetMyTranscriptRequestsDocument = gql`
    query GetMyTranscriptRequests {
  myTranscriptRequests {
    ...TranscriptRequestFields
    generatedTranscript {
      id
      version
      generated_at
      file_path
    }
    activities {
      ...TranscriptActivityFields
    }
    bill {
      id
      status
      amount
      net_amount
      amount_paid
      balance
      due_date
    }
  }
}
    ${TranscriptRequestFieldsFragmentDoc}
${TranscriptActivityFieldsFragmentDoc}`;

/**
 * __useGetMyTranscriptRequestsQuery__
 *
 * To run a query within a Vue component, call `useGetMyTranscriptRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTranscriptRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMyTranscriptRequestsQuery();
 */
export function useGetMyTranscriptRequestsQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>(GetMyTranscriptRequestsDocument, {}, options);
}
export function useGetMyTranscriptRequestsLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>(GetMyTranscriptRequestsDocument, {}, options);
}
export type GetMyTranscriptRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetMyTranscriptRequestsQuery, Types.GetMyTranscriptRequestsQueryVariables>;
export const GetMatricRetrievalAttemptsDocument = gql`
    query GetMatricRetrievalAttempts($page: Int, $first: Int, $status: MatricRetrievalStatusEnum, $result: MatricRetrievalResultEnum) {
  matricRetrievalAttempts(
    page: $page
    first: $first
    status: $status
    result: $result
  ) {
    data {
      id
      surname
      first_name
      other_name
      email
      phone
      programme {
        id
        program_name
      }
      year_of_graduation
      result
      status
      matchedStudent {
        id
        matric_no
        first_name
        surname
      }
      resolver {
        id
        name
      }
      resolved_at
      admin_notes
      created_at
    }
    paginatorInfo {
      currentPage
      lastPage
      total
    }
  }
}
    `;

/**
 * __useGetMatricRetrievalAttemptsQuery__
 *
 * To run a query within a Vue component, call `useGetMatricRetrievalAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatricRetrievalAttemptsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMatricRetrievalAttemptsQuery({
 *   page: // value for 'page'
 *   first: // value for 'first'
 *   status: // value for 'status'
 *   result: // value for 'result'
 * });
 */
export function useGetMatricRetrievalAttemptsQuery(variables: Types.GetMatricRetrievalAttemptsQueryVariables | VueCompositionApi.Ref<Types.GetMatricRetrievalAttemptsQueryVariables> | ReactiveFunction<Types.GetMatricRetrievalAttemptsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>(GetMatricRetrievalAttemptsDocument, variables, options);
}
export function useGetMatricRetrievalAttemptsLazyQuery(variables: Types.GetMatricRetrievalAttemptsQueryVariables | VueCompositionApi.Ref<Types.GetMatricRetrievalAttemptsQueryVariables> | ReactiveFunction<Types.GetMatricRetrievalAttemptsQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>(GetMatricRetrievalAttemptsDocument, variables, options);
}
export type GetMatricRetrievalAttemptsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.GetMatricRetrievalAttemptsQuery, Types.GetMatricRetrievalAttemptsQueryVariables>;
export const WhatsNewEntriesDocument = gql`
    query WhatsNewEntries {
  whatsNew {
    id
    date
    title
    summary
    sections {
      heading
      paragraphs
      bullets
    }
    action {
      label
      path
    }
  }
}
    `;

/**
 * __useWhatsNewEntriesQuery__
 *
 * To run a query within a Vue component, call `useWhatsNewEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhatsNewEntriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWhatsNewEntriesQuery();
 */
export function useWhatsNewEntriesQuery(options: VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>(WhatsNewEntriesDocument, {}, options);
}
export function useWhatsNewEntriesLazyQuery(options: VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>(WhatsNewEntriesDocument, {}, options);
}
export type WhatsNewEntriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Types.WhatsNewEntriesQuery, Types.WhatsNewEntriesQueryVariables>;